import { defineComponent, useAttrs, computed, openBlock, createBlock, resolveDynamicComponent, normalizeClass, unref, withCtx, renderSlot, ref, withDirectives, createElementBlock, Fragment, mergeProps, createCommentVNode, onMounted, onUnmounted, watch, withKeys, renderList, createElementVNode, toDisplayString, normalizeStyle, inject, watchEffect, provide, Transition, vShow, reactive, nextTick, Teleport, createVNode, withModifiers, createTextVNode, onBeforeUnmount, resolveComponent, KeepAlive, onUpdated, vModelRadio, createSlots, toRefs, toHandlerKey, onBeforeUpdate, vModelText, h, onBeforeMount, isRef, useSlots, TransitionGroup, toRaw } from "vue";
const _sfc_main$1D = /* @__PURE__ */ defineComponent({
  __name: "MDBBadge",
  props: {
    badge: String,
    color: String,
    pill: Boolean,
    dot: Boolean,
    notification: Boolean,
    tag: {
      type: String,
      default: "span"
    }
  },
  setup(__props, { expose }) {
    const props = __props;
    const attrs = useAttrs();
    const className = computed(() => {
      return [
        "badge",
        props.color && `bg-${props.color}`,
        props.badge && `badge-${props.badge}`,
        props.pill && "rounded-pill",
        props.dot && "badge-dot",
        props.notification && "badge-notification"
      ];
    });
    expose({ attrs });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const bsColors = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "light",
  "dark"
];
const gradient = "rgba({{color}}, 0.2) 0, rgba({{color}}, 0.3) 40%, rgba({{color}}, 0.4) 50%, rgba({{color}}, 0.5) 60%, rgba({{color}}, 0) 70%";
const defaultColor = [0, 0, 0];
const transitionBreakOpacity = 0.5;
const isBSColor = (propColor) => propColor && bsColors.includes(propColor.toLowerCase());
const colorToRGB = (color2, defaultColor2) => {
  const hexToRgb = (color22) => {
    const HEX_COLOR_LENGTH = 7;
    const IS_SHORT_HEX = color22.length < HEX_COLOR_LENGTH;
    if (IS_SHORT_HEX) {
      color22 = `#${color22[1]}${color22[1]}${color22[2]}${color22[2]}${color22[3]}${color22[3]}`;
    }
    return [
      parseInt(color22.substr(1, 2), 16),
      parseInt(color22.substr(3, 2), 16),
      parseInt(color22.substr(5, 2), 16)
    ];
  };
  const namedColorsToRgba = (color22) => {
    const tempElem = document.body.appendChild(
      document.createElement("fictum")
    );
    const flag = "rgb(1, 2, 3)";
    tempElem.style.color = flag;
    if (tempElem.style.color !== flag) {
      return defaultColor2;
    }
    tempElem.style.color = color22;
    if (tempElem.style.color === flag || tempElem.style.color === "") {
      return defaultColor2;
    }
    color22 = getComputedStyle(tempElem).color;
    document.body.removeChild(tempElem);
    return color22;
  };
  const rgbaToRgb = (color22) => {
    const colorMatch = color22.match(/[.\d]+/g);
    if (colorMatch === null) {
      return;
    }
    const colorArr = colorMatch.map((a) => +Number(a));
    colorArr.length = 3;
    return colorArr;
  };
  if (typeof color2 === "string" && color2.toLowerCase() === "transparent") {
    return defaultColor2;
  }
  if (typeof color2 === "string" && color2[0] === "#") {
    return hexToRgb(color2);
  }
  if (typeof color2 === "string" && color2.indexOf("rgb") === -1) {
    color2 = namedColorsToRgba(color2);
  }
  if (typeof color2 === "string" && color2.indexOf("rgb") === 0) {
    return rgbaToRgb(color2);
  }
  return defaultColor2;
};
const getDiameter = ({ offsetX, offsetY, height, width }) => {
  const top2 = offsetY <= height / 2;
  const left2 = offsetX <= width / 2;
  const pythagorean = (sideA, sideB) => Math.sqrt(sideA ** 2 + sideB ** 2);
  const positionCenter = offsetY === height / 2 && offsetX === width / 2;
  const quadrant = {
    first: top2 === true && left2 === false,
    second: top2 === true && left2 === true,
    third: top2 === false && left2 === true,
    fourth: top2 === false && left2 === false
  };
  const getCorner = {
    topLeft: pythagorean(offsetX, offsetY),
    topRight: pythagorean(width - offsetX, offsetY),
    bottomLeft: pythagorean(offsetX, height - offsetY),
    bottomRight: pythagorean(width - offsetX, height - offsetY)
  };
  let diameter = 0;
  if (positionCenter || quadrant.fourth) {
    diameter = getCorner.topLeft;
  } else if (quadrant.third) {
    diameter = getCorner.topRight;
  } else if (quadrant.second) {
    diameter = getCorner.bottomRight;
  } else if (quadrant.first) {
    diameter = getCorner.bottomLeft;
  }
  return diameter * 2;
};
const setStyles = (el, styles) => {
  for (const property in styles) {
    el.style[property] = styles[property];
  }
};
const getBackgroundImage = (color2) => {
  const rgb = colorToRGB(color2, defaultColor);
  if (color2 !== "" && rgb) {
    const rgbValue = rgb.join(",");
    const gradientImage = gradient.split("{{color}}").join(`${rgbValue}`);
    return `radial-gradient(circle, ${gradientImage})`;
  }
};
const runRipple = (el, waveConfig, options) => {
  const rippleElement = document.createElement("div");
  rippleElement.classList.add("ripple-wave");
  const diameterConfig = {
    offsetX: options.centered ? waveConfig.height / 2 : waveConfig.left,
    offsetY: options.centered ? waveConfig.width / 2 : waveConfig.top,
    height: waveConfig.height,
    width: waveConfig.width
  };
  const diameter = getDiameter(diameterConfig);
  const radiusValue = options.radius || diameter / 2;
  const opacity = {
    delay: options.duration && options.duration * transitionBreakOpacity,
    duration: options.duration && options.duration - options.duration * transitionBreakOpacity
  };
  const styles = {
    left: options.centered ? `${Math.round(waveConfig.width / 2 - radiusValue)}px` : `${Math.round(waveConfig.left - radiusValue)}px`,
    top: options.centered ? `${Math.round(waveConfig.height / 2 - radiusValue)}px` : `${Math.round(waveConfig.top - radiusValue)}px`,
    height: `${Math.round(
      options.radius && options.radius * 2 || diameter
    )}px`,
    width: `${Math.round(
      options.radius && options.radius * 2 || diameter
    )}px`,
    transitionDelay: `0s, ${opacity.delay}ms`,
    transitionDuration: `${options.duration}ms, ${opacity.duration}ms`
  };
  if (options.unbound) {
    el.classList.add("ripple-surface-unbound");
  }
  if (isBSColor(options.color)) {
    el.classList.add(`ripple-surface-${options.color}`);
  } else {
    styles.backgroundImage = getBackgroundImage(options.color);
  }
  setStyles(rippleElement, styles);
  el.appendChild(rippleElement);
  setTimeout(() => {
    rippleElement.classList.add("active");
  }, 50);
  setTimeout(
    () => {
      el.removeChild(rippleElement);
    },
    options.duration ? options.duration + 1e3 : 1e3
  );
};
const RippleDirective = {
  mounted(el, binding) {
    if (binding.value === false) {
      return;
    }
    const options = {
      centered: binding.value && binding.value.centered || false,
      color: binding.value && binding.value.color || "",
      duration: binding.value && binding.value.duration || 500,
      radius: binding.value && binding.value.radius || 0,
      unbound: binding.value && binding.value.unbound || false
    };
    el.classList.add("ripple-surface");
    el.waves = (e) => {
      const waveConfig = {
        top: e.layerY,
        left: e.layerX,
        height: el.offsetHeight,
        width: el.offsetWidth
      };
      runRipple(el, waveConfig, options);
    };
    el.addEventListener("click", (e) => el.waves(e));
  },
  updated(el) {
    if (!el.classList.contains("ripple-surface")) {
      el.classList.add("ripple-surface");
    }
  },
  unmounted(el) {
    el.removeEventListener("click", (e) => el.waves(e));
  }
};
const _sfc_main$1C = /* @__PURE__ */ defineComponent({
  __name: "MDBBtn",
  props: {
    color: String,
    size: String,
    outline: String,
    rounded: Boolean,
    floating: Boolean,
    toggler: Boolean,
    toggle: Boolean,
    role: {
      type: String,
      default: "button"
    },
    type: {
      type: String,
      default: "button"
    },
    tag: {
      type: String,
      default: "button"
    },
    block: {
      type: Boolean,
      default: false
    },
    ripple: {
      type: [Object, Boolean],
      default: (props) => props.outline || props.color === "light" || props.color === "link" ? { color: "dark" } : true
    },
    picker: Boolean
  },
  emits: ["update:toggle"],
  setup(__props, { emit }) {
    const props = __props;
    const toggle = ref(props.toggle);
    const className = computed(() => {
      return [
        !props.picker && "btn",
        props.color && `btn-${props.color}`,
        props.size && `btn-${props.size}`,
        props.outline && `btn-outline-${props.outline}`,
        props.rounded && "btn-rounded",
        props.floating && "btn-floating",
        props.block && "btn-block",
        toggle.value && "active"
      ];
    });
    const handleClick = () => {
      if (props.toggler) {
        toggle.value = !toggle.value;
        emit("update:toggle", toggle.value);
      }
    };
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        type: __props.type,
        role: __props.role,
        class: normalizeClass(unref(className)),
        onClick: handleClick
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "role", "class"])), [
        [unref(RippleDirective), __props.ripple]
      ]);
    };
  }
});
const _sfc_main$1B = /* @__PURE__ */ defineComponent({
  __name: "MDBBtnGroup",
  props: {
    size: String,
    vertical: Boolean,
    role: {
      type: String,
      default: "group"
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        props.size && `btn-group-${props.size}`,
        props.vertical ? "btn-group-vertical" : "btn-group"
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        role: __props.role
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "role"]);
    };
  }
});
const _sfc_main$1A = /* @__PURE__ */ defineComponent({
  __name: "MDBBtnClose",
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return ["btn-close", props.white && `btn-close-white`];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: normalizeClass(unref(className)),
        "aria-label": "Close"
      }, null, 2);
    };
  }
});
const _sfc_main$1z = /* @__PURE__ */ defineComponent({
  __name: "MDBCard",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    border: String,
    bg: String,
    text: [String, Array],
    shadow: String
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      const text = props.text;
      return [
        "card",
        props.border && `border border-${props.border}`,
        props.bg && `bg-${props.bg}`,
        props.shadow && `shadow-${props.shadow}`,
        props.text && spreadProps(text)
      ];
    });
    const spreadProps = (props2) => {
      if (typeof props2 === "string") {
        return `text-${props2}`;
      }
      return props2.map((prop) => `text-${prop}`.trim()).join(" ");
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1y = /* @__PURE__ */ defineComponent({
  __name: "MDBCardBody",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    text: {
      type: [String, Array]
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      const text = props.text;
      return ["card-body", props.text && spreadProps(text)];
    });
    const spreadProps = (props2) => {
      if (typeof props2 === "string") {
        return `text-${props2}`;
      }
      return props2.map((prop) => `text-${prop}`.trim()).join(" ");
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1x = /* @__PURE__ */ defineComponent({
  __name: "MDBCardTitle",
  props: {
    tag: {
      type: String,
      default: "h5"
    },
    subtitle: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const tagName = computed(() => {
      if (!props.subtitle) {
        return props.tag;
      }
      return props.tag !== "h5" ? props.tag : "h6";
    });
    const className = computed(() => {
      return [props.subtitle ? "card-subtitle" : "card-title"];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(tagName)), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1w = /* @__PURE__ */ defineComponent({
  __name: "MDBCardText",
  props: {
    tag: {
      type: String,
      default: "p"
    }
  },
  setup(__props) {
    const className = computed(() => ["card-text"]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1v = /* @__PURE__ */ defineComponent({
  __name: "MDBCardImg",
  props: {
    tag: {
      type: String,
      default: "img"
    },
    src: {
      type: String,
      required: true
    },
    alt: String,
    top: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        props.top && `card-img-top`,
        props.bottom && `card-img-bottom`,
        props.fluid && `img-fluid`,
        props.overlay && "card-img",
        !props.top && !props.bottom && !props.fluid && !props.overlay && `card-img`
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          src: __props.src,
          alt: __props.alt,
          class: unref(className)
        }, _ctx.$attrs), null, 16, ["src", "alt", "class"])),
        __props.overlay ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          class: "card-img-overlay"
        }, _ctx.$attrs), [
          renderSlot(_ctx.$slots, "default")
        ], 16)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _sfc_main$1u = /* @__PURE__ */ defineComponent({
  __name: "MDBCardHeader",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    bg: String,
    border: String
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        "card-header",
        props.border && `border-${props.border}`,
        props.bg && `bg-${props.bg}`
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1t = /* @__PURE__ */ defineComponent({
  __name: "MDBCardFooter",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    bg: String,
    border: String
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        "card-footer",
        props.border && `border-${props.border}`,
        props.bg && `bg-${props.bg}`
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1s = /* @__PURE__ */ defineComponent({
  __name: "MDBCardLink",
  props: {
    tag: {
      type: String,
      default: "a"
    }
  },
  setup(__props) {
    const className = computed(() => ["card-link"]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1r = /* @__PURE__ */ defineComponent({
  __name: "MDBCardGroup",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const className = computed(() => ["card-group"]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$G = {
  key: 0,
  class: "carousel-indicators"
};
const _hoisted_2$w = ["ariaCurrent", "ariaLabel", "onClick"];
const _hoisted_3$o = {
  key: 0,
  class: "img-fluid",
  autoplay: "",
  loop: "",
  muted: ""
};
const _hoisted_4$k = ["src", "type"];
const _hoisted_5$h = ["src", "alt"];
const _hoisted_6$f = { key: 0 };
const _hoisted_7$c = { key: 1 };
const _hoisted_8$a = /* @__PURE__ */ createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1);
const _hoisted_9$a = /* @__PURE__ */ createElementVNode("span", { class: "visually-hidden" }, "Previous", -1);
const _hoisted_10$8 = [
  _hoisted_8$a,
  _hoisted_9$a
];
const _hoisted_11$5 = /* @__PURE__ */ createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1);
const _hoisted_12$4 = /* @__PURE__ */ createElementVNode("span", { class: "visually-hidden" }, "Next", -1);
const _hoisted_13$4 = [
  _hoisted_11$5,
  _hoisted_12$4
];
const _sfc_main$1q = /* @__PURE__ */ defineComponent({
  __name: "MDBCarousel",
  props: {
    captionsClass: {
      type: String,
      default: "carousel-caption d-none d-md-block"
    },
    controls: {
      type: Boolean,
      default: true
    },
    dark: Boolean,
    fade: Boolean,
    indicators: {
      type: Boolean,
      default: true
    },
    interval: {
      type: [Number, Boolean],
      default: 5e3
    },
    items: Array,
    itemsClass: {
      type: String,
      default: "d-block w-100"
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Number,
      default: 0
    },
    pause: {
      type: [String, Boolean],
      default: "hover"
    },
    tag: {
      type: String,
      default: "div"
    },
    touch: {
      type: Boolean,
      default: true
    },
    innerClass: String
  },
  emits: ["update:modelValue"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const className = computed(() => {
      return [
        "carousel",
        "slide",
        props.fade && "carousel-fade",
        props.dark && "carousel-dark"
      ];
    });
    const innerClassName = computed(() => {
      return ["carousel-inner", props.innerClass];
    });
    const activeItemKey = ref(props.modelValue);
    const carouselInnerRef = ref(null);
    const isSliding = ref(false);
    let slidingInterval = null;
    let isPaused = false;
    const prev = () => {
      slideTo("prev");
    };
    const next = () => {
      slideTo("next");
    };
    const slideTo = (target) => {
      if (isSliding.value) {
        return;
      }
      const isPausedState = isPaused;
      isPaused = false;
      slide(target);
      isPaused = isPausedState;
    };
    const slide = (target) => {
      if (isPaused || !carouselInnerRef.value) {
        return;
      }
      isSliding.value = true;
      const targetItemKey = getTargetKey(target);
      const isNext = getTargetSlideOrder(target);
      const directionalClassName = getDirectionalClassName(isNext);
      const orderClassName = getOrderClassName(isNext);
      const currentItem = getItem(activeItemKey.value);
      const targetItem = getItem(targetItemKey);
      activeItemKey.value = targetItemKey;
      targetItem.classList.add(orderClassName);
      emit("update:modelValue", activeItemKey.value);
      if (props.interval) {
        reloadInterval();
      }
      setTimeout(() => {
        currentItem.classList.add(directionalClassName);
        targetItem.classList.add(directionalClassName);
      }, 20);
      setTimeout(() => {
        currentItem.classList.remove("active");
        currentItem.classList.remove(directionalClassName);
        targetItem.classList.remove(directionalClassName);
        targetItem.classList.remove(orderClassName);
        targetItem.classList.add("active");
        isSliding.value = false;
      }, 600);
    };
    const getTargetKey = (target) => {
      if (target === "prev" && activeItemKey.value <= 0) {
        return props.items.length - 1;
      } else if (target === "prev") {
        return activeItemKey.value - 1;
      } else if (target === "next" && activeItemKey.value >= props.items.length - 1) {
        return 0;
      } else if (target === "next") {
        return activeItemKey.value + 1;
      } else {
        return target;
      }
    };
    const getTargetSlideOrder = (target) => {
      if (target === "next" || target > activeItemKey.value) {
        return true;
      } else {
        return false;
      }
    };
    const getDirectionalClassName = (isNext) => isNext ? "carousel-item-start" : "carousel-item-end";
    const getOrderClassName = (isNext) => isNext ? "carousel-item-next" : "carousel-item-prev";
    const getItem = (key) => carouselInnerRef.value.querySelectorAll(".carousel-item")[key];
    const reloadInterval = () => {
      clearInterval(slidingInterval);
      slidingInterval = null;
      const itemInterval = props.items[activeItemKey.value].interval || props.interval;
      slidingInterval = setInterval(() => {
        slide("next");
      }, itemInterval);
    };
    const handleMouseenter = () => {
      if (props.pause === "hover" && props.interval) {
        clearInterval(slidingInterval);
        slidingInterval = null;
        isPaused = true;
      }
    };
    const handleMouseleave = () => {
      if (props.pause === "hover" && props.interval) {
        reloadInterval();
        isPaused = false;
      }
    };
    const handleRight = () => {
      if (props.keyboard) {
        next();
      }
    };
    const handleLeft = () => {
      if (props.keyboard) {
        prev();
      }
    };
    const pointerEvent = Boolean(window.PointerEvent);
    const touchStartX = ref(0);
    const touchDeltaX = ref(0);
    const handleTouchstart = (event) => {
      if (!props.touch) {
        return;
      }
      const pointerType = event;
      const mouseEvent = event;
      const touchEvent = event;
      if (pointerEvent && (pointerType.pointerType === "pen" || pointerType.pointerType === "touch")) {
        touchStartX.value = mouseEvent.clientX;
      } else {
        touchStartX.value = touchEvent.touches[0].clientX;
      }
    };
    const handleTouchmove = (event) => {
      if (!props.touch) {
        return;
      }
      touchDeltaX.value = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - touchStartX.value;
    };
    const handleTouchend = (event) => {
      if (!props.touch) {
        return;
      }
      const pointerType = event;
      const mouseEvent = event;
      if (pointerEvent && (pointerType.pointerType === "pen" || pointerType.pointerType === "touch")) {
        touchDeltaX.value = mouseEvent.clientX - touchStartX.value;
      }
      handleSwipe();
    };
    const handleSwipe = () => {
      const absDeltax = Math.abs(touchDeltaX.value);
      if (absDeltax <= 40) {
        return;
      }
      const direction = absDeltax / touchDeltaX.value;
      touchDeltaX.value = 0;
      if (!direction) {
        return;
      }
      if (direction > 0) {
        prev();
      } else {
        next();
      }
    };
    onMounted(() => {
      const currentActiveItem = carouselInnerRef.value.querySelectorAll(".carousel-item")[activeItemKey.value];
      currentActiveItem.classList.add("active");
      if (props.interval) {
        reloadInterval();
      }
    });
    onUnmounted(() => {
      if (props.interval) {
        clearInterval(slidingInterval);
        slidingInterval = null;
      }
    });
    watch(
      () => props.modelValue,
      (targetItemKey) => slideTo(targetItemKey)
    );
    expose({ next, prev });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        onMouseenter: handleMouseenter,
        onMouseleave: handleMouseleave,
        onKeydown: [
          withKeys(handleRight, ["right"]),
          withKeys(handleLeft, ["left"])
        ],
        onTouchstart: handleTouchstart,
        onTouchmove: handleTouchmove,
        onTouchend: handleTouchend
      }, {
        default: withCtx(() => [
          __props.indicators ? (openBlock(), createElementBlock("div", _hoisted_1$G, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, key) => {
              return openBlock(), createElementBlock("button", {
                key,
                type: "button",
                class: normalizeClass(activeItemKey.value === key && "active"),
                ariaCurrent: activeItemKey.value === key && "true",
                ariaLabel: `Slide ${key + 1}`,
                onClick: ($event) => slideTo(key)
              }, null, 10, _hoisted_2$w);
            }), 128))
          ])) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(unref(innerClassName)),
            ref_key: "carouselInnerRef",
            ref: carouselInnerRef
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, key) => {
              return openBlock(), createElementBlock("div", {
                class: "carousel-item",
                key
              }, [
                item.video ? (openBlock(), createElementBlock("video", _hoisted_3$o, [
                  createElementVNode("source", {
                    src: item.video,
                    type: item.videoType
                  }, null, 8, _hoisted_4$k)
                ])) : (openBlock(), createElementBlock("img", {
                  key: 1,
                  src: item.src,
                  alt: item.alt,
                  class: normalizeClass(__props.itemsClass)
                }, null, 10, _hoisted_5$h)),
                item.label || item.caption ? (openBlock(), createElementBlock("div", {
                  key: 2,
                  class: normalizeClass(__props.captionsClass)
                }, [
                  item.label ? (openBlock(), createElementBlock("h5", _hoisted_6$f, toDisplayString(item.label), 1)) : createCommentVNode("", true),
                  item.caption ? (openBlock(), createElementBlock("p", _hoisted_7$c, toDisplayString(item.caption), 1)) : createCommentVNode("", true)
                ], 2)) : createCommentVNode("", true)
              ]);
            }), 128))
          ], 2),
          __props.controls ? (openBlock(), createElementBlock("button", {
            key: 1,
            onClick: prev,
            class: "carousel-control-prev",
            type: "button"
          }, _hoisted_10$8)) : createCommentVNode("", true),
          __props.controls ? (openBlock(), createElementBlock("button", {
            key: 2,
            onClick: next,
            class: "carousel-control-next",
            type: "button"
          }, _hoisted_13$4)) : createCommentVNode("", true)
        ]),
        _: 1
      }, 40, ["class", "onKeydown"]);
    };
  }
});
const _sfc_main$1p = /* @__PURE__ */ defineComponent({
  __name: "MDBListGroup",
  props: {
    flush: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: [Boolean, String],
      default: false
    },
    numbered: Boolean,
    tag: {
      type: String,
      default: "ul"
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        "list-group",
        props.horizontal && horizontalClass.value,
        props.flush && "list-group-flush",
        props.numbered && "list-group-numbered"
      ];
    });
    const horizontalClass = computed(() => {
      if (!props.horizontal) {
        return;
      }
      return props.horizontal !== true ? `list-group-horizontal-${props.horizontal}` : "list-group-horizontal";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1o = /* @__PURE__ */ defineComponent({
  __name: "MDBListGroupItem",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: Boolean,
      default: false
    },
    color: String
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        "list-group-item",
        props.active && "active",
        props.disabled && "disabled",
        props.action && "list-group-item-action",
        props.color && `list-group-item-${props.color}`
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        "aria-current": __props.active ? true : null,
        "aria-disabled": __props.disabled ? true : null,
        disabled: __props.disabled ? true : null
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "aria-current", "aria-disabled", "disabled"]);
    };
  }
});
const _sfc_main$1n = /* @__PURE__ */ defineComponent({
  __name: "MDBProgress",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    height: Number
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => ["progress"]);
    const style = computed(() => {
      return { height: props.height + "px" };
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        style: normalizeStyle(unref(style))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "style"]);
    };
  }
});
const _sfc_main$1m = /* @__PURE__ */ defineComponent({
  __name: "MDBProgressBar",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    bg: String,
    striped: {
      type: Boolean,
      default: false
    },
    animated: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        "progress-bar",
        props.bg && `bg-${props.bg}`,
        props.striped && "progress-bar-striped",
        props.animated && "progress-bar-animated"
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        role: "progressbar",
        "aria-valuenow": __props.value,
        "aria-valuemin": __props.min,
        "aria-valuemax": __props.max,
        style: normalizeStyle([
          {
            width: (__props.value - __props.min) / (__props.max - __props.min) * 100 + "%"
          }
        ])
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "aria-valuenow", "aria-valuemin", "aria-valuemax", "style"]);
    };
  }
});
const _hoisted_1$F = /* @__PURE__ */ createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1);
const _sfc_main$1l = /* @__PURE__ */ defineComponent({
  __name: "MDBSpinner",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    grow: {
      type: Boolean,
      default: false
    },
    color: String,
    size: String
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        props.grow ? "spinner-grow" : "spinner-border",
        props.color && `text-${props.color}`,
        `${props.size ? props.grow ? "spinner-grow-" + props.size : "spinner-border-" + props.size : ""}`
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        role: "status"
      }, {
        default: withCtx(() => [
          _hoisted_1$F,
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const MAX_UID = 1e6;
const getUID = (prefix) => {
  do {
    prefix += Math.floor(Math.random() * MAX_UID);
  } while (document.getElementById(prefix));
  return prefix;
};
const stripNameRegex = /\..*/;
const customEvents = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
};
const nativeEvents = [
  "click",
  "dblclick",
  "mouseup",
  "mousedown",
  "contextmenu",
  "mousewheel",
  "DOMMouseScroll",
  "mouseover",
  "mouseout",
  "mousemove",
  "selectstart",
  "selectend",
  "keydown",
  "keypress",
  "keyup",
  "orientationchange",
  "touchstart",
  "touchmove",
  "touchend",
  "touchcancel",
  "pointerdown",
  "pointermove",
  "pointerup",
  "pointerleave",
  "pointercancel",
  "gesturestart",
  "gesturechange",
  "gestureend",
  "focus",
  "blur",
  "change",
  "reset",
  "select",
  "submit",
  "focusin",
  "focusout",
  "load",
  "unload",
  "beforeunload",
  "resize",
  "move",
  "DOMContentLoaded",
  "readystatechange",
  "error",
  "abort",
  "scroll"
];
function normalizeParams(originalTypeEvent, handler, delegationFn) {
  const delegation = typeof handler === "string";
  const originalHandler = delegation ? delegationFn : handler;
  let typeEvent = originalTypeEvent.replace(stripNameRegex, "");
  const custom = customEvents[typeEvent];
  if (custom) {
    typeEvent = custom;
  }
  const isNative = nativeEvents.indexOf(typeEvent) > -1;
  if (!isNative) {
    typeEvent = originalTypeEvent;
  }
  return [delegation, originalHandler, typeEvent];
}
function addHandler(element, originalTypeEvent, handler, delegationFn) {
  if (typeof originalTypeEvent !== "string" || !element) {
    return;
  }
  if (!handler) {
    handler = delegationFn;
    delegationFn = null;
  }
  const [delegation, originalHandler, typeEvent] = normalizeParams(
    originalTypeEvent,
    handler,
    delegationFn
  );
  element.addEventListener(typeEvent, originalHandler, delegation);
}
function removeHandler(element, typeEvent, handler, delegationSelector) {
  element.removeEventListener(typeEvent, handler, !!delegationSelector);
}
const on = function(element, event, handler, delegationFn = void 0) {
  addHandler(element, event, handler, delegationFn);
};
const off = function(element, event, handler, delegationFn = void 0) {
  if (typeof event !== "string" || !element) {
    return;
  }
  const [delegation, originalHandler, typeEvent] = normalizeParams(
    event,
    handler,
    delegationFn
  );
  removeHandler(
    element,
    typeEvent,
    originalHandler,
    delegation ? handler : null
  );
};
const onMulti = function(element, eventArray, handler, delegationFn = void 0) {
  const events = eventArray.split(" ");
  for (let i = 0; i < events.length; i++) {
    on(element, events[i], handler, delegationFn);
  }
};
const offMulti = function(element, eventArray, handler, delegationFn = void 0) {
  const events = eventArray.split(" ");
  for (let i = 0; i < events.length; i++) {
    off(element, events[i], handler, delegationFn);
  }
};
const _sfc_main$1k = /* @__PURE__ */ defineComponent({
  __name: "MDBCollapse",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    modelValue: Boolean,
    id: String,
    collapseClass: String,
    duration: {
      type: Number,
      default: 300
    },
    sidenav: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const collapse = ref(null);
    const isActive = ref(props.modelValue);
    const className = computed(() => {
      return [
        collapseClass.value,
        props.collapseClass,
        navbarFlexWrapValue && navbarFlexWrapValue.value ? "navbar-collapse" : "",
        showClass.value
      ];
    });
    const collapseClass = computed(() => {
      return props.sidenav ? "sidenav-collapse" : isActive.value ? "collapse" : null;
    });
    const accordionState = inject("accordionState", null);
    const incrementAccordionItemsCount = inject(
      "incrementAccordionItemsCount",
      false
    );
    const setAccordionActiveItem = inject(
      "setAccordionActiveItem",
      false
    );
    const index2 = ref(null);
    const manageAccordion = () => {
      if (index2.value !== null && isActive.value) {
        setAccordionActiveItem && setAccordionActiveItem(index2.value);
      }
    };
    watchEffect(
      () => {
        if (accordionState) {
          if (accordionState.active !== index2.value) {
            emit("update:modelValue", false);
          }
        }
      },
      { flush: "post" }
    );
    onMounted(() => {
      if (isActive.value) {
        collapse.value.style.height = collapse.value.scrollHeight + "px";
      }
      if (accordionState) {
        index2.value = incrementAccordionItemsCount && incrementAccordionItemsCount();
        if (isActive.value) {
          setAccordionActiveItem && setAccordionActiveItem(index2.value);
        }
      }
    });
    let isCollapsing = false;
    watch(
      () => props.modelValue,
      (cur, prev) => {
        if (isCollapsing) {
          setTimeout(() => {
            emit("update:modelValue", prev);
          }, props.duration);
          return;
        }
        isActive.value = cur;
        if (accordionState) {
          manageAccordion();
        }
      }
    );
    const openCollapse = () => {
      emit("update:modelValue", true);
    };
    provide("openCollapse", openCollapse);
    const navbarFlexWrapValue = inject(
      "navbarFlexWrapValue",
      false
    );
    const showClass = computed(() => {
      if (!navbarFlexWrapValue || navbarFlexWrapValue.value === "wrap" && isActive.value) {
        return "show";
      } else if (navbarFlexWrapValue.value === "nowrap" && isActive.value) {
        return false;
      }
      return false;
    });
    const checkWrapCollapseValue = (cur, prev) => {
      if (prev === "null" && props.modelValue) {
        isActive.value = true;
      } else if (prev === "null" && !props.modelValue) {
        isActive.value = false;
      } else if (prev === "nowrap") {
        isActive.value = false;
      }
    };
    watch(
      () => navbarFlexWrapValue && navbarFlexWrapValue.value,
      (cur, prev) => {
        if (cur === "nowrap") {
          isActive.value = true;
        } else if (cur === "wrap") {
          checkWrapCollapseValue(cur, prev);
        }
        emit("update:modelValue", isActive.value);
      },
      { immediate: true }
    );
    const uid2 = computed(() => {
      return props.id ? props.id : getUID("collapsibleContent-");
    });
    const beforeEnter = (el) => {
      el.style.height = "0";
      isCollapsing = true;
    };
    const enter = (el) => {
      el.style.height = collapse.value.scrollHeight + "px";
    };
    const afterEnter = (el) => {
      if (!el.classList.contains("show")) {
        el.classList.add("show");
      }
      el.style.height = "";
      isCollapsing = false;
    };
    const beforeLeave = (el) => {
      if (!el.style.height) {
        el.classList.add("show");
        el.style.height = collapse.value.scrollHeight + "px";
      }
      isCollapsing = true;
    };
    const leave = (el) => {
      el.style.height = "0px";
    };
    const afterLeave = (el) => {
      el.classList.add("collapse");
      isCollapsing = false;
    };
    const previousWindowWidth = ref(null);
    const isThrottled = ref(false);
    const handleResize = () => {
      if (!isActive.value || isThrottled.value)
        return;
      isThrottled.value = true;
      const windowWidth = window.innerWidth;
      previousWindowWidth.value = windowWidth;
      setTimeout(() => {
        isThrottled.value = false;
      }, 100);
    };
    onMounted(() => {
      previousWindowWidth.value = window.innerWidth;
      on(window, "resize", handleResize);
    });
    onUnmounted(() => {
      off(window, "resize", handleResize);
    });
    expose({ collapse });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        onBeforeEnter: beforeEnter,
        onEnter: enter,
        onAfterEnter: afterEnter,
        onBeforeLeave: beforeLeave,
        onLeave: leave,
        onAfterLeave: afterLeave,
        "enter-active-class": "collapsing",
        "leave-active-class": "collapsing show",
        duration: __props.duration
      }, {
        default: withCtx(() => [
          withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
            class: normalizeClass(unref(className)),
            id: unref(uid2),
            ref_key: "collapse",
            ref: collapse
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["class", "id"])), [
            [vShow, isActive.value]
          ])
        ]),
        _: 3
      }, 8, ["duration"]);
    };
  }
});
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round$1 = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getComputedStyle$2(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$2(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle$2(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$2(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$2(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x, y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$2(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle$2(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$2(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map2 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$2(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve2) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve2(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions2 = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions2;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions2),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions2, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce$2(function() {
        return new Promise(function(resolve2) {
          instance.forceUpdate();
          resolve2(state);
        });
      }),
      destroy: function destroy2() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
function MDBPopper() {
  const isPopperActive = ref(false);
  const triggerEl = ref(null);
  const popperEl = ref(null);
  const popper2 = ref(void 0);
  const popperOptions = reactive({});
  function setPopper(trigger, popper22, config) {
    triggerEl.value = trigger;
    popperEl.value = popper22;
    popperOptions.value = {
      placement: "bottom",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 0]
          }
        }
      ],
      ...config
    };
  }
  function togglePopper() {
    isPopperActive.value = !isPopperActive.value;
    if (isPopperActive.value) {
      nextTick(() => setupPopper());
    }
  }
  function openPopper() {
    if (isPopperActive.value) {
      return;
    }
    isPopperActive.value = true;
    nextTick(() => popper2.value = setupPopper());
  }
  function closePopper() {
    if (!isPopperActive.value) {
      return;
    }
    isPopperActive.value = !isPopperActive.value;
  }
  function setupPopper() {
    if (popper2.value === void 0 || !popper2.value) {
      popper2.value = createPopper(
        triggerEl.value,
        popperEl.value,
        popperOptions.value
      );
    } else {
      popper2.value.update();
    }
  }
  function updatePopper(option, value) {
    popperOptions.value[option] = value;
    popper2.value = createPopper(
      triggerEl.value,
      popperEl.value,
      popperOptions.value
    );
  }
  function destroyPopper() {
    if (!popper2.value) {
      return;
    }
    popper2.value.destroy();
    popper2.value = void 0;
  }
  function getPopperOffset(offset2, element) {
    if (typeof offset2 === "string") {
      return offset2.split(",").map((val) => Number.parseInt(val, 10));
    }
    if (typeof offset2 === "function") {
      return (popperData) => offset2(popperData, element);
    }
    return offset2;
  }
  return {
    setPopper,
    togglePopper,
    isPopperActive,
    openPopper,
    closePopper,
    updatePopper,
    destroyPopper,
    getPopperOffset
  };
}
const handleBreakpoints = (windowWidth, breakpointValues) => {
  const breakpoints = {
    none: {
      width: 0,
      attr: null
    },
    sm: {
      width: 576,
      attr: null
    },
    md: {
      width: 768,
      attr: null
    },
    lg: {
      width: 992,
      attr: null
    },
    xl: {
      width: 1200,
      attr: null
    },
    xxl: {
      width: 1400,
      attr: null
    },
    mega: {
      width: 1e4,
      attr: null
    }
  };
  breakpointValues.forEach((value2) => {
    const match = Object.keys(breakpoints).filter(
      (breakpoint) => value2.includes(breakpoint) ? breakpoint : false
    )[0];
    if (match) {
      breakpoints[match].attr = value2;
    } else {
      breakpoints.none.attr = value2;
    }
  });
  const ranges = {};
  Object.keys(breakpoints).reduce((acc, cur, index2) => {
    if (breakpoints[acc].attr && breakpoints[cur].attr || breakpoints[acc].attr && !cur) {
      ranges[breakpoints[acc].attr] = {
        min: breakpoints[acc].width,
        max: breakpoints[cur].width
      };
      return cur;
    } else if (breakpoints[acc].attr && !breakpoints[cur].attr) {
      if (index2 === Object.keys(breakpoints).length - 1) {
        ranges[breakpoints[acc].attr] = {
          min: breakpoints[acc].width,
          max: breakpoints[cur].width
        };
      }
      return acc;
    }
  });
  const value = Object.keys(ranges).filter((key) => {
    if (windowWidth > ranges[key].min && windowWidth < ranges[key].max) {
      return key;
    }
  })[0];
  return value;
};
const _sfc_main$1j = /* @__PURE__ */ defineComponent({
  __name: "MDBDropdown",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    boundary: {
      type: String,
      default: "clippingParent"
    },
    btnGroup: {
      type: Boolean,
      default: false
    },
    dropup: {
      type: Boolean,
      default: false
    },
    dropend: {
      type: Boolean,
      default: false
    },
    dropstart: {
      type: Boolean,
      default: false
    },
    align: {
      type: [String, Array],
      default: "start"
    },
    offset: {
      type: [Array, String, Function],
      default: () => [0, 0]
    },
    popperConfig: [null, Object, Function],
    target: String,
    modelValue: Boolean
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const className = computed(() => {
      return [
        props.btnGroup ? "btn-group" : "dropdown",
        props.dropup && "dropup",
        props.dropend && "dropend",
        props.dropstart && "dropstart"
      ];
    });
    const {
      setPopper,
      isPopperActive,
      closePopper,
      openPopper,
      updatePopper,
      getPopperOffset
    } = MDBPopper();
    const root = ref(null);
    const triggerEl = ref(null);
    const popperEl = ref(null);
    const windowWidth = ref(window.innerWidth);
    const menuAlignClasses = ref("");
    provide("menuAlignClasses", menuAlignClasses);
    provide("closePopper", closePopper);
    const isActive = ref(props.modelValue);
    watchEffect(() => isActive.value = props.modelValue);
    provide("isActive", isActive);
    const isMenuMounted = ref(false);
    const dropdownMenu = ref(null);
    const setMenuMountedState = (boolean, menuRef) => {
      isMenuMounted.value = boolean;
      dropdownMenu.value = menuRef;
    };
    provide("setMenuMountedState", setMenuMountedState);
    const handleMenuMountedState = (mountedValue) => {
      if (mountedValue) {
        popperSetup();
        openPopper();
      } else {
        closePopper();
      }
    };
    watch(
      () => isMenuMounted.value,
      (cur) => handleMenuMountedState(cur),
      { immediate: true }
    );
    provide("isPopperActive", isPopperActive);
    provide("externalTarget", props.target);
    const handleEscAndOutsideClick = () => {
      emit("update:modelValue", false);
    };
    provide("handleEscAndOutsideClick", handleEscAndOutsideClick);
    const popperPosition = props.dropup ? "top" : props.dropend ? "right" : props.dropstart ? "left" : "bottom";
    const getConfig = () => {
      if (typeof props.align === "string") {
        menuAlignClasses.value = `dropdown-menu-${props.align}`;
      } else {
        menuAlignClasses.value = props.align.map(
          (prop) => `dropdown-menu-${prop}`.trim()
        );
      }
      let align = props.align;
      if (typeof props.align !== "string" || props.align !== "start" && props.align !== "end") {
        align = getBreakpointValue();
        on(window, "resize", listenToResize);
      }
      const placement = `${popperPosition}-${align}`;
      let boundary = document.querySelector(props.boundary);
      if (!boundary) {
        boundary = props.boundary;
      }
      const defaultBsPopperConfig = {
        placement,
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              boundary
            }
          },
          {
            name: "offset",
            options: {
              offset: getPopperOffset(props.offset, root.value)
            }
          }
        ]
      };
      return {
        ...defaultBsPopperConfig,
        ...typeof props.popperConfig === "function" ? props.popperConfig(defaultBsPopperConfig) : props.popperConfig
      };
    };
    const popperSetup = () => {
      triggerEl.value = props.target ? document.querySelector(props.target) : root.value.querySelector("[data-trigger]");
      popperEl.value = dropdownMenu.value;
      const config = getConfig();
      setPopper(triggerEl.value, popperEl.value, config);
    };
    const getBreakpointValue = () => {
      windowWidth.value = window.innerWidth;
      let propsValues = props.align;
      if (typeof props.align === "string") {
        propsValues = ["start", props.align];
      }
      const activeBrakpointValue = handleBreakpoints(
        windowWidth.value,
        propsValues
      );
      if (!activeBrakpointValue) {
        return;
      }
      return activeBrakpointValue.includes("start") ? "start" : "end";
    };
    const listenToResize = () => {
      const align = getBreakpointValue();
      updatePopper("placement", `${popperPosition}-${align}`);
    };
    onUnmounted(() => {
      off(window, "resize", listenToResize);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        ref_key: "root",
        ref: root
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
var vMdbClickOutside = {
  stopProp(e) {
    e.stopPropagation();
  },
  mounted(el, binding) {
    const handler = (e) => {
      const target = e.target;
      if (!el.contains(target) && el !== target) {
        binding.value(e);
      }
    };
    el.clickOutside = handler;
    const event = binding.modifiers.mousedown ? "mousedown" : "click";
    document.addEventListener(event, (e) => {
      var _a;
      return (_a = el.clickOutside) == null ? void 0 : _a.call(el, e);
    });
    document.addEventListener("touchstart", (e) => {
      var _a;
      return (_a = el.clickOutside) == null ? void 0 : _a.call(el, e);
    });
  },
  unmounted(el, binding) {
    if (!el.clickOutside)
      return;
    const event = binding.modifiers.mousedown ? "mousedown" : "click";
    document.removeEventListener(event, (e) => {
      var _a;
      return (_a = el.clickOutside) == null ? void 0 : _a.call(el, e);
    });
    document.removeEventListener("touchstart", (e) => {
      var _a;
      return (_a = el.clickOutside) == null ? void 0 : _a.call(el, e);
    });
    delete el.clickOutside;
  }
};
const _hoisted_1$E = {
  key: 1,
  class: "visually-hidden"
};
const _sfc_main$1i = /* @__PURE__ */ defineComponent({
  __name: "MDBDropdownToggle",
  props: {
    ..._sfc_main$1C.props,
    tag: {
      type: String,
      default: "button"
    },
    href: [String, null],
    split: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        btnClass.value,
        "dropdown-toggle",
        props.split && "dropdown-toggle-split",
        props.size && `btn-${props.size}`,
        props.outline && `btn-outline-${props.outline}`
      ];
    });
    const btnClass = computed(() => {
      if (props.tag !== "button")
        return;
      const color2 = props.color && !props.outline ? `btn-${props.color}` : props.outline ? "" : "btn-primary";
      return `btn ${color2}`;
    });
    const expanded = ref(false);
    const toggle = () => {
      expanded.value = !expanded.value;
    };
    const isPopperActive = inject("isPopperActive");
    watchEffect(() => {
      expanded.value = isPopperActive.value;
    });
    const handleEscAndOutsideClick = inject("handleEscAndOutsideClick");
    const handleClickOutside = (event) => {
      const target = event.target;
      if (isPopperActive && !target.closest(".dropdown-menu")) {
        handleEscAndOutsideClick();
      }
    };
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        type: "button",
        class: normalizeClass(unref(className)),
        "aria-expanded": expanded.value,
        "aria-haspopup": "true",
        onClick: toggle,
        "data-trigger": ""
      }, {
        default: withCtx(() => [
          !__props.split ? renderSlot(_ctx.$slots, "default", { key: 0 }) : (openBlock(), createElementBlock("span", _hoisted_1$E, "Toggle Dropdown"))
        ]),
        _: 3
      }, 8, ["class", "aria-expanded"])), [
        [unref(vMdbClickOutside), handleClickOutside]
      ]);
    };
  }
});
const __default__$o = {
  inheritAttrs: false
};
const _sfc_main$1h = /* @__PURE__ */ defineComponent({
  ...__default__$o,
  __name: "MDBDropdownMenu",
  props: {
    tag: {
      type: String,
      default: "ul"
    },
    fadeIn: {
      type: String,
      default: "fade-in"
    },
    fadeOut: {
      type: String,
      default: "fade-out"
    },
    animation: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    static: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        "dropdown-menu",
        menuAlignClasses === "dropdown-menu-start" ? "dropdown-menu-start" : menuAlignClasses.value,
        fadeClass.value,
        showClass.value && "show",
        props.dark && "dropdown-menu-dark"
      ];
    });
    const menuAlignClasses = inject(
      "menuAlignClasses",
      "dropdown-menu-start"
    );
    const root = ref("root");
    const fadeClass = ref(null);
    const showClass = ref(false);
    const staticStyle = computed(() => {
      return props.static ? { display: "block", position: "static" } : false;
    });
    const handleAnimation = () => {
      if (!props.animation) {
        return;
      }
      setTimeout(() => {
        fadeClass.value = false;
      }, 300);
    };
    const setMenuMountedState = inject("setMenuMountedState", () => false);
    const isActive = inject("isActive", false);
    if (isActive) {
      watch(
        () => isActive.value,
        (cur) => {
          if (cur) {
            setTimeout(() => {
              setMenuMountedState(true, root.value);
            }, 100);
          } else if (!cur && isPopperActive) {
            setInactive();
            setTimeout(() => {
              setMenuMountedState(false);
            }, 300);
          }
        }
      );
    }
    const setInactive = () => {
      off(document, "keydown", handleDown);
      count.value = 0;
      fadeClass.value = props.animation && `animation ${props.fadeOut}`;
      showClass.value = false;
      handleAnimation();
    };
    const isMounted = computed(() => {
      if (props.static) {
        return true;
      } else if (isActive && isActive.value || isActive && !isActive.value && isPopperActive && isPopperActive.value) {
        return true;
      } else if (isActive && !isActive.value && isPopperActive && !isPopperActive.value) {
        setTimeout(() => {
          return false;
        }, 300);
      }
      return false;
    });
    const externalTarget = inject("externalTarget", false);
    const shouldTeleport = ref(false);
    const shouldTeleportTo = ref("");
    onMounted(() => {
      if (externalTarget) {
        const target = document.body.querySelector(externalTarget);
        if (target) {
          shouldTeleport.value = true;
          shouldTeleportTo.value = externalTarget;
        }
      }
    });
    const isPopperActive = inject("isPopperActive", null);
    const setActive = () => {
      on(document, "keydown", handleDown);
      fadeClass.value = props.animation && `animation ${props.fadeIn}`;
      handleAnimation();
    };
    if (isPopperActive) {
      watch(
        () => isPopperActive.value,
        (cur, prev) => {
          if (!prev && cur === true || prev === false) {
            items.value = root.value.querySelectorAll(
              ".dropdown-item"
            );
            showClass.value = true;
            setActive();
          }
        }
      );
    }
    const count = ref(0);
    const items = ref(null);
    const handleEscAndOutsideClick = inject(
      "handleEscAndOutsideClick",
      () => false
    );
    const handleDown = (event) => {
      var _a, _b;
      const key = event.key;
      if (key === "ArrowUp" || key === "ArrowDown") {
        event.preventDefault();
      }
      if (isActive && !isActive.value) {
        return;
      }
      items.value.forEach((item) => {
        item.classList.remove("active");
      });
      switch (key) {
        case "Escape":
          handleEscAndOutsideClick();
          return;
        case "Enter":
          (_a = items.value[count.value - 1]) == null ? void 0 : _a.click();
          return;
        case "ArrowUp":
          count.value--;
          if (count.value <= 0) {
            count.value = items.value.length;
          }
          break;
        case "ArrowDown":
          count.value++;
          if (count.value > items.value.length) {
            count.value = 1;
          }
          break;
      }
      (_b = items.value[count.value - 1]) == null ? void 0 : _b.classList.add("active");
    };
    return (_ctx, _cache) => {
      return !shouldTeleport.value ? (openBlock(), createBlock(Transition, { key: 0 }, {
        default: withCtx(() => [
          unref(isMounted) ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
            key: 0,
            class: unref(className),
            style: unref(staticStyle)
          }, _ctx.$attrs, {
            "data-popper": "",
            ref_key: "root",
            ref: root
          }), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16, ["class", "style"])) : createCommentVNode("", true)
        ]),
        _: 3
      })) : (openBlock(), createBlock(Teleport, {
        key: 1,
        to: shouldTeleportTo.value
      }, [
        createVNode(Transition, null, {
          default: withCtx(() => [
            unref(isMounted) ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
              key: 0,
              class: unref(className),
              style: unref(staticStyle)
            }, _ctx.$attrs, {
              "data-popper": unref(externalTarget),
              ref_key: "root",
              ref: root
            }), {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 16, ["class", "style", "data-popper"])) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 8, ["to"]));
    };
  }
});
const _hoisted_1$D = ["tabindex"];
const _hoisted_2$v = {
  key: 1,
  class: "dropdown-divider"
};
const __default__$n = {
  inheritAttrs: false
};
const _sfc_main$1g = /* @__PURE__ */ defineComponent({
  ...__default__$n,
  __name: "MDBDropdownItem",
  props: {
    tag: {
      type: String,
      default: "a"
    },
    to: [String, Object],
    href: String,
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    exact: {
      type: Boolean,
      default: false
    },
    newTab: {
      type: Boolean,
      default: false
    },
    submenu: {
      type: Boolean,
      default: false
    },
    submenuIcon: String,
    divider: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        dropdownClass.value,
        props.disabled ? "disabled" : "",
        props.active ? "active" : "",
        props.submenu && "dropdown-submenu"
      ];
    });
    const hasLinkOrTag = computed(() => {
      if (props.to !== void 0 || props.href !== void 0 || props.tag !== "a" || props.text) {
        return true;
      }
      return false;
    });
    const dropdownClass = computed(() => {
      if (props.text) {
        return "dropdown-item-text";
      } else if (props.header) {
        return "dropdown-header";
      }
      return "dropdown-item";
    });
    const tagName = computed(() => {
      if (props.to) {
        return "router-link";
      } else if (props.text) {
        return "span";
      }
      return props.tag;
    });
    const tab = computed(() => {
      if (props.newTab) {
        return "_blank";
      }
      return null;
    });
    const handleEscAndOutsideClick = inject(
      "handleEscAndOutsideClick",
      () => false
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        tabindex: __props.divider ? null : 0
      }, [
        unref(hasLinkOrTag) ? (openBlock(), createBlock(resolveDynamicComponent(unref(tagName)), mergeProps({ key: 0 }, _ctx.$attrs, {
          to: __props.to,
          exact: __props.to ? __props.exact : null,
          href: __props.to ? null : __props.href,
          class: unref(className),
          target: unref(tab),
          type: __props.tag === "button" ? "button" : null,
          "aria-current": __props.active ? true : null,
          "aria-disabled": __props.disabled ? true : null,
          disabled: __props.disabled ? true : null,
          onClick: unref(handleEscAndOutsideClick)
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["to", "exact", "href", "class", "target", "type", "aria-current", "aria-disabled", "disabled", "onClick"])) : __props.divider ? (openBlock(), createElementBlock("hr", _hoisted_2$v)) : renderSlot(_ctx.$slots, "default", { key: 2 })
      ], 8, _hoisted_1$D);
    };
  }
});
const _hoisted_1$C = {
  key: 0,
  "data-popper-arrow": "",
  class: "tooltip_arrow"
};
const _sfc_main$1f = /* @__PURE__ */ defineComponent({
  __name: "MDBTooltip",
  props: {
    tag: {
      type: String,
      default: "span"
    },
    modelValue: Boolean,
    reference: String,
    popover: String,
    options: {
      type: [Object, Function],
      default() {
        return {};
      }
    },
    boundary: {
      type: String,
      default: "clippingParent"
    },
    fallbackPlacements: {
      type: Array,
      default: () => ["top", "right", "bottom", "left"]
    },
    offset: {
      type: String,
      default: "0, 5"
    },
    direction: {
      type: String,
      default: "top",
      validator: (value) => ["top", "right", "bottom", "left"].indexOf(value.toLowerCase()) > -1
    },
    maxWidth: {
      type: Number,
      default: 276
    },
    arrow: {
      type: Boolean,
      default: false
    },
    disabled: Boolean
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const { setPopper, isPopperActive, openPopper, closePopper, getPopperOffset } = MDBPopper();
    const triggerEl = ref(null);
    const popperEl = ref(null);
    const widthStyle = computed(() => `max-width: ${props.maxWidth}px!important`);
    const getConfig = () => {
      const placement = props.direction;
      let boundary = document.querySelector(props.boundary);
      if (!boundary) {
        boundary = props.boundary;
      }
      const defaultBsPopperConfig = {
        placement,
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: props.fallbackPlacements
            }
          },
          {
            name: "preventOverflow",
            options: {
              boundary
            }
          },
          {
            name: "offset",
            options: {
              offset: getPopperOffset(props.offset, triggerEl.value)
            }
          },
          {
            name: "arrow",
            options: {
              element: `.tooltip_arrow`,
              padding: 5
            }
          }
        ]
      };
      return {
        ...defaultBsPopperConfig,
        ...typeof props.options === "function" ? props.options(defaultBsPopperConfig) : props.options
      };
    };
    const popperSetup = () => {
      triggerEl.value = props.reference ? document.querySelector(props.reference) : triggerEl.value;
      popperEl.value = props.popover ? document.querySelector(props.popover) : popperEl.value;
      const config = getConfig();
      setPopper(triggerEl.value, popperEl.value, config);
    };
    const isThrottled = ref(false);
    watchEffect(() => {
      if (props.modelValue) {
        if (isThrottled.value) {
          return;
        }
        nextTick(() => {
          popperSetup();
          setTimeout(openPopper, 0);
          setTimeout(() => {
            popperEl.value.classList.add("show");
          }, 0);
        });
      } else {
        if (!isPopperActive.value) {
          return;
        }
        setTimeout(() => {
          popperEl.value.classList.remove("show");
        }, 10);
        isThrottled.value = true;
        setTimeout(() => {
          closePopper();
          isThrottled.value = false;
        }, 150);
      }
    });
    const isActive = computed(() => {
      if (props.modelValue || !props.modelValue && isPopperActive.value) {
        return true;
      } else if (!props.modelValue && !isPopperActive.value) {
        return false;
      }
      return false;
    });
    const onMouseEnter = () => {
      !props.disabled && emit("update:modelValue", true);
    };
    const onMouseLeave = () => {
      !props.disabled && emit("update:modelValue", false);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          ref_key: "triggerEl",
          ref: triggerEl,
          style: { "display": "inline-block" }
        }, _ctx.$attrs, {
          onMouseenter: onMouseEnter,
          onMouseleave: onMouseLeave,
          onFocus: onMouseEnter,
          onBlur: onMouseLeave
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "reference")
          ]),
          _: 3
        }, 16)),
        createVNode(Transition, { name: "fade" }, {
          default: withCtx(() => [
            unref(isActive) ? (openBlock(), createElementBlock("div", {
              key: 0,
              ref_key: "popperEl",
              ref: popperEl,
              class: normalizeClass({
                tooltip: true,
                fade: true,
                "tooltip-inner": true
              }),
              style: normalizeStyle([unref(widthStyle)])
            }, [
              renderSlot(_ctx.$slots, "tip"),
              __props.arrow ? (openBlock(), createElementBlock("div", _hoisted_1$C)) : createCommentVNode("", true)
            ], 4)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 64);
    };
  }
});
const _hoisted_1$B = {
  key: 0,
  class: "popover-header"
};
const _hoisted_2$u = {
  key: 1,
  class: "popover-body"
};
const _hoisted_3$n = {
  key: 2,
  "data-popper-arrow": "",
  class: "popover_arrow"
};
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "MDBPopover",
  props: {
    tag: {
      type: String,
      default: "span"
    },
    modelValue: Boolean,
    reference: String,
    popover: String,
    options: {
      type: [Object, Function],
      default() {
        return {};
      }
    },
    boundary: {
      type: String,
      default: "clippingParent"
    },
    fallbackPlacements: {
      type: Array,
      default: () => ["top", "right", "bottom", "left"]
    },
    offset: {
      type: String,
      default: "0, 5"
    },
    direction: {
      type: String,
      default: "bottom",
      validator: (value) => ["top", "right", "bottom", "left"].indexOf(value.toLowerCase()) > -1
    },
    maxWidth: {
      type: Number,
      default: 276
    },
    arrow: {
      type: Boolean,
      default: false
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const {
      setPopper,
      isPopperActive,
      openPopper,
      closePopper,
      destroyPopper,
      getPopperOffset
    } = MDBPopper();
    const triggerEl = ref(null);
    const popperEl = ref(null);
    const widthStyle = computed(() => `max-width: ${props.maxWidth}px!important`);
    const getOffset = () => {
      if (!props.arrow) {
        return props.offset;
      }
      return [0, 10];
    };
    const getConfig = () => {
      const placement = props.direction;
      let boundary = document.querySelector(props.boundary);
      if (!boundary) {
        boundary = props.boundary;
      }
      const offset2 = getOffset();
      const defaultBsPopperConfig = {
        placement,
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: props.fallbackPlacements
            }
          },
          {
            name: "preventOverflow",
            options: {
              boundary
            }
          },
          {
            name: "offset",
            options: {
              offset: getPopperOffset(offset2, triggerEl.value)
            }
          },
          {
            name: "arrow",
            options: {
              element: `.popover_arrow`,
              padding: 5
            }
          }
        ]
      };
      return {
        ...defaultBsPopperConfig,
        ...typeof props.options === "function" ? props.options(defaultBsPopperConfig) : props.options
      };
    };
    const popperSetup = () => {
      triggerEl.value = props.reference ? document.querySelector(props.reference) : triggerEl.value;
      popperEl.value = props.popover ? document.querySelector(props.popover) : popperEl.value;
      const config = getConfig();
      setPopper(triggerEl.value, popperEl.value, config);
    };
    watchEffect(() => {
      if (props.modelValue) {
        nextTick(() => {
          popperSetup();
          setTimeout(openPopper, 0);
          setTimeout(() => {
            popperEl.value.classList.add("show");
            if (props.hover) {
              on(popperEl.value, "mouseover", onMouseOver);
              on(popperEl.value, "mouseout", onMouseOut);
            }
          }, 0);
        });
      } else {
        if (!isPopperActive.value) {
          return;
        }
        setTimeout(() => {
          off(popperEl.value, "mouseover", onMouseOver);
          off(popperEl.value, "mouseout", onMouseOut);
          popperEl.value.classList.remove("show");
        }, 0);
        setTimeout(closePopper, 0);
        destroyPopper();
      }
    });
    const isActive = computed(() => {
      if (props.modelValue || !props.modelValue && isPopperActive.value) {
        return true;
      } else if (!props.modelValue && !isPopperActive.value) {
        return false;
      }
      return false;
    });
    const onMouseOver = () => {
      emit("update:modelValue", true);
    };
    const onMouseOut = () => {
      emit("update:modelValue", false);
    };
    const handleClickOutside = () => {
      if (!props.dismissible || !props.modelValue) {
        return;
      }
      emit("update:modelValue", false);
    };
    const destroy2 = () => {
      off(triggerEl.value, "mouseover", onMouseOver);
      off(triggerEl.value, "mouseout", onMouseOut);
      destroyPopper();
    };
    onMounted(() => {
      if (props.hover) {
        on(triggerEl.value, "mouseover", onMouseOver);
        on(triggerEl.value, "mouseout", onMouseOut);
      }
    });
    onUnmounted(() => {
      destroy2();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          ref_key: "triggerEl",
          ref: triggerEl,
          style: { "display": "inline-block" },
          tabindex: __props.dismissible ? 0 : null
        }, _ctx.$attrs), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "reference")
          ]),
          _: 3
        }, 16, ["tabindex"])), [
          [unref(vMdbClickOutside), handleClickOutside]
        ]),
        createVNode(Transition, null, {
          default: withCtx(() => [
            unref(isActive) && (_ctx.$slots.header || _ctx.$slots.body) ? (openBlock(), createElementBlock("div", {
              key: 0,
              ref_key: "popperEl",
              ref: popperEl,
              class: normalizeClass({ popover: true, fade: true }),
              style: normalizeStyle([unref(widthStyle)])
            }, [
              _ctx.$slots.header ? (openBlock(), createElementBlock("div", _hoisted_1$B, [
                renderSlot(_ctx.$slots, "header")
              ])) : createCommentVNode("", true),
              _ctx.$slots.body ? (openBlock(), createElementBlock("div", _hoisted_2$u, [
                renderSlot(_ctx.$slots, "body")
              ])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "default"),
              __props.arrow ? (openBlock(), createElementBlock("div", _hoisted_3$n)) : createCommentVNode("", true)
            ], 4)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 64);
    };
  }
});
const _sfc_main$1d = /* @__PURE__ */ defineComponent({
  __name: "MDBModalHeader",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    close: {
      type: Boolean,
      default: true
    },
    closeWhite: {
      type: Boolean,
      default: false
    },
    color: String
  },
  setup(__props) {
    const props = __props;
    const closeModal = inject("closeModal");
    const className = computed(() => {
      return ["modal-header", props.color && `bg-${props.color}`];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          __props.close ? (openBlock(), createBlock(_sfc_main$1A, {
            key: 0,
            white: __props.closeWhite,
            onClick: withModifiers(unref(closeModal), ["prevent"])
          }, null, 8, ["white", "onClick"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1c = /* @__PURE__ */ defineComponent({
  __name: "MDBModalTitle",
  props: {
    tag: {
      type: String,
      default: "h5"
    },
    bold: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return ["modal-title", props.bold && "font-weight-bold"];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1b = /* @__PURE__ */ defineComponent({
  __name: "MDBModalBody",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const className = computed(() => ["modal-body"]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$1a = /* @__PURE__ */ defineComponent({
  __name: "MDBModalFooter",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const className = computed(() => ["modal-footer"]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$19 = /* @__PURE__ */ defineComponent({
  __name: "MDBAccordion",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    modelValue: String,
    stayOpen: Boolean,
    flush: Boolean,
    classes: String,
    borderless: Boolean
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const accordionRef = ref(null);
    const className = computed(() => {
      return [
        "accordion",
        props.flush && "accordion-flush",
        props.classes,
        props.borderless && "accordion-borderless"
      ];
    });
    const activeItem = ref(props.modelValue);
    const setActiveItem = (item) => {
      activeItem.value = item;
      emit("update:modelValue", item);
    };
    watchEffect(() => activeItem.value = props.modelValue);
    provide("activeItem", activeItem);
    provide("stayOpen", props.stayOpen);
    provide("setActiveItem", setActiveItem);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        ref_key: "accordionRef",
        ref: accordionRef
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$A = ["aria-controls"];
const _sfc_main$18 = /* @__PURE__ */ defineComponent({
  __name: "MDBAccordionItem",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    collapseId: {
      type: String,
      required: true
    },
    headerTitle: String,
    headerClasses: String,
    bodyClasses: String,
    itemClasses: String,
    icon: String
  },
  setup(__props) {
    const props = __props;
    const itemRef = ref(null);
    const itemClassName = computed(() => {
      return ["accordion-item", props.itemClasses];
    });
    const headerClassName = computed(() => {
      return ["accordion-header", props.headerClasses];
    });
    const bodyClassName = computed(() => {
      return ["accordion-body", props.bodyClasses];
    });
    const buttonClassName = computed(() => {
      return ["accordion-button", !isActive.value && "collapsed"];
    });
    const icon = computed(() => {
      return props.icon ? [props.icon] : false;
    });
    const setActiveItem = inject(
      "setActiveItem",
      null
    );
    const activeItem = inject("activeItem", null);
    const stayOpen = inject("stayOpen", false);
    const isActive = ref(activeItem.value === props.collapseId);
    watchEffect(() => {
      if (stayOpen) {
        return;
      }
      isActive.value = activeItem.value === props.collapseId;
    });
    const toggleAccordion = () => {
      if (stayOpen) {
        isActive.value = !isActive.value;
      } else {
        isActive.value ? setActiveItem("") : setActiveItem(props.collapseId);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(itemClassName)),
        ref_key: "itemRef",
        ref: itemRef
      }, {
        default: withCtx(() => [
          createElementVNode("h2", {
            class: normalizeClass(unref(headerClassName))
          }, [
            createElementVNode("button", {
              onClick: toggleAccordion,
              class: normalizeClass(unref(buttonClassName)),
              "aria-expanded": "true",
              "aria-controls": __props.collapseId
            }, [
              unref(icon) ? (openBlock(), createElementBlock("i", {
                key: 0,
                class: normalizeClass(unref(icon))
              }, null, 2)) : createCommentVNode("", true),
              createTextVNode(toDisplayString(__props.headerTitle), 1)
            ], 10, _hoisted_1$A)
          ], 2),
          createVNode(_sfc_main$1k, {
            id: __props.collapseId,
            modelValue: isActive.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isActive.value = $event)
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(bodyClassName))
              }, [
                renderSlot(_ctx.$slots, "default")
              ], 2)
            ]),
            _: 3
          }, 8, ["id", "modelValue"])
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$17 = /* @__PURE__ */ defineComponent({
  __name: "MDBIcon",
  props: {
    iconStyle: {
      type: String,
      default: "fas"
    },
    icon: String,
    flag: String,
    size: String,
    fw: Boolean,
    solid: Boolean
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        !props.flag && props.iconStyle,
        props.flag ? `flag flag-${props.flag}` : `fa-${props.icon}`,
        props.size && `fa-${props.size}`,
        props.fw && "fa-fw",
        props.solid && "fa-solid"
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("i", {
        class: normalizeClass(unref(className))
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
function MDBFocusTrap() {
  const trapElement = ref(null);
  const firstFocusableElement = ref(null);
  const lastFocusableElement = ref(null);
  function initFocusTrap(element) {
    trapElement.value = element;
    calculateFocusTrap();
    on(window, "keydown", focusFirstElement);
    return true;
  }
  function calculateFocusTrap() {
    const focusable = Array.from(
      trapElement.value.querySelectorAll(
        'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => {
      const shouldFocus = el instanceof HTMLAnchorElement ? true : !el.disabled;
      return !el.classList.contains("ps__thumb-x") && !el.classList.contains("ps__thumb-y") && shouldFocus;
    });
    if (focusable.length === 0)
      return;
    firstFocusableElement.value = focusable[0];
    lastFocusableElement.value = focusable[focusable.length - 1];
    on(
      lastFocusableElement.value,
      "keydown",
      (e) => handleLastElementKeydown(e)
    );
  }
  function handleLastElementKeydown(e) {
    if (e.key === "Tab") {
      e.preventDefault();
      focusTrap();
    }
  }
  function focusTrap() {
    if (!firstFocusableElement.value)
      return;
    firstFocusableElement.value.focus();
  }
  function focusFirstElement(e, trap = false) {
    if (e.key === "Tab") {
      e.preventDefault();
      focusTrap();
    }
    if (trap)
      return;
    off(window, "keydown", focusFirstElement);
  }
  function removeFocusTrap() {
    off(lastFocusableElement.value, "keydown", handleLastElementKeydown);
  }
  return {
    initFocusTrap,
    removeFocusTrap
  };
}
function useMDBModal(props, emit) {
  const root = ref("root");
  const dialog = ref("dialog");
  const dialogTransform = ref("");
  const focusTrap = ref(null);
  const isActive = ref(props.modelValue);
  const thisElement = ref(null);
  watchEffect(() => {
    isActive.value = props.modelValue;
    if (isActive.value) {
      emit("update:modelValue", true);
    }
  });
  const wrapperClass = computed(() => {
    return [
      "modal",
      props.animation && "fade",
      isActive.value && "show",
      props.staticBackdrop && "modal-static"
    ];
  });
  const dialogClass = computed(() => {
    return [
      "modal-dialog",
      props.size && "modal-" + props.size,
      props.centered && "modal-dialog-centered",
      props.scrollable && "modal-dialog-scrollable",
      props.fullscreen && fullscreenClass.value,
      props.dialogClasses
    ];
  });
  const backdropStyle = computed(() => {
    return props.removeBackdrop ? false : { "background-color": `rgba(0,0,0, 0.5)` };
  });
  const shouldOverflow = ref(false);
  const backdropOverflowStyle = computed(() => {
    if (shouldOverflow.value || props.keepOverflow) {
      return;
    }
    return "overflow: hidden";
  });
  const computedContentStyle = computed(() => {
    return props.bgSrc ? { "background-image": `url("${props.bgSrc}")` } : null;
  });
  const fullscreenClass = computed(() => {
    if (!props.fullscreen) {
      return false;
    }
    return [
      props.fullscreen !== true ? `modal-fullscreen-${props.fullscreen}` : "modal-fullscreen"
    ];
  });
  const animateStaticBackdrop = () => {
    if (typeof dialog.value !== "string") {
      animateStaticModal(dialog.value);
    }
  };
  const closeModal = () => {
    emit("update:modelValue", false);
  };
  provide("closeModal", closeModal);
  const animateStaticModal = (el) => {
    el.style.transform = `scale(1.02)`;
    setTimeout(() => el.style.transform = `scale(1.0)`, 300);
  };
  const handleEscKeyUp = (e) => {
    if (e.key === "Escape" && isActive.value) {
      closeModal();
    }
  };
  const isBodyOverflowing = ref(null);
  const scrollbarWidth = ref(0);
  const getScrollbarWidth = () => {
    const scrollDiv = document.createElement("div");
    scrollDiv.className = "modal-scrollbar-measure";
    document.body.appendChild(scrollDiv);
    const scrollbarWidth2 = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth2;
  };
  const setScrollbar = () => {
    const rect = document.body.getBoundingClientRect();
    isBodyOverflowing.value = Math.round(rect.left + rect.right) < window.innerWidth;
    scrollbarWidth.value = isBodyOverflowing.value ? Number(getScrollbarWidth().toFixed(2)) : 0;
  };
  const enter = (el) => {
    shouldOverflow.value = false;
    dialogTransform.value = "translate(0, -25%)";
    const child = el.childNodes[0];
    child.style.transform = dialogTransform.value;
    el.style.opacity = "0";
    el.style.display = "block";
    setScrollbar();
    document.body.style.paddingRight = `${scrollbarWidth.value}px`;
    el.style.paddingRight = `${scrollbarWidth.value}px`;
    document.body.classList.add("modal-open");
    emit("show", root.value);
  };
  const afterEnter = (el) => {
    var _a;
    const child = el.childNodes[0];
    child.style.transform = "translate(0,0)";
    el.style.opacity = "1";
    setTimeout(() => {
      shouldOverflow.value = true;
      emit("shown", root.value);
    }, 400);
    thisElement.value = root.value;
    if (props.keyboard) {
      on(window, "keyup", handleEscKeyUp);
    }
    if (props.focus) {
      focusTrap.value = MDBFocusTrap();
      (_a = focusTrap.value) == null ? void 0 : _a.initFocusTrap(root.value);
    }
  };
  const beforeLeave = (el) => {
    const child = el.childNodes[0];
    child.style.transform = dialogTransform.value;
    el.style.opacity = "0";
    setTimeout(() => {
      el.style.paddingRight = "";
      document.body.style.paddingRight = "";
      document.body.classList.remove("modal-open");
    }, 200);
    emit("hide", thisElement.value);
    if (props.keyboard) {
      off(window, "keyup", handleEscKeyUp);
    }
    if (props.focus && focusTrap.value) {
      focusTrap.value.removeFocusTrap();
    }
  };
  const afterLeave = () => {
    emit("hidden", thisElement.value);
    shouldOverflow.value = false;
  };
  onBeforeUnmount(() => {
    off(window, "keyup", handleEscKeyUp);
  });
  return {
    wrapperClass,
    dialogClass,
    backdropStyle,
    backdropOverflowStyle,
    computedContentStyle,
    root,
    dialog,
    isActive,
    closeModal,
    animateStaticBackdrop,
    enter,
    afterEnter,
    beforeLeave,
    afterLeave,
    scrollbarWidth,
    setScrollbar,
    shouldOverflow,
    thisElement,
    handleEscKeyUp,
    focusTrap,
    dialogTransform,
    animateStaticModal,
    fullscreenClass
  };
}
const _sfc_main$16 = /* @__PURE__ */ defineComponent({
  __name: "MDBModal",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    modelValue: Boolean,
    size: {
      type: String,
      validator: (value) => ["sm", "lg", "xl"].indexOf(value.toLowerCase()) > -1
    },
    removeBackdrop: {
      type: Boolean,
      default: false
    },
    staticBackdrop: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    bgSrc: {
      type: String,
      default: ""
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 400
    },
    labelledby: String,
    fullscreen: {
      type: [Boolean, String],
      default: false
    },
    animation: {
      type: Boolean,
      default: true
    },
    dialogClasses: {
      type: String
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    focus: {
      type: Boolean,
      default: true
    }
  },
  emits: [
    "show",
    "shown",
    "hide",
    "hidden",
    "update:modelValue"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const {
      wrapperClass,
      dialogClass,
      backdropStyle,
      backdropOverflowStyle,
      computedContentStyle,
      root,
      dialog,
      isActive,
      closeModal,
      animateStaticBackdrop,
      enter,
      afterEnter,
      beforeLeave,
      afterLeave
    } = useMDBModal(props, emit);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        onEnter: unref(enter),
        onAfterEnter: unref(afterEnter),
        onBeforeLeave: unref(beforeLeave),
        onAfterLeave: unref(afterLeave)
      }, {
        default: withCtx(() => [
          unref(isActive) ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
            key: 0,
            ref_key: "root",
            ref: root,
            class: normalizeClass(unref(wrapperClass)),
            style: normalizeStyle([unref(backdropStyle), unref(backdropOverflowStyle)]),
            "aria-hidden": !unref(isActive),
            "aria-modal": unref(isActive) ? true : null,
            "aria-labelledby": __props.labelledby,
            role: "dialog",
            onClick: _cache[0] || (_cache[0] = withModifiers(
              () => {
                if (__props.staticBackdrop) {
                  unref(animateStaticBackdrop)();
                } else {
                  unref(closeModal)();
                }
              },
              ["self"]
            ))
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(dialogClass)),
                role: "document",
                ref_key: "dialog",
                ref: dialog
              }, [
                createElementVNode("div", {
                  class: "modal-content",
                  style: normalizeStyle(unref(computedContentStyle))
                }, [
                  renderSlot(_ctx.$slots, "default")
                ], 4)
              ], 2)
            ]),
            _: 3
          }, 8, ["class", "style", "aria-hidden", "aria-modal", "aria-labelledby"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["onEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"]);
    };
  }
});
const _sfc_main$15 = /* @__PURE__ */ defineComponent({
  __name: "MDBNavbar",
  props: {
    tag: {
      type: String,
      default: "nav"
    },
    bg: String,
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    double: {
      type: Boolean,
      default: false
    },
    expand: String,
    position: String,
    transparent: {
      type: Boolean,
      default: false
    },
    scrolling: {
      type: Boolean,
      default: false
    },
    scrollingOffset: {
      type: Number,
      default: 100
    },
    center: {
      type: Boolean,
      default: false
    },
    container: {
      type: [Boolean, String],
      default: false
    },
    classContainer: String,
    classNavbar: String
  },
  setup(__props) {
    const props = __props;
    const navClass = computed(() => {
      return [
        "navbar",
        props.dark && "navbar-dark",
        props.light && "navbar-light",
        props.bg && !props.transparent ? `bg-${props.bg}` : "",
        props.expand ? props.expand === "small" || props.expand === "sm" ? "navbar-expand-sm" : props.expand === "medium" || props.expand === "md" ? "navbar-expand-md" : props.expand === "large" || props.expand === "lg" ? "navbar-expand-lg" : "navbar-expand-xl" : "",
        props.position === "top" ? "fixed-top" : props.position === "bottom" ? "fixed-bottom" : props.position === "sticky" ? "sticky-top" : "",
        props.scrolling && scrollingClass.value,
        props.double && "double-nav",
        props.center && "justify-content-center",
        props.classNavbar
      ];
    });
    const containerClass = computed(() => {
      if (!props.container) {
        return false;
      }
      return [
        props.container !== true ? `container-${props.container}` : "container-fluid",
        props.classContainer && props.classContainer
      ];
    });
    const scrollingClass = ref("navbar-scroll");
    const handleScroll = () => {
      if (window.pageYOffset > props.scrollingOffset) {
        scrollingClass.value = "navbar-scroll navbar-scrolled";
      } else {
        scrollingClass.value = "navbar-scroll";
      }
    };
    const navbar = ref(null);
    const navbarFlexWrapValue = ref("nowrap");
    provide("navbarFlexWrapValue", navbarFlexWrapValue);
    const handleResize = () => {
      if (!navbar.value)
        return;
      const wrap = getComputedStyle(navbar.value).flexWrap;
      if (wrap === "nowrap") {
        navbarFlexWrapValue.value = "nowrap";
      } else if (wrap === "wrap") {
        navbarFlexWrapValue.value = "wrap";
      }
    };
    onMounted(() => {
      if (getComputedStyle(navbar.value) && getComputedStyle(navbar.value).flexWrap === "wrap") {
        navbarFlexWrapValue.value = "wrap";
      } else {
        navbarFlexWrapValue.value = "nowrap";
      }
      window.addEventListener("resize", () => handleResize());
      if (props.scrolling) {
        window.addEventListener("scroll", handleScroll);
      }
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "navbar",
        ref: navbar,
        class: normalizeClass(unref(navClass)),
        role: "navigation"
      }, {
        default: withCtx(() => [
          __props.container ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(containerClass))
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)) : createCommentVNode("", true),
          !__props.container ? renderSlot(_ctx.$slots, "default", { key: 1 }) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$14 = /* @__PURE__ */ defineComponent({
  __name: "MDBNavbarBrand",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const props = __props;
    const attrs = useAttrs();
    const isLink = computed(() => attrs.href ? "a" : props.tag);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(isLink)), { class: "navbar-brand" }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      });
    };
  }
});
const _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "MDBNavbarNav",
  props: {
    tag: {
      type: String,
      default: "ul"
    },
    right: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    justifyAround: {
      type: Boolean,
      default: false
    },
    class: String,
    nav: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        props.nav ? "nav" : "navbar-nav",
        props.right ? "ms-auto" : props.center ? "justify-content-center w-100" : props.vertical ? "flex-column" : props.justifyAround ? "justify-content-around w-100" : "me-auto",
        props.class && `${props.class}`
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$z = ["href", "target"];
const _sfc_main$12 = /* @__PURE__ */ defineComponent({
  __name: "MDBNavbarItem",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    exact: {
      type: Boolean,
      default: false
    },
    newTab: {
      type: Boolean,
      default: false
    },
    to: [Object, String],
    href: String,
    linkClass: String
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return ["nav-item", !props.to && !props.href && props.active && "active"];
    });
    const linkClassName = computed(() => {
      return [
        "nav-link",
        props.disabled && "disabled",
        props.active && "active",
        props.linkClass
      ];
    });
    const tab = computed(() => {
      if (props.newTab) {
        return "_blank";
      }
      return "";
    });
    return (_ctx, _cache) => {
      const _component_router_link = resolveComponent("router-link");
      return openBlock(), createBlock(resolveDynamicComponent(props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          __props.to ? (openBlock(), createBlock(_component_router_link, {
            key: 0,
            class: normalizeClass(unref(linkClassName)),
            exact: __props.exact,
            to: __props.to,
            target: unref(tab)
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["class", "exact", "to", "target"])) : __props.href ? (openBlock(), createElementBlock("a", {
            key: 1,
            href: __props.href,
            class: normalizeClass(unref(linkClassName)),
            target: unref(tab)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 10, _hoisted_1$z)) : renderSlot(_ctx.$slots, "default", { key: 2 })
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "MDBPagination",
  props: {
    tag: {
      type: String,
      default: "ul"
    },
    circle: {
      type: Boolean,
      default: false
    },
    lg: {
      type: Boolean,
      default: false
    },
    sm: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        "pagination",
        props.sm && "pagination-sm",
        props.lg && "pagination-lg",
        props.circle && "pagination-circle"
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$y = ["href", "tabindex", "aria-disabled"];
const _hoisted_2$t = { "aria-hidden": "true" };
const _hoisted_3$m = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "Previous", -1);
const _hoisted_4$j = ["href", "tabindex", "aria-disabled"];
const _hoisted_5$g = { "aria-hidden": "true" };
const _hoisted_6$e = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "Next", -1);
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "MDBPageNav",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: "#"
    },
    prev: {
      type: Boolean,
      default: false
    },
    next: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => ["page-item", props.disabled && "disabled"]);
    const prevValue = computed(() => props.icon ? "\xAB" : "Previous");
    const nextValue = computed(() => props.icon ? "\xBB" : "Next");
    const disabledTabindex = computed(() => props.disabled ? "-1" : "false");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          __props.prev ? (openBlock(), createElementBlock("a", {
            key: 0,
            class: "page-link",
            href: __props.href,
            tabindex: unref(disabledTabindex),
            "aria-disabled": __props.disabled,
            "aria-label": "Previous"
          }, [
            createElementVNode("span", _hoisted_2$t, toDisplayString(unref(prevValue)), 1),
            _hoisted_3$m
          ], 8, _hoisted_1$y)) : createCommentVNode("", true),
          __props.next ? (openBlock(), createElementBlock("a", {
            key: 1,
            class: "page-link",
            href: __props.href,
            tabindex: unref(disabledTabindex),
            "aria-disabled": __props.disabled,
            "aria-label": "Next"
          }, [
            createElementVNode("span", _hoisted_5$g, toDisplayString(unref(nextValue)), 1),
            _hoisted_6$e
          ], 8, _hoisted_4$j)) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$x = ["href", "aria-label", "aria-disabled", "tabindex"];
const _hoisted_2$s = {
  key: 0,
  "aria-hidden": "true"
};
const _hoisted_3$l = {
  key: 1,
  class: "sr-only"
};
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "MDBPageItem",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    href: String,
    icon: {
      type: Boolean,
      defaul: false
    },
    label: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return ["page-item", props.active && "active", props.disabled && "disabled"];
    });
    const labelValue = computed(() => {
      return props.icon && props.label ? props.label : props.href;
    });
    const disabledTabindex = computed(() => {
      return props.disabled ? "-1" : " false";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          createElementVNode("a", {
            class: "page-link",
            href: __props.href,
            "aria-label": unref(labelValue),
            "aria-disabled": __props.disabled,
            tabindex: unref(disabledTabindex)
          }, [
            __props.icon ? (openBlock(), createElementBlock("span", _hoisted_2$s, [
              renderSlot(_ctx.$slots, "default")
            ])) : createCommentVNode("", true),
            __props.icon ? (openBlock(), createElementBlock("span", _hoisted_3$l, toDisplayString(unref(labelValue)), 1)) : renderSlot(_ctx.$slots, "default", { key: 2 })
          ], 8, _hoisted_1$x)
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "MDBBreadcrumb",
  props: {
    tag: {
      type: String,
      default: "ol"
    }
  },
  setup(__props) {
    const className = computed(() => ["breadcrumb"]);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  __name: "MDBBreadcrumbItem",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    active: {
      type: Boolean,
      default: false
    },
    current: {
      type: String,
      default: "page"
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => ["breadcrumb-item", props.active && "active"]);
    const currentName = computed(() => props.active && props.current);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className)),
        "aria-current": unref(currentName)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "aria-current"]);
    };
  }
});
const _sfc_main$Y = /* @__PURE__ */ defineComponent({
  __name: "MDBFooter",
  props: {
    tag: {
      type: String,
      default: "footer"
    },
    bg: {
      type: String,
      default: "light"
    },
    text: [String, Array]
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      const text = props.text;
      return [
        props.bg && props.bg !== "none" && `bg-${props.bg}`,
        props.text && spreadProps(text)
      ];
    });
    const spreadProps = (props2) => {
      if (typeof props2 === "string") {
        return `text-${props2}`;
      }
      return props2.map((prop) => `text-${prop}`.trim()).join(" ");
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "MDBTabs",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    modelValue: String,
    vertical: {
      type: [Boolean, String],
      default: false
    }
  },
  emits: [
    "update:modelValue",
    "hide",
    "hidden",
    "show",
    "shown"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const prevTab = ref(null);
    const activeTab = ref(null);
    const activeTabId = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (cur) => {
        if (cur !== activeTabId.value) {
          activeTabId.value = cur;
          updateActiveTab(null, cur);
        }
      }
    );
    const updateActiveTab = (element, tabId) => {
      if (!element) {
        element = document.body.querySelector(`#tab-${tabId}`);
      }
      if (prevTab.value) {
        emit("hide", { target: prevTab.value, relatedTarget: element });
      }
      emit("show", { target: element, relatedTarget: prevTab.value });
      emit("update:modelValue", tabId);
      activeTab.value = element;
      activeTabId.value = tabId;
    };
    const emitShown = () => {
      emit("shown", { target: activeTab.value, relatedTarget: prevTab.value });
      prevTab.value = activeTab.value;
    };
    const emitHidden = () => {
      emit("hidden", {
        target: prevTab.value,
        relatedTarget: activeTab.value
      });
    };
    provide("activeTab", activeTabId);
    provide("updateActiveTab", updateActiveTab);
    provide("emitShown", emitShown);
    provide("emitHidden", emitHidden);
    const isVertical = ref(false);
    const windowWidth = ref(window.innerWidth);
    const activeBrakpointValue = ref(null);
    provide("isVertical", isVertical);
    const handleWindowResize = () => {
      windowWidth.value = window.innerWidth;
      const breakpointValue = handleBreakpoints(windowWidth.value, [
        "column",
        props.vertical
      ]);
      if (breakpointValue === activeBrakpointValue.value)
        return;
      isVertical.value = breakpointValue === props.vertical ? true : false;
      activeBrakpointValue.value = breakpointValue;
    };
    onMounted(() => {
      if (!props.vertical)
        return;
      if (props.vertical === true) {
        isVertical.value = true;
      } else {
        handleWindowResize();
        on(window, "resize", handleWindowResize);
      }
    });
    onUnmounted(() => {
      off(window, "resize", handleWindowResize);
    });
    return (_ctx, _cache) => {
      return isVertical.value ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 0,
        class: "row"
      }, _ctx.$attrs), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16)) : renderSlot(_ctx.$slots, "default", { key: 1 });
    };
  }
});
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "MDBTabNav",
  props: {
    tag: {
      type: String,
      default: "ul"
    },
    pills: Boolean,
    justify: Boolean,
    fill: Boolean,
    tabsClasses: String,
    col: {
      type: String,
      default: "3"
    }
  },
  setup(__props) {
    const props = __props;
    const isVertical = inject("isVertical");
    const className = computed(() => {
      return [
        "nav",
        props.pills ? "nav-pills" : "nav-tabs",
        props.justify && "nav-justified",
        props.fill && "nav-fill",
        isVertical.value && "flex-column",
        props.tabsClasses && props.tabsClasses
      ];
    });
    const columnClassName = computed(() => {
      return [`col-${props.col}`];
    });
    return (_ctx, _cache) => {
      return unref(isVertical) ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(columnClassName))
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
          class: normalizeClass(unref(className))
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"]))
      ], 2)) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        key: 1,
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]));
    };
  }
});
const _hoisted_1$w = {
  key: 0,
  class: "nav-item",
  role: "presentation"
};
const _hoisted_2$r = ["id", "aria-controls", "href", "onClick"];
const __default__$m = {
  inheritAttrs: false
};
const _sfc_main$V = /* @__PURE__ */ defineComponent({
  ...__default__$m,
  __name: "MDBTabItem",
  props: {
    tag: {
      type: String,
      default: "a"
    },
    tabId: {
      type: String,
      required: true
    },
    href: String
  },
  setup(__props) {
    const props = __props;
    const item = ref(null);
    const className = computed(() => ["nav-link", isActive.value && "active"]);
    const uid2 = computed(() => `tab-${props.tabId}`);
    const controls = computed(() => `${props.tabId}`);
    const activeTabId = inject("activeTab");
    const isActive = ref(activeTabId && activeTabId.value === props.tabId);
    const updateActiveTab = inject("updateActiveTab");
    watchEffect(
      () => isActive.value = activeTabId && activeTabId.value === props.tabId
    );
    const handleClick = () => {
      updateActiveTab(item.value, props.tabId);
    };
    onMounted(() => {
      if (isActive.value && updateActiveTab) {
        updateActiveTab(item.value, props.tabId);
      }
    });
    return (_ctx, _cache) => {
      return __props.href ? (openBlock(), createElementBlock("li", _hoisted_1$w, [
        createElementVNode("a", mergeProps({
          id: unref(uid2),
          ref_key: "item",
          ref: item,
          class: unref(className),
          role: "tab",
          "aria-controls": unref(controls),
          href: __props.href
        }, _ctx.$attrs, {
          onClick: withModifiers(handleClick, ["prevent"])
        }), [
          renderSlot(_ctx.$slots, "default")
        ], 16, _hoisted_2$r)
      ])) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 1,
        id: unref(uid2),
        ref_key: "item",
        ref: item,
        class: unref(className),
        role: "tab",
        "aria-controls": unref(controls)
      }, _ctx.$attrs, {
        onClick: withModifiers(handleClick, ["prevent"])
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "class", "aria-controls", "onClick"]));
    };
  }
});
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "MDBTabPane",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    tabId: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const item = ref(null);
    const className = computed(() => [
      "tab-pane fade",
      isActive.value && "show active"
    ]);
    const uid2 = computed(() => `${props.tabId}`);
    const labelledby = computed(() => `tab-${props.tabId}`);
    const activeTabId = inject("activeTab");
    const isActive = ref(activeTabId && activeTabId.value === props.tabId);
    watchEffect(
      () => isActive.value = activeTabId && activeTabId.value === props.tabId
    );
    const emitShown = inject("emitShown");
    const emitHidden = inject("emitHidden");
    onMounted(() => {
      if (isActive.value && emitShown) {
        emitShown(props.tabId);
      }
    });
    const afterEnter = (el) => {
      el.style.opacity = "1";
    };
    const enter = (el) => {
      el.style.opacity = "0";
      emitShown(props.tabId);
    };
    const beforeLeave = (el) => {
      el.style.opacity = "1";
      emitHidden(props.tabId);
    };
    const afterLeave = (el) => {
      el.style.opacity = "0";
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        duration: 150,
        onEnter: enter,
        onAfterEnter: afterEnter,
        onBeforeLeave: beforeLeave,
        onAfterLeave: afterLeave
      }, {
        default: withCtx(() => [
          withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
            id: unref(uid2),
            ref_key: "item",
            ref: item,
            class: normalizeClass(unref(className)),
            role: "tabpanel",
            "aria-labelledby": unref(labelledby)
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["id", "class", "aria-labelledby"])), [
            [vShow, isActive.value]
          ])
        ]),
        _: 3
      });
    };
  }
});
const __default__$l = {
  inheritAttrs: false
};
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  ...__default__$l,
  __name: "MDBTabContent",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    col: {
      type: String,
      default: "9"
    },
    contentClasses: String
  },
  setup(__props) {
    const props = __props;
    const isVertical = inject("isVertical", false);
    const className = computed(() => {
      return ["tab-content", props.contentClasses && props.contentClasses];
    });
    const columnClassName = computed(() => {
      return [`col-${props.col}`];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(KeepAlive, null, [
        unref(isVertical) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(unref(columnClassName))
        }, [
          (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({ class: unref(className) }, _ctx.$attrs), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16, ["class"]))
        ], 2)) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          key: 1,
          class: unref(className)
        }, _ctx.$attrs), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"]))
      ], 1024);
    };
  }
});
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "MDBCol",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    col: String,
    sm: String,
    md: String,
    lg: String,
    xl: String,
    offset: String,
    offsetSm: String,
    offsetMd: String,
    offsetLg: String,
    offsetXl: String,
    auto: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        props.col ? "col-" + props.col : "",
        props.sm ? "col-sm-" + props.sm : "",
        props.md ? "col-md-" + props.md : "",
        props.lg ? "col-lg-" + props.lg : "",
        props.xl ? "col-xl-" + props.xl : "",
        !props.col && !props.sm && !props.md && !props.lg && !props.xl ? "col" : "",
        props.offset ? "offset-" + props.offset : "",
        props.offsetSm ? "offset-sm-" + props.offsetSm : "",
        props.offsetMd ? "offset-md-" + props.offsetMd : "",
        props.offsetLg ? "offset-lg-" + props.offsetLg : "",
        props.offsetXl ? "offset-xl-" + props.offsetXl : "",
        props.auto ? "col-auto" : ""
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "MDBRow",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    start: {
      type: Boolean,
      default: false
    },
    end: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    between: {
      type: Boolean,
      default: false
    },
    around: {
      type: Boolean,
      default: false
    },
    cols: [String, Array]
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      const columns = props.cols;
      return [
        "row",
        props.cols ? `${spreadProps(columns)}` : "",
        props.start && "justify-content-start",
        props.end && "justify-content-end",
        props.center && "justify-content-center",
        props.between && "justify-content-between",
        props.around && "justify-content-around"
      ];
    });
    const spreadProps = (props2) => {
      if (typeof props2 === "string") {
        return `row-cols-${props2}`;
      }
      return props2.map((prop) => `row-cols-${prop}`.trim()).join(" ");
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "MDBContainer",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    sm: {
      type: Boolean,
      default: false
    },
    md: {
      type: Boolean,
      default: false
    },
    lg: {
      type: Boolean,
      default: false
    },
    xl: {
      type: Boolean,
      default: false
    },
    xxl: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return [
        props.fluid ? "container-fluid" : "",
        props.sm ? "container-sm" : "",
        props.md ? "container-md" : "",
        props.lg ? "container-lg" : "",
        props.xl ? "container-xl" : "",
        props.xxl ? "container-xxl" : "",
        !props.fluid && !props.sm && !props.md && !props.lg && !props.xl && !props.xxl ? "container" : ""
      ];
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const __default__$k = {
  inheritAttrs: false
};
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  ...__default__$k,
  __name: "MDBTable",
  props: {
    tag: {
      type: String,
      default: "table"
    },
    variant: String,
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    border: {
      type: [Boolean, String],
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    align: String,
    sm: {
      type: Boolean,
      default: false
    },
    tableStyle: String,
    captionTop: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const wrapperClasses = computed(() => {
      if (!props.responsive) {
        return false;
      }
      return props.responsive !== true ? `table-responsive-${props.responsive}` : "table-responsive";
    });
    const borderClass = computed(() => {
      if (!props.border) {
        return "";
      }
      return props.border !== true ? `table-bordered border-${props.border}` : "table-bordered";
    });
    const tableClasses = computed(() => {
      return [
        "table",
        props.dark && "table-dark",
        props.light && "table-light",
        props.variant && `table-${props.variant}`,
        props.striped && "table-striped",
        borderClass.value,
        props.borderless && "table-borderless",
        props.hover && "table-hover",
        props.sm && "table-sm",
        props.align && props.align === "top" ? "align-top" : props.align === "bottom" ? "align-bottom" : props.align === "middle" ? "align-middle" : "",
        props.captionTop && "caption-top",
        props.tableStyle
      ];
    });
    return (_ctx, _cache) => {
      return __props.responsive ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(wrapperClasses))
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          class: unref(tableClasses),
          style: __props.tableStyle
        }, _ctx.$attrs), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["class", "style"]))
      ], 2)) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 1,
        class: unref(tableClasses),
        style: __props.tableStyle
      }, _ctx.$attrs), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "style"]));
    };
  }
});
const _hoisted_1$v = ["id", "value"];
const _hoisted_2$q = ["for"];
const _hoisted_3$k = {
  key: 2,
  class: "form-helper"
};
const _hoisted_4$i = {
  key: 3,
  class: "form-helper"
};
const _hoisted_5$f = { class: "form-counter" };
const _hoisted_6$d = {
  key: 7,
  class: "form-notch"
};
const _hoisted_7$b = /* @__PURE__ */ createElementVNode("div", { class: "form-notch-trailing" }, null, -1);
const _hoisted_8$9 = ["id", "value"];
const _hoisted_9$9 = ["for"];
const _hoisted_10$7 = {
  key: 1,
  class: "form-helper"
};
const _hoisted_11$4 = {
  key: 2,
  class: "form-helper"
};
const _hoisted_12$3 = { class: "form-counter" };
const _hoisted_13$3 = {
  key: 5,
  class: "form-notch"
};
const _hoisted_14$2 = /* @__PURE__ */ createElementVNode("div", { class: "form-notch-trailing" }, null, -1);
const _hoisted_15$2 = {
  key: 9,
  class: "form-text"
};
const __default__$j = {
  inheritAttrs: false
};
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  ...__default__$j,
  __name: "MDBInput",
  props: {
    id: String,
    label: String,
    labelClass: String,
    modelValue: [String, Number, Date],
    size: String,
    formOutline: {
      type: Boolean,
      default: true
    },
    wrapperClass: String,
    inputGroup: {
      type: [Boolean, String],
      default: false
    },
    wrap: {
      type: Boolean,
      default: true
    },
    formText: String,
    white: Boolean,
    validationEvent: String,
    isValidated: Boolean,
    isValid: Boolean,
    validFeedback: String,
    invalidFeedback: String,
    tooltipFeedback: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    },
    helper: String,
    counter: Boolean,
    maxlength: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:modelValue", "click-outside", "on-validate"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const attrs = useAttrs();
    const inputRef = ref(null);
    const inputValue = ref(props.modelValue);
    const labelRef = ref(null);
    const showPlaceholder = ref(false);
    const notchLeadingWidth = ref(9);
    const notchMiddleWidth = ref(0);
    const uid2 = props.id || getUID("MDBInput-");
    const wrapperClassName = computed(() => {
      return [
        props.formOutline && "form-outline",
        inputGroupClassName.value,
        props.white && "form-white",
        props.wrapperClass
      ];
    });
    const inputClassName = computed(() => {
      return [
        "form-control",
        props.size && `form-control-${props.size}`,
        inputValue.value && "active",
        showPlaceholder.value && "placeholder-active",
        isInputValidated.value && isInputValid.value && "is-valid",
        isInputValidated.value && !isInputValid.value && "is-invalid"
      ];
    });
    const labelClassName = computed(() => {
      return ["form-label", props.labelClass];
    });
    const inputGroupClassName = computed(() => {
      if (!props.inputGroup) {
        return;
      }
      return props.inputGroup !== true ? `input-group input-group-${props.inputGroup}` : "input-group";
    });
    const validationStyle = computed(() => {
      return props.inputGroup && isInputValidated.value ? { marginBottom: "1rem" } : "";
    });
    const validFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "valid-tooltip" : "valid-feedback";
    });
    const invalidFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "invalid-tooltip" : "invalid-feedback";
    });
    const isInputValidated = ref(props.isValidated);
    const isInputValid = ref(props.isValid);
    const defaultValidatorInvalidFeedback = ref("");
    const customInvalidFeedback = computed(() => {
      if (isInputValidated.value && !isInputValid.value && props.validationEvent) {
        return defaultValidatorInvalidFeedback.value;
      }
      return props.invalidFeedback;
    });
    const handleValidation = (e) => {
      const target = e.target;
      isInputValid.value = target.checkValidity();
      if (!isInputValid.value) {
        defaultValidatorInvalidFeedback.value = target.validationMessage;
      }
      isInputValidated.value = true;
      emit("on-validate", isInputValid.value);
    };
    const bindValidationEvents = () => {
      if (props.validationEvent === "submit")
        return;
      typeof inputRef.value !== "string" && on(inputRef.value, props.validationEvent, handleValidation);
    };
    function calcNotch() {
      if (labelRef.value) {
        notchMiddleWidth.value = labelRef.value.clientWidth * 0.8 + 8;
      }
    }
    function setPlaceholder() {
      if (attrs.placeholder && !labelRef.value) {
        showPlaceholder.value = true;
      } else {
        showPlaceholder.value = false;
      }
    }
    const currentLength = ref(null);
    currentLength.value = typeof inputValue.value === "string" && inputValue.value ? inputValue.value.length : 0;
    function handleInput(e) {
      const target = e.target;
      if (props.counter) {
        if (target.value.length > props.maxlength) {
          if (typeof inputValue.value === "string") {
            target.value = inputValue.value;
          }
          return;
        }
        currentLength.value = target.value.length;
      }
      inputValue.value = target.value;
      emit("update:modelValue", inputValue.value);
    }
    function clickOutside() {
      emit("click-outside");
    }
    const isTypeDate = attrs.type && attrs.type === "date";
    const checkDateType = (isFocused = false) => {
      if (!isTypeDate) {
        return;
      }
      if (typeof inputRef.value !== "string") {
        inputRef.value.type = isFocused ? "date" : "text";
      }
    };
    onMounted(() => {
      calcNotch();
      setPlaceholder();
      checkDateType();
      if (props.validationEvent) {
        bindValidationEvents();
      }
    });
    onUpdated(() => {
      calcNotch();
      setPlaceholder();
    });
    onUnmounted(() => {
      typeof inputRef.value !== "string" && off(inputRef.value, props.validationEvent, handleValidation);
    });
    watchEffect(() => {
      var _a, _b;
      if (props.counter) {
        if (typeof props.modelValue === "string") {
          if (((_a = props.modelValue) == null ? void 0 : _a.length) > props.maxlength) {
            inputValue.value = props.modelValue.slice(0, props.maxlength);
            currentLength.value = props.maxlength;
            return;
          }
          currentLength.value = ((_b = props.modelValue) == null ? void 0 : _b.length) || 0;
        }
      }
      inputValue.value = props.modelValue;
    });
    watch(
      () => props.isValidated,
      (value) => isInputValidated.value = value
    );
    watch(
      () => props.isValid,
      (value) => isInputValid.value = value
    );
    expose({
      inputRef
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !__props.wrap ? withDirectives((openBlock(), createElementBlock("input", mergeProps({
          key: 0,
          class: unref(inputClassName),
          id: unref(uid2),
          value: inputValue.value
        }, _ctx.$attrs, {
          onInput: handleInput,
          ref_key: "inputRef",
          ref: inputRef,
          onFocus: _cache[0] || (_cache[0] = ($event) => checkDateType(true)),
          onBlur: _cache[1] || (_cache[1] = ($event) => checkDateType())
        }), null, 16, _hoisted_1$v)), [
          [unref(vMdbClickOutside), clickOutside]
        ]) : createCommentVNode("", true),
        __props.label && !__props.wrap ? (openBlock(), createElementBlock("label", {
          key: 1,
          ref_key: "labelRef",
          ref: labelRef,
          class: normalizeClass(unref(labelClassName)),
          for: unref(uid2)
        }, toDisplayString(__props.label), 11, _hoisted_2$q)) : createCommentVNode("", true),
        !__props.wrap && __props.helper ? (openBlock(), createElementBlock("div", _hoisted_3$k, toDisplayString(__props.helper), 1)) : createCommentVNode("", true),
        !__props.wrap && __props.counter ? (openBlock(), createElementBlock("div", _hoisted_4$i, [
          createElementVNode("div", _hoisted_5$f, toDisplayString(currentLength.value) + " / " + toDisplayString(__props.maxlength), 1)
        ])) : createCommentVNode("", true),
        !__props.wrap ? renderSlot(_ctx.$slots, "default", { key: 4 }) : createCommentVNode("", true),
        !__props.wrap && __props.validFeedback ? (openBlock(), createElementBlock("div", {
          key: 5,
          class: normalizeClass(unref(validFeedbackClassName))
        }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
        !__props.wrap && unref(customInvalidFeedback) ? (openBlock(), createElementBlock("div", {
          key: 6,
          class: normalizeClass(unref(invalidFeedbackClassName))
        }, toDisplayString(unref(customInvalidFeedback)), 3)) : createCommentVNode("", true),
        !__props.wrap && __props.formOutline ? (openBlock(), createElementBlock("div", _hoisted_6$d, [
          createElementVNode("div", {
            class: "form-notch-leading",
            style: normalizeStyle({ width: `${notchLeadingWidth.value}px` })
          }, null, 4),
          createElementVNode("div", {
            class: "form-notch-middle",
            style: normalizeStyle({ width: `${notchMiddleWidth.value}px` })
          }, null, 4),
          _hoisted_7$b
        ])) : createCommentVNode("", true),
        __props.wrap ? withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
          key: 8,
          class: normalizeClass(unref(wrapperClassName)),
          style: normalizeStyle(unref(validationStyle))
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend"),
            createElementVNode("input", mergeProps({ class: unref(inputClassName) }, _ctx.$attrs, {
              id: unref(uid2),
              value: inputValue.value,
              onInput: handleInput,
              ref_key: "inputRef",
              ref: inputRef,
              onFocus: _cache[2] || (_cache[2] = ($event) => checkDateType(true)),
              onBlur: _cache[3] || (_cache[3] = ($event) => checkDateType())
            }), null, 16, _hoisted_8$9),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              ref_key: "labelRef",
              ref: labelRef,
              class: normalizeClass(unref(labelClassName)),
              for: unref(uid2)
            }, toDisplayString(__props.label), 11, _hoisted_9$9)) : createCommentVNode("", true),
            __props.helper ? (openBlock(), createElementBlock("div", _hoisted_10$7, toDisplayString(__props.helper), 1)) : createCommentVNode("", true),
            __props.counter ? (openBlock(), createElementBlock("div", _hoisted_11$4, [
              createElementVNode("div", _hoisted_12$3, toDisplayString(currentLength.value) + " / " + toDisplayString(__props.maxlength), 1)
            ])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "default"),
            __props.validFeedback ? (openBlock(), createElementBlock("div", {
              key: 3,
              class: normalizeClass(unref(validFeedbackClassName))
            }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
            unref(customInvalidFeedback) ? (openBlock(), createElementBlock("div", {
              key: 4,
              class: normalizeClass(unref(invalidFeedbackClassName))
            }, toDisplayString(unref(customInvalidFeedback)), 3)) : createCommentVNode("", true),
            __props.formOutline ? (openBlock(), createElementBlock("div", _hoisted_13$3, [
              createElementVNode("div", {
                class: "form-notch-leading",
                style: normalizeStyle({ width: `${notchLeadingWidth.value}px` })
              }, null, 4),
              createElementVNode("div", {
                class: "form-notch-middle",
                style: normalizeStyle({ width: `${notchMiddleWidth.value}px` })
              }, null, 4),
              _hoisted_14$2
            ])) : createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["class", "style"])), [
          [unref(vMdbClickOutside), clickOutside]
        ]) : createCommentVNode("", true),
        __props.formText ? (openBlock(), createElementBlock("div", _hoisted_15$2, toDisplayString(__props.formText), 1)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$u = ["id", "value", "rows"];
const _hoisted_2$p = ["for"];
const _hoisted_3$j = {
  key: 2,
  class: "form-helper"
};
const _hoisted_4$h = {
  key: 3,
  class: "form-helper"
};
const _hoisted_5$e = { class: "form-counter" };
const _hoisted_6$c = ["id", "value", "rows"];
const _hoisted_7$a = ["for"];
const _hoisted_8$8 = {
  key: 1,
  class: "form-helper"
};
const _hoisted_9$8 = {
  key: 2,
  class: "form-helper"
};
const _hoisted_10$6 = { class: "form-counter" };
const _hoisted_11$3 = {
  key: 5,
  class: "form-notch"
};
const _hoisted_12$2 = /* @__PURE__ */ createElementVNode("div", { class: "form-notch-trailing" }, null, -1);
const _hoisted_13$2 = {
  key: 8,
  class: "form-text"
};
const __default__$i = {
  inheritAttrs: false
};
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  ...__default__$i,
  __name: "MDBTextarea",
  props: {
    id: String,
    rows: {
      type: [String, Number],
      default: 4
    },
    label: String,
    modelValue: [String, Number],
    size: String,
    formOutline: {
      type: Boolean,
      default: true
    },
    wrapperClass: String,
    inputGroup: {
      type: [Boolean, String],
      default: false
    },
    wrap: {
      type: Boolean,
      default: true
    },
    formText: String,
    white: Boolean,
    validationEvent: String,
    isValidated: Boolean,
    isValid: Boolean,
    validFeedback: String,
    invalidFeedback: String,
    tooltipFeedback: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    },
    helper: String,
    counter: Boolean,
    maxLength: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:modelValue", "on-validate"],
  setup(__props, { emit }) {
    const props = __props;
    const attrs = useAttrs();
    const textareaRef = ref("textareaRef");
    const textareaValue = ref(props.modelValue);
    const labelRef = ref(null);
    const showPlaceholder = ref(false);
    const notchLeadingWidth = ref(9);
    const notchMiddleWidth = ref(0);
    const uid2 = props.id || getUID("MDBTextarea-");
    const wrapperClassName = computed(() => {
      return [
        props.formOutline && "form-outline",
        inputGroupClassName.value,
        props.white && "form-white",
        props.wrapperClass
      ];
    });
    const textareaClassName = computed(() => {
      return [
        "form-control",
        props.size && `form-control-${props.size}`,
        textareaValue.value && "active",
        showPlaceholder.value && "placeholder-active",
        isInputValidated.value && isInputValid.value && "is-valid",
        isInputValidated.value && !isInputValid.value && "is-invalid"
      ];
    });
    const inputGroupClassName = computed(() => {
      if (!props.inputGroup) {
        return;
      }
      return props.inputGroup !== true ? `input-group input-group-${props.inputGroup}` : "input-group";
    });
    const validationStyle = computed(() => {
      return props.inputGroup && isInputValidated.value ? { marginBottom: "1rem" } : "";
    });
    const validFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "valid-tooltip" : "valid-feedback";
    });
    const invalidFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "invalid-tooltip" : "invalid-feedback";
    });
    const isInputValidated = ref(props.isValidated);
    const isInputValid = ref(props.isValid);
    const defaultValidatorInvalidFeedback = ref("");
    const customInvalidFeedback = computed(() => {
      if (isInputValidated.value && !isInputValid.value && props.validationEvent) {
        return defaultValidatorInvalidFeedback.value;
      }
      return props.invalidFeedback;
    });
    const handleValidation = (e) => {
      const target = e.target;
      isInputValid.value = target.checkValidity();
      if (!isInputValid.value) {
        defaultValidatorInvalidFeedback.value = target.validationMessage;
      }
      isInputValidated.value = true;
      emit("on-validate", isInputValid.value);
    };
    const bindValidationEvents = () => {
      if (props.validationEvent === "submit")
        return;
      on(
        textareaRef.value,
        props.validationEvent,
        handleValidation
      );
    };
    function calcNotch() {
      if (labelRef.value) {
        notchMiddleWidth.value = labelRef.value.clientWidth * 0.8 + 8;
      }
    }
    function setPlaceholder() {
      if (attrs.placeholder && !labelRef.value) {
        showPlaceholder.value = true;
      } else {
        showPlaceholder.value = false;
      }
    }
    const currentLength = ref(null);
    currentLength.value = typeof textareaValue.value === "string" && textareaValue.value ? textareaValue.value.length : 0;
    function handleInput(e) {
      const target = e.target;
      if (props.counter) {
        if (target.value.length > props.maxLength) {
          if (typeof textareaValue.value === "string") {
            target.value = textareaValue.value;
          }
          return;
        }
        currentLength.value = target.value.length;
      }
      textareaValue.value = target.value;
      emit("update:modelValue", textareaValue.value);
    }
    onMounted(() => {
      calcNotch();
      setPlaceholder();
      if (props.validationEvent) {
        bindValidationEvents();
      }
    });
    onUpdated(() => {
      calcNotch();
      setPlaceholder();
    });
    onUnmounted(() => {
      off(
        textareaRef.value,
        props.validationEvent,
        handleValidation
      );
    });
    watchEffect(() => {
      var _a;
      if (props.counter) {
        if (typeof props.modelValue === "string" && ((_a = props.modelValue) == null ? void 0 : _a.length) > props.maxLength) {
          textareaValue.value = props.modelValue.slice(0, props.maxLength);
          currentLength.value = props.maxLength;
          return;
        }
        currentLength.value = typeof props.modelValue === "string" && props.modelValue ? props.modelValue.length : 0;
      }
      textareaValue.value = props.modelValue;
    });
    watch(
      () => props.isValidated,
      (value) => isInputValidated.value = value
    );
    watch(
      () => props.isValid,
      (value) => isInputValid.value = value
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !__props.wrap ? (openBlock(), createElementBlock("textarea", mergeProps({
          key: 0,
          class: unref(textareaClassName)
        }, _ctx.$attrs, {
          id: unref(uid2),
          value: textareaValue.value,
          onInput: handleInput,
          rows: __props.rows,
          ref_key: "textareaRef",
          ref: textareaRef
        }), null, 16, _hoisted_1$u)) : createCommentVNode("", true),
        __props.label && !__props.wrap ? (openBlock(), createElementBlock("label", {
          key: 1,
          ref_key: "labelRef",
          ref: labelRef,
          class: "form-label",
          for: unref(uid2)
        }, toDisplayString(__props.label), 9, _hoisted_2$p)) : createCommentVNode("", true),
        !__props.wrap && __props.helper ? (openBlock(), createElementBlock("div", _hoisted_3$j, toDisplayString(__props.helper), 1)) : createCommentVNode("", true),
        !__props.wrap && __props.counter ? (openBlock(), createElementBlock("div", _hoisted_4$h, [
          createElementVNode("div", _hoisted_5$e, toDisplayString(currentLength.value) + " / " + toDisplayString(__props.maxLength), 1)
        ])) : createCommentVNode("", true),
        !__props.wrap ? renderSlot(_ctx.$slots, "default", { key: 4 }) : createCommentVNode("", true),
        !__props.wrap && __props.validFeedback ? (openBlock(), createElementBlock("div", {
          key: 5,
          class: normalizeClass(unref(validFeedbackClassName))
        }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
        !__props.wrap && unref(customInvalidFeedback) ? (openBlock(), createElementBlock("div", {
          key: 6,
          class: normalizeClass(unref(invalidFeedbackClassName))
        }, toDisplayString(unref(customInvalidFeedback)), 3)) : createCommentVNode("", true),
        __props.wrap ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
          key: 7,
          class: normalizeClass(unref(wrapperClassName)),
          style: normalizeStyle(unref(validationStyle))
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "prepend"),
            createElementVNode("textarea", mergeProps({ class: unref(textareaClassName) }, _ctx.$attrs, {
              id: unref(uid2),
              value: textareaValue.value,
              onInput: handleInput,
              rows: __props.rows,
              ref_key: "textareaRef",
              ref: textareaRef
            }), null, 16, _hoisted_6$c),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              ref_key: "labelRef",
              ref: labelRef,
              class: "form-label",
              for: unref(uid2)
            }, toDisplayString(__props.label), 9, _hoisted_7$a)) : createCommentVNode("", true),
            __props.helper ? (openBlock(), createElementBlock("div", _hoisted_8$8, toDisplayString(__props.helper), 1)) : createCommentVNode("", true),
            __props.counter ? (openBlock(), createElementBlock("div", _hoisted_9$8, [
              createElementVNode("div", _hoisted_10$6, toDisplayString(currentLength.value) + " / " + toDisplayString(__props.maxLength), 1)
            ])) : createCommentVNode("", true),
            __props.validFeedback ? (openBlock(), createElementBlock("div", {
              key: 3,
              class: normalizeClass(unref(validFeedbackClassName))
            }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
            unref(customInvalidFeedback) ? (openBlock(), createElementBlock("div", {
              key: 4,
              class: normalizeClass(unref(invalidFeedbackClassName))
            }, toDisplayString(unref(customInvalidFeedback)), 3)) : createCommentVNode("", true),
            __props.formOutline ? (openBlock(), createElementBlock("div", _hoisted_11$3, [
              createElementVNode("div", {
                class: "form-notch-leading",
                style: normalizeStyle({ width: `${notchLeadingWidth.value}px` })
              }, null, 4),
              createElementVNode("div", {
                class: "form-notch-middle",
                style: normalizeStyle({ width: `${notchMiddleWidth.value}px` })
              }, null, 4),
              _hoisted_12$2
            ])) : createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["class", "style"])) : createCommentVNode("", true),
        __props.formText ? (openBlock(), createElementBlock("div", _hoisted_13$2, toDisplayString(__props.formText), 1)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$t = ["id", "checked", "required", "aria-required"];
const _hoisted_2$o = ["for", "innerHTML"];
const _hoisted_3$i = ["id", "checked", "required", "aria-required"];
const _hoisted_4$g = ["for", "innerHTML"];
const __default__$h = {
  inheritAttrs: false
};
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  ...__default__$h,
  __name: "MDBCheckbox",
  props: {
    id: String,
    label: String,
    modelValue: Boolean,
    inline: Boolean,
    wrapperClass: String,
    labelClass: String,
    inputClass: String,
    btnCheck: Boolean,
    required: Boolean,
    validateOnChange: Boolean,
    isValidated: Boolean,
    isValid: Boolean,
    validFeedback: String,
    invalidFeedback: String,
    tooltipFeedback: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: true
    },
    formCheck: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  emits: ["update:modelValue", "on-validate"],
  setup(__props, { emit }) {
    const props = __props;
    const inputRef = ref("inputRef");
    const inputValue = ref(props.modelValue);
    const uid2 = props.id || getUID("MDBCheckbox-");
    const wrapperClassName = computed(() => {
      return [
        props.formCheck && !props.btnCheck ? "form-check" : "",
        props.inline && "form-check-inline",
        props.wrapperClass
      ];
    });
    const inputClassName = computed(() => {
      return [
        props.btnCheck ? "btn-check" : "form-check-input",
        props.inputClass && props.inputClass,
        isInputValidated.value && isInputValid.value && "is-valid",
        isInputValidated.value && !isInputValid.value && "is-invalid"
      ];
    });
    const labelClassName = computed(() => {
      return [props.labelClass || "form-check-label"];
    });
    const validFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "valid-tooltip" : "valid-feedback";
    });
    const invalidFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "invalid-tooltip" : "invalid-feedback";
    });
    const isInputValidated = ref(props.isValidated);
    const isInputValid = ref(props.isValid);
    const handleValidation = (e) => {
      const target = e.target;
      isInputValid.value = target.checkValidity();
      isInputValidated.value = true;
      emit("on-validate", isInputValid.value);
    };
    const bindValidationEvent = () => {
      on(inputRef.value, "change", handleValidation);
    };
    function handleChange() {
      inputValue.value = !inputValue.value;
      emit("update:modelValue", inputValue.value);
    }
    onMounted(() => {
      if (props.validateOnChange) {
        bindValidationEvent();
      }
    });
    onUnmounted(() => {
      off(inputRef.value, "change", handleValidation);
    });
    watchEffect(() => inputValue.value = props.modelValue);
    watch(
      () => props.isValidated,
      (value) => isInputValidated.value = value
    );
    watch(
      () => props.isValid,
      (value) => isInputValid.value = value
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.wrap ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
          key: 0,
          class: normalizeClass(unref(wrapperClassName))
        }, {
          default: withCtx(() => [
            createElementVNode("input", mergeProps({
              class: unref(inputClassName),
              type: "checkbox"
            }, _ctx.$attrs, {
              id: unref(uid2),
              checked: inputValue.value,
              onChange: handleChange,
              required: __props.required ? true : void 0,
              "aria-required": __props.required,
              ref_key: "inputRef",
              ref: inputRef
            }), null, 16, _hoisted_1$t),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              class: normalizeClass(unref(labelClassName)),
              for: unref(uid2),
              innerHTML: __props.label
            }, null, 10, _hoisted_2$o)) : createCommentVNode("", true),
            __props.validFeedback ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(unref(validFeedbackClassName))
            }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
            __props.invalidFeedback ? (openBlock(), createElementBlock("div", {
              key: 2,
              class: normalizeClass(unref(invalidFeedbackClassName))
            }, toDisplayString(__props.invalidFeedback), 3)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", true),
        !__props.wrap ? (openBlock(), createElementBlock("input", mergeProps({
          key: 1,
          class: unref(inputClassName),
          type: "checkbox"
        }, _ctx.$attrs, {
          id: unref(uid2),
          checked: inputValue.value,
          onChange: handleChange,
          required: __props.required ? true : void 0,
          "aria-required": __props.required,
          ref_key: "inputRef",
          ref: inputRef
        }), null, 16, _hoisted_3$i)) : createCommentVNode("", true),
        !__props.wrap && __props.label ? (openBlock(), createElementBlock("label", {
          key: 2,
          class: normalizeClass(unref(labelClassName)),
          for: unref(uid2),
          innerHTML: __props.label
        }, null, 10, _hoisted_4$g)) : createCommentVNode("", true),
        !__props.wrap && __props.validFeedback ? (openBlock(), createElementBlock("div", {
          key: 3,
          class: normalizeClass(unref(validFeedbackClassName))
        }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
        !__props.wrap && __props.invalidFeedback ? (openBlock(), createElementBlock("div", {
          key: 4,
          class: normalizeClass(unref(invalidFeedbackClassName))
        }, toDisplayString(__props.invalidFeedback), 3)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$s = ["id", "required", "aria-required"];
const _hoisted_2$n = ["for"];
const _hoisted_3$h = ["id", "required", "aria-required"];
const _hoisted_4$f = ["for"];
const __default__$g = {
  inheritAttrs: false
};
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  ...__default__$g,
  __name: "MDBRadio",
  props: {
    id: String,
    label: String,
    inline: Boolean,
    modelValue: String,
    wrapperClass: String,
    labelClass: String,
    btnCheck: Boolean,
    required: Boolean,
    validateOnChange: Boolean,
    isValidated: Boolean,
    isValid: Boolean,
    validFeedback: String,
    invalidFeedback: String,
    tooltipFeedback: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: true
    },
    formCheck: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  emits: ["update:modelValue", "on-validate"],
  setup(__props, { emit }) {
    const props = __props;
    const inputRef = ref("inputRef");
    const inputValue = ref(props.modelValue || false);
    const uid2 = props.id || getUID("MDBRadio-");
    const wrapperClassName = computed(() => {
      return [
        props.formCheck && !props.btnCheck ? "form-check" : "",
        props.inline && "form-check-inline",
        props.wrapperClass
      ];
    });
    const inputClassName = computed(() => {
      return [
        props.btnCheck ? "btn-check" : "form-check-input",
        isInputValidated.value && isInputValid.value && "is-valid",
        isInputValidated.value && !isInputValid.value && "is-invalid"
      ];
    });
    const labelClassName = computed(() => {
      return [props.labelClass || "form-check-label"];
    });
    const validFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "valid-tooltip" : "valid-feedback";
    });
    const invalidFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "invalid-tooltip" : "invalid-feedback";
    });
    const isInputValidated = ref(props.isValidated);
    const isInputValid = ref(props.isValid);
    const handleValidation = (e) => {
      const target = e.target;
      isInputValid.value = target.checkValidity();
      isInputValidated.value = true;
      emit("on-validate", isInputValid.value);
    };
    const bindValidationEvent = () => {
      on(inputRef.value, "change", handleValidation);
    };
    function handleChange(e) {
      const target = e.target;
      emit("update:modelValue", target.value);
    }
    onMounted(() => {
      if (props.validateOnChange) {
        bindValidationEvent();
      }
    });
    onUnmounted(() => {
      off(inputRef.value, "change", handleValidation);
    });
    watchEffect(() => inputValue.value = props.modelValue);
    watch(
      () => props.isValidated,
      (value) => isInputValidated.value = value
    );
    watch(
      () => props.isValid,
      (value) => isInputValid.value = value
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.wrap ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
          key: 0,
          class: normalizeClass(unref(wrapperClassName))
        }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("input", mergeProps({
              class: unref(inputClassName),
              type: "radio"
            }, _ctx.$attrs, {
              id: unref(uid2),
              onChange: handleChange,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
              required: __props.required ? true : void 0,
              "aria-required": __props.required,
              ref_key: "inputRef",
              ref: inputRef
            }), null, 16, _hoisted_1$s), [
              [vModelRadio, inputValue.value]
            ]),
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              class: normalizeClass(unref(labelClassName)),
              for: unref(uid2)
            }, toDisplayString(__props.label), 11, _hoisted_2$n)) : createCommentVNode("", true),
            __props.validFeedback ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(unref(validFeedbackClassName))
            }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
            __props.invalidFeedback ? (openBlock(), createElementBlock("div", {
              key: 2,
              class: normalizeClass(unref(invalidFeedbackClassName))
            }, toDisplayString(__props.invalidFeedback), 3)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"])) : createCommentVNode("", true),
        !__props.wrap ? withDirectives((openBlock(), createElementBlock("input", mergeProps({
          key: 1,
          class: unref(inputClassName),
          type: "radio"
        }, _ctx.$attrs, {
          id: unref(uid2),
          onChange: handleChange,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => inputValue.value = $event),
          required: __props.required ? true : void 0,
          "aria-required": __props.required,
          ref_key: "inputRef",
          ref: inputRef
        }), null, 16, _hoisted_3$h)), [
          [vModelRadio, inputValue.value]
        ]) : createCommentVNode("", true),
        !__props.wrap && __props.label ? (openBlock(), createElementBlock("label", {
          key: 2,
          class: normalizeClass(unref(labelClassName)),
          for: unref(uid2)
        }, toDisplayString(__props.label), 11, _hoisted_4$f)) : createCommentVNode("", true),
        !__props.wrap && __props.validFeedback ? (openBlock(), createElementBlock("div", {
          key: 3,
          class: normalizeClass(unref(validFeedbackClassName))
        }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
        !__props.wrap && __props.invalidFeedback ? (openBlock(), createElementBlock("div", {
          key: 4,
          class: normalizeClass(unref(invalidFeedbackClassName))
        }, toDisplayString(__props.invalidFeedback), 3)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$r = ["for"];
const _hoisted_2$m = ["id"];
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "MDBFile",
  props: {
    id: String,
    inputClass: String,
    invalidFeedback: String,
    isInvalid: Boolean,
    isValid: Boolean,
    isValidated: Boolean,
    label: String,
    labelClass: String,
    modelValue: {
      type: [FileList, Array],
      default: () => []
    },
    size: String,
    tooltipFeedback: Boolean,
    validFeedback: String,
    validateOnChange: Boolean
  },
  emits: ["update:modelValue", "on-validate"],
  setup(__props, { emit }) {
    const props = __props;
    const uid2 = props.id || getUID("MDBFile-");
    const inputValue = ref(props.modelValue);
    const inputClassName = computed(() => {
      return [
        "form-control",
        props.size && `form-control-${props.size}`,
        isInputValidated.value && isInputValid.value && "is-valid",
        isInputValidated.value && !isInputValid.value && "is-invalid",
        props.inputClass
      ];
    });
    const labelClassName = computed(() => {
      return ["form-label", props.labelClass];
    });
    const validFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "valid-tooltip" : "valid-feedback";
    });
    const invalidFeedbackClassName = computed(() => {
      return props.tooltipFeedback ? "invalid-tooltip" : "invalid-feedback";
    });
    const isInputValidated = ref(props.isValidated);
    const isInputValid = ref(props.isValid);
    const handleValidation = (event) => {
      const target = event.target;
      if (target.files) {
        isInputValid.value = target.files.length > 0;
        isInputValidated.value = true;
        emit("on-validate", isInputValid.value);
      }
    };
    const handleChange = (event) => {
      const target = event.target;
      if (target.files) {
        inputValue.value = target.files;
        emit("update:modelValue", inputValue.value);
        if (props.validateOnChange) {
          handleValidation(event);
        }
      }
    };
    watch(
      () => props.modelValue,
      (value) => inputValue.value = value
    );
    watch(
      () => props.isValidated,
      (value) => isInputValidated.value = value
    );
    watch(
      () => props.isValid,
      (value) => {
        isInputValid.value = value;
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.label ? (openBlock(), createElementBlock("label", {
          key: 0,
          class: normalizeClass(unref(labelClassName)),
          for: unref(uid2)
        }, toDisplayString(__props.label), 11, _hoisted_1$r)) : createCommentVNode("", true),
        createElementVNode("input", mergeProps({
          type: "file",
          class: unref(inputClassName)
        }, _ctx.$attrs, {
          id: unref(uid2),
          onChange: handleChange
        }), null, 16, _hoisted_2$m),
        __props.validFeedback ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(unref(validFeedbackClassName))
        }, toDisplayString(__props.validFeedback), 3)) : createCommentVNode("", true),
        __props.invalidFeedback ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(unref(invalidFeedbackClassName))
        }, toDisplayString(__props.invalidFeedback), 3)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$q = ["for"];
const _hoisted_2$l = ["id", "value", "min", "max"];
const _hoisted_3$g = { class: "thumb-value" };
const __default__$f = {
  inheritAttrs: false
};
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  ...__default__$f,
  __name: "MDBRange",
  props: {
    id: String,
    inputClass: String,
    label: String,
    labelClass: String,
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    modelValue: {
      type: Number,
      default: 50
    },
    tag: {
      type: String,
      default: "div"
    },
    thumb: {
      type: Boolean,
      default: true
    },
    thumbClass: String,
    wrapperClass: String
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const inputValue = ref(props.modelValue);
    const minValue = ref(props.min);
    const maxValue = ref(props.max);
    const uid2 = props.id || getUID("MDBRange-");
    const isThumbActive = ref(false);
    const wrapperClassName = computed(() => {
      return ["range", props.wrapperClass];
    });
    const inputClassName = computed(() => {
      return ["form-range", props.inputClass];
    });
    const labelClassName = computed(() => {
      return ["form-label", props.labelClass];
    });
    const thumbClassName = computed(() => {
      return ["thumb", isThumbActive.value && "thumb-active", props.thumbClass];
    });
    const thumbLeftPosition = ref(0);
    const handleInput = (e) => {
      const target = e.target;
      inputValue.value = parseFloat(target.value);
      emit("update:modelValue", inputValue.value);
      setThumbPosition();
    };
    const toggleThumb = (isActive) => {
      isThumbActive.value = isActive;
    };
    const setThumbPosition = () => {
      const inputVal = typeof inputValue.value === "string" ? parseFloat(inputValue.value) : inputValue.value;
      const left2 = (inputVal - minValue.value) * 100 / (maxValue.value - minValue.value);
      thumbLeftPosition.value = `calc(${left2}% + (${8 - left2 * 0.15}px))`;
    };
    nextTick(() => {
      setThumbPosition();
    });
    watch(
      () => props.modelValue,
      (value) => {
        inputValue.value = value;
        setThumbPosition();
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.label ? (openBlock(), createElementBlock("label", {
          key: 0,
          class: normalizeClass(unref(labelClassName)),
          for: unref(uid2)
        }, toDisplayString(__props.label), 11, _hoisted_1$q)) : createCommentVNode("", true),
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
          class: normalizeClass(unref(wrapperClassName))
        }, {
          default: withCtx(() => [
            createElementVNode("input", mergeProps({
              type: "range",
              class: unref(inputClassName),
              id: unref(uid2),
              value: inputValue.value,
              min: minValue.value,
              max: maxValue.value
            }, _ctx.$attrs, {
              onInput: handleInput,
              onMousedown: _cache[0] || (_cache[0] = ($event) => toggleThumb(true)),
              onTouchstart: _cache[1] || (_cache[1] = ($event) => toggleThumb(true)),
              onMouseup: _cache[2] || (_cache[2] = ($event) => toggleThumb(false)),
              onTouchend: _cache[3] || (_cache[3] = ($event) => toggleThumb(false))
            }), null, 16, _hoisted_2$l),
            __props.thumb ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(thumbClassName)),
              style: normalizeStyle({ left: thumbLeftPosition.value })
            }, [
              createElementVNode("span", _hoisted_3$g, toDisplayString(inputValue.value), 1)
            ], 6)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 64);
    };
  }
});
const _hoisted_1$p = ["id", "checked"];
const _hoisted_2$k = ["for"];
const __default__$e = {
  inheritAttrs: false
};
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  ...__default__$e,
  __name: "MDBSwitch",
  props: {
    id: String,
    inputClass: String,
    label: String,
    labelClass: String,
    modelValue: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    },
    wrapperClass: String
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const inputValue = ref(props.modelValue);
    const uid2 = props.id || getUID("MDBSwitch-");
    const wrapperClassName = computed(() => {
      return ["form-check form-switch", props.wrapperClass];
    });
    const inputClassName = computed(() => {
      return ["form-check-input", props.inputClass];
    });
    const labelClassName = computed(() => {
      return ["form-check-label", props.labelClass];
    });
    function handleChange() {
      inputValue.value = !inputValue.value;
      emit("update:modelValue", inputValue.value);
    }
    watch(
      () => props.modelValue,
      (value) => inputValue.value = value
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(wrapperClassName))
      }, {
        default: withCtx(() => [
          createElementVNode("input", mergeProps({
            type: "checkbox",
            class: unref(inputClassName),
            id: unref(uid2)
          }, _ctx.$attrs, {
            checked: inputValue.value,
            onChange: handleChange
          }), null, 16, _hoisted_1$p),
          createElementVNode("label", {
            class: normalizeClass(unref(labelClassName)),
            for: unref(uid2)
          }, toDisplayString(__props.label), 11, _hoisted_2$k)
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
});
const ScrollSpyDirective = {
  mounted(el, binding) {
    el.scrollspy = {
      links: [],
      container: window,
      scrollPosition: null,
      async: false,
      offset: 0
    };
    if (binding.value) {
      el.scrollspy.container = document.getElementById(binding.value.container) || window;
      el.scrollspy.async = binding.value.async || false;
      el.scrollspy.offset = binding.value.offset || 0;
    }
    el.scrollspy.scrollPosition = getScrollPostion(el.scrollspy.container);
    el.scrollspy.findHrefs = (node) => {
      var _a;
      if (node.attributes && node instanceof HTMLAnchorElement && node.href) {
        el.scrollspy.links.push(node);
        if (node.classList.contains("collapsible-scrollspy")) {
          const list = (_a = node.parentNode) == null ? void 0 : _a.querySelector("ul");
          list.dataset.mdbCollapsibleScrollspyHeight = list.clientHeight.toString();
          list.style.overflow = "hidden";
          list.style.height = "0";
        }
      } else if (node.childNodes) {
        node.childNodes.forEach(
          (child) => {
            var _a2, _b;
            return (_b = (_a2 = el.scrollspy).findHrefs) == null ? void 0 : _b.call(_a2, child);
          }
        );
      }
    };
    el.scrollspy.setActive = (index2) => {
      if (binding.value && binding.value.callback) {
        binding.instance[binding.value.callback](index2);
        return;
      }
      el.scrollspy.links.forEach((link, i) => {
        if (index2 === i) {
          link.classList.add("active");
        } else {
          link.classList.remove("active");
        }
      });
      setNestedActive(el.scrollspy.links, index2, el.scrollspy.container);
      setCollapsibleActive(el.scrollspy.links);
    };
    el.scrollspy.spy = () => {
      var _a, _b, _c, _d;
      if (el.disableScroll)
        return;
      const container = el.scrollspy.container;
      el.scrollspy.scrollPosition = getScrollPostion(container);
      el.scrollspy.links.forEach((link) => {
        const element = document.querySelector(link.hash);
        if (!element) {
          return;
        }
        const rect = element.getBoundingClientRect();
        let condition;
        if (container === window) {
          condition = window.innerHeight > rect.top && rect.top + rect.height >= 0;
        } else {
          if (!(container instanceof Window)) {
            const containerRect = container.getBoundingClientRect();
            condition = rect.top <= containerRect.top + containerRect.height && rect.top + rect.height >= containerRect.top;
          }
        }
        link.isLinkActive = condition;
      });
      const activeLinks = el.scrollspy.links.filter(
        (link) => link.isLinkActive
      );
      if (activeLinks.length > 0) {
        const activeElement = activeLinks[0];
        const activeLink = activeElement.scrollspyIndex;
        (_b = (_a = el.scrollspy).setActive) == null ? void 0 : _b.call(_a, activeLink);
      } else {
        (_d = (_c = el.scrollspy).setActive) == null ? void 0 : _d.call(_c, -1);
      }
    };
    el.scrollspy.clickHandler = (e, link) => {
      var _a, _b;
      const container = el.scrollspy.container;
      window.clearTimeout(el.disableScrollTimeout);
      el.disableScroll = true;
      e.preventDefault();
      const element = document.querySelector(link.hash);
      if (!element) {
        return;
      }
      const rect = element.getBoundingClientRect();
      if (container === window) {
        window.scrollTo({
          top: window.scrollY + rect.y - el.scrollspy.offset
        });
      } else {
        if (!(container instanceof Window)) {
          const containerRect = container.getBoundingClientRect();
          container.style.scrollBehavior = "smooth";
          container.scrollTop = container.scrollTop + rect.y - containerRect.y - el.scrollspy.offset;
        }
      }
      (_b = (_a = el.scrollspy).setActive) == null ? void 0 : _b.call(_a, link.scrollspyIndex);
      link.scrollspyIndex && setParentsActive(el.scrollspy.links[link.scrollspyIndex], el);
      setCollapsibleActive(el.scrollspy.links);
      el.disableScrollTimeout = setTimeout(() => {
        el.disableScroll = false;
      }, 800);
    };
    el.scrollspy.findHrefs(el);
    el.scrollspy.links.forEach((link, i) => {
      link.scrollspyIndex = i;
      link.addEventListener(
        "click",
        (e) => {
          var _a, _b;
          return (_b = (_a = el.scrollspy).clickHandler) == null ? void 0 : _b.call(_a, e, link);
        }
      );
    });
    el.scrollspy.spy();
    el.scrollspy.container.addEventListener(
      "scroll",
      (e) => {
        var _a, _b;
        return (_b = (_a = el.scrollspy).spy) == null ? void 0 : _b.call(_a, e);
      }
    );
    window.addEventListener("resize", (e) => {
      var _a, _b;
      return (_b = (_a = el.scrollspy).spy) == null ? void 0 : _b.call(_a, e);
    });
  },
  updated(el, binding) {
    var _a, _b;
    if (((_a = binding.modifiers) == null ? void 0 : _a.async) && binding.value && !binding.value.loading && ((_b = binding.oldValue) == null ? void 0 : _b.loading)) {
      setTimeout(() => {
        var _a2, _b2, _c, _d;
        el.scrollspy.links = [];
        (_b2 = (_a2 = el.scrollspy).findHrefs) == null ? void 0 : _b2.call(_a2, el);
        el.scrollspy.links.forEach((link, i) => {
          link.scrollspyIndex = i;
          link.addEventListener(
            "click",
            (e) => {
              var _a3, _b3;
              return (_b3 = (_a3 = el.scrollspy).clickHandler) == null ? void 0 : _b3.call(_a3, e, link);
            }
          );
        });
        (_d = (_c = el.scrollspy).spy) == null ? void 0 : _d.call(_c);
      }, 0);
    }
  },
  unmounted(el) {
    window.removeEventListener("scroll", (e) => {
      var _a, _b;
      return (_b = (_a = el.scrollspy).spy) == null ? void 0 : _b.call(_a, e);
    });
    window.removeEventListener("resize", (e) => {
      var _a, _b;
      return (_b = (_a = el.scrollspy).spy) == null ? void 0 : _b.call(_a, e);
    });
  }
};
const setNestedActive = (links, index2, container) => {
  const allLinks = links[index2];
  if (!allLinks || !allLinks.parentNode) {
    return;
  }
  const allNestedLinks = Array.from(
    allLinks.parentNode.querySelectorAll("a")
  );
  allNestedLinks.shift();
  allNestedLinks.forEach((link) => {
    const element = document.querySelector(link.hash);
    if (!element) {
      return;
    }
    const rect = element.getBoundingClientRect();
    let condition;
    if (container === window) {
      condition = window.innerHeight > rect.top && rect.top + rect.height >= 0;
    } else {
      if (!(container instanceof Window)) {
        const containerRect = container.getBoundingClientRect();
        condition = rect.top < containerRect.top && rect.top + rect.height > containerRect.top;
      }
    }
    link.isActive = condition;
  });
  const activeLinks = allNestedLinks.filter((link) => link.isLinkActive);
  if (activeLinks.length > 0) {
    activeLinks[0].classList.add("active");
  }
};
const setParentsActive = (link, el) => {
  var _a;
  let parent = link.parentNode;
  if (!parent) {
    return;
  }
  while (parent && parent !== el) {
    if (parent.classList.contains("nav-item")) {
      (_a = parent.querySelector("a")) == null ? void 0 : _a.classList.add("active");
    }
    parent = parent.parentNode;
  }
};
const getScrollPostion = (container) => {
  return container === window ? container.scrollY : !(container instanceof Window) ? container.scrollTop : null;
};
const setCollapsibleActive = (links) => {
  links.forEach((link) => {
    var _a, _b;
    if (link.classList.contains("collapsible-scrollspy") && link.classList.contains("active")) {
      const list = (_a = link.parentNode) == null ? void 0 : _a.querySelector("ul");
      if (list) {
        list.style.overflow = "hidden";
        list.style.height = `${list.dataset.mdbCollapsibleScrollspyHeight}px`;
      }
    } else if (link.classList.contains("collapsible-scrollspy")) {
      const list = (_b = link.parentNode) == null ? void 0 : _b.querySelector("ul");
      if (list) {
        list.style.overflow = "hidden";
        list.style.height = "0";
      }
    }
  });
};
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "MDBNavbarToggler",
  props: {
    tag: {
      type: String,
      default: "button"
    },
    target: {
      type: String,
      default: "#navbarSupportedContent"
    },
    togglerClass: String,
    togglerIcon: {
      type: String,
      default: "bars"
    },
    togglerSize: {
      type: String,
      default: "1x"
    },
    iconStyle: {
      type: String,
      default: "fas"
    }
  },
  setup(__props) {
    const props = __props;
    const isExpanded = ref(false);
    const navTogglerClass = computed(() => ["navbar-toggler", props.togglerClass]);
    const handleClick = () => isExpanded.value = !isExpanded.value;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(navTogglerClass)),
        type: "button",
        "aria-controls": __props.target,
        "aria-expanded": isExpanded.value,
        "aria-label": "Toggle navigation",
        onClick: handleClick
      }, {
        default: withCtx(() => [
          createVNode(unref(_sfc_main$17), {
            icon: __props.togglerIcon,
            size: __props.togglerSize,
            iconStyle: __props.iconStyle
          }, null, 8, ["icon", "size", "iconStyle"])
        ]),
        _: 1
      }, 8, ["class", "aria-controls", "aria-expanded"]);
    };
  }
});
const isVisible = (element) => {
  if (!element) {
    return false;
  }
  const parent = element.parentElement;
  if (element.style && element.parentNode && parent.style) {
    const elementStyle = getComputedStyle(element);
    const parentNodeStyle = getComputedStyle(parent);
    return elementStyle.display !== "none" && parentNodeStyle.display !== "none" && elementStyle.visibility !== "hidden";
  }
  return false;
};
function MDBStackable() {
  const stackableElement = ref(null);
  const stackableSelector = ref(null);
  const toastProxy = ref(null);
  const config = reactive({});
  const offset2 = ref(null);
  const parent = ref(null);
  function setStack(proxy, element, selector, options) {
    stackableElement.value = element;
    stackableSelector.value = selector;
    toastProxy.value = proxy;
    config.position = options.position || "top";
    config.container = options.container || null;
    config.refresh = options.refresh || 1e3;
    config.filter = options.filter || function(el) {
      return el;
    };
    if (config.container) {
      parent.value = document.querySelector(config.container);
    }
  }
  function stackableElements() {
    return [...document.querySelectorAll(stackableSelector.value)].filter((el, i) => config.filter(el, i)).map((el) => ({ el, rect: el.getBoundingClientRect() })).filter(({ el, rect }) => {
      const basicCondition = el.id !== stackableElement.value.id && isVisible(el);
      if (offset2.value === null) {
        return basicCondition;
      }
      return basicCondition && getBoundryOffset(rect) < offset2.value;
    }).sort((a, b) => {
      return getBoundryOffset(b.rect) - getBoundryOffset(a.rect);
    });
  }
  function nextStackElements() {
    return [
      ...document.querySelectorAll(
        stackableSelector.value
      )
    ].filter((el) => el.id !== stackableElement.value.id && isVisible(el)).filter((el, i) => config.filter(el, i)).filter((el) => {
      return getBoundryOffset(el.getBoundingClientRect()) > offset2.value;
    });
  }
  function getBoundryOffset(rect) {
    let parentTopOffset = 0;
    let parentBottomBoundry = window.innerHeight;
    if (parent.value) {
      const parentRect = parent.value.getBoundingClientRect();
      parentTopOffset = parentRect.top;
      parentBottomBoundry = parentRect.bottom;
    }
    if (config.position === "top") {
      return rect.top - parentTopOffset;
    }
    return parentBottomBoundry - rect.bottom;
  }
  function calculateStackingOffset() {
    const [previousElement] = stackableElements();
    if (!previousElement) {
      offset2.value = 0;
    } else {
      offset2.value = getBoundryOffset(previousElement.rect) + previousElement.rect.height;
    }
    return offset2.value;
  }
  function resetStackingOffset() {
    offset2.value = null;
  }
  return {
    setStack,
    nextStackElements,
    calculateStackingOffset,
    resetStackingOffset
  };
}
const _hoisted_1$o = { class: "me-auto" };
const _hoisted_2$j = { class: "me-auto" };
const __default__$d = {
  name: "MDBToast",
  inheritAttrs: false
};
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  ...__default__$d,
  props: {
    tag: {
      type: String,
      default: "div"
    },
    id: String,
    modelValue: Boolean,
    offset: {
      type: String,
      default: "10"
    },
    position: {
      type: String,
      default: "top-right"
    },
    width: {
      type: [String, null],
      default: null
    },
    color: {
      type: String
    },
    container: String,
    autohide: {
      type: Boolean,
      default: true
    },
    animation: {
      type: Boolean,
      default: true
    },
    delay: {
      type: Number,
      default: 5e3
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    stacking: {
      type: Boolean,
      default: true
    },
    text: String,
    static: {
      type: Boolean,
      default: false
    },
    icon: String,
    toast: String
  },
  emits: [
    "update:modelValue",
    "show",
    "shown",
    "hide",
    "hidden"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const className = computed(() => {
      return [
        "toast",
        props.animation && "fade",
        "mx-auto",
        props.color && `bg-${props.color}`,
        props.toast && `toast-${props.toast}`,
        toastPositionClasses.value,
        showClass.value && "show"
      ];
    });
    const toastPositionClasses = computed(() => {
      if (props.static)
        return;
      return props.container ? "toast-absolute" : "toast-fixed";
    });
    const headerClassName = computed(() => {
      return [
        "toast-header",
        props.toast && `toast-${props.toast}`,
        props.color && `bg-${props.color}`,
        props.text && `text-${props.text}`
      ];
    });
    const btnClassName = computed(() => {
      return ["btn-close", props.text === "white" ? "btn-close-white" : null];
    });
    const bodyClassName = computed(() => {
      return [
        "toast-body",
        props.text === "white" ? "text-white" : null,
        "text-start"
      ];
    });
    const widthStyle = computed(() => `width: ${props.width}`);
    const alignmentStyle = ref(null);
    const displayStyle = ref(null);
    const showClass = ref(props.static ? true : false);
    const uid2 = props.id || getUID("MDBToast-");
    const toastRef = ref(null);
    const verticalOffset = () => {
      if (!props.stacking || !props.position)
        return 0;
      return calculateStackingOffset();
    };
    const getPosition = () => {
      if (!props.position)
        return null;
      const [y, x] = props.position.split("-");
      return { y, x };
    };
    const updatePosition = () => {
      const { y } = getPosition();
      const offsetY = verticalOffset();
      toastRef.value.style[y] = `${parseInt(offsetY) + parseInt(props.offset)}px`;
      setupAlignment();
    };
    const setupAlignment = () => {
      const offsetY = verticalOffset();
      const position = getPosition();
      const oppositeY = position.y === "top" ? "bottom" : "top";
      const oppositeX = position.x === "left" ? "right" : "left";
      if (position.x === "center") {
        alignmentStyle.value = {
          [position.y]: `${parseInt(offsetY) + parseInt(props.offset)}px`,
          [oppositeY]: "unset",
          left: "50%",
          transform: "translate(-50%)"
        };
      } else {
        alignmentStyle.value = {
          [position.y]: `${parseInt(offsetY) + parseInt(props.offset)}px`,
          [position.x]: `${props.offset}px`,
          [oppositeY]: "unset",
          [oppositeX]: "unset",
          transform: "unset"
        };
      }
    };
    watch(
      () => props.position,
      () => setupAlignment()
    );
    watch(
      () => props.offset,
      () => setupAlignment()
    );
    const {
      setStack,
      calculateStackingOffset,
      nextStackElements,
      resetStackingOffset
    } = MDBStackable();
    const observer = ref(null);
    const setupStacking = () => {
      setStack(toastRef, toastRef.value, ".toast", {
        position: getPosition().y,
        offset: props.offset,
        container: props.container,
        filter: (el) => {
          return el.dataset.mdbStacking && !el.dataset.mdbStatic;
        }
      });
      observerStacking();
    };
    const observerStacking = () => {
      observer.value = new MutationObserver((mutations) => {
        for (const m of mutations) {
          const newValue = m.target.getAttribute(m.attributeName);
          nextTick(() => {
            onShouldStackUpdate(newValue);
          });
        }
      });
      observer.value.observe(toastRef.value, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ["class"]
      });
    };
    const updateToastStack = () => {
      const nextElements = nextStackElements();
      if (nextElements.length <= 0) {
        return;
      }
      nextElements.forEach((el) => {
        if (el.id !== uid2) {
          el.classList.add("should-stack-update");
        }
      });
    };
    const onShouldStackUpdate = (classAttrValue) => {
      const classList = classAttrValue.split(" ");
      if (classList.includes("should-stack-update")) {
        updatePosition();
        toastRef.value.classList.remove("should-stack-update");
      }
    };
    const isActive = ref(props.modelValue);
    const timeoutValue = ref(null);
    watchEffect(() => {
      isActive.value = props.modelValue;
    });
    const openToast = () => {
      emit("show");
      _clearTimeout();
      setupAlignment();
      displayStyle.value = "display: block";
      const complete = () => {
        emit("shown");
        off(toastRef.value, "transitionend", complete);
        if (props.autohide) {
          timeoutValue.value = setTimeout(hide2, props.delay);
        }
      };
      nextTick(() => {
        setTimeout(() => {
          showClass.value = true;
        }, 0);
        if (props.animation) {
          on(toastRef.value, "transitionend", complete);
        } else {
          complete();
        }
      });
    };
    const closeToast = () => {
      emit("hide");
      const complete = () => {
        displayStyle.value = "display: none";
        alignmentStyle.value = null;
        emit("hidden");
        off(toastRef.value, "transitionend", complete);
        if (props.stacking) {
          updateToastStack();
        }
      };
      showClass.value = false;
      if (props.stacking && !props.static) {
        resetStackingOffset();
      }
      if (props.animation) {
        on(toastRef.value, "transitionend", complete);
      } else {
        complete();
      }
    };
    watch(
      () => isActive.value,
      (isActive2) => {
        if (isActive2) {
          openToast();
        } else {
          closeToast();
        }
      }
    );
    const show = () => {
      emit("update:modelValue", true);
    };
    const hide2 = () => {
      if (props.autohide && !timeoutValue.value)
        return;
      emit("update:modelValue", false);
    };
    const _clearTimeout = () => {
      clearTimeout(timeoutValue.value);
      timeoutValue.value = null;
    };
    onMounted(() => {
      if (!props.modelValue) {
        displayStyle.value = "display: none";
      }
      if (props.container) {
        const containerEl = document.querySelector(props.container);
        if (!containerEl)
          return;
        containerEl.classList.add("parent-toast-relative");
      }
      if (props.stacking) {
        setupStacking();
      }
    });
    onUnmounted(() => {
      _clearTimeout();
      if (observer.value) {
        observer.value.disconnect();
      }
    });
    expose({
      show,
      hide: hide2
    });
    return (_ctx, _cache) => {
      return __props.appendToBody ? (openBlock(), createBlock(Teleport, {
        key: 0,
        to: "body"
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          id: unref(uid2),
          ref_key: "toastRef",
          ref: toastRef,
          class: ["", unref(className)],
          style: [displayStyle.value, unref(widthStyle), alignmentStyle.value],
          role: "alert",
          "aria-live": "assertive",
          "aria-atomic": "true",
          "data-mdb-stacking": __props.stacking ? true : null,
          "data-mdb-static": props.static ? true : null
        }, _ctx.$attrs), {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(headerClassName))
            }, [
              __props.icon ? (openBlock(), createElementBlock("i", {
                key: 0,
                class: normalizeClass(__props.icon)
              }, null, 2)) : createCommentVNode("", true),
              createElementVNode("strong", _hoisted_1$o, [
                renderSlot(_ctx.$slots, "title")
              ]),
              createElementVNode("small", null, [
                renderSlot(_ctx.$slots, "small")
              ]),
              createElementVNode("button", {
                type: "button",
                class: normalizeClass(unref(btnClassName)),
                "aria-label": "Close",
                onClick: hide2
              }, null, 2)
            ], 2),
            createElementVNode("div", {
              class: normalizeClass(unref(bodyClassName))
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 2)
          ]),
          _: 3
        }, 16, ["id", "class", "style", "data-mdb-stacking", "data-mdb-static"]))
      ])) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 1,
        id: unref(uid2),
        ref_key: "toastRef",
        ref: toastRef,
        class: ["", unref(className)],
        style: [displayStyle.value, unref(widthStyle), alignmentStyle.value],
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        "data-mdb-stacking": __props.stacking ? true : null
      }, _ctx.$attrs), {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(unref(headerClassName))
          }, [
            __props.icon ? (openBlock(), createElementBlock("i", {
              key: 0,
              class: normalizeClass(__props.icon)
            }, null, 2)) : createCommentVNode("", true),
            createElementVNode("strong", _hoisted_2$j, [
              renderSlot(_ctx.$slots, "title")
            ]),
            createElementVNode("small", null, [
              renderSlot(_ctx.$slots, "small")
            ]),
            createElementVNode("button", {
              type: "button",
              class: normalizeClass(unref(btnClassName)),
              "aria-label": "Close",
              onClick: hide2
            }, null, 2)
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(unref(bodyClassName))
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 16, ["id", "class", "style", "data-mdb-stacking"]));
    };
  }
});
const __default__$c = {
  inheritAttrs: false
};
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  ...__default__$c,
  __name: "MDBAlert",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    modelValue: Boolean,
    offset: {
      type: String,
      default: "10"
    },
    position: {
      type: String,
      default: "top-right"
    },
    width: {
      type: [String, null],
      default: null
    },
    color: {
      type: String
    },
    container: String,
    autohide: {
      type: Boolean,
      default: true
    },
    animation: {
      type: Boolean,
      default: true
    },
    delay: {
      type: Number,
      default: 5e3
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    stacking: {
      type: Boolean,
      default: true
    },
    static: {
      type: Boolean,
      default: false
    },
    dismiss: Boolean,
    id: String,
    hidden: Boolean
  },
  emits: [
    "update:modelValue",
    "show",
    "shown",
    "hide",
    "hidden"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const className = computed(() => {
      return [
        "alert",
        props.animation && "fade",
        "text-start",
        props.color && `alert-${props.color}`,
        toastPositionClasses.value,
        showClass.value && "show",
        props.dismiss && "alert-dismissible"
      ];
    });
    const toastPositionClasses = computed(() => {
      if (props.static)
        return;
      return props.container ? "alert-absolute" : "alert-fixed";
    });
    const widthStyle = computed(() => `width: ${props.width}`);
    const alignmentStyle = ref(null);
    const displayStyle = ref(null);
    const showClass = ref(props.static && !props.hidden ? true : false);
    const uid2 = props.id || getUID("MDBAlert-");
    const alertRef = ref(null);
    const verticalOffset = () => {
      if (!props.stacking || !props.position)
        return 0;
      return calculateStackingOffset();
    };
    const getPosition = () => {
      if (!props.position)
        return null;
      const [y, x] = props.position.split("-");
      return { y, x };
    };
    const updatePosition = () => {
      const { y } = getPosition();
      const offsetY = verticalOffset();
      alertRef.value.style[y] = `${parseInt(offsetY) + parseInt(props.offset)}px`;
      setupAlignment();
    };
    const setupAlignment = () => {
      const offsetY = verticalOffset();
      const position = getPosition();
      const oppositeY = position.y === "top" ? "bottom" : "top";
      const oppositeX = position.x === "left" ? "right" : "left";
      if (position.x === "center") {
        alignmentStyle.value = {
          [position.y]: `${parseInt(offsetY) + parseInt(props.offset)}px`,
          [oppositeY]: "unset",
          left: "50%",
          transform: "translate(-50%)"
        };
      } else {
        alignmentStyle.value = {
          [position.y]: `${parseInt(offsetY) + parseInt(props.offset)}px`,
          [position.x]: `${props.offset}px`,
          [oppositeY]: "unset",
          [oppositeX]: "unset",
          transform: "unset"
        };
      }
    };
    watch(
      () => props.position,
      () => setupAlignment()
    );
    watch(
      () => props.offset,
      () => setupAlignment()
    );
    const {
      setStack,
      calculateStackingOffset,
      nextStackElements,
      resetStackingOffset
    } = MDBStackable();
    const observer = ref(null);
    const setupStacking = () => {
      setStack(alertRef, alertRef.value, ".alert", {
        position: getPosition().y,
        offset: props.offset,
        container: props.container,
        filter: (el) => {
          return el.dataset.mdbStacking && !el.dataset.mdbStatic;
        }
      });
      observerStacking();
    };
    const observerStacking = () => {
      observer.value = new MutationObserver((mutations) => {
        for (const m of mutations) {
          const newValue = m.target.getAttribute(m.attributeName);
          nextTick(() => {
            onShouldStackUpdate(newValue);
          });
        }
      });
      observer.value.observe(alertRef.value, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ["class"]
      });
    };
    const updateAlertStack = () => {
      const nextElements = nextStackElements();
      if (!nextElements.length) {
        return;
      }
      nextElements.forEach((el) => {
        if (el.id !== uid2) {
          el.classList.add("should-stack-update");
        }
      });
    };
    const onShouldStackUpdate = (classAttrValue) => {
      const classList = classAttrValue.split(" ");
      if (classList.includes("should-stack-update")) {
        updatePosition();
        alertRef.value.classList.remove("should-stack-update");
      }
    };
    const isActive = ref(props.modelValue);
    const timeoutValue = ref(null);
    watchEffect(() => {
      isActive.value = props.modelValue;
    });
    const openAlert = () => {
      emit("show");
      _clearTimeout();
      setupAlignment();
      displayStyle.value = "display: block";
      const complete = () => {
        emit("shown");
        off(alertRef.value, "transitionend", complete);
        if (props.autohide) {
          timeoutValue.value = setTimeout(hide2, props.delay);
        }
      };
      nextTick(() => {
        setTimeout(() => {
          showClass.value = true;
        }, 0);
        if (props.animation) {
          on(alertRef.value, "transitionend", complete);
        } else {
          complete();
        }
      });
    };
    const closeAlert = () => {
      emit("hide");
      const complete = () => {
        displayStyle.value = "display: none";
        alignmentStyle.value = null;
        emit("hidden");
        off(alertRef.value, "transitionend", complete);
        if (props.stacking && !props.static) {
          updateAlertStack();
        }
      };
      showClass.value = false;
      if (props.stacking && !props.static) {
        resetStackingOffset();
      }
      if (props.animation) {
        on(alertRef.value, "transitionend", complete);
      } else {
        complete();
      }
    };
    watch(
      () => isActive.value,
      (isActive2) => {
        if (isActive2) {
          openAlert();
        } else {
          closeAlert();
        }
      }
    );
    const show = () => {
      emit("update:modelValue", true);
    };
    const hide2 = () => {
      if (props.autohide && !timeoutValue.value)
        return;
      emit("update:modelValue", false);
    };
    const _clearTimeout = () => {
      clearTimeout(timeoutValue.value);
      timeoutValue.value = null;
    };
    onMounted(() => {
      if (props.static && props.hidden || !props.modelValue && !props.static) {
        displayStyle.value = "display: none";
      }
      if (props.container) {
        const containerEl = document.querySelector(props.container);
        if (!containerEl)
          return;
        containerEl.classList.add("parent-alert-relative");
      }
      if (props.stacking && !props.static) {
        setupStacking();
      }
    });
    onUnmounted(() => {
      _clearTimeout();
      if (observer.value) {
        observer.value.disconnect();
      }
    });
    expose({
      show,
      hide: hide2
    });
    return (_ctx, _cache) => {
      return __props.appendToBody ? (openBlock(), createBlock(Teleport, {
        key: 0,
        to: "body"
      }, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          id: unref(uid2),
          ref_key: "alertRef",
          ref: alertRef,
          class: unref(className),
          style: [displayStyle.value, unref(widthStyle), alignmentStyle.value],
          role: "alert",
          "aria-live": "assertive",
          "aria-atomic": "true",
          "data-mdb-stacking": __props.stacking ? true : null,
          "data-mdb-static": props.static ? true : null
        }, _ctx.$attrs), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default"),
            __props.dismiss ? (openBlock(), createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn-close",
              "aria-label": "Close",
              onClick: hide2
            })) : createCommentVNode("", true)
          ]),
          _: 3
        }, 16, ["id", "class", "style", "data-mdb-stacking", "data-mdb-static"]))
      ])) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 1,
        id: unref(uid2),
        ref_key: "alertRef",
        ref: alertRef,
        class: unref(className),
        style: [displayStyle.value, unref(widthStyle), alignmentStyle.value],
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        "data-mdb-stacking": __props.stacking ? true : null,
        "data-mdb-static": props.static ? true : null
      }, _ctx.$attrs), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          __props.dismiss ? (openBlock(), createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            onClick: hide2
          })) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["id", "class", "style", "data-mdb-stacking", "data-mdb-static"]));
    };
  }
});
const __default__$b = {
  name: "MDBModalPro",
  extends: _sfc_main$16
};
const _sfc_main$E = defineComponent({
  ...__default__$b,
  props: {
    side: { type: Boolean, default: false },
    frame: { type: [Boolean, String], default: false },
    position: null,
    nonInvasive: { type: Boolean, default: false },
    direction: { default: "top" }
  },
  emits: [
    "show",
    "shown",
    "hide",
    "hidden",
    "update:modelValue"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const {
      dialogClass,
      wrapperClass,
      backdropOverflowStyle,
      computedContentStyle,
      root,
      dialog,
      isActive,
      closeModal,
      animateStaticBackdrop,
      afterEnter,
      afterLeave,
      scrollbarWidth,
      shouldOverflow,
      setScrollbar,
      thisElement,
      handleEscKeyUp,
      focusTrap,
      dialogTransform
    } = useMDBModal(props, emit);
    const dialogClassPro = computed(() => {
      const classes = [];
      props.side && classes.push("modal-side");
      props.frame && classes.push("modal-frame");
      props.position && classes.push(`modal-${props.position}`);
      props.nonInvasive && classes.push("modal-non-invasive-show");
      return classes;
    });
    const value = ref(props.modelValue);
    watchEffect(() => value.value = props.modelValue);
    watch(
      () => value.value,
      (cur) => {
        emit("update:modelValue", cur);
      }
    );
    const dialogTransformPro = computed(() => {
      if (props.direction === "right") {
        return "translate(25%,0)";
      } else if (props.direction === "bottom") {
        return "translate(0,25%)";
      } else if (props.direction === "left") {
        return "translate(-25%,0)";
      }
      return null;
    });
    const emitEvent = (e, eventName) => {
      emit(eventName, e);
    };
    const backdropStyle = computed(() => {
      return props.removeBackdrop || props.nonInvasive ? false : { "background-color": `rgba(0,0,0, 0.5)` };
    });
    const backdropPointerEventsStyle = computed(() => {
      return props.nonInvasive ? { "pointer-events": "none" } : false;
    });
    const enter = (el) => {
      shouldOverflow.value = dialogTransformPro.value === "translate(0,25%)" ? false : true;
      dialogTransform.value = dialogTransformPro.value || "translate(0, -25%)";
      el.childNodes[0].style.transform = dialogTransform.value;
      el.style.opacity = "0";
      el.style.display = "block";
      setScrollbar();
      const onlyModalOpen = !document.body.classList.contains("modal-open");
      let paddingValue = scrollbarWidth.value;
      document.body.style.overflowY = "hidden";
      if (onlyModalOpen && props.nonInvasive) {
        paddingValue = 0;
      }
      if (props.nonInvasive) {
        document.body.style.overflowY = "auto";
      }
      document.body.style.paddingRight = `${paddingValue}px`;
      el.style.paddingRight = `${scrollbarWidth.value}px`;
      document.body.classList.add("modal-open");
      emit("show", root.value);
    };
    const beforeLeave = (el) => {
      el.childNodes[0].style.transform = dialogTransform.value;
      el.style.opacity = "0";
      setTimeout(() => {
        el.style.paddingRight = null;
        if (!props.nonInvasive) {
          document.body.style.paddingRight = null;
          document.body.style.overflowY = "auto";
        }
        document.body.classList.remove("modal-open");
      }, 200);
      emit("hide", thisElement.value);
      if (props.keyboard) {
        off(window, "keyup", handleEscKeyUp);
      }
      if (props.focus && focusTrap.value) {
        focusTrap.value.removeFocusTrap();
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        onEnter: enter,
        onAfterEnter: unref(afterEnter),
        onBeforeLeave: beforeLeave,
        onAfterLeave: unref(afterLeave)
      }, {
        default: withCtx(() => [
          unref(isActive) ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
            key: 0,
            ref_key: "root",
            ref: root,
            class: normalizeClass(unref(wrapperClass)),
            style: normalizeStyle([
              unref(backdropStyle),
              unref(backdropOverflowStyle),
              unref(backdropPointerEventsStyle)
            ]),
            "aria-hidden": !unref(isActive),
            "aria-modal": unref(isActive) ? true : null,
            "aria-labelledby": _ctx.labelledby,
            role: "dialog",
            onClick: _cache[0] || (_cache[0] = withModifiers(
              () => {
                if (__props.nonInvasive) {
                  return;
                }
                if (_ctx.staticBackdrop) {
                  unref(animateStaticBackdrop)();
                } else {
                  unref(closeModal)();
                }
              },
              ["self"]
            )),
            onShow: _cache[1] || (_cache[1] = ($event) => emitEvent($event, "show")),
            onShown: _cache[2] || (_cache[2] = ($event) => emitEvent($event, "shown")),
            onHide: _cache[3] || (_cache[3] = ($event) => emitEvent($event, "hide")),
            onHidden: _cache[4] || (_cache[4] = ($event) => emitEvent($event, "hidden"))
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                ref_key: "dialog",
                ref: dialog,
                class: normalizeClass([unref(dialogClass), unref(dialogClassPro)]),
                role: "document"
              }, [
                createElementVNode("div", {
                  class: "modal-content",
                  style: normalizeStyle(unref(computedContentStyle))
                }, [
                  renderSlot(_ctx.$slots, "default")
                ], 4)
              ], 2)
            ]),
            _: 3
          }, 40, ["class", "style", "aria-hidden", "aria-modal", "aria-labelledby"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["onAfterEnter", "onAfterLeave"]);
    };
  }
});
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "MDBRating",
  props: {
    tag: {
      type: String,
      default: "ul"
    },
    modelValue: {
      type: Number,
      default: -1
    },
    readonly: Boolean,
    events: Boolean,
    dynamic: Boolean,
    classes: String
  },
  emits: ["update:modelValue", "item-click", "item-hover"],
  setup(__props, { emit }) {
    const props = __props;
    const ratingRef = ref(null);
    const className = computed(() => {
      return ["rating", props.classes];
    });
    const activeItem = ref(props.modelValue);
    const setActiveRating = (rating, e) => {
      if (!e) {
        return;
      }
      emit("update:modelValue", rating);
      props.events && emit("item-click", e);
    };
    watchEffect(() => activeItem.value = props.modelValue);
    const hoveredItem = ref(null);
    const setHoveredRating = (rating, e) => {
      if (!e) {
        return;
      }
      hoveredItem.value = rating;
      e !== "leave" && props.events && emit("item-hover", e);
    };
    const dynamicStyle = reactive({
      icon: "",
      color: ""
    });
    const setDynamic = (icon, color2) => {
      dynamicStyle.icon = icon;
      dynamicStyle.color = color2;
    };
    provide("activeItem", activeItem);
    provide("hoveredItem", hoveredItem);
    provide("setActiveRating", setActiveRating);
    provide("setHoveredRating", setHoveredRating);
    provide("readonly", props.readonly);
    provide("dynamic", props.dynamic);
    provide("dynamicStyle", dynamicStyle);
    provide("setDynamic", setDynamic);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "ratingRef",
        ref: ratingRef,
        class: normalizeClass(unref(className)),
        onMouseleave: _cache[0] || (_cache[0] = ($event) => setHoveredRating(null, "leave"))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 40, ["class"]);
    };
  }
});
const __default__$a = {
  inheritAttrs: false
};
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  ...__default__$a,
  __name: "MDBRatingItem",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    iconClass: String,
    classes: String,
    icon: {
      type: String,
      default: "star"
    },
    flag: String,
    size: String,
    color: String,
    title: String,
    index: {
      type: Number,
      required: true
    },
    popover: { type: [Boolean, String], default: false },
    insertBefore: String,
    insertAfter: String
  },
  setup(__props) {
    const props = __props;
    const ratingItemRef = ref(null);
    const activeItem = inject("activeItem", false);
    const hoveredItem = inject("hoveredItem", false);
    const setActiveRating = inject(
      "setActiveRating",
      false
    );
    const setHoveredRating = inject("setHoveredRating", false);
    const readonly = inject("readonly", false);
    const dynamic = inject("dynamic", false);
    const dynamicStyle = inject("dynamicStyle", false);
    const setDynamic = inject(
      "setDynamic",
      false
    );
    const isActive = computed(() => {
      return hoveredItem && !hoveredItem.value && activeItem && activeItem.value && activeItem.value >= props.index || hoveredItem && hoveredItem.value >= props.index;
    });
    watch(
      [hoveredItem, activeItem],
      () => {
        if (dynamic && hoveredItem && activeItem && setDynamic) {
          const dynamicValue = hoveredItem.value ? hoveredItem.value : activeItem.value;
          dynamicValue === props.index && setDynamic(props.icon, props.color);
        }
      },
      { immediate: true }
    );
    const handleClick = (e) => {
      if (props.popover) {
        isPopoverActive.value = !isPopoverActive.value;
      }
      !readonly && setActiveRating && setActiveRating(props.index, e);
    };
    const handleMouseEnter = (e) => {
      !readonly && setHoveredRating && setHoveredRating(props.index, e);
    };
    const isTooltipActive = ref(false);
    const isPopoverActive = ref(false);
    return (_ctx, _cache) => {
      return __props.popover ? (openBlock(), createBlock(_sfc_main$1e, {
        key: 0,
        modelValue: isPopoverActive.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isPopoverActive.value = $event),
        direction: "top"
      }, createSlots({
        reference: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps(_ctx.$attrs, {
            ref_key: "ratingItemRef",
            ref: ratingItemRef,
            class: [__props.insertAfter || __props.insertBefore ? "px-2 d-flex" : null, __props.classes]
          }), {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.insertBefore) + " ", 1),
              createVNode(_sfc_main$17, {
                iconStyle: unref(isActive) ? "fas" : "far",
                icon: unref(dynamicStyle) && unref(dynamicStyle).icon ? unref(dynamicStyle).icon : __props.icon,
                size: __props.size,
                flag: __props.flag,
                class: normalizeClass([unref(isActive) && "active", !__props.color && "text-primary", __props.iconClass]),
                style: normalizeStyle({
                  color: unref(dynamicStyle) && unref(dynamicStyle).color ? unref(dynamicStyle).color : __props.color
                }),
                onClick: handleClick,
                onMouseenter: handleMouseEnter
              }, null, 8, ["iconStyle", "icon", "size", "flag", "class", "style"]),
              createTextVNode(" " + toDisplayString(__props.insertAfter), 1)
            ]),
            _: 1
          }, 16, ["class"]))
        ]),
        _: 2
      }, [
        __props.popover && __props.popover !== true ? {
          name: "body",
          fn: withCtx(() => [
            createTextVNode(toDisplayString(__props.popover), 1)
          ]),
          key: "0"
        } : {
          name: "body",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          key: "1"
        }
      ]), 1032, ["modelValue"])) : (openBlock(), createBlock(_sfc_main$1f, {
        key: 1,
        modelValue: isTooltipActive.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isTooltipActive.value = $event),
        disabled: __props.title ? null : true
      }, {
        reference: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps(_ctx.$attrs, {
            ref_key: "ratingItemRef",
            ref: ratingItemRef,
            class: [__props.insertAfter || __props.insertBefore ? "px-2 d-flex" : null, __props.classes]
          }), {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.insertBefore) + " ", 1),
              createVNode(_sfc_main$17, {
                iconStyle: unref(isActive) ? "fas" : "far",
                icon: unref(dynamicStyle) && unref(dynamicStyle).icon ? unref(dynamicStyle).icon : __props.icon,
                size: __props.size,
                flag: __props.flag,
                class: normalizeClass([unref(isActive) && "active", !__props.color && "text-primary", __props.iconClass]),
                style: normalizeStyle({
                  color: unref(dynamicStyle) && unref(dynamicStyle).color ? unref(dynamicStyle).color : __props.color
                }),
                onClick: handleClick,
                onMouseenter: handleMouseEnter
              }, null, 8, ["iconStyle", "icon", "size", "flag", "class", "style"]),
              createTextVNode(" " + toDisplayString(__props.insertAfter), 1)
            ]),
            _: 1
          }, 16, ["class"]))
        ]),
        tip: withCtx(() => [
          createTextVNode(toDisplayString(__props.title), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]));
    };
  }
});
function toggleStepClass(validatingStepIndex, action, className, steps) {
  if (className) {
    steps[validatingStepIndex].ref.classList[action](className);
  }
}
function toggleInvalid(validatingStepIndex, steps) {
  toggleStepClass(validatingStepIndex, "add", "stepper-invalid", steps);
  toggleStepClass(validatingStepIndex, "remove", "stepper-completed", steps);
  toggleStepClass(validatingStepIndex, "add", "", steps);
  toggleStepClass(validatingStepIndex, "remove", "", steps);
}
function validateStep(validatingStepIndex, steps, nextStepIndex, stepperLinear, isLast = false) {
  const numberOfSteps = steps.length;
  let result = true;
  if (!isLast && validatingStepIndex === nextStepIndex) {
    result = false;
  }
  if (validatingStepIndex >= numberOfSteps || validatingStepIndex < 0) {
    result = false;
  }
  if (stepperLinear) {
    if (!isLast && validatingStepIndex > nextStepIndex - 1) {
      result = false;
    }
    if (nextStepIndex > validatingStepIndex || nextStepIndex === numberOfSteps || isLast) {
      const activeStep = steps[validatingStepIndex].ref;
      const requiredElements = Array.prototype.slice.call(
        activeStep.querySelectorAll(
          "input[required]"
        )
      );
      const isValid = requiredElements.every((el) => {
        return el.checkValidity() === true;
      });
      if (!isValid) {
        toggleInvalid(validatingStepIndex, steps);
        result = false;
      }
    }
  }
  return result;
}
const _hoisted_1$n = {
  key: 0,
  class: "stepper-mobile-head bg-light"
};
const _hoisted_2$i = {
  key: 1,
  class: "stepper-mobile-footer bg-light"
};
const _hoisted_3$f = { class: "stepper-back-btn" };
const _hoisted_4$e = /* @__PURE__ */ createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1);
const _hoisted_5$d = {
  key: 0,
  class: "stepper-mobile-progress gray-500"
};
const _hoisted_6$b = { class: "stepper-next-btn" };
const _hoisted_7$9 = /* @__PURE__ */ createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1);
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "MDBStepper",
  props: {
    tag: {
      type: String,
      default: "ul"
    },
    activeStepIndex: {
      type: Number,
      default: 1
    },
    linear: Boolean,
    noEditable: Boolean,
    vertical: Boolean,
    mobile: Boolean,
    mobileProgress: Boolean,
    verticalBreakpoint: Number,
    mobileBreakpoint: Number,
    disableStepperHeadClick: Boolean,
    nextBtn: {
      type: String,
      default: "NEXT"
    },
    backBtn: {
      type: String,
      default: "BACK"
    },
    stepTxt: {
      type: String,
      default: "step"
    },
    stepOfTxt: {
      type: String,
      default: "of"
    }
  },
  emits: ["on-invalid", "on-valid", "on-change-step"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const stepperRef = ref(null);
    const wrapperClassName = computed(() => {
      return [
        "stepper",
        isVertical.value && "stepper-vertical",
        isMobile.value && "stepper-mobile",
        props.mobileProgress && "stepper-progress-bar"
      ];
    });
    const state = reactive({
      steps: [],
      count: 0,
      activeStep: props.activeStepIndex - 1,
      prevStep: void 0
    });
    const addStep = () => {
      const newStep = {
        index: state.count,
        completed: false,
        ref: null,
        validated: false,
        valid: false,
        visited: false
      };
      state.steps.push(newStep);
      state.count++;
      return newStep.index;
    };
    const addStepRef = (ref2, index2) => {
      state.steps[index2].ref = ref2;
    };
    const setActiveStep = (index2) => {
      if (checkIndex(index2)) {
        state.activeStep = index2;
        emitEvent(index2, "on-valid");
      }
    };
    const setPrevStep = (index2) => {
      if (checkIndex(index2)) {
        state.prevStep = index2;
        setStepAttribute(index2, "completed");
        emitEvent(index2, "on-change-step");
      }
    };
    const setStepAttribute = (index2, attribute) => {
      if (checkIndex(index2)) {
        state.steps[index2][attribute] = true;
      }
    };
    const checkIndex = (index2) => {
      return state.steps.findIndex((step) => step.index === index2) > -1;
    };
    const verticalState = ref(props.vertical);
    const isVertical = computed(() => {
      return props.vertical || verticalState.value;
    });
    const mobileState = ref(props.mobile);
    const isMobile = computed(() => {
      return props.mobile || mobileState.value;
    });
    provide("state", state);
    provide("addStep", addStep);
    provide("addStepRef", addStepRef);
    provide("setActiveStep", setActiveStep);
    provide("setPrevStep", setPrevStep);
    provide("linear", props.linear);
    provide("mobile", isMobile);
    provide("vertical", isVertical);
    provide("noEditable", props.noEditable);
    provide("setStepAttribute", setStepAttribute);
    provide("disableStepperHeadClick", props.disableStepperHeadClick);
    const stepperHeight = ref(null);
    const setStepperHeight = (height) => {
      stepperHeight.value = height;
    };
    provide("setStepperHeight", setStepperHeight);
    const checkBreakpoints = () => {
      const shouldBeHorizontal = props.verticalBreakpoint < window.innerWidth;
      const shouldBeVertical = props.verticalBreakpoint > window.innerWidth;
      const shouldBeMobile = props.mobileBreakpoint > window.innerWidth;
      if (shouldBeHorizontal) {
        mobileState.value = false;
        verticalState.value = false;
      } else if (shouldBeVertical && !shouldBeMobile) {
        mobileState.value = false;
        verticalState.value = true;
      } else if (shouldBeMobile) {
        mobileState.value = true;
        verticalState.value = false;
      }
    };
    const stepValidation = (activeStep, steps, stepIndex) => {
      if (props.linear) {
        setStepAttribute(activeStep, "validated");
        const isValid = validateStep(activeStep, steps, stepIndex, props.linear);
        if (!isValid) {
          emitEvent(activeStep, "on-invalid");
        }
        return isValid;
      }
      return true;
    };
    const emitEvent = (stepIndex, type) => {
      if (checkIndex(stepIndex)) {
        emit(type, state.steps[stepIndex].ref);
      }
    };
    provide("emitEvent", emitEvent);
    const nextStep = () => {
      if (stepValidation(state.activeStep, state.steps, state.activeStep + 1)) {
        checkIndex(state.activeStep + 1) && setPrevStep(state.activeStep);
        setActiveStep(state.activeStep + 1);
      }
    };
    const prevStep = () => {
      checkIndex(state.activeStep - 1) && setPrevStep(state.activeStep);
      setActiveStep(state.activeStep - 1);
    };
    const changeStep = (index2) => {
      const validated = index2 - 1 > state.activeStep ? true : stepValidation(state.activeStep, state.steps, index2 - 1);
      if (validated) {
        if (index2 - 1 !== state.activeStep) {
          setPrevStep(state.activeStep);
          setActiveStep(index2 - 1);
        }
      }
    };
    onMounted(() => {
      if (props.mobileBreakpoint || props.verticalBreakpoint) {
        checkBreakpoints();
        window.addEventListener("resize", checkBreakpoints);
      }
    });
    expose({
      changeStep,
      nextStep,
      prevStep
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "stepperRef",
        ref: stepperRef,
        class: normalizeClass(unref(wrapperClassName)),
        style: normalizeStyle({ height: unref(isVertical) ? null : `${stepperHeight.value}px` })
      }, {
        default: withCtx(() => [
          unref(isMobile) ? (openBlock(), createElementBlock("div", _hoisted_1$n, toDisplayString(props.stepTxt) + " " + toDisplayString(state.activeStep + 1) + " " + toDisplayString(props.stepOfTxt) + " " + toDisplayString(state.count), 1)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default"),
          unref(isMobile) ? (openBlock(), createElementBlock("div", _hoisted_2$i, [
            createElementVNode("div", _hoisted_3$f, [
              createElementVNode("button", {
                type: "button",
                class: "btn btn-link",
                onClick: prevStep
              }, [
                _hoisted_4$e,
                createTextVNode(" " + toDisplayString(props.backBtn), 1)
              ])
            ]),
            __props.mobileProgress ? (openBlock(), createElementBlock("div", _hoisted_5$d, [
              createElementVNode("div", {
                class: "stepper-mobile-progress-bar bg-primary",
                style: normalizeStyle({ width: `${(state.activeStep + 1) / state.count * 100}%` })
              }, null, 4)
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_6$b, [
              createElementVNode("button", {
                type: "button",
                class: "btn btn-link ripple-surface",
                onClick: nextStep
              }, [
                createTextVNode(toDisplayString(props.nextBtn) + " ", 1),
                _hoisted_7$9
              ])
            ])
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class", "style"]);
    };
  }
});
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "MDBStepperStep",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    optional: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const stepRef = ref(null);
    const className = computed(() => {
      return [
        "stepper-step",
        isActive.value && "stepper-active",
        isCompleted.value && "stepper-completed",
        isValidated.value && "was-validated",
        isVisited.value && "stepper-disabled"
      ];
    });
    const { steps, activeStep } = toRefs(inject("state", null));
    const addStep = inject("addStep", null);
    const addStepRef = inject(
      "addStepRef",
      null
    );
    const stepIndex = addStep();
    provide("stepIndex", stepIndex);
    const isActive = computed(() => {
      return activeStep.value === stepIndex;
    });
    const isCompleted = computed(() => {
      return steps.value[stepIndex].completed;
    });
    const isVisited = computed(() => {
      return steps.value[stepIndex].visited;
    });
    provide("optional", props.optional);
    watch(
      () => isActive.value,
      (cur) => {
        if (cur) {
          nextTick(() => setHeight());
        }
      }
    );
    const isValidated = computed(() => {
      return steps.value[stepIndex].validated;
    });
    watch(
      () => isValidated.value,
      (cur) => {
        if (cur) {
          setTimeout(setHeight, 200);
        }
      }
    );
    const vertical = inject("vertical", false);
    const mobile = inject("mobile", false);
    if (mobile) {
      watch(
        () => mobile.value,
        (cur) => {
          if (cur) {
            setTimeout(setHeight, 250);
          }
        }
      );
    }
    if (vertical) {
      watch(
        () => vertical.value,
        (cur) => {
          if (cur) {
            setHeight();
          }
        }
      );
    }
    const getParentElement = (element, selector) => {
      let isParentOk = false;
      let checkElement = element;
      while (!isParentOk && checkElement !== document.body) {
        const parentElement = checkElement.parentNode;
        if (parentElement.classList.contains(selector)) {
          isParentOk = true;
        }
        checkElement = parentElement;
      }
      return checkElement;
    };
    const setStepperHeight = inject("setStepperHeight");
    const setHeight = () => {
      if (!stepRef.value)
        return;
      const element = stepRef.value;
      const stepContent = element.querySelector(".stepper-content");
      const stepFooter = getParentElement(element, "stepper").querySelector(
        `.stepper-mobile-footer`
      );
      const contentStyle = stepContent && getComputedStyle(stepContent);
      const footerStyle = stepFooter ? getComputedStyle(stepFooter) : "";
      let stepHead;
      if (mobile && mobile.value) {
        stepHead = getParentElement(element, "stepper").querySelector(
          ".stepper-mobile-head"
        );
      } else {
        stepHead = element.querySelector(".stepper-head");
      }
      const headStyle = stepHead && getComputedStyle(stepHead);
      if (stepContent && contentStyle) {
        const stepContentHeight = stepContent.offsetHeight + parseFloat(contentStyle.marginTop) + parseFloat(contentStyle.marginBottom);
        const stepHeadHeight = stepHead.offsetHeight + parseFloat(headStyle.marginTop) + parseFloat(headStyle.marginBottom);
        const stepFooterHeight = footerStyle ? stepFooter.offsetHeight + parseFloat(footerStyle.marginTop) + parseFloat(footerStyle.marginBottom) : 0;
        setStepperHeight(stepHeadHeight + stepContentHeight + stepFooterHeight);
      }
    };
    onMounted(() => {
      addStepRef(stepRef.value, stepIndex);
      if (activeStep.value === stepIndex && vertical && !vertical.value) {
        setHeight();
      }
      on(window, "resize", setHeight);
    });
    onUnmounted(() => {
      off(window, "resize", setHeight);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "stepRef",
        ref: stepRef,
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$m = {
  key: 0,
  class: "stepper-head-icon"
};
const _hoisted_2$h = {
  key: 1,
  class: "stepper-head-icon"
};
const _hoisted_3$e = { class: "stepper-head-text" };
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "MDBStepperHead",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    icon: String
  },
  setup(__props) {
    const { activeStep, steps } = toRefs(inject("state"));
    const stepIndex = inject("stepIndex", null);
    const setActiveStep = inject("setActiveStep", null);
    const setPrevStep = inject("setPrevStep", null);
    const linear = inject("linear", null);
    const noEditable = inject("noEditable", null);
    const setStepAttribute = inject(
      "setStepAttribute",
      null
    );
    const optional = inject("optional", null);
    const emitEvent = inject("emitEvent", null);
    const disableStepperHeadClick = inject(
      "disableStepperHeadClick",
      null
    );
    const setCurrentActive = () => {
      if (linear && stepIndex > activeStep.value) {
        setStepAttribute(activeStep.value, "validated");
        const isValid = validateStep(
          activeStep.value,
          steps.value,
          stepIndex,
          linear
        );
        if (!isValid) {
          emitEvent(activeStep.value, "on-invalid");
          return;
        }
      }
      if (noEditable) {
        setStepAttribute(activeStep.value, "visited");
        const isVisited = steps.value[stepIndex].visited;
        if (isVisited) {
          return;
        }
      }
      stepIndex !== activeStep.value && setPrevStep(activeStep.value);
      setActiveStep(stepIndex);
    };
    const clickEvent = computed(() => {
      return disableStepperHeadClick ? null : "click";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: "stepper-head",
        "data-mdb-content": unref(optional) ? "Optional" : null,
        [toHandlerKey(unref(clickEvent))]: setCurrentActive
      }, {
        default: withCtx(() => [
          __props.icon ? (openBlock(), createElementBlock("span", _hoisted_1$m, toDisplayString(__props.icon), 1)) : (openBlock(), createElementBlock("span", _hoisted_2$h, [
            renderSlot(_ctx.$slots, "icon")
          ])),
          createElementVNode("span", _hoisted_3$e, [
            renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 16, ["data-mdb-content"]);
    };
  }
});
const OnScrollDirective = {
  mounted(el, binding) {
    if (binding.value === false || !el)
      return;
    const options = binding.value;
    let isFirstShow = true;
    let isFirstHide = true;
    el.animate = () => {
      const offset2 = parseInt(options.offset, 10) || 0;
      const repeatOnShow = options.repeatOnShow || false;
      const callback2 = options.callback || options;
      const getOffset = () => {
        const rect = el.getBoundingClientRect();
        return rect.top;
      };
      const elementOffsetTop = getOffset();
      const elementHeight = el.offsetHeight;
      const windowHeight = window.innerHeight;
      const isInView = elementOffsetTop + offset2 <= windowHeight && elementOffsetTop + offset2 + elementHeight >= 0;
      switch (true) {
        case (isInView && isFirstShow):
          if (repeatOnShow) {
            isFirstHide = true;
          }
          isFirstShow = false;
          callback2("hasShown");
          break;
        case (!isInView && isFirstHide && !isFirstShow):
          if (repeatOnShow) {
            isFirstShow = true;
          }
          isFirstHide = false;
          callback2("hasHidden");
          break;
      }
    };
    window.addEventListener("scroll", (e) => el.animate(e));
  },
  unmounted(el, binding) {
    if (binding.value === false)
      return;
    window.removeEventListener("scroll", (e) => el.animate(e));
  }
};
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "MDBAnimation",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    trigger: {
      type: String,
      default: "onClick",
      validator: (type) => ["onHover", "onClick", "manually", "onLoad", "onScroll"].indexOf(type) > -1
    },
    modelValue: Boolean,
    animation: {
      type: [String, Boolean],
      default: "fade-in"
    },
    duration: {
      type: Number,
      default: 500
    },
    reset: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 0
    },
    interval: {
      type: Number,
      default: 0
    },
    repeat: {
      type: [Boolean, Number],
      default: false
    },
    direction: {
      type: String,
      default: "normal"
    },
    repeatOnScroll: {
      type: Boolean,
      default: false
    },
    scrollOffset: {
      type: Number,
      default: 0
    },
    showOnLoad: {
      type: Boolean,
      default: true
    }
  },
  emits: ["hide", "show", "start", "end", "update:modelValue"],
  setup(__props, { expose, emit }) {
    const props = __props;
    const animationClasses = ref("");
    const className = computed(() => [animationClasses.value]);
    const setAnimationClasses = () => {
      animationClasses.value = `animation ${props.animation}`;
      emit("start", wrapper.value);
    };
    const clearAnimationClasses = () => {
      animationClasses.value = "";
      off(wrapper.value, "animationend", clearAnimationClasses);
      if (props.trigger === "manually" && props.modelValue && !props.repeat) {
        emit("update:modelValue", false);
      }
    };
    const emitEnd = () => {
      emit("end", wrapper.value);
      off(wrapper.value, "animationend", emitEnd);
    };
    const animationWrapperStyle = computed(() => {
      return {
        animationIterationCount: !props.interval && props.repeat === true ? "infinite" : props.repeat,
        animationDelay: `${props.delay}ms`,
        animationDuration: `${props.duration}ms`,
        animationDirection: props.direction
      };
    });
    const startAnimation = () => {
      setAnimationClasses();
      if (isOnHover.value) {
        resetHoverEvents();
      }
      if (props.interval) {
        on(wrapper.value, "animationend", startInterval);
      }
      if (props.reset) {
        bindAnimationReset();
      }
      on(wrapper.value, "animationend", emitEnd);
    };
    const stopAnimation = () => {
      clearAnimationClasses();
    };
    watch(
      () => props.animation,
      () => {
        startAnimation();
      }
    );
    const isOnHover = ref(props.trigger === "onHover");
    const activateHoverEvents = () => {
      isOnHover.value = true;
    };
    const isOnClick = ref(props.trigger === "onClick");
    const activateClickEvents = () => {
      isOnClick.value = true;
    };
    const isOnManual = ref(props.trigger === "manually");
    const activateManualEvents = () => {
      isOnManual.value = true;
    };
    const activeScrollEvents = {
      callback: (value) => handleScroll(value),
      offset: props.scrollOffset,
      repeatOnShow: props.repeatOnScroll
    };
    const handleScroll = (scrollStatus) => {
      switch (scrollStatus) {
        case "hasShown":
          startAnimation();
          showAnimateElement();
          break;
        case "hasHidden":
          if (props.repeatOnScroll) {
            clearAnimationClasses();
            if (!props.showOnLoad || props.scrollOffset > 0) {
              hideAnimateElement();
            }
          }
          break;
      }
    };
    const hideScrollElementOnShow = () => {
      if (!props.showOnLoad || props.scrollOffset > 0) {
        hideAnimateElement();
      }
    };
    const hideAnimateElement = () => {
      wrapper.value.style.visibility = "hidden";
      emit("hide", wrapper.value);
    };
    const showAnimateElement = () => {
      wrapper.value.style.visibility = "visible";
      emit("show", wrapper.value);
    };
    const triggerManual = ref(props.modelValue);
    watchEffect(() => {
      triggerManual.value = props.modelValue;
    });
    watch(
      () => triggerManual.value,
      (cur, prev) => {
        if (cur && isOnManual.value) {
          startAnimation();
        } else if (prev === true) {
          stopAnimation();
        }
      }
    );
    const startInterval = () => {
      clearAnimationClasses();
      setTimeout(() => {
        setAnimationClasses();
      }, props.interval);
    };
    const resetHoverEvents = () => {
      isOnHover.value = false;
      setTimeout(() => {
        isOnHover.value = true;
      }, props.duration + 100);
    };
    const bindAnimationReset = () => {
      on(wrapper.value, "animationend", clearAnimationClasses);
    };
    const wrapper = ref(null);
    onMounted(() => {
      if (!props.animation) {
        return;
      }
      switch (props.trigger) {
        case "onHover":
          activateHoverEvents();
          break;
        case "onClick":
          activateClickEvents();
          break;
        case "onLoad":
          startAnimation();
          break;
        case "manually":
          activateManualEvents();
          break;
        case "onScroll":
          hideScrollElementOnShow();
          break;
      }
    });
    onUnmounted(() => {
      off(wrapper.value, "animationend", clearAnimationClasses);
      off(wrapper.value, "animationend", startInterval);
      off(wrapper.value, "animationend", emitEnd);
    });
    expose({
      startAnimation,
      stopAnimation
    });
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "wrapper",
        ref: wrapper,
        class: normalizeClass(unref(className)),
        style: normalizeStyle(unref(animationWrapperStyle)),
        onMouseenter: _cache[0] || (_cache[0] = () => isOnHover.value && startAnimation()),
        onClick: _cache[1] || (_cache[1] = () => isOnClick.value && startAnimation())
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 40, ["class", "style"])), [
        [
          unref(OnScrollDirective),
          __props.trigger === "onScroll" ? activeScrollEvents : false
        ]
      ]);
    };
  }
});
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "MDBStepperContent",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const className = computed(() => {
      return [
        "stepper-content",
        "py-3",
        vertical && vertical.value && !isActive.value && "stepper-content-hide"
      ];
    });
    const height = ref("0px");
    const heightStyle = computed(() => ({
      height: height.value
    }));
    const contentRef = ref(null);
    const { activeStep, prevStep } = toRefs(inject("state"));
    const stepIndex = inject("stepIndex", null);
    ref(true);
    const shouldBeActive = computed(() => activeStep.value === stepIndex);
    const isActive = ref(shouldBeActive.value);
    const shouldHide = ref(null);
    const vertical = inject("vertical", false);
    const animation = computed(() => {
      return shouldHide.value ? activeStep.value > prevStep.value ? "slide-out-left" : activeStep.value < prevStep.value ? "slide-out-right" : "" : (prevStep.value || prevStep.value === 0) && activeStep.value > prevStep.value ? "slide-in-right" : activeStep.value < prevStep.value ? "slide-in-left" : "";
    });
    const setHeight = () => {
      height.value = "100%";
    };
    watch(
      () => shouldBeActive.value,
      (cur) => {
        if (vertical && !vertical.value) {
          isActive.value = cur;
          return;
        }
        if (!cur) {
          const stepContent = contentRef.value;
          const stepHeight = stepContent.scrollHeight;
          contentRef.value.style.transition = "none";
          height.value = `${stepHeight}px`;
        }
        setTimeout(() => {
          contentRef.value.style.transition = "height 0.3s ease-in-out, margin-top 0.3s ease-in-out, margin-bottom 0.3s ease-in-out, padding-top 0.3s ease-in-out, padding-bottom 0.3s ease-in-out";
          isActive.value = cur;
        });
      }
    );
    watch(
      () => isActive.value,
      (cur) => {
        if (vertical && vertical.value && cur) {
          setTimeout(setHeight, 250);
        }
      }
    );
    if (vertical) {
      watch(
        () => vertical.value,
        (cur) => {
          nextTick(() => {
            if (cur && contentRef.value) {
              setTimeout(setHeight, 250);
            }
          });
        }
      );
    }
    watch(
      () => prevStep.value,
      (cur) => {
        if (vertical && vertical.value) {
          return;
        }
        if (contentRef.value && cur === stepIndex) {
          shouldHide.value = true;
          contentRef.value.startAnimation();
          setTimeout(
            () => {
              shouldHide.value = false;
            },
            window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 800
          );
        }
      },
      { immediate: true }
    );
    onMounted(() => {
      if (vertical && vertical.value) {
        setHeight();
      }
    });
    return (_ctx, _cache) => {
      return unref(vertical) ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        key: 0,
        ref_key: "contentRef",
        ref: contentRef,
        style: normalizeStyle(unref(heightStyle)),
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["style", "class"])) : !unref(vertical) && (isActive.value || shouldHide.value) ? (openBlock(), createBlock(_sfc_main$y, {
        key: 1,
        ref_key: "contentRef",
        ref: contentRef,
        tag: __props.tag,
        class: normalizeClass(unref(className)),
        trigger: "onLoad",
        reset: "",
        animation: unref(animation),
        duration: 800
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["tag", "class", "animation"])) : createCommentVNode("", true);
    };
  }
});
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "MDBStepperForm",
  props: {
    tag: {
      type: String,
      default: "form"
    }
  },
  setup(__props) {
    const { steps, activeStep } = toRefs(inject("state"));
    const linear = inject("linear");
    const setStepAttribute = inject("setStepAttribute");
    const formRef = ref(null);
    const className = computed(() => {
      return ["stepper-form", "needs-validation"];
    });
    const onSubmit = (e) => {
      const form = e.target;
      if (!form.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
      }
      steps.value.forEach((el, i) => {
        setStepAttribute(i, "validated");
        validateStep(activeStep.value, steps.value, i, linear, true);
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "formRef",
        ref: formRef,
        class: normalizeClass(unref(className)),
        noValidate: "",
        onSubmit
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 40, ["class"]);
    };
  }
});
const _hoisted_1$l = ["id"];
const _hoisted_2$g = { class: "popconfirm show" };
const _hoisted_3$d = { class: "popconfirm-message" };
const _hoisted_4$d = {
  key: 0,
  class: "popconfirm-icon-container"
};
const _hoisted_5$c = { class: "popconfirm-message-text" };
const _hoisted_6$a = { class: "popconfirm-buttons-container" };
const _hoisted_7$8 = ["id"];
const _hoisted_8$7 = { class: "popconfirm-message" };
const _hoisted_9$7 = {
  key: 0,
  class: "popconfirm-icon-container"
};
const _hoisted_10$5 = { class: "popconfirm-message-text" };
const _hoisted_11$2 = { class: "popconfirm-buttons-container" };
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "MDBPopconfirm",
  props: {
    tag: {
      type: String,
      default: "button"
    },
    message: {
      type: String,
      default: "Are you sure?"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    cancelLabel: {
      type: String,
      default: "Cancel"
    },
    confirmText: {
      type: String,
      default: "Ok"
    },
    confirmLabel: {
      type: String,
      default: "Confirm"
    },
    icon: {
      type: String,
      default: ""
    },
    modal: Boolean,
    offset: {
      type: String,
      default: "0, 5"
    },
    position: {
      type: String,
      default: "bottom"
    }
  },
  emits: ["confirm", "cancel"],
  setup(__props, { emit }) {
    const props = __props;
    const isRTL = document.documentElement.dir === "rtl";
    const popconfirmContainerClassName = computed(() => {
      return [props.modal ? "popconfirm-modal" : "popconfirm-popover", "shadow-4"];
    });
    const popconfirmClassName = computed(() => {
      return ["popconfirm", "fade", show.value];
    });
    const uid2 = getUID("MDBPopconfirm-");
    const show = ref("");
    const translatePositionValue = () => {
      switch (props.position) {
        case "top left":
          return isRTL ? "top-start" : "top-end";
        case "top":
          return "top";
        case "top right":
          return isRTL ? "top-end" : "top-start";
        case "bottom left":
          return isRTL ? "bottom-start" : "bottom-end";
        case "bottom":
          return "bottom";
        case "bottom right":
          return isRTL ? "bottom-end" : "bottom-start";
        case "left":
          return isRTL ? "right" : "left";
        case "left top":
          return isRTL ? "right-end" : "left-end";
        case "left bottom":
          return isRTL ? "right-start" : "left-start";
        case "right":
          return isRTL ? "left" : "right";
        case "right top":
          return isRTL ? "left-end" : "right-end";
        case "right bottom":
          return isRTL ? "left-start" : "right-start";
        case void 0:
          return "bottom";
        default:
          return props.position;
      }
    };
    const modalRef = ref(null);
    const { setPopper, isPopperActive, openPopper, closePopper, getPopperOffset } = MDBPopper();
    const triggerEl = ref(null);
    const popperEl = ref(null);
    const popperSetup = () => {
      const placement = translatePositionValue();
      const config = {
        placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: getPopperOffset(props.offset, modalRef.value)
            }
          }
        ]
      };
      setPopper(
        triggerEl.value,
        popperEl.value,
        config
      );
    };
    const isActive = ref(false);
    watchEffect(() => {
      if (isActive.value && !props.modal) {
        nextTick(() => {
          popperSetup();
          openPopper();
          setTimeout(() => {
            show.value = "show";
          }, 0);
          on(window, "keydown", handleEscapeKey);
        });
      } else {
        if (!isPopperActive.value) {
          return;
        }
        show.value = "";
        setTimeout(closePopper, 150);
        off(window, "keydown", handleEscapeKey);
      }
    });
    const open = () => {
      if (!isActive.value) {
        isActive.value = true;
      }
    };
    const close = () => {
      isActive.value = false;
    };
    const clickOutside = (event) => {
      const isButton = triggerEl.value === event.target;
      const isPopover = popperEl.value === event.target;
      const isPopoverContent = popperEl.value && popperEl.value.contains(event.target);
      if (!isButton && !isPopover && !isPopoverContent) {
        close();
      }
    };
    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        close();
      }
    };
    const handleButtonClick = (event) => {
      emit(event);
      close();
    };
    onUnmounted(() => {
      off(window, "keydown", handleEscapeKey);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          ref_key: "triggerEl",
          ref: triggerEl,
          class: "btn btn-primary popconfirm-toggle"
        }, _ctx.$attrs, { onClick: open }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16)),
        __props.modal && isActive.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          id: unref(uid2),
          ref_key: "modalRef",
          ref: modalRef,
          class: "popconfirm-backdrop",
          onClick: close
        }, [
          createElementVNode("div", {
            class: normalizeClass([unref(popconfirmContainerClassName)])
          }, [
            createElementVNode("div", _hoisted_2$g, [
              createElementVNode("div", _hoisted_3$d, [
                __props.icon ? (openBlock(), createElementBlock("span", _hoisted_4$d, [
                  createElementVNode("i", {
                    class: normalizeClass(__props.icon)
                  }, null, 2)
                ])) : createCommentVNode("", true),
                createElementVNode("span", _hoisted_5$c, toDisplayString(!_ctx.$slots.message ? __props.message : null), 1),
                _ctx.$slots.message ? renderSlot(_ctx.$slots, "message", { key: 1 }) : createCommentVNode("", true)
              ]),
              createElementVNode("div", _hoisted_6$a, [
                createVNode(_sfc_main$1C, {
                  color: "flat",
                  size: "sm",
                  "aria-label": __props.cancelLabel,
                  onClick: _cache[0] || (_cache[0] = ($event) => handleButtonClick("cancel"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.cancelText), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"]),
                createVNode(_sfc_main$1C, {
                  color: "primary",
                  size: "sm",
                  "aria-label": __props.confirmLabel,
                  onClick: _cache[1] || (_cache[1] = ($event) => handleButtonClick("confirm"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.confirmText), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"])
              ])
            ])
          ], 2)
        ], 8, _hoisted_1$l)) : (openBlock(), createBlock(Teleport, {
          key: 1,
          to: "body"
        }, [
          isActive.value ? withDirectives((openBlock(), createElementBlock("div", {
            key: 0,
            id: unref(uid2),
            ref_key: "popperEl",
            ref: popperEl,
            class: normalizeClass(unref(popconfirmContainerClassName))
          }, [
            createElementVNode("div", {
              class: normalizeClass(unref(popconfirmClassName))
            }, [
              createElementVNode("div", _hoisted_8$7, [
                __props.icon ? (openBlock(), createElementBlock("span", _hoisted_9$7, [
                  createElementVNode("i", {
                    class: normalizeClass(__props.icon)
                  }, null, 2)
                ])) : createCommentVNode("", true),
                createElementVNode("span", _hoisted_10$5, toDisplayString(!_ctx.$slots.message ? __props.message : null), 1),
                _ctx.$slots.message ? renderSlot(_ctx.$slots, "message", { key: 1 }) : createCommentVNode("", true)
              ]),
              createElementVNode("div", _hoisted_11$2, [
                createVNode(_sfc_main$1C, {
                  color: "flat",
                  size: "sm",
                  "aria-label": __props.cancelLabel,
                  onClick: _cache[2] || (_cache[2] = ($event) => handleButtonClick("cancel"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.cancelText), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"]),
                createVNode(_sfc_main$1C, {
                  color: "primary",
                  size: "sm",
                  "aria-label": __props.confirmLabel,
                  onClick: _cache[3] || (_cache[3] = ($event) => handleButtonClick("confirm"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.confirmText), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"])
              ])
            ], 2)
          ], 10, _hoisted_7$8)), [
            [unref(vMdbClickOutside), clickOutside]
          ]) : createCommentVNode("", true)
        ]))
      ], 64);
    };
  }
});
const _hoisted_1$k = { class: "lightbox-gallery-loader" };
const _hoisted_2$f = { class: "lightbox-gallery-left-tools" };
const _hoisted_3$c = { class: "lightbox-gallery-counter" };
const _hoisted_4$c = { class: "lightbox-gallery-right-tools" };
const _hoisted_5$b = ["aria-label"];
const _hoisted_6$9 = { class: "lightbox-gallery-content" };
const _hoisted_7$7 = ["alt", "src"];
const _hoisted_8$6 = { class: "lightbox-gallery-caption-wrapper" };
const _hoisted_9$6 = { class: "lightbox-gallery-caption" };
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "MDBLightbox",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    zoomLevel: {
      type: [Number, String],
      default: 1
    },
    fontAwesome: {
      type: String,
      default: "free"
    }
  },
  emits: [
    "close",
    "closed",
    "open",
    "opened",
    "slide",
    "slided",
    "zoom-in",
    "zoomed-in",
    "zoom-out",
    "zoomed-out"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const lightboxRef = ref(null);
    const galleryRef = ref(null);
    const className = computed(() => {
      return ["lightbox"];
    });
    const isActive = ref(false);
    const activeImgIndex = ref(-1);
    const initialImagesArray = ref([]);
    const images = ref([]);
    const fullscreen = ref(false);
    provide("initialImagesArray", initialImagesArray);
    const setRef = (el, key) => {
      const imgRef = el;
      images.value[key].ref = imgRef;
    };
    const caption = ref("");
    watch(
      () => activeImgIndex.value,
      () => {
        nextTick(() => {
          const currentImg = getCurrentImg();
          caption.value = currentImg.caption || currentImg.alt || `Lightbox image ${currentImg.id + 1}`;
        });
      }
    );
    const resetImagesArrays = () => {
      initialImagesArray.value = [];
      images.value = [];
      imgCount.value = 0;
    };
    const queryImages = () => {
      resetImagesArrays();
      const queryImages2 = lightboxRef.value.querySelectorAll(
        "img"
      );
      queryImages2.forEach((img) => {
        addImg(img);
      });
      getImages();
    };
    const updateImages = () => {
      queryImages();
    };
    const imgCount = ref(0);
    const addImg = (img) => {
      const { lightboxThumbnail, lightboxSrc, lightboxCaption, lightboxDisabled } = img.dataset;
      const image = {
        id: imgCount.value,
        refId: img.id,
        left: 0,
        opacity: 1,
        scale: 0.25,
        active: false,
        thumbnail: lightboxThumbnail,
        src: lightboxSrc || lightboxThumbnail,
        alt: img.alt,
        caption: lightboxCaption,
        disabled: lightboxDisabled,
        ref: img
      };
      if (image.disabled) {
        return;
      }
      initialImagesArray.value.push(image);
      images.value.push(image);
      imgCount.value++;
    };
    const setActiveImg = (imgId) => {
      activeImgIndex.value = imgId;
    };
    const setImgStyle = (img, key) => {
      if (img.left === 0) {
        img.active = true;
        img.opacity = 1;
        img.scale = 1;
      } else {
        img.active = false;
        img.opacity = 0;
      }
      if (key === imgCount.value - 1 && imgCount.value > 1) {
        img.left = -100;
      }
    };
    const calculateImgSize = (img) => {
      if (img.width >= img.height) {
        img.style.width = "100%";
        img.style.maxWidth = "100%";
        img.style.height = "auto";
        img.style.top = `${(img.parentNode.offsetHeight - img.height) / 2}px`;
        img.style.left = "0px";
      } else {
        img.style.height = "100%";
        img.style.maxHeight = "100%";
        img.style.width = "auto";
        img.style.left = `${(img.parentNode.offsetWidth - img.width) / 2}px`;
        img.style.top = "0px";
      }
      if (img.width >= img.parentNode.offsetWidth) {
        img.style.width = `${img.parentNode.offsetWidth}px`;
        img.style.height = "auto";
        img.style.left = "0px";
        img.style.top = `${(img.parentNode.offsetHeight - img.height) / 2}px`;
      }
      if (img.height >= img.parentNode.offsetHeight) {
        img.style.height = `${img.parentNode.offsetHeight}px`;
        img.style.width = "auto";
        img.style.top = "0px";
        img.style.left = `${(img.parentNode.offsetWidth - img.width) / 2}px`;
      }
    };
    const getImages = () => {
      images.value = [...initialImagesArray.value];
    };
    const resetImagesValues = () => {
      images.value = images.value.map((img) => {
        return {
          ...img,
          left: 0,
          opacity: 0,
          active: false
        };
      });
    };
    const getCurrentImg = () => {
      return images.value.filter((img) => img.left === 0)[0];
    };
    const sortImages = () => {
      for (let i = 0; i < activeImgIndex.value; i++) {
        images.value.push(images.value.shift());
      }
    };
    const resetImgLeftPosition = () => {
      images.value = images.value.map((img, i) => {
        return {
          ...img,
          left: 0 + 100 * i
        };
      });
    };
    const resetImagesForClosing = () => {
      images.value = images.value.map((img) => ({
        ...img,
        opacity: 0,
        scale: 0.25
      }));
    };
    provide("addImg", addImg);
    const isLoading = ref(false);
    const toolsOpacity = ref(1);
    const toolsToggleTimer = ref(0);
    const resetToolsToggler = () => {
      toolsOpacity.value = 1;
      clearTimeout(toolsToggleTimer.value);
      setToolsToggleTimout();
    };
    const setToolsToggleTimout = () => {
      toolsToggleTimer.value = setTimeout(() => {
        toolsOpacity.value = 0;
        clearTimeout(toolsToggleTimer.value);
      }, 4e3);
    };
    const disableScroll = () => {
      document.body.classList.add("disabled-scroll");
      if (document.documentElement.scrollHeight > document.documentElement.clientHeight) {
        document.body.classList.add("replace-scrollbar");
      }
    };
    const enableScroll = () => {
      setTimeout(() => {
        document.body.classList.remove("disabled-scroll");
        document.body.classList.remove("replace-scrollbar");
      }, 300);
    };
    const toggleLightbox = (itemId = 0) => {
      if (itemId === -1 || isActive.value) {
        close();
      } else {
        open(itemId);
      }
    };
    const toggleFullscreen = () => {
      var _a;
      if (!fullscreen.value) {
        if ((_a = galleryRef.value) == null ? void 0 : _a.requestFullscreen) {
          galleryRef.value.requestFullscreen();
        }
        fullscreen.value = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
        fullscreen.value = false;
      }
    };
    provide("toggleLightbox", toggleLightbox);
    const open = (itemId = 0) => {
      emit("open");
      getImages();
      setActiveImg(itemId);
      sortImages();
      resetImgLeftPosition();
      isActive.value = true;
      nextTick(() => {
        images.value.forEach((img, key) => {
          setImgStyle(img, key);
          calculateImgSize(img.ref);
        });
        setTimeout(() => {
          images.value.forEach((img) => {
            if (img.left === 0) {
              img.scale = 1;
            }
          });
        }, 50);
        disableScroll();
        setToolsToggleTimout();
        addEvents();
        emit("opened");
        setFocusOn();
      });
    };
    const close = () => {
      if (isActive.value) {
        emit("close");
        if (fullscreen.value) {
          toggleFullscreen();
        }
        enableScroll();
        removeEvents();
        resetImagesForClosing();
        isActive.value = false;
        activeImgIndex.value = -1;
        restoreDefaultZoom();
        resetImagesValues();
        emit("closed");
        setFocusOn();
      }
    };
    const fullscreenBtnRef = ref(null);
    const toggleBtnRef = ref(null);
    const closeBtnRef = ref(null);
    const arrowLeftBtnRef = ref(null);
    const arrowRightBtnRef = ref(null);
    const focusTrapCount = ref(0);
    const focusableButtons = [
      fullscreenBtnRef,
      toggleBtnRef,
      closeBtnRef,
      arrowLeftBtnRef,
      arrowRightBtnRef
    ];
    const tabCount = (e) => {
      if (e.key === "Tab") {
        e.preventDefault();
        focusableButtons[focusTrapCount.value].value.focus();
        if (focusTrapCount.value < focusableButtons.length - 1) {
          focusTrapCount.value++;
        } else {
          focusTrapCount.value = 0;
        }
      }
    };
    const setFocusOn = () => {
      if (isActive.value) {
        setTimeout(() => {
          window.addEventListener("keydown", tabCount);
        }, 100);
      } else if (!isActive.value) {
        setTimeout(() => {
          focusTrapCount.value = 0;
          window.removeEventListener("keydown", tabCount);
        }, 100);
      }
    };
    const isAnimating = ref(false);
    const animationStart = () => {
      isAnimating.value = true;
      setTimeout(() => {
        isAnimating.value = false;
      }, 400);
    };
    const slideHorizontally = (direction) => {
      images.value.forEach((img) => {
        let newPositionLeft;
        if (direction === 1) {
          newPositionLeft = img.left - 100;
          if (newPositionLeft < -100)
            newPositionLeft = (imgCount.value - 2) * 100;
        } else {
          newPositionLeft = img.left + 100;
          if (newPositionLeft === (imgCount.value - 1) * 100)
            newPositionLeft = -100;
        }
        if (newPositionLeft === 0) {
          img.opacity = 1;
          img.scale = 1;
          img.active = true;
          calculateImgSize(img.ref);
        } else {
          img.opacity = 0;
          img.scale = 0.25;
          img.active = false;
        }
        img.left = newPositionLeft;
      });
    };
    const slideToTarget = (target) => {
      if (target === 0 && activeImgIndex.value === 0) {
        return;
      }
      if (target === imgCount.value - 1 && activeImgIndex.value === imgCount.value - 1) {
        return;
      }
      isLoading.value = true;
      images.value.forEach((img) => {
        img.opacity = 0;
        img.scale = 0.25;
      });
      resetImagesValues();
      setTimeout(() => {
        getImages();
        setActiveImg(target === 0 ? 0 : imgCount.value - 1);
        sortImages();
        resetImgLeftPosition();
        nextTick(() => {
          calculateImgSize(getCurrentImg().ref);
          images.value.forEach((img, key) => {
            setImgStyle(img, key);
          });
          isLoading.value = false;
        });
      }, 400);
    };
    const slide = (direction = "right") => {
      if (isAnimating.value || imgCount.value <= 1) {
        return;
      }
      emit("slide");
      animationStart();
      resetDoubleTap();
      let change;
      switch (direction) {
        case "right":
          change = 1;
          break;
        case "left":
          change = -1;
          break;
        case "first":
          change = 0;
          break;
        case "last":
          change = imgCount.value - 1;
          break;
      }
      if (Math.abs(change) === 1) {
        slideHorizontally(change);
        const next = activeImgIndex.value + change < 0 ? imgCount.value - 1 : activeImgIndex.value + change > imgCount.value - 1 ? 0 : activeImgIndex.value + change;
        setActiveImg(next);
      } else {
        slideToTarget(change);
      }
      restoreDefaultZoom();
      emit("slided");
    };
    const originalPosition = reactive({
      x: 0,
      y: 0
    });
    const position = reactive({
      x: 0,
      y: 0
    });
    const mousedownPosition = reactive({
      x: 0,
      y: 0
    });
    const doubleTapTimer = ref(0);
    const tapTime = ref(0);
    const tapCounter = ref(0);
    const checkDoubleTap = (e) => {
      clearTimeout(doubleTapTimer.value);
      const currentTime = new Date().getTime();
      const tapLength = currentTime - tapTime.value;
      if (tapCounter.value > 0 && tapLength < 500) {
        handleDoubleClick(e);
        doubleTapTimer.value = setTimeout(() => {
          tapTime.value = new Date().getTime();
          tapCounter.value = 0;
        }, 300);
      } else {
        tapCounter.value++;
        tapTime.value = new Date().getTime();
      }
    };
    const resetDoubleTap = () => {
      tapTime.value = 0;
      tapCounter.value = 0;
      clearTimeout(doubleTapTimer.value);
    };
    const handleDoubleClick = (e) => {
      if (multitouch) {
        return;
      }
      if (!(e instanceof TouchEvent && e.touches) && e instanceof MouseEvent) {
        setNewPositionOnZoomIn(e);
      }
      if (zoom.value !== 1) {
        restoreDefaultZoom();
      } else {
        zoomIn();
      }
    };
    const mousedown = ref(false);
    let touchZoomPosition;
    let multitouch = false;
    const handleMousedown = (event) => {
      const touch2 = event instanceof TouchEvent ? event.touches : void 0;
      if ((touch2 == null ? void 0 : touch2.length) > 1) {
        multitouch = true;
        touchZoomPosition = touch2;
      }
      const x = touch2 ? touch2[0].clientX : event.clientX;
      const y = touch2 ? touch2[0].clientY : event.clientY;
      const { ref: currentImg } = getCurrentImg();
      originalPosition.x = parseFloat(currentImg.style.left) || 0;
      originalPosition.y = parseFloat(currentImg.style.top) || 0;
      position.x = originalPosition.x;
      position.y = originalPosition.y;
      mousedownPosition.x = x * (1 / zoom.value) - position.x;
      mousedownPosition.y = y * (1 / zoom.value) - position.y;
      mousedown.value = true;
    };
    const handleMouseLeave = () => {
      if (!mousedown.value)
        return;
      mousedown.value = false;
    };
    const handleMousemove = (e) => {
      if (!mousedown.value)
        return;
      const touch2 = e instanceof TouchEvent ? e.touches : void 0;
      const x = touch2 ? touch2[0].clientX : e.clientX;
      const y = touch2 ? touch2[0].clientY : e.clientY;
      if (touch2)
        resetToolsToggler();
      const { ref: currentImg } = getCurrentImg();
      if (!multitouch) {
        if (zoom.value !== 1) {
          position.x = x * (1 / zoom.value) - mousedownPosition.x;
          position.y = y * (1 / zoom.value) - mousedownPosition.y;
          currentImg.style.left = `${position.x}px`;
          currentImg.style.top = `${position.y}px`;
        } else {
          if (images.value.length <= 1)
            return;
          position.x = x * (1 / zoom.value) - mousedownPosition.x;
          currentImg.style.left = `${position.x}px`;
        }
      }
    };
    const handleMouseup = (event, touch2 = void 0) => {
      if (!mousedown.value)
        return;
      const moveX = position.x - originalPosition.x;
      mousedown.value = false;
      if (moveX !== 0) {
        moveImg(moveX);
      }
      if (touch2) {
        checkDoubleTap(event);
      }
      if (multitouch) {
        if (event.targetTouches.length === 0) {
          multitouch = false;
          touchZoomPosition = [];
        }
      }
    };
    const moveImg = (movement) => {
      if (multitouch) {
        return;
      }
      if (zoom.value !== 1 || imgCount.value <= 1) {
        return;
      }
      if (movement > 0) {
        if (isRTL) {
          slide();
        } else {
          slide("left");
        }
      } else if (movement < 0) {
        if (isRTL) {
          slide("left");
        } else {
          slide();
        }
      }
    };
    const handleWindowResize = () => {
      images.value.forEach((img) => {
        calculateImgSize(img.ref);
      });
    };
    const handleFullScreenChange = () => {
      const isFullscreenEnabled = document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
      if (isFullscreenEnabled === void 0) {
        fullscreen.value = false;
      }
    };
    const zoom = ref(1);
    const zoomTimer = ref(null);
    const toggleZoom = () => {
      if (zoom.value !== 1) {
        restoreDefaultZoom();
      } else {
        zoomIn();
      }
    };
    const zoomIn = () => {
      if (zoom.value >= 3)
        return;
      emit("zoom-in");
      const zoomValue = typeof props.zoomLevel === "string" ? parseFloat(props.zoomLevel) : props.zoomLevel;
      zoom.value += zoomValue;
      getCurrentImg().scale = zoom.value;
      emit("zoomed-in");
    };
    const zoomOut = () => {
      if (zoom.value <= 1)
        return;
      emit("zoom-out");
      const zoomValue = typeof props.zoomLevel === "string" ? parseFloat(props.zoomLevel) : props.zoomLevel;
      zoom.value -= zoomValue;
      getCurrentImg().scale = zoom.value;
      emit("zoomed-out");
      if (zoom.value === 1) {
        restoreDefaultPosition();
      }
    };
    const restoreDefaultZoom = () => {
      if (zoom.value !== 1) {
        emit("zoom-out");
        zoom.value = 1;
        getCurrentImg().scale = 1;
        restoreDefaultPosition();
        emit("zoomed-out");
      }
    };
    const handleImgScroll = (e) => {
      if (e.deltaY > 0) {
        zoomOut();
      } else {
        if (zoom.value >= 3)
          return;
        setNewPositionOnZoomIn(e);
        zoomIn();
      }
    };
    const setNewPositionOnZoomIn = (e) => {
      clearTimeout(zoomTimer.value);
      const positionX = window.innerWidth / 2 - e.offsetX - 50;
      const positionY = window.innerHeight / 2 - e.offsetY - 50;
      const currentImg = getCurrentImg();
      currentImg.ref.style.transition = "all 0.5s ease-out";
      currentImg.ref.style.left = `${positionX}px`;
      currentImg.ref.style.top = `${positionY}px`;
      zoomTimer.value = setTimeout(() => {
        currentImg.ref.style.transition = "none";
      }, 500);
    };
    const restoreDefaultPosition = () => {
      clearTimeout(zoomTimer.value);
      const currentImg = getCurrentImg().ref;
      currentImg.style.transition = "all 0.5s ease-out";
      currentImg.style.top = "0px";
      currentImg.style.left = "0px";
      calculateImgSize(currentImg);
      setTimeout(() => {
        currentImg.style.transition = "none";
      }, 500);
    };
    const calculateTouchZoom = (event) => {
      const initialDistance = Math.hypot(
        touchZoomPosition[1].pageX - touchZoomPosition[0].pageX,
        touchZoomPosition[1].pageY - touchZoomPosition[0].pageY
      );
      const finalDistance = Math.hypot(
        event.touches[1].pageX - event.touches[0].pageX,
        event.touches[1].pageY - event.touches[0].pageY
      );
      const distanceChange = Math.abs(initialDistance - finalDistance);
      const screenWidth = event.view.screen.width;
      if (distanceChange > screenWidth * 0.03) {
        if (initialDistance <= finalDistance) {
          zoomIn();
        } else {
          zoomOut();
        }
        touchZoomPosition = event.touches;
      }
    };
    const onWindowTouchstart = (event) => {
      if (event.touches.length > 1) {
        multitouch = true;
        touchZoomPosition = event.touches;
      }
    };
    const onWindowTouchmove = (event) => {
      if (multitouch && event.type === "touchmove" && event.targetTouches.length > 1) {
        event.preventDefault();
        calculateTouchZoom(event);
      }
    };
    const isRTL = document.documentElement.dir === "rtl";
    const handleBackdropClick = (e) => {
      resetToolsToggler();
      if (e.target.tagName !== "DIV")
        return;
      close();
    };
    const handleKeyup = (e) => {
      if (!isActive.value) {
        return;
      }
      e.preventDefault();
      resetToolsToggler();
      switch (e.keyCode) {
        case 39:
          if (isRTL) {
            slide("left");
          } else {
            slide();
          }
          break;
        case 37:
          if (isRTL) {
            slide();
          } else {
            slide("left");
          }
          break;
        case 27:
          close();
          break;
        case 36:
          slide("first");
          break;
        case 35:
          slide("last");
          break;
        case 38:
          zoomIn();
          break;
        case 40:
          zoomOut();
          break;
      }
    };
    const addEvents = () => {
      on(galleryRef.value, "click", handleBackdropClick);
      on(window, "keyup", handleKeyup);
      on(window, "resize", handleWindowResize);
      on(window, "orientationchange", handleWindowResize);
      on(window, "fullscreenchange", handleFullScreenChange);
      on(window, "touchstart", onWindowTouchstart);
    };
    const removeEvents = () => {
      off(galleryRef.value, "click", handleBackdropClick);
      off(window, "keyup", handleKeyup);
      off(window, "resize", handleWindowResize);
      off(window, "orientationchange", handleWindowResize);
      off(window, "fullscreenchange", handleFullScreenChange);
      off(window, "touchstart", onWindowTouchstart);
    };
    onMounted(() => {
      addEvents();
      queryImages();
      document.addEventListener("touchmove", onWindowTouchmove, { passive: false });
    });
    onUnmounted(() => {
      removeEvents();
      document.removeEventListener("touchmove", onWindowTouchmove);
    });
    onBeforeUpdate(() => {
      images.value.forEach((img) => {
        img.ref = null;
      });
    });
    expose({
      updateImages,
      open,
      slide,
      zoomIn,
      zoomOut,
      toggleFullscreen,
      close,
      addImg,
      resetImagesArrays,
      getCurrentImg,
      activeImgIndex,
      initialImagesArray,
      lightboxRef
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps(_ctx.$attrs, {
          ref_key: "lightboxRef",
          ref: lightboxRef,
          class: unref(className)
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          createElementVNode("div", {
            ref_key: "galleryRef",
            ref: galleryRef,
            class: "lightbox-gallery",
            style: normalizeStyle({
              opacity: isActive.value ? 1 : 0,
              pointerEvents: isActive.value ? "initial" : "none",
              visibility: isActive.value ? "visible" : "hidden"
            }),
            onMousemove: resetToolsToggler
          }, [
            withDirectives(createElementVNode("div", _hoisted_1$k, [
              createVNode(_sfc_main$1l, {
                grow: "",
                color: "light"
              })
            ], 512), [
              [vShow, isLoading.value]
            ]),
            createElementVNode("div", {
              class: "lightbox-gallery-toolbar",
              style: normalizeStyle({ opacity: toolsOpacity.value })
            }, [
              createElementVNode("div", _hoisted_2$f, [
                createElementVNode("p", _hoisted_3$c, toDisplayString(`${activeImgIndex.value + 1} / ${imgCount.value}`), 1)
              ]),
              createElementVNode("div", _hoisted_4$c, [
                createElementVNode("button", {
                  ref_key: "fullscreenBtnRef",
                  ref: fullscreenBtnRef,
                  "aria-label": "Toggle fullscreen",
                  class: normalizeClass([
                    "lightbox-gallery-fullscreen-btn",
                    fullscreen.value && "active",
                    __props.fontAwesome === "pro" && "fontawesome-pro"
                  ]),
                  onClick: toggleFullscreen
                }, null, 2),
                createElementVNode("button", {
                  ref_key: "toggleBtnRef",
                  ref: toggleBtnRef,
                  class: normalizeClass([
                    "lightbox-gallery-zoom-btn",
                    __props.fontAwesome === "pro" && "fontawesome-pro",
                    zoom.value > 1 && "active"
                  ]),
                  "aria-label": zoom.value > 1 ? "Zoom in" : "Zoom out",
                  onClick: toggleZoom
                }, null, 10, _hoisted_5$b),
                createElementVNode("button", {
                  ref_key: "closeBtnRef",
                  ref: closeBtnRef,
                  "aria-label": "Close",
                  class: normalizeClass([
                    "lightbox-gallery-close-btn",
                    __props.fontAwesome === "pro" && "fontawesome-pro"
                  ]),
                  onClick: close
                }, null, 2)
              ])
            ], 4),
            createElementVNode("div", _hoisted_6$9, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(images.value, (img, key) => {
                return openBlock(), createElementBlock("div", {
                  key,
                  class: "lightbox-gallery-image",
                  style: normalizeStyle({
                    position: "absolute",
                    top: "0px",
                    left: `${img.left}%`,
                    opacity: img.opacity,
                    transform: `scale(${img.scale})`
                  })
                }, [
                  createElementVNode("img", {
                    ref_for: true,
                    ref: (el) => setRef(el, key),
                    alt: img.alt || `Lightbox image ${img.id + 1}`,
                    draggable: "false",
                    class: normalizeClass([img.active ? "active" : null, "lightbox-image"]),
                    src: img.src,
                    onWheel: handleImgScroll,
                    onMouseup: handleMouseup,
                    onMousemove: handleMousemove,
                    onMouseleave: handleMouseLeave,
                    onMousedown: handleMousedown,
                    onTouchend: _cache[0] || (_cache[0] = (event) => handleMouseup(event, true)),
                    onTouchmove: handleMousemove,
                    onTouchstart: handleMousedown,
                    onDblclick: handleDoubleClick
                  }, null, 42, _hoisted_7$7)
                ], 4);
              }), 128))
            ]),
            createElementVNode("div", {
              class: "lightbox-gallery-arrow-left",
              style: normalizeStyle({ opacity: toolsOpacity.value })
            }, [
              createElementVNode("button", {
                ref_key: "arrowLeftBtnRef",
                ref: arrowLeftBtnRef,
                class: normalizeClass([__props.fontAwesome === "pro" && "fontawesome-pro"]),
                "aria-label": "Previous",
                onClick: _cache[1] || (_cache[1] = ($event) => slide("left"))
              }, null, 2)
            ], 4),
            createElementVNode("div", {
              class: "lightbox-gallery-arrow-right",
              style: normalizeStyle({ opacity: toolsOpacity.value })
            }, [
              createElementVNode("button", {
                ref_key: "arrowRightBtnRef",
                ref: arrowRightBtnRef,
                class: normalizeClass([__props.fontAwesome === "pro" && "fontawesome-pro"]),
                "aria-label": "Next",
                onClick: _cache[2] || (_cache[2] = ($event) => slide())
              }, null, 2)
            ], 4),
            createElementVNode("div", _hoisted_8$6, [
              createElementVNode("p", _hoisted_9$6, toDisplayString(caption.value), 1)
            ])
          ], 36)
        ]))
      ], 64);
    };
  }
});
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "MDBLightboxItem",
  props: {
    tag: {
      type: String,
      default: "img"
    },
    id: String,
    fullScreenSrc: String,
    caption: String,
    disabled: Boolean
  },
  emits: ["update:modelValue", "item-click", "item-hover"],
  setup(__props, { emit }) {
    const props = __props;
    const lightboxItemRef = ref(null);
    const uid2 = props.id || getUID("MDBLightboxItem-");
    const toggleLightbox = inject(
      "toggleLightbox",
      false
    );
    const initialImagesArray = inject("initialImagesArray", []);
    const findImg = () => {
      return !Array.isArray(initialImagesArray) && initialImagesArray.value && initialImagesArray.value.find((img) => img.refId === uid2);
    };
    const handleClick = () => {
      const image = findImg();
      if (toggleLightbox && image) {
        toggleLightbox(image.id);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        id: unref(uid2),
        ref_key: "lightboxItemRef",
        ref: lightboxItemRef,
        "data-lightbox-src": __props.fullScreenSrc,
        "data-lightbox-caption": __props.caption,
        "data-lightbox-disabled": __props.disabled ? true : null,
        class: normalizeClass({
          ["lightbox-disabled"]: __props.disabled
        }),
        onClick: handleClick
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "data-lightbox-src", "data-lightbox-caption", "data-lightbox-disabled", "class"]);
    };
  }
});
const _hoisted_1$j = ["src", "alt"];
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "MDBChip",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    src: String,
    alt: String,
    size: String,
    outline: String,
    close: Boolean,
    handleClose: Function
  },
  emits: ["close-chip"],
  setup(__props, { emit }) {
    const props = __props;
    const active = ref(true);
    function handleCloseClick() {
      if (props.handleClose) {
        props.handleClose();
      }
      emit("close-chip");
      active.value = false;
    }
    const className = computed(() => [
      "chip",
      props.size && `chip-${props.size}`,
      props.outline && `chip-outline btn-outline-${props.outline}`
    ]);
    return (_ctx, _cache) => {
      return active.value ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        key: 0,
        class: normalizeClass(unref(className))
      }, {
        default: withCtx(() => [
          __props.src ? (openBlock(), createElementBlock("img", {
            key: 0,
            src: __props.src,
            alt: __props.alt
          }, null, 8, _hoisted_1$j)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default"),
          withDirectives(createElementVNode("i", {
            class: "fas fa-times close",
            onClick: handleCloseClick
          }, null, 512), [
            [vShow, __props.close]
          ])
        ]),
        _: 3
      }, 8, ["class"])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$i = ["contenteditable", "onDblclick", "onBlur", "onKeydown"];
const _hoisted_2$e = ["onClick"];
const _hoisted_3$b = ["id", "placeholder", "onKeyup", "onKeydown"];
const _hoisted_4$b = ["for"];
const _hoisted_5$a = { class: "form-notch" };
const _hoisted_6$8 = /* @__PURE__ */ createElementVNode("div", { class: "form-notch-trailing" }, null, -1);
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "MDBChipsInput",
  props: {
    id: String,
    tag: {
      type: String,
      default: "div"
    },
    chips: {
      type: Array,
      default: () => []
    },
    label: String,
    labelClasses: String,
    placeholder: String,
    secondaryPlaceholder: String,
    chipSize: String,
    value: Array,
    editable: Boolean
  },
  emits: [
    "delete-chip",
    "add-chip",
    "arrow-down",
    "arrow-up",
    "arrow-left",
    "arrow-right"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const chipsList = ref([]);
    const inputValue = ref("");
    const input = ref(null);
    const chipRef = ref([]);
    const labelRef = ref(null);
    const isReadyToDelete = ref(true);
    const notchLeadingWidth = ref(9);
    const notchMiddleWidth = ref(0);
    const uid2 = props.id || getUID("MDBInput-");
    const state = reactive({
      count: 0,
      activeStep: void 0,
      prevStep: void 0
    });
    function addChip() {
      if (inputValue.value === "" || chipsList.value.find((chip) => chip.value === inputValue.value)) {
        inputValue.value = "";
        return;
      }
      chipsList.value.push({
        value: inputValue.value,
        id: getUID("chip-"),
        editable: null,
        closeBtn: true,
        isActive: null
      });
      inputValue.value = "";
      emit("add-chip", chipsValueList.value);
    }
    function handleClick(e) {
      const target = e.target;
      if (target.classList.contains("chip") || target.classList.contains("close")) {
        return;
      }
      input.value.focus();
    }
    function onBlur() {
      chipsList.value.forEach((chip) => chip.isActive = null);
      handleAddingChips();
    }
    function handleAddingChips() {
      if (/^ *$/.test(inputValue.value)) {
        inputValue.value = "";
        return;
      }
      addChip();
    }
    function handleDeletePress() {
      if (!inputValue.value && isReadyToDelete.value) {
        const activeChipIndex = chipsList.value.findIndex(
          (chip) => chip.isActive === true
        );
        if (activeChipIndex > -1) {
          chipsList.value.splice(activeChipIndex, 1);
          if (state.count) {
            if (state.prevStep > state.activeStep) {
              state.count = state.prevStep - 1;
            } else {
              state.count = state.activeStep - 1;
            }
          }
          if (chipsList.value[state.count]) {
            chipsList.value[state.count].isActive = true;
          }
        } else {
          chipsList.value.pop();
          if (state.count >= chipsList.value.length - 1) {
            state.count = chipsList.value.length - 1;
          }
        }
        emit("delete-chip", chipsValueList.value);
      }
    }
    function handleCloseClick(chipName) {
      const array = chipsList.value;
      const index2 = array.indexOf(chipName);
      array.splice(index2, 1);
      if (state.count >= chipsList.value.length - 1) {
        state.count = chipsList.value.length - 1;
      }
      emit("delete-chip", chipsValueList.value);
    }
    function handleRightPress() {
      handleRightMove();
      emit("arrow-right");
    }
    function handleUpPress() {
      handleRightMove();
      emit("arrow-up");
    }
    function handleLeftPress() {
      handleLeftMove();
      emit("arrow-left");
    }
    function handleDownPress() {
      handleLeftMove();
      emit("arrow-down");
    }
    function handleRightMove() {
      if (state.activeStep === void 0) {
        chipsList.value[state.count].isActive = true;
        state.activeStep = state.count;
      } else {
        state.count++;
        chipsList.value[state.count - 1].isActive = null;
        if (state.count >= chipsList.value.length) {
          state.count = 0;
        }
        state.prevStep = state.activeStep;
        state.activeStep = state.count;
        chipsList.value[state.count].isActive = true;
      }
    }
    function handleLeftMove() {
      if (state.activeStep === void 0) {
        state.count = chipsList.value.length - 1;
        chipsList.value[state.count].isActive = true;
        state.activeStep = state.count;
      } else {
        state.count--;
        chipsList.value[state.count + 1].isActive = null;
        if (state.count <= -1) {
          state.count = chipsList.value.length - 1;
        }
        state.prevStep = state.activeStep;
        state.activeStep = state.count;
        chipsList.value[state.count].isActive = true;
      }
    }
    function handleEditable(id, index2) {
      if (props.editable) {
        const filteredChip = chipsList.value.find((chip) => chip.id === id);
        if (filteredChip) {
          isReadyToDelete.value = false;
          filteredChip.editable = true;
          filteredChip.closeBtn = false;
        }
        if (chipRef.value[index2]) {
          setTimeout(() => {
            chipRef.value[index2].focus();
          }, 0);
        }
      }
    }
    function disableEditable(id, index2) {
      if (props.editable) {
        isReadyToDelete.value = true;
        const filteredChip = chipsList.value.find((chip) => chip.id === id);
        if (filteredChip) {
          filteredChip.editable = false;
          filteredChip.closeBtn = true;
        }
        if (chipRef.value[index2]) {
          filteredChip.value = chipRef.value[index2].textContent.trim();
          if (filteredChip.value === "") {
            chipsList.value.splice(index2, 1);
          }
        }
      }
    }
    function calcNotch() {
      if (labelRef.value) {
        notchMiddleWidth.value = labelRef.value.clientWidth * 0.8 + 8;
      }
    }
    function addInitialValues() {
      if (props.chips.length > 0) {
        props.chips.forEach((chip) => {
          chipsList.value.push({
            value: chip,
            id: getUID("chip-"),
            editable: null,
            closeBtn: true,
            isActive: null
          });
        });
      } else {
        chipsList.value = [];
      }
    }
    const setChipRef = (el) => {
      if (el) {
        chipRef.value.push(el);
      }
    };
    onBeforeUpdate(() => chipRef.value = []);
    onMounted(() => addInitialValues());
    onUpdated(() => calcNotch());
    const isNotEmpty = computed(() => chipsList.value.length > 0);
    const chipsValueList = computed(
      () => chipsList.value.map((chip) => chip.value)
    );
    const tagClassName = computed(() => ["chips", "chips-placeholder"]);
    const chipClassName = (index2) => {
      const isActive = chipsList.value.map((chip) => chip.isActive);
      return [
        "chip",
        props.chipSize && "chip-" + props.chipSize,
        isActive[index2] && "active"
      ];
    };
    const notchClassName = computed(() => [
      isNotEmpty.value && "chips-padding chips-transition"
    ]);
    const inputClassName = computed(() => [isNotEmpty.value && "active"]);
    const labelClassName = computed(() => ["form-label", props.labelClasses]);
    const calculatePlaceholder = computed(() => {
      const calculatedPlaceholder = !props.secondaryPlaceholder && props.placeholder ? props.placeholder : props.secondaryPlaceholder;
      const calculatedSecondaryPlaceholder = !props.placeholder && props.secondaryPlaceholder ? props.secondaryPlaceholder : props.placeholder;
      if (chipsList.value.length > 0) {
        return calculatedSecondaryPlaceholder;
      }
      return calculatedPlaceholder;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass(unref(tagClassName)),
        onClick: handleClick,
        onKeydown: withKeys(handleDeletePress, ["delete"])
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(["form-outline chips-input-wrapper", unref(notchClassName)])
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(chipsList.value, (chip, index2) => {
              return withDirectives((openBlock(), createElementBlock("div", {
                ref_for: true,
                ref: setChipRef,
                key: chip.id,
                contenteditable: chip.editable,
                class: normalizeClass(chipClassName(index2)),
                onDblclick: ($event) => handleEditable(chip.id, index2),
                onBlur: ($event) => disableEditable(chip.id, index2),
                onKeydown: withKeys(($event) => disableEditable(chip.id, index2), ["enter"])
              }, [
                createTextVNode(toDisplayString(chip.value) + " ", 1),
                withDirectives(createElementVNode("i", {
                  class: "fas fa-times close",
                  onClick: ($event) => handleCloseClick(chip)
                }, null, 8, _hoisted_2$e), [
                  [vShow, chip.closeBtn]
                ])
              ], 42, _hoisted_1$i)), [
                [unref(RippleDirective)]
              ]);
            }), 128)),
            withDirectives(createElementVNode("input", {
              id: unref(uid2),
              ref_key: "input",
              ref: input,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
              class: normalizeClass(["form-control chips-input", unref(inputClassName)]),
              type: "text",
              placeholder: unref(calculatePlaceholder),
              onBlur,
              onKeyup: withKeys(handleAddingChips, ["enter"]),
              onKeydown: [
                withKeys(handleLeftPress, ["left"]),
                withKeys(handleRightPress, ["right"]),
                withKeys(handleDownPress, ["down"]),
                withKeys(handleUpPress, ["up"])
              ]
            }, null, 42, _hoisted_3$b), [
              [vModelText, inputValue.value]
            ]),
            props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              ref_key: "labelRef",
              ref: labelRef,
              class: normalizeClass(unref(labelClassName)),
              for: unref(uid2)
            }, toDisplayString(props.label), 11, _hoisted_4$b)) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_5$a, [
              createElementVNode("div", {
                class: "form-notch-leading",
                style: normalizeStyle({ width: `${notchLeadingWidth.value}px` })
              }, null, 4),
              createElementVNode("div", {
                class: "form-notch-middle",
                style: normalizeStyle({ width: `${notchMiddleWidth.value}px` })
              }, null, 4),
              _hoisted_6$8
            ])
          ], 2)
        ]),
        _: 1
      }, 40, ["class", "onKeydown"]);
    };
  }
});
const _hoisted_1$h = ["for"];
const _hoisted_2$d = ["id", "value", "min", "max"];
const _hoisted_3$a = { class: "thumb-value" };
const _hoisted_4$a = ["id", "value", "min", "max"];
const _hoisted_5$9 = { class: "thumb-value" };
const __default__$9 = {
  name: "MDBMultiRange",
  inheritAttrs: false
};
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  ...__default__$9,
  props: {
    id: String,
    secondId: String,
    inputClass: String,
    label: String,
    labelClass: String,
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    firstValue: {
      type: Number,
      default: 0
    },
    secondValue: {
      type: Number,
      default: 100
    },
    tag: {
      type: String,
      default: "div"
    },
    thumb: {
      type: Boolean,
      default: true
    },
    oneRange: {
      type: Boolean,
      default: false
    },
    thumbClass: String,
    wrapperClass: String
  },
  emits: [
    "update:firstValue",
    "update:secondValue",
    "start",
    "end",
    "slide"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const inputValue = ref(props.firstValue);
    const minValue = ref(props.min);
    const maxValue = ref(props.max);
    const uid2 = props.id || getUID("MDBRange-");
    const activeThumbs = reactive({ first: false, second: false });
    const secondInputValue = ref(props.secondValue);
    const secondUid = props.secondId || getUID("MDBRange-");
    const wrapperClassName = computed(() => {
      return ["range multi-range-slider", props.wrapperClass];
    });
    const inputClassName = computed(() => {
      return ["form-range", props.inputClass];
    });
    const secondInputClassName = computed(() => {
      return ["form-range multi-range-input", props.inputClass];
    });
    const labelClassName = computed(() => {
      return ["form-label", props.labelClass];
    });
    const thumbClassName = computed(() => {
      return ["thumb", activeThumbs["first"] && "thumb-active", props.thumbClass];
    });
    const secondThumbClassName = computed(() => {
      return ["thumb", activeThumbs["second"] && "thumb-active", props.thumbClass];
    });
    const thumbsLeftPosition = reactive({ first: 0, second: 0 });
    const secondInputStyle = computed(() => {
      return {
        position: "absolute",
        left: 0
      };
    });
    const handleInput = (e) => {
      const target = e.target;
      const value = parseFloat(target.value);
      if (value > secondInputValue.value) {
        target.valueAsNumber = secondInputValue.value;
        return;
      }
      inputValue.value = value;
      emit("update:firstValue", inputValue.value);
      setThumbPosition("first");
    };
    const handleSecondInput = (e) => {
      const target = e.target;
      const value = parseFloat(target.value);
      if (value < inputValue.value) {
        target.valueAsNumber = inputValue.value;
        return;
      }
      secondInputValue.value = value;
      emit("update:secondValue", secondInputValue.value);
      setThumbPosition("second");
    };
    const toggleThumb = (thumb, state) => {
      activeThumbs[thumb] = state;
    };
    const setThumbPosition = (thumb) => {
      let left2;
      const minV = typeof minValue.value === "string" ? parseFloat(minValue.value) : minValue.value;
      const maxV = typeof maxValue.value === "string" ? parseFloat(maxValue.value) : maxValue.value;
      if (thumb === "first") {
        const iV = typeof inputValue.value === "string" ? parseFloat(inputValue.value) : inputValue.value;
        left2 = (iV - minV) * 100 / (maxV - minV);
      } else if (thumb === "second") {
        const siV = typeof secondInputValue.value === "string" ? parseFloat(secondInputValue.value) : secondInputValue.value;
        left2 = (siV - minV) * 100 / (maxV - minV);
      }
      thumbsLeftPosition[thumb] = `calc(${left2}% + (${8 - left2 * 0.15}px))`;
    };
    nextTick(() => {
      setThumbPosition("first");
      setThumbPosition("second");
    });
    watch(
      () => props.firstValue,
      (value) => {
        inputValue.value = value;
        setThumbPosition("first");
      }
    );
    watch(
      () => props.secondValue,
      (value) => {
        secondInputValue.value = value;
        setThumbPosition("second");
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        __props.label ? (openBlock(), createElementBlock("label", {
          key: 0,
          class: normalizeClass(unref(labelClassName)),
          for: unref(uid2)
        }, toDisplayString(__props.label), 11, _hoisted_1$h)) : createCommentVNode("", true),
        (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
          class: normalizeClass(unref(wrapperClassName))
        }, {
          default: withCtx(() => [
            createElementVNode("input", mergeProps({
              id: unref(uid2),
              type: "range",
              class: unref(inputClassName),
              value: inputValue.value,
              min: minValue.value,
              max: maxValue.value
            }, _ctx.$attrs, {
              onInput: handleInput,
              onMousedown: _cache[0] || (_cache[0] = ($event) => (toggleThumb("first", true), _ctx.$emit("start"))),
              onTouchstart: _cache[1] || (_cache[1] = ($event) => (toggleThumb("first", true), _ctx.$emit("start"))),
              onMouseup: _cache[2] || (_cache[2] = ($event) => (toggleThumb("first", false), _ctx.$emit("end"))),
              onTouchend: _cache[3] || (_cache[3] = ($event) => (toggleThumb("first", false), _ctx.$emit("end"))),
              onKeydown: [
                _cache[4] || (_cache[4] = withKeys(($event) => _ctx.$emit("slide"), ["left"])),
                _cache[5] || (_cache[5] = withKeys(($event) => _ctx.$emit("slide"), ["right"])),
                _cache[6] || (_cache[6] = withKeys(($event) => _ctx.$emit("slide"), ["up"])),
                _cache[7] || (_cache[7] = withKeys(($event) => _ctx.$emit("slide"), ["down"]))
              ],
              onFocus: _cache[8] || (_cache[8] = ($event) => toggleThumb("first", true)),
              onBlur: _cache[9] || (_cache[9] = ($event) => toggleThumb("first", false))
            }), null, 16, _hoisted_2$d),
            __props.thumb ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(thumbClassName)),
              style: normalizeStyle({ left: thumbsLeftPosition["first"] })
            }, [
              createElementVNode("span", _hoisted_3$a, toDisplayString(inputValue.value), 1)
            ], 6)) : createCommentVNode("", true),
            !props.oneRange ? (openBlock(), createElementBlock("input", mergeProps({
              key: 1,
              id: unref(secondUid),
              type: "range",
              class: unref(secondInputClassName),
              value: secondInputValue.value,
              min: minValue.value,
              max: maxValue.value
            }, _ctx.$attrs, {
              onInput: handleSecondInput,
              onMousedown: _cache[10] || (_cache[10] = ($event) => (toggleThumb("second", true), _ctx.$emit("start"))),
              onTouchstart: _cache[11] || (_cache[11] = ($event) => (toggleThumb("second", true), _ctx.$emit("start"))),
              onMouseup: _cache[12] || (_cache[12] = ($event) => (toggleThumb("second", false), _ctx.$emit("end"))),
              onTouchend: _cache[13] || (_cache[13] = ($event) => (toggleThumb("second", false), _ctx.$emit("end"))),
              onKeydown: [
                _cache[14] || (_cache[14] = withKeys(($event) => _ctx.$emit("slide"), ["left"])),
                _cache[15] || (_cache[15] = withKeys(($event) => _ctx.$emit("slide"), ["right"])),
                _cache[16] || (_cache[16] = withKeys(($event) => _ctx.$emit("slide"), ["up"])),
                _cache[17] || (_cache[17] = withKeys(($event) => _ctx.$emit("slide"), ["down"]))
              ],
              onFocus: _cache[18] || (_cache[18] = ($event) => toggleThumb("second", true)),
              onBlur: _cache[19] || (_cache[19] = ($event) => toggleThumb("second", false)),
              style: unref(secondInputStyle)
            }), null, 16, _hoisted_4$a)) : createCommentVNode("", true),
            __props.thumb && !props.oneRange ? (openBlock(), createElementBlock("span", {
              key: 2,
              class: normalizeClass(unref(secondThumbClassName)),
              style: normalizeStyle({ left: thumbsLeftPosition["second"] })
            }, [
              createElementVNode("span", _hoisted_5$9, toDisplayString(secondInputValue.value), 1)
            ], 6)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 64);
    };
  }
});
/*!
 * perfect-scrollbar v1.5.3
 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
function get(element) {
  return getComputedStyle(element);
}
function set$1(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === "number") {
      val = val + "px";
    }
    element.style[key] = val;
  }
  return element;
}
function div(className) {
  var div2 = document.createElement("div");
  div2.className = className;
  return div2;
}
var elMatches = typeof Element !== "undefined" && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function matches(element, query) {
  if (!elMatches) {
    throw new Error("No element matching method supported");
  }
  return elMatches.call(element, query);
}
function remove(element) {
  if (element.remove) {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
}
function queryChildren(element, selector) {
  return Array.prototype.filter.call(
    element.children,
    function(child) {
      return matches(child, selector);
    }
  );
}
var cls = {
  main: "ps",
  rtl: "ps__rtl",
  element: {
    thumb: function(x) {
      return "ps__thumb-" + x;
    },
    rail: function(x) {
      return "ps__rail-" + x;
    },
    consuming: "ps__child--consume"
  },
  state: {
    focus: "ps--focus",
    clicking: "ps--clicking",
    active: function(x) {
      return "ps--active-" + x;
    },
    scrolling: function(x) {
      return "ps--scrolling-" + x;
    }
  }
};
var scrollingClassTimeout = { x: null, y: null };
function addScrollingClass(i, x) {
  var classList = i.element.classList;
  var className = cls.state.scrolling(x);
  if (classList.contains(className)) {
    clearTimeout(scrollingClassTimeout[x]);
  } else {
    classList.add(className);
  }
}
function removeScrollingClass(i, x) {
  scrollingClassTimeout[x] = setTimeout(
    function() {
      return i.isAlive && i.element.classList.remove(cls.state.scrolling(x));
    },
    i.settings.scrollingThreshold
  );
}
function setScrollingClassInstantly(i, x) {
  addScrollingClass(i, x);
  removeScrollingClass(i, x);
}
var EventElement = function EventElement2(element) {
  this.element = element;
  this.handlers = {};
};
var prototypeAccessors = { isEmpty: { configurable: true } };
EventElement.prototype.bind = function bind(eventName, handler) {
  if (typeof this.handlers[eventName] === "undefined") {
    this.handlers[eventName] = [];
  }
  this.handlers[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};
EventElement.prototype.unbind = function unbind(eventName, target) {
  var this$1$1 = this;
  this.handlers[eventName] = this.handlers[eventName].filter(function(handler) {
    if (target && handler !== target) {
      return true;
    }
    this$1$1.element.removeEventListener(eventName, handler, false);
    return false;
  });
};
EventElement.prototype.unbindAll = function unbindAll() {
  for (var name in this.handlers) {
    this.unbind(name);
  }
};
prototypeAccessors.isEmpty.get = function() {
  var this$1$1 = this;
  return Object.keys(this.handlers).every(
    function(key) {
      return this$1$1.handlers[key].length === 0;
    }
  );
};
Object.defineProperties(EventElement.prototype, prototypeAccessors);
var EventManager = function EventManager2() {
  this.eventElements = [];
};
EventManager.prototype.eventElement = function eventElement(element) {
  var ee = this.eventElements.filter(function(ee2) {
    return ee2.element === element;
  })[0];
  if (!ee) {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};
EventManager.prototype.bind = function bind2(element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};
EventManager.prototype.unbind = function unbind2(element, eventName, handler) {
  var ee = this.eventElement(element);
  ee.unbind(eventName, handler);
  if (ee.isEmpty) {
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
  }
};
EventManager.prototype.unbindAll = function unbindAll2() {
  this.eventElements.forEach(function(e) {
    return e.unbindAll();
  });
  this.eventElements = [];
};
EventManager.prototype.once = function once(element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function(evt) {
    ee.unbind(eventName, onceHandler);
    handler(evt);
  };
  ee.bind(eventName, onceHandler);
};
function createEvent(name) {
  if (typeof window.CustomEvent === "function") {
    return new CustomEvent(name);
  } else {
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(name, false, false, void 0);
    return evt;
  }
}
function processScrollDiff(i, axis, diff, useScrollingClass, forceFireReachEvent) {
  if (useScrollingClass === void 0)
    useScrollingClass = true;
  if (forceFireReachEvent === void 0)
    forceFireReachEvent = false;
  var fields;
  if (axis === "top") {
    fields = [
      "contentHeight",
      "containerHeight",
      "scrollTop",
      "y",
      "up",
      "down"
    ];
  } else if (axis === "left") {
    fields = [
      "contentWidth",
      "containerWidth",
      "scrollLeft",
      "x",
      "left",
      "right"
    ];
  } else {
    throw new Error("A proper axis should be provided");
  }
  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
}
function processScrollDiff$1(i, diff, ref2, useScrollingClass, forceFireReachEvent) {
  var contentHeight = ref2[0];
  var containerHeight = ref2[1];
  var scrollTop = ref2[2];
  var y = ref2[3];
  var up = ref2[4];
  var down = ref2[5];
  if (useScrollingClass === void 0)
    useScrollingClass = true;
  if (forceFireReachEvent === void 0)
    forceFireReachEvent = false;
  var element = i.element;
  i.reach[y] = null;
  if (element[scrollTop] < 1) {
    i.reach[y] = "start";
  }
  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
    i.reach[y] = "end";
  }
  if (diff) {
    element.dispatchEvent(createEvent("ps-scroll-" + y));
    if (diff < 0) {
      element.dispatchEvent(createEvent("ps-scroll-" + up));
    } else if (diff > 0) {
      element.dispatchEvent(createEvent("ps-scroll-" + down));
    }
    if (useScrollingClass) {
      setScrollingClassInstantly(i, y);
    }
  }
  if (i.reach[y] && (diff || forceFireReachEvent)) {
    element.dispatchEvent(createEvent("ps-" + y + "-reach-" + i.reach[y]));
  }
}
function toInt(x) {
  return parseInt(x, 10) || 0;
}
function isEditable(el) {
  return matches(el, "input,[contenteditable]") || matches(el, "select,[contenteditable]") || matches(el, "textarea,[contenteditable]") || matches(el, "button,[contenteditable]");
}
function outerWidth(element) {
  var styles = get(element);
  return toInt(styles.width) + toInt(styles.paddingLeft) + toInt(styles.paddingRight) + toInt(styles.borderLeftWidth) + toInt(styles.borderRightWidth);
}
var env = {
  isWebKit: typeof document !== "undefined" && "WebkitAppearance" in document.documentElement.style,
  supportsTouch: typeof window !== "undefined" && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof navigator !== "undefined" && navigator.msMaxTouchPoints,
  isChrome: typeof navigator !== "undefined" && /Chrome/i.test(navigator && navigator.userAgent)
};
function updateGeometry(i) {
  var element = i.element;
  var roundedScrollTop = Math.floor(element.scrollTop);
  var rect = element.getBoundingClientRect();
  i.containerWidth = Math.round(rect.width);
  i.containerHeight = Math.round(rect.height);
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;
  if (!element.contains(i.scrollbarXRail)) {
    queryChildren(element, cls.element.rail("x")).forEach(
      function(el) {
        return remove(el);
      }
    );
    element.appendChild(i.scrollbarXRail);
  }
  if (!element.contains(i.scrollbarYRail)) {
    queryChildren(element, cls.element.rail("y")).forEach(
      function(el) {
        return remove(el);
      }
    );
    element.appendChild(i.scrollbarYRail);
  }
  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(
      i,
      toInt(i.railXWidth * i.containerWidth / i.contentWidth)
    );
    i.scrollbarXLeft = toInt(
      (i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth)
    );
  } else {
    i.scrollbarXActive = false;
  }
  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(
      i,
      toInt(i.railYHeight * i.containerHeight / i.contentHeight)
    );
    i.scrollbarYTop = toInt(
      roundedScrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight)
    );
  } else {
    i.scrollbarYActive = false;
  }
  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }
  updateCss(element, i);
  if (i.scrollbarXActive) {
    element.classList.add(cls.state.active("x"));
  } else {
    element.classList.remove(cls.state.active("x"));
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
  }
  if (i.scrollbarYActive) {
    element.classList.add(cls.state.active("y"));
  } else {
    element.classList.remove(cls.state.active("y"));
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    element.scrollTop = 0;
  }
}
function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}
function updateCss(element, i) {
  var xRailOffset = { width: i.railXWidth };
  var roundedScrollTop = Math.floor(element.scrollTop);
  if (i.isRtl) {
    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
  }
  set$1(i.scrollbarXRail, xRailOffset);
  var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  set$1(i.scrollbarYRail, yRailOffset);
  set$1(i.scrollbarX, {
    left: i.scrollbarXLeft,
    width: i.scrollbarXWidth - i.railBorderXWidth
  });
  set$1(i.scrollbarY, {
    top: i.scrollbarYTop,
    height: i.scrollbarYHeight - i.railBorderYWidth
  });
}
function clickRail(i) {
  i.element;
  i.event.bind(i.scrollbarY, "mousedown", function(e) {
    return e.stopPropagation();
  });
  i.event.bind(i.scrollbarYRail, "mousedown", function(e) {
    var positionTop = e.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;
    i.element.scrollTop += direction * i.containerHeight;
    updateGeometry(i);
    e.stopPropagation();
  });
  i.event.bind(i.scrollbarX, "mousedown", function(e) {
    return e.stopPropagation();
  });
  i.event.bind(i.scrollbarXRail, "mousedown", function(e) {
    var positionLeft = e.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
    i.element.scrollLeft += direction * i.containerWidth;
    updateGeometry(i);
    e.stopPropagation();
  });
}
function dragThumb(i) {
  bindMouseScrollHandler(i, [
    "containerWidth",
    "contentWidth",
    "pageX",
    "railXWidth",
    "scrollbarX",
    "scrollbarXWidth",
    "scrollLeft",
    "x",
    "scrollbarXRail"
  ]);
  bindMouseScrollHandler(i, [
    "containerHeight",
    "contentHeight",
    "pageY",
    "railYHeight",
    "scrollbarY",
    "scrollbarYHeight",
    "scrollTop",
    "y",
    "scrollbarYRail"
  ]);
}
function bindMouseScrollHandler(i, ref2) {
  var containerHeight = ref2[0];
  var contentHeight = ref2[1];
  var pageY = ref2[2];
  var railYHeight = ref2[3];
  var scrollbarY = ref2[4];
  var scrollbarYHeight = ref2[5];
  var scrollTop = ref2[6];
  var y = ref2[7];
  var scrollbarYRail = ref2[8];
  var element = i.element;
  var startingScrollTop = null;
  var startingMousePageY = null;
  var scrollBy = null;
  function mouseMoveHandler(e) {
    if (e.touches && e.touches[0]) {
      e[pageY] = e.touches[0].pageY;
    }
    element[scrollTop] = startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
    addScrollingClass(i, y);
    updateGeometry(i);
    e.stopPropagation();
    if (e.type.startsWith("touch") && e.changedTouches.length > 1) {
      e.preventDefault();
    }
  }
  function mouseUpHandler() {
    removeScrollingClass(i, y);
    i[scrollbarYRail].classList.remove(cls.state.clicking);
    i.event.unbind(i.ownerDocument, "mousemove", mouseMoveHandler);
  }
  function bindMoves(e, touchMode) {
    startingScrollTop = element[scrollTop];
    if (touchMode && e.touches) {
      e[pageY] = e.touches[0].pageY;
    }
    startingMousePageY = e[pageY];
    scrollBy = (i[contentHeight] - i[containerHeight]) / (i[railYHeight] - i[scrollbarYHeight]);
    if (!touchMode) {
      i.event.bind(i.ownerDocument, "mousemove", mouseMoveHandler);
      i.event.once(i.ownerDocument, "mouseup", mouseUpHandler);
      e.preventDefault();
    } else {
      i.event.bind(i.ownerDocument, "touchmove", mouseMoveHandler);
    }
    i[scrollbarYRail].classList.add(cls.state.clicking);
    e.stopPropagation();
  }
  i.event.bind(i[scrollbarY], "mousedown", function(e) {
    bindMoves(e);
  });
  i.event.bind(i[scrollbarY], "touchstart", function(e) {
    bindMoves(e, true);
  });
}
function keyboard(i) {
  var element = i.element;
  var elementHovered = function() {
    return matches(element, ":hover");
  };
  var scrollbarFocused = function() {
    return matches(i.scrollbarX, ":focus") || matches(i.scrollbarY, ":focus");
  };
  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if (scrollTop === 0 && deltaY > 0 || scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0) {
        return !i.settings.wheelPropagation;
      }
    }
    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if (scrollLeft === 0 && deltaX < 0 || scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }
  i.event.bind(i.ownerDocument, "keydown", function(e) {
    if (e.isDefaultPrevented && e.isDefaultPrevented() || e.defaultPrevented) {
      return;
    }
    if (!elementHovered() && !scrollbarFocused()) {
      return;
    }
    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === "IFRAME") {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (isEditable(activeElement)) {
        return;
      }
    }
    var deltaX = 0;
    var deltaY = 0;
    switch (e.which) {
      case 37:
        if (e.metaKey) {
          deltaX = -i.contentWidth;
        } else if (e.altKey) {
          deltaX = -i.containerWidth;
        } else {
          deltaX = -30;
        }
        break;
      case 38:
        if (e.metaKey) {
          deltaY = i.contentHeight;
        } else if (e.altKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = 30;
        }
        break;
      case 39:
        if (e.metaKey) {
          deltaX = i.contentWidth;
        } else if (e.altKey) {
          deltaX = i.containerWidth;
        } else {
          deltaX = 30;
        }
        break;
      case 40:
        if (e.metaKey) {
          deltaY = -i.contentHeight;
        } else if (e.altKey) {
          deltaY = -i.containerHeight;
        } else {
          deltaY = -30;
        }
        break;
      case 32:
        if (e.shiftKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = -i.containerHeight;
        }
        break;
      case 33:
        deltaY = i.containerHeight;
        break;
      case 34:
        deltaY = -i.containerHeight;
        break;
      case 36:
        deltaY = i.contentHeight;
        break;
      case 35:
        deltaY = -i.contentHeight;
        break;
      default:
        return;
    }
    if (i.settings.suppressScrollX && deltaX !== 0) {
      return;
    }
    if (i.settings.suppressScrollY && deltaY !== 0) {
      return;
    }
    element.scrollTop -= deltaY;
    element.scrollLeft += deltaX;
    updateGeometry(i);
    if (shouldPreventDefault(deltaX, deltaY)) {
      e.preventDefault();
    }
  });
}
function wheel(i) {
  var element = i.element;
  function shouldPreventDefault(deltaX, deltaY) {
    var roundedScrollTop = Math.floor(element.scrollTop);
    var isTop = element.scrollTop === 0;
    var isBottom = roundedScrollTop + element.offsetHeight === element.scrollHeight;
    var isLeft = element.scrollLeft === 0;
    var isRight = element.scrollLeft + element.offsetWidth === element.scrollWidth;
    var hitsBound;
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      hitsBound = isTop || isBottom;
    } else {
      hitsBound = isLeft || isRight;
    }
    return hitsBound ? !i.settings.wheelPropagation : true;
  }
  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;
    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }
    if (e.deltaMode && e.deltaMode === 1) {
      deltaX *= 10;
      deltaY *= 10;
    }
    if (deltaX !== deltaX && deltaY !== deltaY) {
      deltaX = 0;
      deltaY = e.wheelDelta;
    }
    if (e.shiftKey) {
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }
  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!env.isWebKit && element.querySelector("select:focus")) {
      return true;
    }
    if (!element.contains(target)) {
      return false;
    }
    var cursor = target;
    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }
      var style = get(cursor);
      if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) {
            return true;
          }
        }
      }
      if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) {
            return true;
          }
        }
      }
      cursor = cursor.parentNode;
    }
    return false;
  }
  function mousewheelHandler(e) {
    var ref2 = getDeltaFromEvent(e);
    var deltaX = ref2[0];
    var deltaY = ref2[1];
    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
      return;
    }
    var shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      element.scrollTop -= deltaY * i.settings.wheelSpeed;
      element.scrollLeft += deltaX * i.settings.wheelSpeed;
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      if (deltaY) {
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
      } else {
        element.scrollTop += deltaX * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      if (deltaX) {
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else {
        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    }
    updateGeometry(i);
    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent && !e.ctrlKey) {
      e.stopPropagation();
      e.preventDefault();
    }
  }
  if (typeof window.onwheel !== "undefined") {
    i.event.bind(element, "wheel", mousewheelHandler);
  } else if (typeof window.onmousewheel !== "undefined") {
    i.event.bind(element, "mousewheel", mousewheelHandler);
  }
}
function touch(i) {
  if (!env.supportsTouch && !env.supportsIePointer) {
    return;
  }
  var element = i.element;
  function shouldPrevent(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);
    if (magnitudeY > magnitudeX) {
      if (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight || deltaY > 0 && scrollTop === 0) {
        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
      }
    } else if (magnitudeX > magnitudeY) {
      if (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth || deltaX > 0 && scrollLeft === 0) {
        return true;
      }
    }
    return true;
  }
  function applyTouchMove(differenceX, differenceY) {
    element.scrollTop -= differenceY;
    element.scrollLeft -= differenceX;
    updateGeometry(i);
  }
  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;
  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      return e;
    }
  }
  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === "pen" && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (e.pointerType && e.pointerType !== "mouse" && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
      return true;
    }
    return false;
  }
  function touchStart(e) {
    if (!shouldHandle(e)) {
      return;
    }
    var touch2 = getTouch(e);
    startOffset.pageX = touch2.pageX;
    startOffset.pageY = touch2.pageY;
    startTime = new Date().getTime();
    if (easingLoop !== null) {
      clearInterval(easingLoop);
    }
  }
  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!element.contains(target)) {
      return false;
    }
    var cursor = target;
    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }
      var style = get(cursor);
      if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) {
            return true;
          }
        }
      }
      if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) {
            return true;
          }
        }
      }
      cursor = cursor.parentNode;
    }
    return false;
  }
  function touchMove(e) {
    if (shouldHandle(e)) {
      var touch2 = getTouch(e);
      var currentOffset = { pageX: touch2.pageX, pageY: touch2.pageY };
      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;
      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
        return;
      }
      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;
      var currentTime = new Date().getTime();
      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }
      if (shouldPrevent(differenceX, differenceY)) {
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (i.settings.swipeEasing) {
      clearInterval(easingLoop);
      easingLoop = setInterval(function() {
        if (i.isInitialized) {
          clearInterval(easingLoop);
          return;
        }
        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }
        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }
        if (!i.element) {
          clearInterval(easingLoop);
          return;
        }
        applyTouchMove(speed.x * 30, speed.y * 30);
        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }
  if (env.supportsTouch) {
    i.event.bind(element, "touchstart", touchStart);
    i.event.bind(element, "touchmove", touchMove);
    i.event.bind(element, "touchend", touchEnd);
  } else if (env.supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(element, "pointerdown", touchStart);
      i.event.bind(element, "pointermove", touchMove);
      i.event.bind(element, "pointerup", touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(element, "MSPointerDown", touchStart);
      i.event.bind(element, "MSPointerMove", touchMove);
      i.event.bind(element, "MSPointerUp", touchEnd);
    }
  }
}
var defaultSettings = function() {
  return {
    handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollingThreshold: 1e3,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: false,
    suppressScrollY: false,
    swipeEasing: true,
    useBothWheelAxes: false,
    wheelPropagation: true,
    wheelSpeed: 1
  };
};
var handlers$1 = {
  "click-rail": clickRail,
  "drag-thumb": dragThumb,
  keyboard,
  wheel,
  touch
};
var PerfectScrollbar = function PerfectScrollbar2(element, userSettings) {
  var this$1$1 = this;
  if (userSettings === void 0)
    userSettings = {};
  if (typeof element === "string") {
    element = document.querySelector(element);
  }
  if (!element || !element.nodeName) {
    throw new Error("no element is specified to initialize PerfectScrollbar");
  }
  this.element = element;
  element.classList.add(cls.main);
  this.settings = defaultSettings();
  for (var key in userSettings) {
    this.settings[key] = userSettings[key];
  }
  this.containerWidth = null;
  this.containerHeight = null;
  this.contentWidth = null;
  this.contentHeight = null;
  var focus = function() {
    return element.classList.add(cls.state.focus);
  };
  var blur = function() {
    return element.classList.remove(cls.state.focus);
  };
  this.isRtl = get(element).direction === "rtl";
  if (this.isRtl === true) {
    element.classList.add(cls.rtl);
  }
  this.isNegativeScroll = function() {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  }();
  this.negativeScrollAdjustment = this.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
  this.event = new EventManager();
  this.ownerDocument = element.ownerDocument || document;
  this.scrollbarXRail = div(cls.element.rail("x"));
  element.appendChild(this.scrollbarXRail);
  this.scrollbarX = div(cls.element.thumb("x"));
  this.scrollbarXRail.appendChild(this.scrollbarX);
  this.scrollbarX.setAttribute("tabindex", 0);
  this.event.bind(this.scrollbarX, "focus", focus);
  this.event.bind(this.scrollbarX, "blur", blur);
  this.scrollbarXActive = null;
  this.scrollbarXWidth = null;
  this.scrollbarXLeft = null;
  var railXStyle = get(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
  if (isNaN(this.scrollbarXBottom)) {
    this.isScrollbarXUsingBottom = false;
    this.scrollbarXTop = toInt(railXStyle.top);
  } else {
    this.isScrollbarXUsingBottom = true;
  }
  this.railBorderXWidth = toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
  set$1(this.scrollbarXRail, { display: "block" });
  this.railXMarginWidth = toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
  set$1(this.scrollbarXRail, { display: "" });
  this.railXWidth = null;
  this.railXRatio = null;
  this.scrollbarYRail = div(cls.element.rail("y"));
  element.appendChild(this.scrollbarYRail);
  this.scrollbarY = div(cls.element.thumb("y"));
  this.scrollbarYRail.appendChild(this.scrollbarY);
  this.scrollbarY.setAttribute("tabindex", 0);
  this.event.bind(this.scrollbarY, "focus", focus);
  this.event.bind(this.scrollbarY, "blur", blur);
  this.scrollbarYActive = null;
  this.scrollbarYHeight = null;
  this.scrollbarYTop = null;
  var railYStyle = get(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(railYStyle.right, 10);
  if (isNaN(this.scrollbarYRight)) {
    this.isScrollbarYUsingRight = false;
    this.scrollbarYLeft = toInt(railYStyle.left);
  } else {
    this.isScrollbarYUsingRight = true;
  }
  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
  this.railBorderYWidth = toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
  set$1(this.scrollbarYRail, { display: "block" });
  this.railYMarginHeight = toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
  set$1(this.scrollbarYRail, { display: "" });
  this.railYHeight = null;
  this.railYRatio = null;
  this.reach = {
    x: element.scrollLeft <= 0 ? "start" : element.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
    y: element.scrollTop <= 0 ? "start" : element.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
  };
  this.isAlive = true;
  this.settings.handlers.forEach(function(handlerName) {
    return handlers$1[handlerName](this$1$1);
  });
  this.lastScrollTop = Math.floor(element.scrollTop);
  this.lastScrollLeft = element.scrollLeft;
  this.event.bind(this.element, "scroll", function(e) {
    return this$1$1.onScroll(e);
  });
  updateGeometry(this);
};
PerfectScrollbar.prototype.update = function update() {
  if (!this.isAlive) {
    return;
  }
  this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0;
  set$1(this.scrollbarXRail, { display: "block" });
  set$1(this.scrollbarYRail, { display: "block" });
  this.railXMarginWidth = toInt(get(this.scrollbarXRail).marginLeft) + toInt(get(this.scrollbarXRail).marginRight);
  this.railYMarginHeight = toInt(get(this.scrollbarYRail).marginTop) + toInt(get(this.scrollbarYRail).marginBottom);
  set$1(this.scrollbarXRail, { display: "none" });
  set$1(this.scrollbarYRail, { display: "none" });
  updateGeometry(this);
  processScrollDiff(this, "top", 0, false, true);
  processScrollDiff(this, "left", 0, false, true);
  set$1(this.scrollbarXRail, { display: "" });
  set$1(this.scrollbarYRail, { display: "" });
};
PerfectScrollbar.prototype.onScroll = function onScroll(e) {
  if (!this.isAlive) {
    return;
  }
  updateGeometry(this);
  processScrollDiff(this, "top", this.element.scrollTop - this.lastScrollTop);
  processScrollDiff(
    this,
    "left",
    this.element.scrollLeft - this.lastScrollLeft
  );
  this.lastScrollTop = Math.floor(this.element.scrollTop);
  this.lastScrollLeft = this.element.scrollLeft;
};
PerfectScrollbar.prototype.destroy = function destroy() {
  if (!this.isAlive) {
    return;
  }
  this.event.unbindAll();
  remove(this.scrollbarX);
  remove(this.scrollbarY);
  remove(this.scrollbarXRail);
  remove(this.scrollbarYRail);
  this.removePsClasses();
  this.element = null;
  this.scrollbarX = null;
  this.scrollbarY = null;
  this.scrollbarXRail = null;
  this.scrollbarYRail = null;
  this.isAlive = false;
};
PerfectScrollbar.prototype.removePsClasses = function removePsClasses() {
  this.element.className = this.element.className.split(" ").filter(function(name) {
    return !name.match(/^ps([-_].+|)$/);
  }).join(" ");
};
const eventNames = [
  "scroll",
  "ps-scroll-y",
  "ps-scroll-x",
  "ps-scroll-up",
  "ps-scroll-down",
  "ps-scroll-left",
  "ps-scroll-right",
  "ps-y-reach-start",
  "ps-y-reach-end",
  "ps-x-reach-start",
  "ps-x-reach-end"
];
var PerfectScrollbar$1 = {
  name: "PerfectScrollbar",
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    tag: {
      type: String,
      required: false,
      default: "div"
    },
    watchOptions: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: eventNames,
  data() {
    return {
      ps: null
    };
  },
  watch: {
    watchOptions(shouldWatch) {
      if (!shouldWatch && this.watcher) {
        this.watcher();
      } else {
        this.createWatcher();
      }
    }
  },
  mounted() {
    this.create();
    if (this.watchOptions) {
      this.createWatcher();
    }
  },
  updated() {
    this.$nextTick(() => {
      this.update();
    });
  },
  beforeUnmount() {
    this.destroy();
  },
  methods: {
    create() {
      if (!(this.ps && this.$isServer)) {
        this.ps = new PerfectScrollbar(this.$el, this.options);
        eventNames.forEach((eventName) => {
          this.ps.element.addEventListener(eventName, (event) => this.$emit(eventName, event));
        });
      }
    },
    createWatcher() {
      this.watcher = this.$watch("options", () => {
        this.destroy();
        this.create();
      }, {
        deep: true
      });
    },
    update() {
      if (this.ps) {
        this.ps.update();
      }
    },
    destroy() {
      if (this.ps) {
        this.ps.destroy();
        this.ps = null;
      }
    }
  },
  render() {
    return h(
      this.tag,
      {
        class: "ps"
      },
      this.$slots.default && this.$slots.default()
    );
  }
};
const __default__$8 = {
  inheritAttrs: false
};
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  ...__default__$8,
  __name: "MDBScrollbar",
  props: {
    wheelSpeed: {
      type: Number,
      default: 1
    },
    wheelPropagation: Boolean,
    swipeEasing: {
      type: Boolean,
      default: true
    },
    minScrollbarLength: {
      type: Number,
      default: 0
    },
    maxScrollbarLength: {
      type: Number,
      default: 0
    },
    scrollingThreshold: {
      type: Number,
      default: 1e3
    },
    useBothWheelAxes: Boolean,
    suppressScrollX: Boolean,
    suppressScrollY: Boolean,
    scrollXMarginOffset: {
      type: Number,
      default: 0
    },
    scrollYMarginOffset: {
      type: Number,
      default: 0
    },
    scrollbarClass: String,
    scrollbarStyle: String,
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    disableKeyboard: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const width = ref(props.width);
    const height = ref(props.height);
    const className = computed(() => {
      return [props.scrollbarClass];
    });
    const scrollbarStyles = computed(() => {
      const stylesObjectFromString = props.scrollbarStyle ? Object.fromEntries(
        props.scrollbarStyle.split(";").map((item) => item.trim().split(":"))
      ) : props.scrollbarStyle;
      return {
        ...stylesObjectFromString,
        width: width.value,
        height: height.value
      };
    });
    const settings = computed(() => {
      return {
        handlers: !props.disableKeyboard ? ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"] : ["click-rail", "drag-thumb", "wheel", "touch"],
        wheelSpeed: props.wheelSpeed,
        wheelPropagation: props.wheelPropagation,
        swipeEasing: props.swipeEasing,
        minScrollbarLength: props.minScrollbarLength,
        maxScrollbarLength: props.maxScrollbarLength,
        scrollingThreshold: props.scrollingThreshold,
        useBothWheelAxes: props.useBothWheelAxes,
        suppressScrollX: props.suppressScrollX,
        suppressScrollY: props.suppressScrollY,
        scrollXMarginOffset: props.scrollXMarginOffset,
        scrollYMarginOffset: props.scrollYMarginOffset
      };
    });
    watchEffect(() => {
      height.value = props.height;
      width.value = props.width;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(PerfectScrollbar$1), mergeProps({
        class: unref(className),
        options: unref(settings),
        style: unref(scrollbarStyles)
      }, _ctx.$attrs), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "options", "style"]);
    };
  }
});
const __default__$7 = {
  inheritAttrs: false
};
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  ...__default__$7,
  __name: "MDBLoading",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    fullScreen: {
      type: Boolean,
      default: true
    },
    parentSelector: String,
    modelValue: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: "spinner-border"
    },
    loadingText: {
      type: String,
      default: "Loading..."
    },
    backdropColor: {
      type: String,
      default: "black"
    },
    backdropOpacity: {
      type: Number,
      default: 0.4
    },
    overflow: {
      type: Boolean,
      defeault: true
    },
    spinnerClasses: String,
    textClasses: String
  },
  setup(__props) {
    const props = __props;
    const loadingClassName = computed(() => {
      return [
        props.parentSelector ? "loading position-absolute" : "loading-full position-fixed",
        "loading-spinner"
      ];
    });
    const spinnerClassName = computed(() => {
      return [props.icon, "loading-icon", props.spinnerClasses];
    });
    const loadingTextClassName = computed(() => {
      return ["loading-text", props.textClasses];
    });
    const loadingRef = ref(null);
    const isActive = ref(props.modelValue);
    watchEffect(() => isActive.value = props.modelValue);
    watch(
      () => isActive.value,
      (cur) => {
        if (props.fullScreen && props.overflow) {
          cur ? document.body.style.overflow = "hidden" : document.body.style.overflow = "";
        }
      },
      { immediate: true }
    );
    onMounted(() => {
      if (props.parentSelector) {
        const parent = document.querySelector(props.parentSelector);
        parent.classList.add("position-relative");
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        isActive.value && !__props.parentSelector ? (openBlock(), createBlock(Teleport, {
          key: 0,
          to: "body"
        }, [
          (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
            ref_key: "loadingRef",
            ref: loadingRef,
            class: unref(loadingClassName)
          }, _ctx.$attrs), {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(unref(spinnerClassName)),
                role: "status"
              }, null, 2),
              createElementVNode("span", {
                class: normalizeClass(unref(loadingTextClassName))
              }, toDisplayString(__props.loadingText), 3)
            ]),
            _: 1
          }, 16, ["class"])),
          createElementVNode("div", {
            class: "loading-backdrop",
            style: normalizeStyle({ opacity: __props.backdropOpacity, backgroundColor: __props.backdropColor })
          }, null, 4)
        ])) : __props.parentSelector && isActive.value ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          key: 1,
          ref_key: "loadingRef",
          ref: loadingRef,
          class: unref(loadingClassName)
        }, _ctx.$attrs), {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(unref(spinnerClassName)),
              role: "status"
            }, null, 2),
            createElementVNode("span", {
              class: normalizeClass(unref(loadingTextClassName))
            }, toDisplayString(__props.loadingText), 3)
          ]),
          _: 1
        }, 16, ["class"])) : createCommentVNode("", true),
        __props.parentSelector && isActive.value ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: "loading-backdrop position-absolute",
          style: normalizeStyle({ opacity: __props.backdropOpacity, backgroundColor: __props.backdropColor })
        }, null, 4)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
function noop() {
}
const uid = function() {
  let id = 0;
  return function() {
    return id++;
  };
}();
function isNullOrUndef(value) {
  return value === null || typeof value === "undefined";
}
function isArray(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }
  const type = Object.prototype.toString.call(value);
  if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") {
    return true;
  }
  return false;
}
function isObject(value) {
  return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const isNumberFinite = (value) => (typeof value === "number" || value instanceof Number) && isFinite(+value);
function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}
function valueOrDefault(value, defaultValue) {
  return typeof value === "undefined" ? defaultValue : value;
}
const toPercentage = (value, dimension) => typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const toDimension = (value, dimension) => typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function callback(fn2, args, thisArg) {
  if (fn2 && typeof fn2.call === "function") {
    return fn2.apply(thisArg, args);
  }
}
function each(loopable, fn2, thisArg, reverse) {
  let i, len, keys;
  if (isArray(loopable)) {
    len = loopable.length;
    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn2.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn2.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;
    for (i = 0; i < len; i++) {
      fn2.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}
function _elementsEqual(a0, a1) {
  let i, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
function clone$1(source) {
  if (isArray(source)) {
    return source.map(clone$1);
  }
  if (isObject(source)) {
    const target = /* @__PURE__ */ Object.create(null);
    const keys = Object.keys(source);
    const klen = keys.length;
    let k = 0;
    for (; k < klen; ++k) {
      target[keys[k]] = clone$1(source[keys[k]]);
    }
    return target;
  }
  return source;
}
function isValidKey(key) {
  return ["__proto__", "prototype", "constructor"].indexOf(key) === -1;
}
function _merger(key, target, source, options) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    merge(tval, sval, options);
  } else {
    target[key] = clone$1(sval);
  }
}
function merge(target, source, options) {
  const sources = isArray(source) ? source : [source];
  const ilen = sources.length;
  if (!isObject(target)) {
    return target;
  }
  options = options || {};
  const merger = options.merger || _merger;
  for (let i = 0; i < ilen; ++i) {
    source = sources[i];
    if (!isObject(source)) {
      continue;
    }
    const keys = Object.keys(source);
    for (let k = 0, klen = keys.length; k < klen; ++k) {
      merger(keys[k], target, source, options);
    }
  }
  return target;
}
function mergeIf(target, source) {
  return merge(target, source, { merger: _mergerIf });
}
function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone$1(sval);
  }
}
const keyResolvers = {
  "": (v) => v,
  x: (o) => o.x,
  y: (o) => o.y
};
function resolveObjectKey(obj, key) {
  const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
  return resolver(obj);
}
function _getKeyResolver(key) {
  const keys = _splitKey(key);
  return (obj) => {
    for (const k of keys) {
      if (k === "") {
        break;
      }
      obj = obj && obj[k];
    }
    return obj;
  };
}
function _splitKey(key) {
  const parts = key.split(".");
  const keys = [];
  let tmp = "";
  for (const part of parts) {
    tmp += part;
    if (tmp.endsWith("\\")) {
      tmp = tmp.slice(0, -1) + ".";
    } else {
      keys.push(tmp);
      tmp = "";
    }
  }
  return keys;
}
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value) => typeof value !== "undefined";
const isFunction = (value) => typeof value === "function";
const setsEqual = (a, b) => {
  if (a.size !== b.size) {
    return false;
  }
  for (const item of a) {
    if (!b.has(item)) {
      return false;
    }
  }
  return true;
};
function _isClickEvent(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function niceNum(range) {
  const roundedRange = Math.round(range);
  range = almostEquals(range, roundedRange, range / 1e3) ? roundedRange : range;
  const niceRange = Math.pow(10, Math.floor(log10(range)));
  const fraction = range / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
function _factorize(value) {
  const result = [];
  const sqrt = Math.sqrt(value);
  let i;
  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a, b) => a - b).pop();
  return result;
}
function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostEquals(x, y, epsilon) {
  return Math.abs(x - y) < epsilon;
}
function almostWhole(x, epsilon) {
  const rounded = Math.round(x);
  return rounded - epsilon <= x && rounded + epsilon >= x;
}
function _setMinAndMaxByKey(array, target, property) {
  let i, ilen, value;
  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];
    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
function _decimalPlaces(x) {
  if (!isNumberFinite(x)) {
    return;
  }
  let e = 1;
  let p = 0;
  while (Math.round(x * e) / e !== x) {
    e *= 10;
    p++;
  }
  return p;
}
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle < -0.5 * PI) {
    angle += TAU;
  }
  return {
    angle,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function _angleDiff(a, b) {
  return (a - b + PITAU) % TAU - PI;
}
function _normalizeAngle(a) {
  return (a % TAU + TAU) % TAU;
}
function _angleBetween(angle, start2, end2, sameAngleIsFullCircle) {
  const a = _normalizeAngle(angle);
  const s = _normalizeAngle(start2);
  const e = _normalizeAngle(end2);
  const angleToStart = _normalizeAngle(s - a);
  const angleToEnd = _normalizeAngle(e - a);
  const startToAngle = _normalizeAngle(a - s);
  const endToAngle = _normalizeAngle(a - e);
  return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function _limitValue(value, min2, max2) {
  return Math.max(min2, Math.min(max2, value));
}
function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}
function _isBetween(value, start2, end2, epsilon = 1e-6) {
  return value >= Math.min(start2, end2) - epsilon && value <= Math.max(start2, end2) + epsilon;
}
function _lookup(table, value, cmp) {
  cmp = cmp || ((index2) => table[index2] < value);
  let hi = table.length - 1;
  let lo = 0;
  let mid;
  while (hi - lo > 1) {
    mid = lo + hi >> 1;
    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  return { lo, hi };
}
const _lookupByKey = (table, key, value, last) => _lookup(table, value, last ? (index2) => table[index2][key] <= value : (index2) => table[index2][key] < value);
const _rlookupByKey = (table, key, value) => _lookup(table, value, (index2) => table[index2][key] >= value);
function _filterBetween(values, min2, max2) {
  let start2 = 0;
  let end2 = values.length;
  while (start2 < end2 && values[start2] < min2) {
    start2++;
  }
  while (end2 > start2 && values[end2 - 1] > max2) {
    end2--;
  }
  return start2 > 0 || end2 < values.length ? values.slice(start2, end2) : values;
}
const arrayEvents = ["push", "pop", "shift", "splice", "unshift"];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, "_chartjs", {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [listener]
    }
  });
  arrayEvents.forEach((key) => {
    const method = "_onData" + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach((object) => {
          if (typeof object[method] === "function") {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index2 = listeners.indexOf(listener);
  if (index2 !== -1) {
    listeners.splice(index2, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach((key) => {
    delete array[key];
  });
  delete array._chartjs;
}
function _arrayUnique(items) {
  const set2 = /* @__PURE__ */ new Set();
  let i, ilen;
  for (i = 0, ilen = items.length; i < ilen; ++i) {
    set2.add(items[i]);
  }
  if (set2.size === ilen) {
    return items;
  }
  return Array.from(set2);
}
const requestAnimFrame = function() {
  if (typeof window === "undefined") {
    return function(callback2) {
      return callback2();
    };
  }
  return window.requestAnimationFrame;
}();
function throttled(fn2, thisArg, updateFn) {
  const updateArgs = updateFn || ((args2) => Array.prototype.slice.call(args2));
  let ticking = false;
  let args = [];
  return function(...rest) {
    args = updateArgs(rest);
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn2.apply(thisArg, args);
      });
    }
  };
}
function debounce$1(fn2, delay) {
  let timeout;
  return function(...args) {
    if (delay) {
      clearTimeout(timeout);
      timeout = setTimeout(fn2, delay, args);
    } else {
      fn2.apply(this, args);
    }
    return delay;
  };
}
const _toLeftRightCenter = (align) => align === "start" ? "left" : align === "end" ? "right" : "center";
const _alignStartEnd = (align, start2, end2) => align === "start" ? start2 : align === "end" ? end2 : (start2 + end2) / 2;
const _textX = (align, left2, right2, rtl) => {
  const check = rtl ? "left" : "right";
  return align === check ? right2 : align === "center" ? (left2 + right2) / 2 : left2;
};
function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start2 = 0;
  let count = pointCount;
  if (meta._sorted) {
    const { iScale, _parsed } = meta;
    const axis = iScale.axis;
    const { min: min2, max: max2, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) {
      start2 = _limitValue(
        Math.min(
          _lookupByKey(_parsed, iScale.axis, min2).lo,
          animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min2)).lo
        ),
        0,
        pointCount - 1
      );
    }
    if (maxDefined) {
      count = _limitValue(
        Math.max(
          _lookupByKey(_parsed, iScale.axis, max2, true).hi + 1,
          animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max2), true).hi + 1
        ),
        start2,
        pointCount
      ) - start2;
    } else {
      count = pointCount - start2;
    }
  }
  return { start: start2, count };
}
function _scaleRangesChanged(meta) {
  const { xScale, yScale, _scaleRanges } = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}
const atEdge = (t) => t === 0 || t === 1;
const elasticIn = (t, s, p) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p) => Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
const effects = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * HALF_PI) + 1,
  easeOutSine: (t) => Math.sin(t * HALF_PI),
  easeInOutSine: (t) => -0.5 * (Math.cos(PI * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
  easeOutElastic: (t) => atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
  easeInOutElastic(t) {
    const s = 0.1125;
    const p = 0.45;
    return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
  },
  easeInBack(t) {
    const s = 1.70158;
    return t * t * ((s + 1) * t - s);
  },
  easeOutBack(t) {
    const s = 1.70158;
    return (t -= 1) * t * ((s + 1) * t + s) + 1;
  },
  easeInOutBack(t) {
    let s = 1.70158;
    if ((t /= 0.5) < 1) {
      return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
    }
    return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
  },
  easeInBounce: (t) => 1 - effects.easeOutBounce(1 - t),
  easeOutBounce(t) {
    const m = 7.5625;
    const d = 2.75;
    if (t < 1 / d) {
      return m * t * t;
    }
    if (t < 2 / d) {
      return m * (t -= 1.5 / d) * t + 0.75;
    }
    if (t < 2.5 / d) {
      return m * (t -= 2.25 / d) * t + 0.9375;
    }
    return m * (t -= 2.625 / d) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */
function round(v) {
  return v + 0.5 | 0;
}
const lim = (v, l, h3) => Math.max(Math.min(v, h3), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}
const map$1 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 };
const hex = [..."0123456789ABCDEF"];
const h1 = (b) => hex[b & 15];
const h2 = (b) => hex[(b & 240) >> 4] + hex[b & 15];
const eq = (b) => (b & 240) >> 4 === (b & 15);
const isShort = (v) => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === "#") {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }
  return ret;
}
const alpha = (a, f) => a < 255 ? f(a) : "";
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v ? "#" + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : void 0;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h3, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h3 / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h3, s, v) {
  const f = (n, k = (n + h3 / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h3, w, b) {
  const rgb = hsl2rgbn(h3, 1, 0.5);
  let i;
  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w - b;
    rgb[i] += w;
  }
  return rgb;
}
function hueValue(r, g, b, d, max2) {
  if (r === max2) {
    return (g - b) / d + (g < b ? 6 : 0);
  }
  if (g === max2) {
    return (b - r) / d + 2;
  }
  return (r - g) / d + 4;
}
function rgb2hsl(v) {
  const range = 255;
  const r = v.r / range;
  const g = v.g / range;
  const b = v.b / range;
  const max2 = Math.max(r, g, b);
  const min2 = Math.min(r, g, b);
  const l = (max2 + min2) / 2;
  let h3, s, d;
  if (max2 !== min2) {
    d = max2 - min2;
    s = l > 0.5 ? d / (2 - max2 - min2) : d / (max2 + min2);
    h3 = hueValue(r, g, b, d, max2);
    h3 = h3 * 60 + 0.5;
  }
  return [h3 | 0, s || 0, l];
}
function calln(f, a, b, c) {
  return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h3, s, l) {
  return calln(hsl2rgbn, h3, s, l);
}
function hwb2rgb(h3, w, b) {
  return calln(hwb2rgbn, h3, w, b);
}
function hsv2rgb(h3, s, v) {
  return calln(hsv2rgbn, h3, s, v);
}
function hue(h3) {
  return (h3 % 360 + 360) % 360;
}
function hueParse(str) {
  const m = HUE_RE.exec(str);
  let a = 255;
  let v;
  if (!m) {
    return;
  }
  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }
  const h3 = hue(+m[2]);
  const p1 = +m[3] / 100;
  const p2 = +m[4] / 100;
  if (m[1] === "hwb") {
    v = hwb2rgb(h3, p1, p2);
  } else if (m[1] === "hsv") {
    v = hsv2rgb(h3, p1, p2);
  } else {
    v = hsl2rgb(h3, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a
  };
}
function rotate(v, deg) {
  var h3 = rgb2hsl(v);
  h3[0] = hue(h3[0] + deg);
  h3 = hsl2rgb(h3);
  v.r = h3[0];
  v.g = h3[1];
  v.b = h3[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a = rgb2hsl(v);
  const h3 = a[0];
  const s = n2p(a[1]);
  const l = n2p(a[2]);
  return v.a < 255 ? `hsla(${h3}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h3}, ${s}%, ${l}%)`;
}
const map$2 = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
};
const names$1 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1);
  const tkeys = Object.keys(map$2);
  let i, j, k, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map$2[k]);
    }
    k = parseInt(names$1[ok], 16);
    unpacked[nk] = [k >> 16 & 255, k >> 8 & 255, k & 255];
  }
  return unpacked;
}
let names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a = names[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m = RGB_RE.exec(str);
  let a = 255;
  let r, g, b;
  if (!m) {
    return;
  }
  if (m[7] !== r) {
    const v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r,
    g,
    b,
    a
  };
}
function rgbString(v) {
  return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = (v) => v <= 31308e-7 ? v * 12.92 : Math.pow(v, 1 / 2.4) * 1.055 - 0.055;
const from = (v) => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate$1(rgb1, rgb2, t) {
  const r = from(b2n(rgb1.r));
  const g = from(b2n(rgb1.g));
  const b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}
function modHSL(v, i, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = { r: 0, g: 0, b: 0, a: 255 };
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = { r: input[0], g: input[1], b: input[2], a: 255 };
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone(input, { r: 0, g: 0, b: 0, a: 1 });
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === "r") {
    return rgbParse(str);
  }
  return hueParse(str);
}
class Color {
  constructor(input) {
    if (input instanceof Color) {
      return input;
    }
    const type = typeof input;
    let v;
    if (type === "object") {
      v = fromObject(input);
    } else if (type === "string") {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : void 0;
  }
  mix(color2, weight) {
    if (color2) {
      const c1 = this.rgb;
      const c2 = color2.rgb;
      let w2;
      const p = weight === w2 ? 0.5 : weight;
      const w = 2 * p - 1;
      const a = c1.a - c2.a;
      const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
      w2 = 1 - w1;
      c1.r = 255 & w1 * c1.r + w2 * c2.r + 0.5;
      c1.g = 255 & w1 * c1.g + w2 * c2.g + 0.5;
      c1.b = 255 & w1 * c1.b + w2 * c2.b + 0.5;
      c1.a = p * c1.a + (1 - p) * c2.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color2, t) {
    if (color2) {
      this._rgb = interpolate$1(this._rgb, color2._rgb, t);
    }
    return this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(a) {
    this._rgb.a = n2b(a);
    return this;
  }
  clearer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb = this._rgb;
    const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
    rgb.r = rgb.g = rgb.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
}
function index_esm(input) {
  return new Color(input);
}
function isPatternOrGradient(value) {
  if (value && typeof value === "object") {
    const type = value.toString();
    return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
  }
  return false;
}
function color(value) {
  return isPatternOrGradient(value) ? value : index_esm(value);
}
function getHoverColor(value) {
  return isPatternOrGradient(value) ? value : index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const overrides = /* @__PURE__ */ Object.create(null);
const descriptors = /* @__PURE__ */ Object.create(null);
function getScope$1(node, key) {
  if (!key) {
    return node;
  }
  const keys = key.split(".");
  for (let i = 0, n = keys.length; i < n; ++i) {
    const k = keys[i];
    node = node[k] || (node[k] = /* @__PURE__ */ Object.create(null));
  }
  return node;
}
function set(root, scope, values) {
  if (typeof scope === "string") {
    return merge(getScope$1(root, scope), values);
  }
  return merge(getScope$1(root, ""), scope);
}
class Defaults {
  constructor(_descriptors2) {
    this.animation = void 0;
    this.backgroundColor = "rgba(0,0,0,0.1)";
    this.borderColor = "rgba(0,0,0,0.1)";
    this.color = "#666";
    this.datasets = {};
    this.devicePixelRatio = (context) => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options) => getHoverColor(options.backgroundColor);
    this.hoverBorderColor = (ctx, options) => getHoverColor(options.borderColor);
    this.hoverColor = (ctx, options) => getHoverColor(options.color);
    this.indexAxis = "x";
    this.interaction = {
      mode: "nearest",
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = void 0;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors2);
  }
  set(scope, values) {
    return set(this, scope, values);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values) {
    return set(descriptors, scope, values);
  }
  override(scope, values) {
    return set(overrides, scope, values);
  }
  route(scope, name, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = "_" + name;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name],
        writable: true
      },
      [name]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target = targetScopeObject[targetName];
          if (isObject(local)) {
            return Object.assign({}, target, local);
          }
          return valueOrDefault(local, target);
        },
        set(value) {
          this[privateName] = value;
        }
      }
    });
  }
}
var defaults$1 = new Defaults({
  _scriptable: (name) => !name.startsWith("on"),
  _indexable: (name) => name !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
});
function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function _measureText(ctx, data, gc, longest, string) {
  let textWidth = data[string];
  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i, j, jlen, thing, nestedThing;
  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];
    if (thing !== void 0 && thing !== null && isArray(thing) !== true) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        if (nestedThing !== void 0 && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data[gc[i]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio2 = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio2) / devicePixelRatio2 + halfWidth;
}
function clearCanvas(canvas, ctx) {
  ctx = ctx || canvas.getContext("2d");
  ctx.save();
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options, x, y) {
  drawPointLegend(ctx, options, x, y, null);
}
function drawPointLegend(ctx, options, x, y, w) {
  let type, xOffset, yOffset, size, cornerRadius, width;
  const style = options.pointStyle;
  const rotation = options.rotation;
  const radius = options.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === "object") {
    type = style.toString();
    if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius) || radius <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
    default:
      if (w) {
        ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
      } else {
        ctx.arc(x, y, radius, 0, TAU);
      }
      ctx.closePath();
      break;
    case "triangle":
      ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
      ctx.closePath();
      break;
    case "rectRounded":
      cornerRadius = radius * 0.516;
      size = radius - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size;
      yOffset = Math.sin(rad + QUARTER_PI) * size;
      ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;
    case "rect":
      if (!rotation) {
        size = Math.SQRT1_2 * radius;
        width = w ? w / 2 : size;
        ctx.rect(x - width, y - size, 2 * width, 2 * size);
        break;
      }
      rad += QUARTER_PI;
    case "rectRot":
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + yOffset, y - xOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      ctx.closePath();
      break;
    case "crossRot":
      rad += QUARTER_PI;
    case "cross":
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.moveTo(x + yOffset, y - xOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      break;
    case "star":
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.moveTo(x + yOffset, y - xOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      rad += QUARTER_PI;
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      ctx.moveTo(x + yOffset, y - xOffset);
      ctx.lineTo(x - yOffset, y + xOffset);
      break;
    case "line":
      xOffset = w ? w / 2 : Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      break;
    case "dash":
      ctx.moveTo(x, y);
      ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
      break;
  }
  ctx.fill();
  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5;
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
function _steppedLineTo(ctx, previous, target, flip2, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  if (mode === "middle") {
    const midpoint = (previous.x + target.x) / 2;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === "after" !== !!flip2) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }
  ctx.lineTo(target.x, target.y);
}
function _bezierCurveTo(ctx, previous, target, flip2) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  ctx.bezierCurveTo(
    flip2 ? previous.cp1x : previous.cp2x,
    flip2 ? previous.cp1y : previous.cp2y,
    flip2 ? target.cp2x : target.cp1x,
    flip2 ? target.cp2y : target.cp1y,
    target.x,
    target.y
  );
}
function renderText(ctx, text, x, y, font, opts = {}) {
  const lines = isArray(text) ? text : [text];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
  let i, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i = 0; i < lines.length; ++i) {
    line = lines[i];
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line, x, y, opts.maxWidth);
    }
    ctx.fillText(line, x, y, opts.maxWidth);
    decorateText(ctx, x, y, line, opts);
    y += font.lineHeight;
  }
  ctx.restore();
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x, y, line, opts) {
  if (opts.strikethrough || opts.underline) {
    const metrics = ctx.measureText(line);
    const left2 = x - metrics.actualBoundingBoxLeft;
    const right2 = x + metrics.actualBoundingBoxRight;
    const top2 = y - metrics.actualBoundingBoxAscent;
    const bottom2 = y + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top2 + bottom2) / 2 : bottom2;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left2, yDecoration);
    ctx.lineTo(right2, yDecoration);
    ctx.stroke();
  }
}
function addRoundedRectPath(ctx, rect) {
  const { x, y, w, h: h3, radius } = rect;
  ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -HALF_PI, PI, true);
  ctx.lineTo(x, y + h3 - radius.bottomLeft);
  ctx.arc(x + radius.bottomLeft, y + h3 - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  ctx.lineTo(x + w - radius.bottomRight, y + h3);
  ctx.arc(x + w - radius.bottomRight, y + h3 - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  ctx.lineTo(x + w, y + radius.topRight);
  ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function toLineHeight(value, size) {
  const matches2 = ("" + value).match(LINE_HEIGHT);
  if (!matches2 || matches2[1] === "normal") {
    return size * 1.2;
  }
  value = +matches2[2];
  switch (matches2[3]) {
    case "px":
      return value;
    case "%":
      value /= 100;
      break;
  }
  return size * value;
}
const numberOrZero = (v) => +v || 0;
function _readValueToProps(value, props) {
  const ret = {};
  const objProps = isObject(props);
  const keys = objProps ? Object.keys(props) : props;
  const read2 = isObject(value) ? objProps ? (prop) => valueOrDefault(value[prop], value[props[prop]]) : (prop) => value[prop] : () => value;
  for (const prop of keys) {
    ret[prop] = numberOrZero(read2(prop));
  }
  return ret;
}
function toTRBL(value) {
  return _readValueToProps(value, { top: "y", right: "x", bottom: "y", left: "x" });
}
function toTRBLCorners(value) {
  return _readValueToProps(value, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
}
function toPadding(value) {
  const obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults$1.font;
  let size = valueOrDefault(options.size, fallback.size);
  if (typeof size === "string") {
    size = parseInt(size, 10);
  }
  let style = valueOrDefault(options.style, fallback.style);
  if (style && !("" + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = "";
  }
  const font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
    size,
    style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ""
  };
  font.string = toFontString(font);
  return font;
}
function resolve(inputs, context, index2, info) {
  let cacheable = true;
  let i, ilen, value;
  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];
    if (value === void 0) {
      continue;
    }
    if (context !== void 0 && typeof value === "function") {
      value = value(context);
      cacheable = false;
    }
    if (index2 !== void 0 && isArray(value)) {
      value = value[index2 % value.length];
      cacheable = false;
    }
    if (value !== void 0) {
      if (info && !cacheable) {
        info.cacheable = false;
      }
      return value;
    }
  }
}
function _addGrace(minmax, grace, beginAtZero) {
  const { min: min2, max: max2 } = minmax;
  const change = toDimension(grace, (max2 - min2) / 2);
  const keepZero = (value, add) => beginAtZero && value === 0 ? 0 : value + add;
  return {
    min: keepZero(min2, -Math.abs(change)),
    max: keepZero(max2, change)
  };
}
function createContext(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}
function _createResolver(scopes, prefixes = [""], rootScopes = scopes, fallback, getTarget = () => scopes[0]) {
  if (!defined(fallback)) {
    fallback = _resolve("_fallback", scopes);
  }
  const cache = {
    [Symbol.toStringTag]: "Object",
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: rootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: (scope) => _createResolver([scope, ...scopes], prefixes, rootScopes, fallback)
  };
  return new Proxy(cache, {
    deleteProperty(target, prop) {
      delete target[prop];
      delete target._keys;
      delete scopes[0][prop];
      return true;
    },
    get(target, prop) {
      return _cached(
        target,
        prop,
        () => _resolveWithPrefixes(prop, prefixes, scopes, target)
      );
    },
    getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    set(target, prop, value) {
      const storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value;
      delete target._keys;
      return true;
    }
  });
}
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: (ctx) => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: (scope) => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    deleteProperty(target, prop) {
      delete target[prop];
      delete proxy[prop];
      return true;
    },
    get(target, prop, receiver) {
      return _cached(
        target,
        prop,
        () => _resolveWithContext(target, prop, receiver)
      );
    },
    getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? { enumerable: true, configurable: true } : void 0 : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    set(target, prop, value) {
      proxy[prop] = value;
      delete target[prop];
      return true;
    }
  });
}
function _descriptors(proxy, defaults2 = { scriptable: true, indexable: true }) {
  const { _scriptable = defaults2.scriptable, _indexable = defaults2.indexable, _allKeys = defaults2.allKeys } = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
const readKey = (prefix, name) => prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value) => isObject(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve2) {
  if (Object.prototype.hasOwnProperty.call(target, prop)) {
    return target[prop];
  }
  const value = resolve2();
  target[prop] = value;
  return value;
}
function _resolveWithContext(target, prop, receiver) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  let value = _proxy[prop];
  if (isFunction(value) && descriptors2.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }
  if (isArray(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors2.isIndexable);
  }
  if (needsSubResolver(prop, value)) {
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors2);
  }
  return value;
}
function _resolveScriptable(prop, value, target, receiver) {
  const { _proxy, _context, _subProxy, _stack } = target;
  if (_stack.has(prop)) {
    throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
  }
  _stack.add(prop);
  value = value(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value)) {
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }
  return value;
}
function _resolveArray(prop, value, target, isIndexable) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  if (defined(_context.index) && isIndexable(prop)) {
    value = value[_context.index % value.length];
  } else if (isObject(value[0])) {
    const arr = value;
    const scopes = _proxy._scopes.filter((s) => s !== arr);
    value = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors2));
    }
  }
  return value;
}
function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent) => key === true ? parent : typeof key === "string" ? resolveObjectKey(parent, key) : void 0;
function addScopes(set2, parentScopes, key, parentFallback, value) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set2.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value);
      if (defined(fallback) && fallback !== key && fallback !== parentFallback) {
        return fallback;
      }
    } else if (scope === false && defined(parentFallback) && key !== parentFallback) {
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value);
  const allScopes = [...parentScopes, ...rootScopes];
  const set2 = /* @__PURE__ */ new Set();
  set2.add(value);
  let key = addScopesFromKey(set2, allScopes, prop, fallback || prop, value);
  if (key === null) {
    return false;
  }
  if (defined(fallback) && fallback !== prop) {
    key = addScopesFromKey(set2, allScopes, fallback, key, value);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(
    Array.from(set2),
    [""],
    rootScopes,
    fallback,
    () => subGetTarget(resolver, prop, value)
  );
}
function addScopesFromKey(set2, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set2, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target = parent[prop];
  if (isArray(target) && isObject(value)) {
    return value;
  }
  return target;
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  let value;
  for (const prefix of prefixes) {
    value = _resolve(readKey(prefix, prop), scopes);
    if (defined(value)) {
      return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value = scope[key];
    if (defined(value)) {
      return value;
    }
  }
}
function getKeysFromAllScopes(target) {
  let keys = target._keys;
  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }
  return keys;
}
function resolveKeysFromAllScopes(scopes) {
  const set2 = /* @__PURE__ */ new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter((k) => !k.startsWith("_"))) {
      set2.add(key);
    }
  }
  return Array.from(set2);
}
function _parseObjectDataRadialScale(meta, data, start2, count) {
  const { iScale } = meta;
  const { key = "r" } = this._parsing;
  const parsed = new Array(count);
  let i, ilen, index2, item;
  for (i = 0, ilen = count; i < ilen; ++i) {
    index2 = i + start2;
    item = data[index2];
    parsed[i] = {
      r: iScale.parse(resolveObjectKey(item, key), index2)
    };
  }
  return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i) => i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis) => indexAxis === "x" ? "y" : "x";
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t * s01;
  const fb = t * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }
    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}
function monotoneCompute(points, mK, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
    }
  }
}
function splineCurveMonotone(points, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  let i, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min2, max2) {
  return Math.max(Math.min(pt, max2), min2);
}
function capBezierPoints(points, area) {
  let i, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  let i, ilen, point, controlPoints;
  if (options.spanGaps) {
    points = points.filter((pt) => !pt.skip);
  }
  if (options.cubicInterpolationMode === "monotone") {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev = loop ? points[points.length - 1] : points[0];
    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(
        prev,
        point,
        points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen],
        options.tension
      );
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev = point;
    }
  }
  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}
function _isDomSupported() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === "[object ShadowRoot]") {
    parent = parent.host;
  }
  return parent;
}
function parseMaxStyle(styleValue, node, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === "string") {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf("%") !== -1) {
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
const getComputedStyle$1 = (element) => window.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle$1(el).getPropertyValue(property);
}
const positions = ["top", "right", "bottom", "left"];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? "-" + suffix : "";
  for (let i = 0; i < 4; i++) {
    const pos = positions[i];
    result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
const useOffsetPos = (x, y, target) => (x > 0 || y > 0) && (!target || !target.shadowRoot);
function getCanvasPosition(e, canvas) {
  const touches = e.touches;
  const source = touches && touches.length ? touches[0] : e;
  const { offsetX, offsetY } = source;
  let box = false;
  let x, y;
  if (useOffsetPos(offsetX, offsetY, e.target)) {
    x = offsetX;
    y = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x = source.clientX - rect.left;
    y = source.clientY - rect.top;
    box = true;
  }
  return { x, y, box };
}
function getRelativePosition(evt, chart) {
  if ("native" in evt) {
    return evt;
  }
  const { canvas, currentDevicePixelRatio } = chart;
  const style = getComputedStyle$1(canvas);
  const borderBox = style.boxSizing === "border-box";
  const paddings = getPositionedStyle(style, "padding");
  const borders = getPositionedStyle(style, "border", "width");
  const { x, y, box } = getCanvasPosition(evt, canvas);
  const xOffset = paddings.left + (box && borders.left);
  const yOffset = paddings.top + (box && borders.top);
  let { width, height } = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height) {
  let maxWidth, maxHeight;
  if (width === void 0 || height === void 0) {
    const container = _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect();
      const containerStyle = getComputedStyle$1(container);
      const containerBorder = getPositionedStyle(containerStyle, "border", "width");
      const containerPadding = getPositionedStyle(containerStyle, "padding");
      width = rect.width - containerPadding.width - containerBorder.width;
      height = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
    }
  }
  return {
    width,
    height,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
const round1 = (v) => Math.round(v * 10) / 10;
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle$1(canvas);
  const margins = getPositionedStyle(style, "margin");
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, "clientWidth") || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, "clientHeight") || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let { width, height } = containerSize;
  if (style.boxSizing === "content-box") {
    const borders = getPositionedStyle(style, "border", "width");
    const paddings = getPositionedStyle(style, "padding");
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins.width);
  height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
  if (width && !height) {
    height = round1(width / 2);
  }
  return {
    width,
    height
  };
}
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = deviceHeight / pixelRatio;
  chart.width = deviceWidth / pixelRatio;
  const canvas = chart.canvas;
  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
const supportsEventListenerOptions = function() {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    window.addEventListener("test", null, options);
    window.removeEventListener("test", null, options);
  } catch (e) {
  }
  return passiveSupported;
}();
function readUsedSize(element, property) {
  const value = getStyle(element, property);
  const matches2 = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches2 ? +matches2[1] : void 0;
}
function _pointInLine(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: p1.y + t * (p2.y - p1.y)
  };
}
function _steppedInterpolation(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
  };
}
function _bezierInterpolation(p1, p2, t, mode) {
  const cp1 = { x: p1.cp2x, y: p1.cp2y };
  const cp2 = { x: p2.cp1x, y: p2.cp1y };
  const a = _pointInLine(p1, cp1, t);
  const b = _pointInLine(cp1, cp2, t);
  const c = _pointInLine(cp2, p2, t);
  const d = _pointInLine(a, b, t);
  const e = _pointInLine(b, c, t);
  return _pointInLine(d, e, t);
}
const intlCache = /* @__PURE__ */ new Map();
function getNumberFormat(locale, options) {
  options = options || {};
  const cacheKey = locale + JSON.stringify(options);
  let formatter2 = intlCache.get(cacheKey);
  if (!formatter2) {
    formatter2 = new Intl.NumberFormat(locale, options);
    intlCache.set(cacheKey, formatter2);
  }
  return formatter2;
}
function formatNumber(num, locale, options) {
  return getNumberFormat(locale, options).format(num);
}
const getRightToLeftAdapter = function(rectX, width) {
  return {
    x(x) {
      return rectX + rectX + width - x;
    },
    setWidth(w) {
      width = w;
    },
    textAlign(align) {
      if (align === "center") {
        return align;
      }
      return align === "right" ? "left" : "right";
    },
    xPlus(x, value) {
      return x - value;
    },
    leftForLtr(x, itemWidth) {
      return x - itemWidth;
    }
  };
};
const getLeftToRightAdapter = function() {
  return {
    x(x) {
      return x;
    },
    setWidth(w) {
    },
    textAlign(align) {
      return align;
    },
    xPlus(x, value) {
      return x + value;
    },
    leftForLtr(x, _itemWidth) {
      return x;
    }
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === "ltr" || direction === "rtl") {
    style = ctx.canvas.style;
    original = [
      style.getPropertyValue("direction"),
      style.getPropertyPriority("direction")
    ];
    style.setProperty("direction", direction, "important");
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== void 0) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty("direction", original[0], original[1]);
  }
}
function propertyFn(property) {
  if (property === "angle") {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }
  return {
    between: _isBetween,
    compare: (a, b) => a - b,
    normalize: (x) => x
  };
}
function normalizeSegment({ start: start2, end: end2, count, loop, style }) {
  return {
    start: start2 % count,
    end: end2 % count,
    loop: loop && (end2 - start2 + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const { property, start: startBound, end: endBound } = bounds;
  const { between, normalize } = propertyFn(property);
  const count = points.length;
  let { start: start2, end: end2, loop } = segment;
  let i, ilen;
  if (loop) {
    start2 += count;
    end2 += count;
    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start2 % count][property]), startBound, endBound)) {
        break;
      }
      start2--;
      end2--;
    }
    start2 %= count;
    end2 %= count;
  }
  if (end2 < start2) {
    end2 += count;
  }
  return { start: start2, end: end2, loop, style: segment.style };
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [segment];
  }
  const { property, start: startBound, end: endBound } = bounds;
  const count = points.length;
  const { compare, between, normalize } = propertyFn(property);
  const { start: start2, end: end2, loop, style } = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value, point, prevValue;
  const startIsBefore = () => between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value) === 0 || between(endBound, prevValue, value);
  const shouldStart = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i = start2, prev = start2; i <= end2; ++i) {
    point = points[i % count];
    if (point.skip) {
      continue;
    }
    value = normalize(point[property]);
    if (value === prevValue) {
      continue;
    }
    inside = between(value, startBound, endBound);
    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : prev;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({ start: subStart, end: i, loop, count, style }));
      subStart = null;
    }
    prev = i;
    prevValue = value;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({ start: subStart, end: end2, loop, count, style }));
  }
  return result;
}
function _boundSegments(line, bounds) {
  const result = [];
  const segments = line.segments;
  for (let i = 0; i < segments.length; i++) {
    const sub = _boundSegment(segments[i], line.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start2 = 0;
  let end2 = count - 1;
  if (loop && !spanGaps) {
    while (start2 < count && !points[start2].skip) {
      start2++;
    }
  }
  while (start2 < count && points[start2].skip) {
    start2++;
  }
  start2 %= count;
  if (loop) {
    end2 += start2;
  }
  while (end2 > start2 && points[end2 % count].skip) {
    end2--;
  }
  end2 %= count;
  return { start: start2, end: end2 };
}
function solidSegments(points, start2, max2, loop) {
  const count = points.length;
  const result = [];
  let last = start2;
  let prev = points[start2];
  let end2;
  for (end2 = start2 + 1; end2 <= max2; ++end2) {
    const cur = points[end2 % count];
    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({ start: start2 % count, end: (end2 - 1) % count, loop });
        start2 = last = cur.stop ? end2 : null;
      }
    } else {
      last = end2;
      if (prev.skip) {
        start2 = end2;
      }
    }
    prev = cur;
  }
  if (last !== null) {
    result.push({ start: start2 % count, end: last % count, loop });
  }
  return result;
}
function _computeSegments(line, segmentOptions) {
  const points = line.points;
  const spanGaps = line.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line._loop;
  const { start: start2, end: end2 } = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line, [{ start: start2, end: end2, loop }], points, segmentOptions);
  }
  const max2 = end2 < start2 ? end2 + count : end2;
  const completeLoop = !!line._fullLoop && start2 === 0 && end2 === count - 1;
  return splitByStyles(line, solidSegments(points, start2, max2, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
  const chartContext = line._chart.getContext();
  const baseStyle = readStyle(line.options);
  const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start2 = segments[0].start;
  let i = start2;
  function addStyle(s, e, l, st) {
    const dir = spanGaps ? -1 : 1;
    if (s === e) {
      return;
    }
    s += count;
    while (points[s % count].skip) {
      s -= dir;
    }
    while (points[e % count].skip) {
      e += dir;
    }
    if (s % count !== e % count) {
      result.push({ start: s % count, end: e % count, loop: l, style: st });
      prevStyle = st;
      start2 = e % count;
    }
  }
  for (const segment of segments) {
    start2 = spanGaps ? start2 : segment.start;
    let prev = points[start2 % count];
    let style;
    for (i = start2 + 1; i <= segment.end; i++) {
      const pt = points[i % count];
      style = readStyle(segmentOptions.setContext(createContext(chartContext, {
        type: "segment",
        p0: prev,
        p1: pt,
        p0DataIndex: (i - 1) % count,
        p1DataIndex: i % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start2, i - 1, segment.loop, prevStyle);
      }
      prev = pt;
      prevStyle = style;
    }
    if (start2 < i - 1) {
      addStyle(start2, i - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}
function styleChanged(style, prevStyle) {
  return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
class Animator {
  constructor() {
    this._request = null;
    this._charts = /* @__PURE__ */ new Map();
    this._running = false;
    this._lastDate = void 0;
  }
  _notify(chart, anims, date, type) {
    const callbacks = anims.listeners[type];
    const numSteps = anims.duration;
    callbacks.forEach((fn2) => fn2({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i = items.length - 1;
      let draw2 = false;
      let item;
      for (; i >= 0; --i) {
        item = items[i];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw2 = true;
        } else {
          items[i] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw2) {
        chart.draw();
        this._notify(chart, anims, date, "progress");
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, "complete");
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i = items.length - 1;
    for (; i >= 0; --i) {
      items[i].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), "complete");
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
}
var animator = new Animator();
const transparent = "transparent";
const interpolators = {
  boolean(from2, to2, factor) {
    return factor > 0.5 ? to2 : from2;
  },
  color(from2, to2, factor) {
    const c0 = color(from2 || transparent);
    const c1 = c0.valid && color(to2 || transparent);
    return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to2;
  },
  number(from2, to2, factor) {
    return from2 + (to2 - from2) * factor;
  }
};
class Animation {
  constructor(cfg, target, prop, to2) {
    const currentValue = target[prop];
    to2 = resolve([cfg.to, to2, currentValue, cfg.from]);
    const from2 = resolve([cfg.from, currentValue, to2]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from2];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from2;
    this._to = to2;
    this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(cfg, to2, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([cfg.to, to2, currentValue, cfg.from]);
      this._from = resolve([cfg.from, currentValue, to2]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration = this._duration;
    const prop = this._prop;
    const from2 = this._from;
    const loop = this._loop;
    const to2 = this._to;
    let factor;
    this._active = from2 !== to2 && (loop || elapsed < duration);
    if (!this._active) {
      this._target[prop] = to2;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from2;
      return;
    }
    factor = elapsed / duration % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from2, to2, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({ res, rej });
    });
  }
  _notify(resolved) {
    const method = resolved ? "res" : "rej";
    const promises = this._promises || [];
    for (let i = 0; i < promises.length; i++) {
      promises[i][method]();
    }
  }
}
const numbers = ["x", "y", "borderWidth", "radius", "tension"];
const colors = ["color", "borderColor", "backgroundColor"];
defaults$1.set("animation", {
  delay: void 0,
  duration: 1e3,
  easing: "easeOutQuart",
  fn: void 0,
  from: void 0,
  loop: void 0,
  to: void 0,
  type: void 0
});
const animationOptions = Object.keys(defaults$1.animation);
defaults$1.describe("animation", {
  _fallback: false,
  _indexable: false,
  _scriptable: (name) => name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
defaults$1.set("animations", {
  colors: {
    type: "color",
    properties: colors
  },
  numbers: {
    type: "number",
    properties: numbers
  }
});
defaults$1.describe("animations", {
  _fallback: "animation"
});
defaults$1.set("transitions", {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: "transparent"
      },
      visible: {
        type: "boolean",
        duration: 0
      }
    }
  },
  hide: {
    animations: {
      colors: {
        to: "transparent"
      },
      visible: {
        type: "boolean",
        easing: "linear",
        fn: (v) => v | 0
      }
    }
  }
});
class Animations {
  constructor(chart, config) {
    this._chart = chart;
    this._properties = /* @__PURE__ */ new Map();
    this.configure(config);
  }
  configure(config) {
    if (!isObject(config)) {
      return;
    }
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config).forEach((key) => {
      const cfg = config[key];
      if (!isObject(cfg)) {
        return;
      }
      const resolved = {};
      for (const option of animationOptions) {
        resolved[option] = cfg[option];
      }
      (isArray(cfg.properties) && cfg.properties || [key]).forEach((prop) => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target, values) {
    const newOptions = values.options;
    const options = resolveTargetOptions(target, newOptions);
    if (!options) {
      return [];
    }
    const animations = this._createAnimations(options, newOptions);
    if (newOptions.$shared) {
      awaitAll(target.options.$animations, newOptions).then(() => {
        target.options = newOptions;
      }, () => {
      });
    }
    return animations;
  }
  _createAnimations(target, values) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target.$animations || (target.$animations = {});
    const props = Object.keys(values);
    const date = Date.now();
    let i;
    for (i = props.length - 1; i >= 0; --i) {
      const prop = props[i];
      if (prop.charAt(0) === "$") {
        continue;
      }
      if (prop === "options") {
        animations.push(...this._animateOptions(target, values));
        continue;
      }
      const value = values[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target[prop] = value;
        continue;
      }
      running[prop] = animation = new Animation(cfg, target, prop, value);
      animations.push(animation);
    }
    return animations;
  }
  update(target, values) {
    if (this._properties.size === 0) {
      Object.assign(target, values);
      return;
    }
    const animations = this._createAnimations(target, values);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
}
function awaitAll(animations, properties) {
  const running = [];
  const keys = Object.keys(properties);
  for (let i = 0; i < keys.length; i++) {
    const anim = animations[keys[i]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }
  let options = target.options;
  if (!options) {
    target.options = newOptions;
    return;
  }
  if (options.$shared) {
    target.options = options = Object.assign({}, options, { $shared: false, $animations: {} });
  }
  return options;
}
function scaleClip(scale, allowedOverflow) {
  const opts = scale && scale.options || {};
  const reverse = opts.reverse;
  const min2 = opts.min === void 0 ? allowedOverflow : 0;
  const max2 = opts.max === void 0 ? allowedOverflow : 0;
  return {
    start: reverse ? max2 : min2,
    end: reverse ? min2 : max2
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x = scaleClip(xScale, allowedOverflow);
  const y = scaleClip(yScale, allowedOverflow);
  return {
    top: y.end,
    right: x.end,
    bottom: y.start,
    left: x.start
  };
}
function toClip(value) {
  let t, r, b, l;
  if (isObject(value)) {
    t = value.top;
    r = value.right;
    b = value.bottom;
    l = value.left;
  } else {
    t = r = b = l = value;
  }
  return {
    top: t,
    right: r,
    bottom: b,
    left: l,
    disabled: value === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i, ilen;
  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }
  return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
  const keys = stack.keys;
  const singleMode = options.mode === "single";
  let i, ilen, datasetIndex, otherValue;
  if (value === null) {
    return;
  }
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];
    if (datasetIndex === dsIndex) {
      if (options.all) {
        continue;
      }
      break;
    }
    otherValue = stack.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || (value === 0 || sign(value) === sign(otherValue)))) {
      value += otherValue;
    }
  }
  return value;
}
function convertObjectDataToArray(data) {
  const keys = Object.keys(data);
  const adata = new Array(keys.length);
  let i, ilen, key;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      x: key,
      y: data[key]
    };
  }
  return adata;
}
function isStacked(scale, meta) {
  const stacked = scale && scale.options.stacked;
  return stacked || stacked === void 0 && meta.stack !== void 0;
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
  const { min: min2, max: max2, minDefined, maxDefined } = scale.getUserBounds();
  return {
    min: minDefined ? min2 : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max2 : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
  for (const meta of vScale.getMatchingVisibleMetas(type).reverse()) {
    const value = stack[meta.index];
    if (positive && value > 0 || !positive && value < 0) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const { chart, _cachedMeta: meta } = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const { iScale, vScale, index: datasetIndex } = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack;
  for (let i = 0; i < ilen; ++i) {
    const item = parsed[i];
    const { [iAxis]: index2, [vAxis]: value } = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index2);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
  }
}
function getFirstScaleId(chart, axis) {
  const scales2 = chart.scales;
  return Object.keys(scales2).filter((key) => scales2[key].axis === axis).shift();
}
function createDatasetContext(parent, index2) {
  return createContext(
    parent,
    {
      active: false,
      dataset: void 0,
      datasetIndex: index2,
      index: index2,
      mode: "default",
      type: "dataset"
    }
  );
}
function createDataContext(parent, index2, element) {
  return createContext(parent, {
    active: false,
    dataIndex: index2,
    parsed: void 0,
    raw: void 0,
    element,
    index: index2,
    mode: "default",
    type: "data"
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === void 0 || stacks[axis][datasetIndex] === void 0) {
      return;
    }
    delete stacks[axis][datasetIndex];
  }
}
const isDirectUpdateMode = (mode) => mode === "reset" || mode === "none";
const cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked && { keys: getSortedDatasetIndices(chart, true), values: null };
class DatasetController {
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = void 0;
    this._parsing = false;
    this._data = void 0;
    this._objectData = void 0;
    this._sharedOptions = void 0;
    this._drawStart = void 0;
    this._drawCount = void 0;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = void 0;
    this._syncList = [];
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x, y, r) => axis === "x" ? x : axis === "r" ? r : y;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, "x"));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, "y"));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, "r"));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale) {
    const meta = this._cachedMeta;
    return scale === meta.iScale ? meta.vScale : meta.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject(data)) {
      this._data = convertObjectDataToArray(data);
    } else if (_data !== data) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data && Object.isExtensible(data)) {
        listenArrayEvents(data, this);
      }
      this._syncList = [];
      this._data = data;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
    }
  }
  configure() {
    const config = this.chart.config;
    const scopeKeys = config.datasetScopeKeys(this._type);
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start2, count) {
    const { _cachedMeta: meta, _data: data } = this;
    const { iScale, _stacked } = meta;
    const iAxis = iScale.axis;
    let sorted = start2 === 0 && count === data.length ? true : meta._sorted;
    let prev = start2 > 0 && meta._parsed[start2 - 1];
    let i, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data;
      meta._sorted = true;
      parsed = data;
    } else {
      if (isArray(data[start2])) {
        parsed = this.parseArrayData(meta, data, start2, count);
      } else if (isObject(data[start2])) {
        parsed = this.parseObjectData(meta, data, start2, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data, start2, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
      for (i = 0; i < count; ++i) {
        meta._parsed[i + start2] = cur = parsed[i];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data, start2, count) {
    const { iScale, vScale } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i, ilen, index2;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start2;
      parsed[i] = {
        [iAxis]: singleScale || iScale.parse(labels[index2], index2),
        [vAxis]: vScale.parse(data[index2], index2)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data, start2, count) {
    const { xScale, yScale } = meta;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start2;
      item = data[index2];
      parsed[i] = {
        x: xScale.parse(item[0], index2),
        y: yScale.parse(item[1], index2)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data, start2, count) {
    const { xScale, yScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start2;
      item = data[index2];
      parsed[i] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index2),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index2)
      };
    }
    return parsed;
  }
  getParsed(index2) {
    return this._cachedMeta._parsed[index2];
  }
  getDataElement(index2) {
    return this._cachedMeta.data[index2];
  }
  applyStack(scale, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value = parsed[scale.axis];
    const stack = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale.axis]
    };
    return applyStack(stack, value, meta.index, { mode });
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    const parsedValue = parsed[scale.axis];
    let value = parsedValue === null ? NaN : parsedValue;
    const values = stack && parsed._stacks[scale.axis];
    if (stack && values) {
      stack.values = values;
      value = applyStack(stack, parsedValue, this._cachedMeta.index);
    }
    range.min = Math.min(range.min, value);
    range.max = Math.max(range.max, value);
  }
  getMinMax(scale, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale);
    const stack = createStack(canStack, meta, this.chart);
    const range = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
    let i, parsed;
    function _skip() {
      parsed = _parsed[i];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i = 0; i < ilen; ++i) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range, scale, parsed, stack);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i = ilen - 1; i >= 0; --i) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range, scale, parsed, stack);
        break;
      }
    }
    return range;
  }
  getAllParsedValues(scale) {
    const parsed = this._cachedMeta._parsed;
    const values = [];
    let i, ilen, value;
    for (i = 0, ilen = parsed.length; i < ilen; ++i) {
      value = parsed[i][scale.axis];
      if (isNumberFinite(value)) {
        values.push(value);
      }
    }
    return values;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
      value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || "default");
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {
  }
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements2 = meta.data || [];
    const area = chart.chartArea;
    const active = [];
    const start2 = this._drawStart || 0;
    const count = this._drawCount || elements2.length - start2;
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start2, count);
    }
    for (i = start2; i < start2 + count; ++i) {
      const element = elements2[i];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i = 0; i < active.length; ++i) {
      active[i].draw(ctx, area);
    }
  }
  getStyle(index2, active) {
    const mode = active ? "active" : "default";
    return index2 === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index2 || 0, mode);
  }
  getContext(index2, active, mode) {
    const dataset = this.getDataset();
    let context;
    if (index2 >= 0 && index2 < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index2];
      context = element.$context || (element.$context = createDataContext(this.getContext(), index2, element));
      context.parsed = this.getParsed(index2);
      context.raw = dataset.data[index2];
      context.index = context.dataIndex = index2;
    } else {
      context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index2, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index2);
  }
  _resolveElementOptions(elementType, mode = "default", index2) {
    const active = mode === "active";
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + "-" + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index2);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config = this.chart.config;
    const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
    const prefixes = active ? [`${elementType}Hover`, "hover", elementType, ""] : [elementType, ""];
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
    const names2 = Object.keys(defaults$1.elements[elementType]);
    const context = () => this.getContext(index2, active);
    const values = config.resolveNamedOptions(scopes, names2, context, prefixes);
    if (values.$shared) {
      values.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
    }
    return values;
  }
  _resolveAnimations(index2, transition, active) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options;
    if (chart.options.animation !== false) {
      const config = this.chart.config;
      const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      options = config.createResolver(scopes, this.getContext(index2, active, transition));
    }
    const animations = new Animations(chart, options && options.animations);
    if (options && options._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options) {
    if (!options.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  _getSharedOptions(start2, mode) {
    const firstOpts = this.resolveDataElementOptions(start2, mode);
    const previouslySharedOptions = this._sharedOptions;
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    return { sharedOptions, includeOptions };
  }
  updateElement(element, index2, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index2, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(void 0, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index2, mode, active) {
    element.active = active;
    const options = this.getStyle(index2, active);
    this._resolveAnimations(index2, mode, active).update(element, {
      options: !active && this.getSharedOptions(options) || options
    });
  }
  removeHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", false);
  }
  setHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", true);
    }
  }
  _resyncElements(resetNewElements) {
    const data = this._data;
    const elements2 = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements2.length;
    const numData = data.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start2, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data = meta.data;
    const end2 = start2 + count;
    let i;
    const move = (arr) => {
      arr.length += count;
      for (i = arr.length - 1; i >= end2; i--) {
        arr[i] = arr[i - count];
      }
    };
    move(data);
    for (i = start2; i < end2; ++i) {
      data[i] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start2, count);
    if (resetNewElements) {
      this.updateElements(data, start2, count, "reset");
    }
  }
  updateElements(element, start2, count, mode) {
  }
  _removeElements(start2, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start2, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start2, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([this.index, ...args]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync(["_insertElements", this.getDataset().data.length - count, count]);
  }
  _onDataPop() {
    this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(["_removeElements", 0, 1]);
  }
  _onDataSplice(start2, count) {
    if (count) {
      this._sync(["_removeElements", start2, count]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync(["_insertElements", start2, newCount]);
    }
  }
  _onDataUnshift() {
    this._sync(["_insertElements", 0, arguments.length]);
  }
}
DatasetController.defaults = {};
DatasetController.prototype.datasetElementType = null;
DatasetController.prototype.dataElementType = null;
function getAllScaleValues(scale, type) {
  if (!scale._cache.$bar) {
    const visibleMetas = scale.getMatchingVisibleMetas(type);
    let values = [];
    for (let i = 0, ilen = visibleMetas.length; i < ilen; i++) {
      values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
    }
    scale._cache.$bar = _arrayUnique(values.sort((a, b) => a - b));
  }
  return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
  const scale = meta.iScale;
  const values = getAllScaleValues(scale, meta.type);
  let min2 = scale._length;
  let i, ilen, curr, prev;
  const updateMinAndPrev = () => {
    if (curr === 32767 || curr === -32768) {
      return;
    }
    if (defined(prev)) {
      min2 = Math.min(min2, Math.abs(curr - prev) || min2);
    }
    prev = curr;
  };
  for (i = 0, ilen = values.length; i < ilen; ++i) {
    curr = scale.getPixelForValue(values[i]);
    updateMinAndPrev();
  }
  prev = void 0;
  for (i = 0, ilen = scale.ticks.length; i < ilen; ++i) {
    curr = scale.getPixelForTick(i);
    updateMinAndPrev();
  }
  return min2;
}
function computeFitCategoryTraits(index2, ruler, options, stackCount) {
  const thickness = options.barThickness;
  let size, ratio;
  if (isNullOrUndef(thickness)) {
    size = ruler.min * options.categoryPercentage;
    ratio = options.barPercentage;
  } else {
    size = thickness * stackCount;
    ratio = 1;
  }
  return {
    chunk: size / stackCount,
    ratio,
    start: ruler.pixels[index2] - size / 2
  };
}
function computeFlexCategoryTraits(index2, ruler, options, stackCount) {
  const pixels = ruler.pixels;
  const curr = pixels[index2];
  let prev = index2 > 0 ? pixels[index2 - 1] : null;
  let next = index2 < pixels.length - 1 ? pixels[index2 + 1] : null;
  const percent = options.categoryPercentage;
  if (prev === null) {
    prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
  }
  if (next === null) {
    next = curr + curr - prev;
  }
  const start2 = curr - (curr - Math.min(prev, next)) / 2 * percent;
  const size = Math.abs(next - prev) / 2 * percent;
  return {
    chunk: size / stackCount,
    ratio: options.barPercentage,
    start: start2
  };
}
function parseFloatBar(entry, item, vScale, i) {
  const startValue = vScale.parse(entry[0], i);
  const endValue = vScale.parse(entry[1], i);
  const min2 = Math.min(startValue, endValue);
  const max2 = Math.max(startValue, endValue);
  let barStart = min2;
  let barEnd = max2;
  if (Math.abs(min2) > Math.abs(max2)) {
    barStart = max2;
    barEnd = min2;
  }
  item[vScale.axis] = barEnd;
  item._custom = {
    barStart,
    barEnd,
    start: startValue,
    end: endValue,
    min: min2,
    max: max2
  };
}
function parseValue(entry, item, vScale, i) {
  if (isArray(entry)) {
    parseFloatBar(entry, item, vScale, i);
  } else {
    item[vScale.axis] = vScale.parse(entry, i);
  }
  return item;
}
function parseArrayOrPrimitive(meta, data, start2, count) {
  const iScale = meta.iScale;
  const vScale = meta.vScale;
  const labels = iScale.getLabels();
  const singleScale = iScale === vScale;
  const parsed = [];
  let i, ilen, item, entry;
  for (i = start2, ilen = start2 + count; i < ilen; ++i) {
    entry = data[i];
    item = {};
    item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
    parsed.push(parseValue(entry, item, vScale, i));
  }
  return parsed;
}
function isFloatBar(custom) {
  return custom && custom.barStart !== void 0 && custom.barEnd !== void 0;
}
function barSign(size, vScale, actualBase) {
  if (size !== 0) {
    return sign(size);
  }
  return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
  let reverse, start2, end2, top2, bottom2;
  if (properties.horizontal) {
    reverse = properties.base > properties.x;
    start2 = "left";
    end2 = "right";
  } else {
    reverse = properties.base < properties.y;
    start2 = "bottom";
    end2 = "top";
  }
  if (reverse) {
    top2 = "end";
    bottom2 = "start";
  } else {
    top2 = "start";
    bottom2 = "end";
  }
  return { start: start2, end: end2, reverse, top: top2, bottom: bottom2 };
}
function setBorderSkipped(properties, options, stack, index2) {
  let edge = options.borderSkipped;
  const res = {};
  if (!edge) {
    properties.borderSkipped = res;
    return;
  }
  if (edge === true) {
    properties.borderSkipped = { top: true, right: true, bottom: true, left: true };
    return;
  }
  const { start: start2, end: end2, reverse, top: top2, bottom: bottom2 } = borderProps(properties);
  if (edge === "middle" && stack) {
    properties.enableBorderRadius = true;
    if ((stack._top || 0) === index2) {
      edge = top2;
    } else if ((stack._bottom || 0) === index2) {
      edge = bottom2;
    } else {
      res[parseEdge(bottom2, start2, end2, reverse)] = true;
      edge = top2;
    }
  }
  res[parseEdge(edge, start2, end2, reverse)] = true;
  properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
  if (reverse) {
    edge = swap(edge, a, b);
    edge = startEnd(edge, b, a);
  } else {
    edge = startEnd(edge, a, b);
  }
  return edge;
}
function swap(orig, v1, v2) {
  return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start2, end2) {
  return v === "start" ? start2 : v === "end" ? end2 : v;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
  properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
  parsePrimitiveData(meta, data, start2, count) {
    return parseArrayOrPrimitive(meta, data, start2, count);
  }
  parseArrayData(meta, data, start2, count) {
    return parseArrayOrPrimitive(meta, data, start2, count);
  }
  parseObjectData(meta, data, start2, count) {
    const { iScale, vScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
    const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
    const parsed = [];
    let i, ilen, item, obj;
    for (i = start2, ilen = start2 + count; i < ilen; ++i) {
      obj = data[i];
      item = {};
      item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
      parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
    }
    return parsed;
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    super.updateRangeFromParsed(range, scale, parsed, stack);
    const custom = parsed._custom;
    if (custom && scale === this._cachedMeta.vScale) {
      range.min = Math.min(range.min, custom.min);
      range.max = Math.max(range.max, custom.max);
    }
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const { iScale, vScale } = meta;
    const parsed = this.getParsed(index2);
    const custom = parsed._custom;
    const value = isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
    return {
      label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
      value
    };
  }
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
    const meta = this._cachedMeta;
    meta.stack = this.getDataset().stack;
  }
  update(mode) {
    const meta = this._cachedMeta;
    this.updateElements(meta.data, 0, meta.data.length, mode);
  }
  updateElements(bars, start2, count, mode) {
    const reset = mode === "reset";
    const { index: index2, _cachedMeta: { vScale } } = this;
    const base = vScale.getBasePixel();
    const horizontal = vScale.isHorizontal();
    const ruler = this._getRuler();
    const { sharedOptions, includeOptions } = this._getSharedOptions(start2, mode);
    for (let i = start2; i < start2 + count; i++) {
      const parsed = this.getParsed(i);
      const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? { base, head: base } : this._calculateBarValuePixels(i);
      const ipixels = this._calculateBarIndexPixels(i, ruler);
      const stack = (parsed._stacks || {})[vScale.axis];
      const properties = {
        horizontal,
        base: vpixels.base,
        enableBorderRadius: !stack || isFloatBar(parsed._custom) || (index2 === stack._top || index2 === stack._bottom),
        x: horizontal ? vpixels.head : ipixels.center,
        y: horizontal ? ipixels.center : vpixels.head,
        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
      }
      const options = properties.options || bars[i].options;
      setBorderSkipped(properties, options, stack, index2);
      setInflateAmount(properties, options, ruler.ratio);
      this.updateElement(bars[i], i, properties, mode);
    }
  }
  _getStacks(last, dataIndex) {
    const { iScale } = this._cachedMeta;
    const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta) => meta.controller.options.grouped);
    const stacked = iScale.options.stacked;
    const stacks = [];
    const skipNull = (meta) => {
      const parsed = meta.controller.getParsed(dataIndex);
      const val = parsed && parsed[meta.vScale.axis];
      if (isNullOrUndef(val) || isNaN(val)) {
        return true;
      }
    };
    for (const meta of metasets) {
      if (dataIndex !== void 0 && skipNull(meta)) {
        continue;
      }
      if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === void 0 && meta.stack === void 0) {
        stacks.push(meta.stack);
      }
      if (meta.index === last) {
        break;
      }
    }
    if (!stacks.length) {
      stacks.push(void 0);
    }
    return stacks;
  }
  _getStackCount(index2) {
    return this._getStacks(void 0, index2).length;
  }
  _getStackIndex(datasetIndex, name, dataIndex) {
    const stacks = this._getStacks(datasetIndex, dataIndex);
    const index2 = name !== void 0 ? stacks.indexOf(name) : -1;
    return index2 === -1 ? stacks.length - 1 : index2;
  }
  _getRuler() {
    const opts = this.options;
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const pixels = [];
    let i, ilen;
    for (i = 0, ilen = meta.data.length; i < ilen; ++i) {
      pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
    }
    const barThickness = opts.barThickness;
    const min2 = barThickness || computeMinSampleSize(meta);
    return {
      min: min2,
      pixels,
      start: iScale._startPixel,
      end: iScale._endPixel,
      stackCount: this._getStackCount(),
      scale: iScale,
      grouped: opts.grouped,
      ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
    };
  }
  _calculateBarValuePixels(index2) {
    const { _cachedMeta: { vScale, _stacked }, options: { base: baseValue, minBarLength } } = this;
    const actualBase = baseValue || 0;
    const parsed = this.getParsed(index2);
    const custom = parsed._custom;
    const floating = isFloatBar(custom);
    let value = parsed[vScale.axis];
    let start2 = 0;
    let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
    let head, size;
    if (length !== value) {
      start2 = length - value;
      length = value;
    }
    if (floating) {
      value = custom.barStart;
      length = custom.barEnd - custom.barStart;
      if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
        start2 = 0;
      }
      start2 += value;
    }
    const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start2;
    let base = vScale.getPixelForValue(startValue);
    if (this.chart.getDataVisibility(index2)) {
      head = vScale.getPixelForValue(start2 + length);
    } else {
      head = base;
    }
    size = head - base;
    if (Math.abs(size) < minBarLength) {
      size = barSign(size, vScale, actualBase) * minBarLength;
      if (value === actualBase) {
        base -= size / 2;
      }
      const startPixel = vScale.getPixelForDecimal(0);
      const endPixel = vScale.getPixelForDecimal(1);
      const min2 = Math.min(startPixel, endPixel);
      const max2 = Math.max(startPixel, endPixel);
      base = Math.max(Math.min(base, max2), min2);
      head = base + size;
    }
    if (base === vScale.getPixelForValue(actualBase)) {
      const halfGrid = sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
      base += halfGrid;
      size -= halfGrid;
    }
    return {
      size,
      base,
      head,
      center: head + size / 2
    };
  }
  _calculateBarIndexPixels(index2, ruler) {
    const scale = ruler.scale;
    const options = this.options;
    const skipNull = options.skipNull;
    const maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
    let center, size;
    if (ruler.grouped) {
      const stackCount = skipNull ? this._getStackCount(index2) : ruler.stackCount;
      const range = options.barThickness === "flex" ? computeFlexCategoryTraits(index2, ruler, options, stackCount) : computeFitCategoryTraits(index2, ruler, options, stackCount);
      const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index2 : void 0);
      center = range.start + range.chunk * stackIndex + range.chunk / 2;
      size = Math.min(maxBarThickness, range.chunk * range.ratio);
    } else {
      center = scale.getPixelForValue(this.getParsed(index2)[scale.axis], index2);
      size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
    }
    return {
      base: center - size / 2,
      head: center + size / 2,
      center,
      size
    };
  }
  draw() {
    const meta = this._cachedMeta;
    const vScale = meta.vScale;
    const rects = meta.data;
    const ilen = rects.length;
    let i = 0;
    for (; i < ilen; ++i) {
      if (this.getParsed(i)[vScale.axis] !== null) {
        rects[i].draw(this._ctx);
      }
    }
  }
}
BarController.id = "bar";
BarController.defaults = {
  datasetElementType: false,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: true,
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "base", "width", "height"]
    }
  }
};
BarController.overrides = {
  scales: {
    _index_: {
      type: "category",
      offset: true,
      grid: {
        offset: true
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: true
    }
  }
};
class BubbleController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
  }
  parsePrimitiveData(meta, data, start2, count) {
    const parsed = super.parsePrimitiveData(meta, data, start2, count);
    for (let i = 0; i < parsed.length; i++) {
      parsed[i]._custom = this.resolveDataElementOptions(i + start2).radius;
    }
    return parsed;
  }
  parseArrayData(meta, data, start2, count) {
    const parsed = super.parseArrayData(meta, data, start2, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data[start2 + i];
      parsed[i]._custom = valueOrDefault(item[2], this.resolveDataElementOptions(i + start2).radius);
    }
    return parsed;
  }
  parseObjectData(meta, data, start2, count) {
    const parsed = super.parseObjectData(meta, data, start2, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data[start2 + i];
      parsed[i]._custom = valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i + start2).radius);
    }
    return parsed;
  }
  getMaxOverflow() {
    const data = this._cachedMeta.data;
    let max2 = 0;
    for (let i = data.length - 1; i >= 0; --i) {
      max2 = Math.max(max2, data[i].size(this.resolveDataElementOptions(i)) / 2);
    }
    return max2 > 0 && max2;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const { xScale, yScale } = meta;
    const parsed = this.getParsed(index2);
    const x = xScale.getLabelForValue(parsed.x);
    const y = yScale.getLabelForValue(parsed.y);
    const r = parsed._custom;
    return {
      label: meta.label,
      value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
    };
  }
  update(mode) {
    const points = this._cachedMeta.data;
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start2, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start2, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    for (let i = start2; i < start2 + count; i++) {
      const point = points[i];
      const parsed = !reset && this.getParsed(i);
      const properties = {};
      const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
      const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
      properties.skip = isNaN(iPixel) || isNaN(vPixel);
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
        if (reset) {
          properties.options.radius = 0;
        }
      }
      this.updateElement(point, i, properties, mode);
    }
  }
  resolveDataElementOptions(index2, mode) {
    const parsed = this.getParsed(index2);
    let values = super.resolveDataElementOptions(index2, mode);
    if (values.$shared) {
      values = Object.assign({}, values, { $shared: false });
    }
    const radius = values.radius;
    if (mode !== "active") {
      values.radius = 0;
    }
    values.radius += valueOrDefault(parsed && parsed._custom, radius);
    return values;
  }
}
BubbleController.id = "bubble";
BubbleController.defaults = {
  datasetElementType: false,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "borderWidth", "radius"]
    }
  }
};
BubbleController.overrides = {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        }
      }
    }
  }
};
function getRatioAndOffset(rotation, circumference, cutout) {
  let ratioX = 1;
  let ratioY = 1;
  let offsetX = 0;
  let offsetY = 0;
  if (circumference < TAU) {
    const startAngle = rotation;
    const endAngle = startAngle + circumference;
    const startX = Math.cos(startAngle);
    const startY = Math.sin(startAngle);
    const endX = Math.cos(endAngle);
    const endY = Math.sin(endAngle);
    const calcMax = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
    const calcMin = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
    const maxX = calcMax(0, startX, endX);
    const maxY = calcMax(HALF_PI, startY, endY);
    const minX = calcMin(PI, startX, endX);
    const minY = calcMin(PI + HALF_PI, startY, endY);
    ratioX = (maxX - minX) / 2;
    ratioY = (maxY - minY) / 2;
    offsetX = -(maxX + minX) / 2;
    offsetY = -(maxY + minY) / 2;
  }
  return { ratioX, ratioY, offsetX, offsetY };
}
class DoughnutController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.enableOptionSharing = true;
    this.innerRadius = void 0;
    this.outerRadius = void 0;
    this.offsetX = void 0;
    this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(start2, count) {
    const data = this.getDataset().data;
    const meta = this._cachedMeta;
    if (this._parsing === false) {
      meta._parsed = data;
    } else {
      let getter = (i2) => +data[i2];
      if (isObject(data[start2])) {
        const { key = "value" } = this._parsing;
        getter = (i2) => +resolveObjectKey(data[i2], key);
      }
      let i, ilen;
      for (i = start2, ilen = start2 + count; i < ilen; ++i) {
        meta._parsed[i] = getter(i);
      }
    }
  }
  _getRotation() {
    return toRadians(this.options.rotation - 90);
  }
  _getCircumference() {
    return toRadians(this.options.circumference);
  }
  _getRotationExtents() {
    let min2 = TAU;
    let max2 = -TAU;
    for (let i = 0; i < this.chart.data.datasets.length; ++i) {
      if (this.chart.isDatasetVisible(i)) {
        const controller = this.chart.getDatasetMeta(i).controller;
        const rotation = controller._getRotation();
        const circumference = controller._getCircumference();
        min2 = Math.min(min2, rotation);
        max2 = Math.max(max2, rotation + circumference);
      }
    }
    return {
      rotation: min2,
      circumference: max2 - min2
    };
  }
  update(mode) {
    const chart = this.chart;
    const { chartArea } = chart;
    const meta = this._cachedMeta;
    const arcs = meta.data;
    const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
    const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
    const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
    const chartWeight = this._getRingWeight(this.index);
    const { circumference, rotation } = this._getRotationExtents();
    const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference, cutout);
    const maxWidth = (chartArea.width - spacing) / ratioX;
    const maxHeight = (chartArea.height - spacing) / ratioY;
    const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
    const outerRadius = toDimension(this.options.radius, maxRadius);
    const innerRadius = Math.max(outerRadius * cutout, 0);
    const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
    this.offsetX = offsetX * outerRadius;
    this.offsetY = offsetY * outerRadius;
    meta.total = this.calculateTotal();
    this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
    this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  _circumference(i, reset) {
    const opts = this.options;
    const meta = this._cachedMeta;
    const circumference = this._getCircumference();
    if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
      return 0;
    }
    return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
  }
  updateElements(arcs, start2, count, mode) {
    const reset = mode === "reset";
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const animateScale = reset && animationOpts.animateScale;
    const innerRadius = animateScale ? 0 : this.innerRadius;
    const outerRadius = animateScale ? 0 : this.outerRadius;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start2, mode);
    let startAngle = this._getRotation();
    let i;
    for (i = 0; i < start2; ++i) {
      startAngle += this._circumference(i, reset);
    }
    for (i = start2; i < start2 + count; ++i) {
      const circumference = this._circumference(i, reset);
      const arc = arcs[i];
      const properties = {
        x: centerX + this.offsetX,
        y: centerY + this.offsetY,
        startAngle,
        endAngle: startAngle + circumference,
        circumference,
        outerRadius,
        innerRadius
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
      }
      startAngle += circumference;
      this.updateElement(arc, i, properties, mode);
    }
  }
  calculateTotal() {
    const meta = this._cachedMeta;
    const metaData = meta.data;
    let total = 0;
    let i;
    for (i = 0; i < metaData.length; i++) {
      const value = meta._parsed[i];
      if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
        total += Math.abs(value);
      }
    }
    return total;
  }
  calculateCircumference(value) {
    const total = this._cachedMeta.total;
    if (total > 0 && !isNaN(value)) {
      return TAU * (Math.abs(value) / total);
    }
    return 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index2], chart.options.locale);
    return {
      label: labels[index2] || "",
      value
    };
  }
  getMaxBorderWidth(arcs) {
    let max2 = 0;
    const chart = this.chart;
    let i, ilen, meta, controller, options;
    if (!arcs) {
      for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
        if (chart.isDatasetVisible(i)) {
          meta = chart.getDatasetMeta(i);
          arcs = meta.data;
          controller = meta.controller;
          break;
        }
      }
    }
    if (!arcs) {
      return 0;
    }
    for (i = 0, ilen = arcs.length; i < ilen; ++i) {
      options = controller.resolveDataElementOptions(i);
      if (options.borderAlign !== "inner") {
        max2 = Math.max(max2, options.borderWidth || 0, options.hoverBorderWidth || 0);
      }
    }
    return max2;
  }
  getMaxOffset(arcs) {
    let max2 = 0;
    for (let i = 0, ilen = arcs.length; i < ilen; ++i) {
      const options = this.resolveDataElementOptions(i);
      max2 = Math.max(max2, options.offset || 0, options.hoverOffset || 0);
    }
    return max2;
  }
  _getRingWeightOffset(datasetIndex) {
    let ringWeightOffset = 0;
    for (let i = 0; i < datasetIndex; ++i) {
      if (this.chart.isDatasetVisible(i)) {
        ringWeightOffset += this._getRingWeight(i);
      }
    }
    return ringWeightOffset;
  }
  _getRingWeight(datasetIndex) {
    return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
DoughnutController.id = "doughnut";
DoughnutController.defaults = {
  datasetElementType: false,
  dataElementType: "arc",
  animation: {
    animateRotate: true,
    animateScale: false
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["circumference", "endAngle", "innerRadius", "outerRadius", "startAngle", "x", "y", "offset", "borderWidth", "spacing"]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
};
DoughnutController.descriptors = {
  _scriptable: (name) => name !== "spacing",
  _indexable: (name) => name !== "spacing"
};
DoughnutController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const { labels: { pointStyle } } = chart.legend.options;
            return data.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(tooltipItem) {
          let dataLabel = tooltipItem.label;
          const value = ": " + tooltipItem.formattedValue;
          if (isArray(dataLabel)) {
            dataLabel = dataLabel.slice();
            dataLabel[0] += value;
          } else {
            dataLabel += value;
          }
          return dataLabel;
        }
      }
    }
  }
};
class LineController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    this.supportsDecimation = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const { dataset: line, data: points = [], _dataset } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start: start2, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start2;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start2 = 0;
      count = points.length;
    }
    line._chart = this.chart;
    line._datasetIndex = this.index;
    line._decimated = !!_dataset._decimated;
    line.points = points;
    const options = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options.borderWidth = 0;
    }
    options.segment = this.options.segment;
    this.updateElement(line, void 0, {
      animated: !animationsDisabled,
      options
    }, mode);
    this.updateElements(points, start2, count, mode);
  }
  updateElements(points, start2, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start2, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    let prevParsed = start2 > 0 && this.getParsed(start2 - 1);
    for (let i = start2; i < start2 + count; ++i) {
      const point = points[i];
      const parsed = this.getParsed(i);
      const properties = directUpdate ? point : {};
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data = meta.data || [];
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
}
LineController.id = "line";
LineController.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: true,
  spanGaps: false
};
LineController.overrides = {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
};
class PolarAreaController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.innerRadius = void 0;
    this.outerRadius = void 0;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index2].r, chart.options.locale);
    return {
      label: labels[index2] || "",
      value
    };
  }
  parseObjectData(meta, data, start2, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data, start2, count);
  }
  update(mode) {
    const arcs = this._cachedMeta.data;
    this._updateRadius();
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  getMinMax() {
    const meta = this._cachedMeta;
    const range = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    meta.data.forEach((element, index2) => {
      const parsed = this.getParsed(index2).r;
      if (!isNaN(parsed) && this.chart.getDataVisibility(index2)) {
        if (parsed < range.min) {
          range.min = parsed;
        }
        if (parsed > range.max) {
          range.max = parsed;
        }
      }
    });
    return range;
  }
  _updateRadius() {
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
    const outerRadius = Math.max(minSize / 2, 0);
    const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
    const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
    this.outerRadius = outerRadius - radiusLength * this.index;
    this.innerRadius = this.outerRadius - radiusLength;
  }
  updateElements(arcs, start2, count, mode) {
    const reset = mode === "reset";
    const chart = this.chart;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const scale = this._cachedMeta.rScale;
    const centerX = scale.xCenter;
    const centerY = scale.yCenter;
    const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * PI;
    let angle = datasetStartAngle;
    let i;
    const defaultAngle = 360 / this.countVisibleElements();
    for (i = 0; i < start2; ++i) {
      angle += this._computeAngle(i, mode, defaultAngle);
    }
    for (i = start2; i < start2 + count; i++) {
      const arc = arcs[i];
      let startAngle = angle;
      let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
      let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
      angle = endAngle;
      if (reset) {
        if (animationOpts.animateScale) {
          outerRadius = 0;
        }
        if (animationOpts.animateRotate) {
          startAngle = endAngle = datasetStartAngle;
        }
      }
      const properties = {
        x: centerX,
        y: centerY,
        innerRadius: 0,
        outerRadius,
        startAngle,
        endAngle,
        options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
      };
      this.updateElement(arc, i, properties, mode);
    }
  }
  countVisibleElements() {
    const meta = this._cachedMeta;
    let count = 0;
    meta.data.forEach((element, index2) => {
      if (!isNaN(this.getParsed(index2).r) && this.chart.getDataVisibility(index2)) {
        count++;
      }
    });
    return count;
  }
  _computeAngle(index2, mode, defaultAngle) {
    return this.chart.getDataVisibility(index2) ? toRadians(this.resolveDataElementOptions(index2, mode).angle || defaultAngle) : 0;
  }
}
PolarAreaController.id = "polarArea";
PolarAreaController.defaults = {
  dataElementType: "arc",
  animation: {
    animateRotate: true,
    animateScale: true
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius"]
    }
  },
  indexAxis: "r",
  startAngle: 0
};
PolarAreaController.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const { labels: { pointStyle } } = chart.legend.options;
            return data.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(context) {
          return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: false
      },
      beginAtZero: true,
      grid: {
        circular: true
      },
      pointLabels: {
        display: false
      },
      startAngle: 0
    }
  }
};
class PieController extends DoughnutController {
}
PieController.id = "pie";
PieController.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
};
class RadarController extends DatasetController {
  getLabelAndValue(index2) {
    const vScale = this._cachedMeta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: vScale.getLabels()[index2],
      value: "" + vScale.getLabelForValue(parsed[vScale.axis])
    };
  }
  parseObjectData(meta, data, start2, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data, start2, count);
  }
  update(mode) {
    const meta = this._cachedMeta;
    const line = meta.dataset;
    const points = meta.data || [];
    const labels = meta.iScale.getLabels();
    line.points = points;
    if (mode !== "resize") {
      const options = this.resolveDatasetElementOptions(mode);
      if (!this.options.showLine) {
        options.borderWidth = 0;
      }
      const properties = {
        _loop: true,
        _fullLoop: labels.length === points.length,
        options
      };
      this.updateElement(line, void 0, properties, mode);
    }
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start2, count, mode) {
    const scale = this._cachedMeta.rScale;
    const reset = mode === "reset";
    for (let i = start2; i < start2 + count; i++) {
      const point = points[i];
      const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
      const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
      const x = reset ? scale.xCenter : pointPosition.x;
      const y = reset ? scale.yCenter : pointPosition.y;
      const properties = {
        x,
        y,
        angle: pointPosition.angle,
        skip: isNaN(x) || isNaN(y),
        options
      };
      this.updateElement(point, i, properties, mode);
    }
  }
}
RadarController.id = "radar";
RadarController.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: true,
  elements: {
    line: {
      fill: "start"
    }
  }
};
RadarController.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
};
class Element$1 {
  constructor() {
    this.x = void 0;
    this.y = void 0;
    this.active = false;
    this.options = void 0;
    this.$animations = void 0;
  }
  tooltipPosition(useFinalPosition) {
    const { x, y } = this.getProps(["x", "y"], useFinalPosition);
    return { x, y };
  }
  hasValue() {
    return isNumber(this.x) && isNumber(this.y);
  }
  getProps(props, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      return this;
    }
    const ret = {};
    props.forEach((prop) => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
}
Element$1.defaults = {};
Element$1.defaultRoutes = void 0;
const formatters = {
  values(value) {
    return isArray(value) ? value : "" + value;
  },
  numeric(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const locale = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e15) {
        notation = "scientific";
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options = { notation, minimumFractionDigits: numDecimal, maximumFractionDigits: numDecimal };
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale, options);
  },
  logarithmic(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const remain = tickValue / Math.pow(10, Math.floor(log10(tickValue)));
    if (remain === 1 || remain === 2 || remain === 5) {
      return formatters.numeric.call(this, tickValue, index2, ticks);
    }
    return "";
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = { formatters };
defaults$1.set("scale", {
  display: true,
  offset: false,
  reverse: false,
  beginAtZero: false,
  bounds: "ticks",
  grace: 0,
  grid: {
    display: true,
    lineWidth: 1,
    drawBorder: true,
    drawOnChartArea: true,
    drawTicks: true,
    tickLength: 8,
    tickWidth: (_ctx, options) => options.lineWidth,
    tickColor: (_ctx, options) => options.color,
    offset: false,
    borderDash: [],
    borderDashOffset: 0,
    borderWidth: 1
  },
  title: {
    display: false,
    text: "",
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: false,
    textStrokeWidth: 0,
    textStrokeColor: "",
    padding: 3,
    display: true,
    autoSkip: true,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: Ticks.formatters.values,
    minor: {},
    major: {},
    align: "center",
    crossAlign: "near",
    showLabelBackdrop: false,
    backdropColor: "rgba(255, 255, 255, 0.75)",
    backdropPadding: 2
  }
});
defaults$1.route("scale.ticks", "color", "", "color");
defaults$1.route("scale.grid", "color", "", "borderColor");
defaults$1.route("scale.grid", "borderColor", "", "borderColor");
defaults$1.route("scale.title", "color", "", "color");
defaults$1.describe("scale", {
  _fallback: false,
  _scriptable: (name) => !name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
  _indexable: (name) => name !== "borderDash" && name !== "tickBorderDash"
});
defaults$1.describe("scales", {
  _fallback: "scale"
});
defaults$1.describe("scale.ticks", {
  _scriptable: (name) => name !== "backdropPadding" && name !== "callback",
  _indexable: (name) => name !== "backdropPadding"
});
function autoSkip(scale, ticks) {
  const tickOpts = scale.options.ticks;
  const ticksLimit = tickOpts.maxTicksLimit || determineMaxTicks(scale);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
    }
    skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing);
  return newTicks;
}
function determineMaxTicks(scale) {
  const offset2 = scale.options.offset;
  const tickLength = scale._tickSize();
  const maxScale = scale._length / tickLength + (offset2 ? 0 : 1);
  const maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i = 0, ilen = factors.length - 1; i < ilen; i++) {
    const factor = factors[i];
    if (factor > spacing) {
      return factor;
    }
  }
  return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i, ilen;
  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
  let count = 0;
  let next = majorIndices[0];
  let i;
  spacing = Math.ceil(spacing);
  for (i = 0; i < ticks.length; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  const start2 = valueOrDefault(majorStart, 0);
  const end2 = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length, i, next;
  spacing = Math.ceil(spacing);
  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }
  next = start2;
  while (next < 0) {
    count++;
    next = Math.round(start2 + count * spacing);
  }
  for (i = Math.max(start2, 0); i < end2; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = Math.round(start2 + count * spacing);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i, diff;
  if (len < 2) {
    return false;
  }
  for (diff = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff) {
      return false;
    }
  }
  return diff;
}
const reverseAlign = (align) => align === "left" ? "right" : align === "right" ? "left" : align;
const offsetFromEdge = (scale, edge, offset2) => edge === "top" || edge === "left" ? scale[edge] + offset2 : scale[edge] - offset2;
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i = 0;
  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }
  return result;
}
function getPixelForGridLine(scale, index2, offsetGridLines) {
  const length = scale.ticks.length;
  const validIndex2 = Math.min(index2, length - 1);
  const start2 = scale._startPixel;
  const end2 = scale._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale.getPixelForTick(validIndex2);
  let offset2;
  if (offsetGridLines) {
    if (length === 1) {
      offset2 = Math.max(lineValue - start2, end2 - lineValue);
    } else if (index2 === 0) {
      offset2 = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset2 = (lineValue - scale.getPixelForTick(validIndex2 - 1)) / 2;
    }
    lineValue += validIndex2 < index2 ? offset2 : -offset2;
    if (lineValue < start2 - epsilon || lineValue > end2 + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length) {
  each(caches, (cache) => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i;
    if (gcLen > length) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }
  const font = toFont(options.font, fallback);
  const padding = toPadding(options.padding);
  const lines = isArray(options.text) ? options.text.length : 1;
  return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
  return createContext(parent, {
    scale,
    type: "scale"
  });
}
function createTickContext(parent, index2, tick) {
  return createContext(parent, {
    tick,
    index: index2,
    type: "tick"
  });
}
function titleAlign(align, position, reverse) {
  let ret = _toLeftRightCenter(align);
  if (reverse && position !== "right" || !reverse && position === "right") {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale, offset2, position, align) {
  const { top: top2, left: left2, bottom: bottom2, right: right2, chart } = scale;
  const { chartArea, scales: scales2 } = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height = bottom2 - top2;
  const width = right2 - left2;
  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left2, right2);
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleY = scales2[positionAxisID].getPixelForValue(value) + height - offset2;
    } else if (position === "center") {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset2;
    } else {
      titleY = offsetFromEdge(scale, position, offset2);
    }
    maxWidth = right2 - left2;
  } else {
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleX = scales2[positionAxisID].getPixelForValue(value) - width + offset2;
    } else if (position === "center") {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset2;
    } else {
      titleX = offsetFromEdge(scale, position, offset2);
    }
    titleY = _alignStartEnd(align, bottom2, top2);
    rotation = position === "left" ? -HALF_PI : HALF_PI;
  }
  return { titleX, titleY, maxWidth, rotation };
}
class Scale extends Element$1 {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = void 0;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = void 0;
    this.maxHeight = void 0;
    this.paddingTop = void 0;
    this.paddingBottom = void 0;
    this.paddingLeft = void 0;
    this.paddingRight = void 0;
    this.axis = void 0;
    this.labelRotation = void 0;
    this.min = void 0;
    this.max = void 0;
    this._range = void 0;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = void 0;
    this._endPixel = void 0;
    this._reversePixels = false;
    this._userMax = void 0;
    this._userMin = void 0;
    this._suggestedMax = void 0;
    this._suggestedMin = void 0;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = void 0;
  }
  init(options) {
    this.options = options.setContext(this.getContext());
    this.axis = options.axis;
    this._userMin = this.parse(options.min);
    this._userMax = this.parse(options.max);
    this._suggestedMin = this.parse(options.suggestedMin);
    this._suggestedMax = this.parse(options.suggestedMax);
  }
  parse(raw, index2) {
    return raw;
  }
  getUserBounds() {
    let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let { min: min2, max: max2, minDefined, maxDefined } = this.getUserBounds();
    let range;
    if (minDefined && maxDefined) {
      return { min: min2, max: max2 };
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i = 0, ilen = metas.length; i < ilen; ++i) {
      range = metas[i].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min2 = Math.min(min2, range.min);
      }
      if (!maxDefined) {
        max2 = Math.max(max2, range.max);
      }
    }
    min2 = maxDefined && min2 > max2 ? max2 : min2;
    max2 = minDefined && min2 > max2 ? min2 : max2;
    return {
      min: finiteOrDefault(min2, finiteOrDefault(max2, min2)),
      max: finiteOrDefault(max2, finiteOrDefault(min2, max2))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [this]);
  }
  update(maxWidth, maxHeight, margins) {
    const { beginAtZero, grace, ticks: tickOpts } = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
      this.afterAutoSkip();
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [this]);
  }
  _callHooks(name) {
    this.chart.notifyPlugins(name, this.getContext());
    callback(this.options[name], [this]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      tick = ticks[i];
      tick.label = callback(tickOpts.callback, [tick.value, i, ticks], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const options = this.options;
    const tickOpts = options.ticks;
    const numTicks = this.ticks.length;
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(
        Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)),
        Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))
      ));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    callback(this.options.beforeFit, [this]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
    const display = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const { first, last, widest, highest } = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last, sin, cos) {
    const { ticks: { align, padding }, position } = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last.width;
        }
      } else if (align === "start") {
        paddingRight = last.width;
      } else if (align === "end") {
        paddingLeft = first.width;
      } else if (align !== "inner") {
        paddingLeft = first.width / 2;
        paddingRight = last.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last.height / 2;
      let paddingBottom = first.height / 2;
      if (align === "start") {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === "end") {
        paddingTop = last.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const { axis, position } = this.options;
    return position === "top" || position === "bottom" || axis === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (isNullOrUndef(ticks[i].label)) {
        ticks.splice(i, 1);
        ilen--;
        i--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length) {
    const { ctx, _longestTextCache: caches } = this;
    const widths = [];
    const heights = [];
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
    for (i = 0; i < length; ++i) {
      label = ticks[i].label;
      tickFont = this._resolveTickFontOptions(i);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || { data: {}, gc: [] };
      lineHeight = tickFont.lineHeight;
      width = height = 0;
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height = lineHeight;
      } else if (isArray(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height, highestLabelSize);
    }
    garbageCollect(caches, length);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = (idx) => ({ width: widths[idx] || 0, height: heights[idx] || 0 });
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights
    };
  }
  getLabelForValue(value) {
    return value;
  }
  getPixelForValue(value, index2) {
    return NaN;
  }
  getValueForPixel(pixel) {
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getPixelForDecimal(decimal) {
    if (this._reversePixels) {
      decimal = 1 - decimal;
    }
    const pixel = this._startPixel + decimal * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal : decimal;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: min2, max: max2 } = this;
    return min2 < 0 && max2 < 0 ? max2 : min2 > 0 && max2 > 0 ? min2 : 0;
  }
  getContext(index2) {
    const ticks = this.ticks || [];
    if (index2 >= 0 && index2 < ticks.length) {
      const tick = ticks[index2];
      return tick.$context || (tick.$context = createTickContext(this.getContext(), index2, tick));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w = labelSizes ? labelSizes.widest.width + padding : 0;
    const h3 = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal() ? h3 * cos > w * sin ? w / cos : h3 / sin : h3 * sin < w * cos ? h3 / cos : w / sin;
  }
  _isVisible() {
    const display = this.options.display;
    if (display !== "auto") {
      return !!display;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options = this.options;
    const { grid, position } = options;
    const offset2 = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset2 ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = grid.setContext(this.getContext());
    const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function(pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
    if (position === "top") {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y2 = chartArea.bottom;
    } else if (position === "bottom") {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position === "left") {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x2 = chartArea.right;
    } else if (position === "right") {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === "x") {
      if (position === "center") {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      y1 = chartArea.top;
      y2 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === "y") {
      if (position === "center") {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x2 = chartArea.right;
    }
    const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit));
    for (i = 0; i < ticksLength; i += step) {
      const optsAtIndex = grid.setContext(this.getContext(i));
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = optsAtIndex.borderDash || [];
      const borderDashOffset = optsAtIndex.borderDashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i, offset2);
      if (lineValue === void 0) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x2 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y2 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2,
        y2,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options = this.options;
    const { position, ticks: optionTicks } = options;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const { align, crossAlign, padding, mirror } = optionTicks;
    const tl = getTickMarkLength(options.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = "middle";
    if (position === "top") {
      y = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === "bottom") {
      y = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === "left") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (position === "right") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (axis === "x") {
      if (position === "center") {
        y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === "y") {
      if (position === "center") {
        x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        x = this.chart.scales[positionAxisID].getPixelForValue(value);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === "y") {
      if (align === "start") {
        textBaseline = "top";
      } else if (align === "end") {
        textBaseline = "bottom";
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i));
      pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i);
      lineHeight = font.lineHeight;
      lineCount = isArray(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color2 = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      let tickTextAlign = textAlign;
      if (isHorizontal) {
        x = pixel;
        if (textAlign === "inner") {
          if (i === ilen - 1) {
            tickTextAlign = !this.options.reverse ? "right" : "left";
          } else if (i === 0) {
            tickTextAlign = !this.options.reverse ? "left" : "right";
          } else {
            tickTextAlign = "center";
          }
        }
        if (position === "top") {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
      } else {
        y = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height = labelSizes.heights[i];
        const width = labelSizes.widths[i];
        let top2 = y + textOffset - labelPadding.top;
        let left2 = x - labelPadding.left;
        switch (textBaseline) {
          case "middle":
            top2 -= height / 2;
            break;
          case "bottom":
            top2 -= height;
            break;
        }
        switch (textAlign) {
          case "center":
            left2 -= width / 2;
            break;
          case "right":
            left2 -= width;
            break;
        }
        backdrop = {
          left: left2,
          top: top2,
          width: width + labelPadding.width,
          height: height + labelPadding.height,
          color: optsAtIndex.backdropColor
        };
      }
      items.push({
        rotation,
        label,
        font,
        color: color2,
        strokeColor,
        strokeWidth,
        textOffset,
        textAlign: tickTextAlign,
        textBaseline,
        translation: [x, y],
        backdrop
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const { position, ticks } = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position === "top" ? "left" : "right";
    }
    let align = "center";
    if (ticks.align === "start") {
      align = "left";
    } else if (ticks.align === "end") {
      align = "right";
    } else if (ticks.align === "inner") {
      align = "inner";
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const { position, ticks: { crossAlign, mirror, padding } } = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x;
    if (position === "left") {
      if (mirror) {
        x = this.right + padding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x += widest / 2;
        } else {
          textAlign = "right";
          x += widest;
        }
      } else {
        x = this.right - tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x -= widest / 2;
        } else {
          textAlign = "left";
          x = this.left;
        }
      }
    } else if (position === "right") {
      if (mirror) {
        x = this.left + padding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x -= widest / 2;
        } else {
          textAlign = "left";
          x -= widest;
        }
      } else {
        x = this.left + tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x += widest / 2;
        } else {
          textAlign = "right";
          x = this.right;
        }
      }
    } else {
      textAlign = "right";
    }
    return { textAlign, x };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position = this.options.position;
    if (position === "left" || position === "right") {
      return { top: 0, left: this.left, bottom: chart.height, right: this.right };
    }
    if (position === "top" || position === "bottom") {
      return { top: this.top, left: 0, bottom: this.bottom, right: chart.width };
    }
  }
  drawBackground() {
    const { ctx, options: { backgroundColor }, left: left2, top: top2, width, height } = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left2, top2, width, height);
      ctx.restore();
    }
  }
  getLineWidthForValue(value) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index2 = ticks.findIndex((t) => t.value === value);
    if (index2 >= 0) {
      const opts = grid.setContext(this.getContext(index2));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        const item = items[i];
        if (grid.drawOnChartArea) {
          drawLine(
            { x: item.x1, y: item.y1 },
            { x: item.x2, y: item.y2 },
            item
          );
        }
        if (grid.drawTicks) {
          drawLine(
            { x: item.tx1, y: item.ty1 },
            { x: item.tx2, y: item.ty2 },
            {
              color: item.tickColor,
              width: item.tickWidth,
              borderDash: item.tickBorderDash,
              borderDashOffset: item.tickBorderDashOffset
            }
          );
        }
      }
    }
  }
  drawBorder() {
    const { chart, ctx, options: { grid } } = this;
    const borderOpts = grid.setContext(this.getContext());
    const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x2, y1, y2;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y2 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x2 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.borderWidth;
    ctx.strokeStyle = borderOpts.borderColor;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    let i, ilen;
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      const item = items[i];
      const tickFont = item.font;
      const label = item.label;
      if (item.backdrop) {
        ctx.fillStyle = item.backdrop.color;
        ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
      }
      let y = item.textOffset;
      renderText(ctx, label, 0, y, tickFont, item);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const { ctx, options: { position, title, reverse } } = this;
    if (!title.display) {
      return;
    }
    const font = toFont(title.font);
    const padding = toPadding(title.padding);
    const align = title.align;
    let offset2 = font.lineHeight / 2;
    if (position === "bottom" || position === "center" || isObject(position)) {
      offset2 += padding.bottom;
      if (isArray(title.text)) {
        offset2 += font.lineHeight * (title.text.length - 1);
      }
    } else {
      offset2 += padding.top;
    }
    const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset2, position, align);
    renderText(ctx, title.text, 0, 0, font, {
      color: title.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position, reverse),
      textBaseline: "middle",
      translation: [titleX, titleY]
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
      return [{
        z: tz,
        draw: (chartArea) => {
          this.draw(chartArea);
        }
      }];
    }
    return [{
      z: gz,
      draw: (chartArea) => {
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawTitle();
      }
    }, {
      z: gz + 1,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: tz,
      draw: (chartArea) => {
        this.drawLabels(chartArea);
      }
    }];
  }
  getMatchingVisibleMetas(type) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + "AxisID";
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      const meta = metas[i];
      if (meta[axisID] === this.id && (!type || meta.type === type)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index2) {
    const opts = this.options.ticks.setContext(this.getContext(index2));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
}
class TypedRegistry {
  constructor(type, scope, override) {
    this.type = type;
    this.scope = scope;
    this.override = override;
    this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(type) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id = item.id;
    const scope = this.scope + "." + id;
    if (!id) {
      throw new Error("class does not have id: " + item);
    }
    if (id in items) {
      return scope;
    }
    items[id] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults$1.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id) {
    return this.items[id];
  }
  unregister(item) {
    const items = this.items;
    const id = item.id;
    const scope = this.scope;
    if (id in items) {
      delete items[id];
    }
    if (scope && id in defaults$1[scope]) {
      delete defaults$1[scope][id];
      if (this.override) {
        delete overrides[id];
      }
    }
  }
}
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge(/* @__PURE__ */ Object.create(null), [
    parentScope ? defaults$1.get(parentScope) : {},
    defaults$1.get(scope),
    item.defaults
  ]);
  defaults$1.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults$1.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach((property) => {
    const propertyParts = property.split(".");
    const sourceName = propertyParts.pop();
    const sourceScope = [scope].concat(propertyParts).join(".");
    const parts = routes[property].split(".");
    const targetName = parts.pop();
    const targetScope = parts.join(".");
    defaults$1.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return "id" in proto && "defaults" in proto;
}
class Registry {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, "datasets", true);
    this.elements = new TypedRegistry(Element$1, "elements");
    this.plugins = new TypedRegistry(Object, "plugins");
    this.scales = new TypedRegistry(Scale, "scales");
    this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...args) {
    this._each("register", args);
  }
  remove(...args) {
    this._each("unregister", args);
  }
  addControllers(...args) {
    this._each("register", args, this.controllers);
  }
  addElements(...args) {
    this._each("register", args, this.elements);
  }
  addPlugins(...args) {
    this._each("register", args, this.plugins);
  }
  addScales(...args) {
    this._each("register", args, this.scales);
  }
  getController(id) {
    return this._get(id, this.controllers, "controller");
  }
  getElement(id) {
    return this._get(id, this.elements, "element");
  }
  getPlugin(id) {
    return this._get(id, this.plugins, "plugin");
  }
  getScale(id) {
    return this._get(id, this.scales, "scale");
  }
  removeControllers(...args) {
    this._each("unregister", args, this.controllers);
  }
  removeElements(...args) {
    this._each("unregister", args, this.elements);
  }
  removePlugins(...args) {
    this._each("unregister", args, this.plugins);
  }
  removeScales(...args) {
    this._each("unregister", args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [...args].forEach((arg) => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
        this._exec(method, reg, arg);
      } else {
        each(arg, (item) => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry2, component) {
    const camelMethod = _capitalize(method);
    callback(component["before" + camelMethod], [], component);
    registry2[method](component);
    callback(component["after" + camelMethod], [], component);
  }
  _getRegistryForType(type) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const reg = this._typedRegistries[i];
      if (reg.isForType(type)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id, typedRegistry, type) {
    const item = typedRegistry.get(id);
    if (item === void 0) {
      throw new Error('"' + id + '" is not a registered ' + type + ".");
    }
    return item;
  }
}
var registry = new Registry();
class ScatterController extends DatasetController {
  update(mode) {
    const meta = this._cachedMeta;
    const { data: points = [] } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start: start2, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start2;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start2 = 0;
      count = points.length;
    }
    if (this.options.showLine) {
      const { dataset: line, _dataset } = meta;
      line._chart = this.chart;
      line._datasetIndex = this.index;
      line._decimated = !!_dataset._decimated;
      line.points = points;
      const options = this.resolveDatasetElementOptions(mode);
      options.segment = this.options.segment;
      this.updateElement(line, void 0, {
        animated: !animationsDisabled,
        options
      }, mode);
    }
    this.updateElements(points, start2, count, mode);
  }
  addElements() {
    const { showLine } = this.options;
    if (!this.datasetElementType && showLine) {
      this.datasetElementType = registry.getElement("line");
    }
    super.addElements();
  }
  updateElements(points, start2, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const firstOpts = this.resolveDataElementOptions(start2, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    let prevParsed = start2 > 0 && this.getParsed(start2 - 1);
    for (let i = start2; i < start2 + count; ++i) {
      const point = points[i];
      const parsed = this.getParsed(i);
      const properties = directUpdate ? point : {};
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const data = meta.data || [];
    if (!this.options.showLine) {
      let max2 = 0;
      for (let i = data.length - 1; i >= 0; --i) {
        max2 = Math.max(max2, data[i].size(this.resolveDataElementOptions(i)) / 2);
      }
      return max2 > 0 && max2;
    }
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
}
ScatterController.id = "scatter";
ScatterController.defaults = {
  datasetElementType: false,
  dataElementType: "point",
  showLine: false,
  fill: false
};
ScatterController.overrides = {
  interaction: {
    mode: "point"
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(item) {
          return "(" + item.label + ", " + item.formattedValue + ")";
        }
      }
    }
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
};
var controllers = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PolarAreaController,
  PieController,
  RadarController,
  ScatterController
});
function abstract() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class DateAdapter {
  constructor(options) {
    this.options = options || {};
  }
  init(chartOptions) {
  }
  formats() {
    return abstract();
  }
  parse(value, format) {
    return abstract();
  }
  format(timestamp, format) {
    return abstract();
  }
  add(timestamp, amount, unit) {
    return abstract();
  }
  diff(a, b, unit) {
    return abstract();
  }
  startOf(timestamp, unit, weekday) {
    return abstract();
  }
  endOf(timestamp, unit) {
    return abstract();
  }
}
DateAdapter.override = function(members) {
  Object.assign(DateAdapter.prototype, members);
};
var adapters = {
  _date: DateAdapter
};
function binarySearch(metaset, axis, value, intersect) {
  const { controller, data, _sorted } = metaset;
  const iScale = controller._cachedMeta.iScale;
  if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      return lookupMethod(data, axis, value);
    } else if (controller._sharedOptions) {
      const el = data[0];
      const range = typeof el.getRange === "function" && el.getRange(axis);
      if (range) {
        const start2 = lookupMethod(data, axis, value - range);
        const end2 = lookupMethod(data, axis, value + range);
        return { lo: start2.lo, hi: end2.hi };
      }
    }
  }
  return { lo: 0, hi: data.length - 1 };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value = position[axis];
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    const { index: index2, data } = metasets[i];
    const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
    for (let j = lo; j <= hi; ++j) {
      const element = data[j];
      if (!element.skip) {
        handler(element, index2, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf("x") !== -1;
  const useY = axis.indexOf("y") !== -1;
  return function(pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
  const items = [];
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return items;
  }
  const evaluationFunc = function(element, datasetIndex, index2) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }
    if (element.inRange(position.x, position.y, useFinalPosition)) {
      items.push({ element, datasetIndex, index: index2 });
    }
  };
  evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index2) {
    const { startAngle, endAngle } = element.getProps(["startAngle", "endAngle"], useFinalPosition);
    const { angle } = getAngleFromPoint(element, { x: position.x, y: position.y });
    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({ element, datasetIndex, index: index2 });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index2) {
    const inRange2 = element.inRange(position.x, position.y, useFinalPosition);
    if (intersect && !inRange2) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = !!includeInvisible || chart.isPointInArea(center);
    if (!pointInArea && !inRange2) {
      return;
    }
    const distance = distanceMetric(position, center);
    if (distance < minDistance) {
      items = [{ element, datasetIndex, index: index2 }];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({ element, datasetIndex, index: index2 });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return [];
  }
  return axis === "r" && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
  const items = [];
  const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
  let intersectsItem = false;
  evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index2) => {
    if (element[rangeMethod](position[axis], useFinalPosition)) {
      items.push({ element, datasetIndex, index: index2 });
      intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
    }
  });
  if (intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  evaluateInteractionItems,
  modes: {
    index(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "x";
      const includeInvisible = options.includeInvisible || false;
      const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      const elements2 = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach((meta) => {
        const index2 = items[0].index;
        const element = meta.data[index2];
        if (element && !element.skip) {
          elements2.push({ element, datasetIndex: meta.index, index: index2 });
        }
      });
      return elements2;
    },
    dataset(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i = 0; i < data.length; ++i) {
          items.push({ element: data[i], datasetIndex, index: i });
        }
      }
      return items;
    },
    point(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
    },
    nearest(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
    },
    x(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
    },
    y(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
    }
  }
};
const STATIC_POSITIONS = ["left", "top", "right", "bottom"];
function filterByPosition(array, position) {
  return array.filter((v) => v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter((v) => STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a, b) => {
    const v0 = reverse ? b : a;
    const v1 = reverse ? a : b;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i, ilen, box, pos, stack, stackWeight;
  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box = boxes[i];
    ({ position: pos, options: { stack, stackWeight = 1 } } = box);
    layoutBoxes.push({
      index: i,
      box,
      pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack && pos + stack,
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts2) {
  const stacks = {};
  for (const wrap of layouts2) {
    const { stack, pos, stackWeight } = wrap;
    if (!stack || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack] || (stacks[stack] = { count: 0, placed: 0, weight: 0, size: 0 });
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts2, params) {
  const stacks = buildStacks(layouts2);
  const { vBoxMaxWidth, hBoxMaxHeight } = params;
  let i, ilen, layout2;
  for (i = 0, ilen = layouts2.length; i < ilen; ++i) {
    layout2 = layouts2[i];
    const { fullSize } = layout2.box;
    const stack = stacks[layout2.stack];
    const factor = stack && layout2.stackWeight / stack.weight;
    if (layout2.horizontal) {
      layout2.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout2.height = hBoxMaxHeight;
    } else {
      layout2.width = vBoxMaxWidth;
      layout2.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter((wrap) => wrap.box.fullSize), true);
  const left2 = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
  const right2 = sortByWeight(filterByPosition(layoutBoxes, "right"));
  const top2 = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
  const bottom2 = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, "x");
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, "y");
  return {
    fullSize,
    leftAndTop: left2.concat(top2),
    rightAndBottom: right2.concat(centerVertical).concat(bottom2).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, "chartArea"),
    vertical: left2.concat(right2).concat(centerVertical),
    horizontal: top2.concat(bottom2).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
  return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout2, stacks) {
  const { pos, box } = layout2;
  const maxPadding = chartArea.maxPadding;
  if (!isObject(pos)) {
    if (layout2.size) {
      chartArea[pos] -= layout2.size;
    }
    const stack = stacks[layout2.stack] || { size: 0, count: 1 };
    stack.size = Math.max(stack.size, layout2.horizontal ? box.height : box.width);
    layout2.size = stack.size / stack.count;
    chartArea[pos] += layout2.size;
  }
  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right"));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom"));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout2.horizontal ? { same: widthChanged, other: heightChanged } : { same: heightChanged, other: widthChanged };
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos("top");
  chartArea.x += updatePos("left");
  updatePos("right");
  updatePos("bottom");
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions2) {
    const margin = { left: 0, top: 0, right: 0, bottom: 0 };
    positions2.forEach((pos) => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal ? marginForPositions(["left", "right"]) : marginForPositions(["top", "bottom"]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i, ilen, layout2, box, refit, changed;
  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout2 = boxes[i];
    box = layout2.box;
    box.update(
      layout2.width || chartArea.w,
      layout2.height || chartArea.h,
      getMargins(layout2.horizontal, chartArea)
    );
    const { same, other } = updateDims(chartArea, params, layout2, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box.fullSize) {
      refitBoxes.push(layout2);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left2, top2, width, height) {
  box.top = top2;
  box.left = left2;
  box.right = left2 + width;
  box.bottom = top2 + height;
  box.width = width;
  box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let { x, y } = chartArea;
  for (const layout2 of boxes) {
    const box = layout2.box;
    const stack = stacks[layout2.stack] || { count: 1, placed: 0, weight: 1 };
    const weight = layout2.stackWeight / stack.weight || 1;
    if (layout2.horizontal) {
      const width = chartArea.w * weight;
      const height = stack.size || box.height;
      if (defined(stack.start)) {
        y = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
      } else {
        setBoxDims(box, chartArea.left + stack.placed, y, width, height);
      }
      stack.start = y;
      stack.placed += width;
      y = box.bottom;
    } else {
      const height = chartArea.h * weight;
      const width = stack.size || box.width;
      if (defined(stack.start)) {
        x = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box, x, chartArea.top + stack.placed, width, height);
      }
      stack.start = x;
      stack.placed += height;
      x = box.right;
    }
  }
  chartArea.x = x;
  chartArea.y = y;
}
defaults$1.set("layout", {
  autoPadding: true,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || "top";
    item.weight = item.weight || 0;
    item._layers = item._layers || function() {
      return [{
        z: 0,
        draw(chartArea) {
          item.draw(chartArea);
        }
      }];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index2 = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index2 !== -1) {
      chart.boxes.splice(index2, 1);
    }
  },
  configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update(chart, width, height, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each(chart.boxes, (box) => {
      if (typeof box.beforeLayout === "function") {
        box.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) => wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each(boxes.chartArea, (layout2) => {
      const box = layout2.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, { left: 0, top: 0, right: 0, bottom: 0 });
    });
  }
};
class BasePlatform {
  acquireContext(canvas, aspectRatio) {
  }
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type, listener) {
  }
  removeEventListener(chart, type, listener) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height, aspectRatio) {
    width = Math.max(0, width || element.width);
    height = height || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config) {
  }
}
class BasicPlatform extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext("2d") || null;
  }
  updateConfig(config) {
    config.options.animation = false;
  }
}
const EXPANDO_KEY$1 = "$chartjs";
const EVENT_TYPES = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
};
const isNullOrEmpty = (value) => value === null || value === "";
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute("height");
  const renderWidth = canvas.getAttribute("width");
  canvas[EXPANDO_KEY$1] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || "block";
  style.boxSizing = style.boxSizing || "border-box";
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, "width");
    if (displayWidth !== void 0) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === "") {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, "height");
      if (displayHeight !== void 0) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? { passive: true } : false;
function addListener(node, type, listener) {
  node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
  chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
  const type = EVENT_TYPES[event.type] || event.type;
  const { x, y } = getRelativePosition(event, chart);
  return {
    type,
    chart,
    native: event,
    x: x !== void 0 ? x : null,
    y: y !== void 0 ? y : null
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node of nodeList) {
    if (node === canvas || node.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.addedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, { childList: true, subtree: true });
  return observer;
}
function createDetachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.removedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, { childList: true, subtree: true });
  return observer;
}
const drpListeningCharts = /* @__PURE__ */ new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener("resize", onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener("resize", onWindowResize);
  }
}
function createResizeObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height) => {
    const w = container.clientWidth;
    listener(width, height);
    if (w < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver((entries) => {
    const entry = entries[0];
    const width = entry.contentRect.width;
    const height = entry.contentRect.height;
    if (width === 0 && height === 0) {
      return;
    }
    resize(width, height);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type === "resize") {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type, listener) {
  const canvas = chart.canvas;
  const proxy = throttled((event) => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart, (args) => {
    const event = args[0];
    return [event, event.offsetX, event.offsetY];
  });
  addListener(canvas, type, proxy);
  return proxy;
}
class DomPlatform extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext("2d");
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY$1]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY$1].initial;
    ["height", "width"].forEach((prop) => {
      const value = initial[prop];
      if (isNullOrUndef(value)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach((key) => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY$1];
    return true;
  }
  addEventListener(chart, type, listener) {
    this.removeEventListener(chart, type);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers2 = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers2[type] || createProxyAndListen;
    proxies[type] = handler(chart, type, listener);
  }
  removeEventListener(chart, type) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type];
    if (!proxy) {
      return;
    }
    const handlers2 = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers2[type] || removeListener;
    handler(chart, type, proxy);
    proxies[type] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height, aspectRatio) {
    return getMaximumSize(canvas, width, height, aspectRatio);
  }
  isAttached(canvas) {
    const container = _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
}
function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }
  return DomPlatform;
}
class PluginService {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === "beforeInit") {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, "install");
    }
    const descriptors2 = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors2, chart, hook, args);
    if (hook === "afterDestroy") {
      this._notify(descriptors2, chart, "stop");
      this._notify(this._init, chart, "uninstall");
    }
    return result;
  }
  _notify(descriptors2, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors2) {
      const plugin2 = descriptor.plugin;
      const method = plugin2[hook];
      const params = [chart, args, descriptor.options];
      if (callback(method, params, plugin2) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = void 0;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors2 = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors2;
  }
  _createDescriptors(chart, all) {
    const config = chart && chart.config;
    const options = valueOrDefault(config.options && config.options.plugins, {});
    const plugins2 = allPlugins(config);
    return options === false && !all ? [] : createDescriptors(chart, plugins2, options, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors2 = this._cache;
    const diff = (a, b) => a.filter((x) => !b.some((y) => x.plugin.id === y.plugin.id));
    this._notify(diff(previousDescriptors, descriptors2), chart, "stop");
    this._notify(diff(descriptors2, previousDescriptors), chart, "start");
  }
}
function allPlugins(config) {
  const localIds = {};
  const plugins2 = [];
  const keys = Object.keys(registry.plugins.items);
  for (let i = 0; i < keys.length; i++) {
    plugins2.push(registry.getPlugin(keys[i]));
  }
  const local = config.plugins || [];
  for (let i = 0; i < local.length; i++) {
    const plugin2 = local[i];
    if (plugins2.indexOf(plugin2) === -1) {
      plugins2.push(plugin2);
      localIds[plugin2.id] = true;
    }
  }
  return { plugins: plugins2, localIds };
}
function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }
  if (options === true) {
    return {};
  }
  return options;
}
function createDescriptors(chart, { plugins: plugins2, localIds }, options, all) {
  const result = [];
  const context = chart.getContext();
  for (const plugin2 of plugins2) {
    const id = plugin2.id;
    const opts = getOpts(options[id], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin: plugin2,
      options: pluginOpts(chart.config, { plugin: plugin2, local: localIds[id] }, opts, context)
    });
  }
  return result;
}
function pluginOpts(config, { plugin: plugin2, local }, opts, context) {
  const keys = config.pluginScopeKeys(plugin2);
  const scopes = config.getOptionScopes(opts, keys);
  if (local && plugin2.defaults) {
    scopes.push(plugin2.defaults);
  }
  return config.createResolver(scopes, context, [""], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}
function getIndexAxis(type, options) {
  const datasetDefaults = defaults$1.datasets[type] || {};
  const datasetOptions = (options.datasets || {})[type] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function getAxisFromDefaultScaleID(id, indexAxis) {
  let axis = id;
  if (id === "_index_") {
    axis = indexAxis;
  } else if (id === "_value_") {
    axis = indexAxis === "x" ? "y" : "x";
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? "_index_" : "_value_";
}
function axisFromPosition(position) {
  if (position === "top" || position === "bottom") {
    return "x";
  }
  if (position === "left" || position === "right") {
    return "y";
  }
}
function determineAxis(id, scaleOptions) {
  if (id === "x" || id === "y") {
    return id;
  }
  return scaleOptions.axis || axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function mergeScaleConfig(config, options) {
  const chartDefaults = overrides[config.type] || { scales: {} };
  const configScales = options.scales || {};
  const chartIndexAxis = getIndexAxis(config.type, options);
  const firstIDs = /* @__PURE__ */ Object.create(null);
  const scales2 = /* @__PURE__ */ Object.create(null);
  Object.keys(configScales).forEach((id) => {
    const scaleConf = configScales[id];
    if (!isObject(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
    }
    const axis = determineAxis(id, scaleConf);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    firstIDs[axis] = firstIDs[axis] || id;
    scales2[id] = mergeIf(/* @__PURE__ */ Object.create(null), [{ axis }, scaleConf, defaultScaleOptions[axis], defaultScaleOptions[defaultId]]);
  });
  config.data.datasets.forEach((dataset) => {
    const type = dataset.type || config.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
    const datasetDefaults = overrides[type] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach((defaultID) => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
      scales2[id] = scales2[id] || /* @__PURE__ */ Object.create(null);
      mergeIf(scales2[id], [{ axis }, configScales[id], defaultScaleOptions[defaultID]]);
    });
  });
  Object.keys(scales2).forEach((key) => {
    const scale = scales2[key];
    mergeIf(scale, [defaults$1.scales[scale.type], defaults$1.scale]);
  });
  return scales2;
}
function initOptions(config) {
  const options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}
function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}
const keyCache = /* @__PURE__ */ new Map();
const keysCached = /* @__PURE__ */ new Set();
function cachedKeys(cacheKey, generate) {
  let keys = keyCache.get(cacheKey);
  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }
  return keys;
}
const addIfFound = (set2, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== void 0) {
    set2.add(opts);
  }
};
class Config {
  constructor(config) {
    this._config = initConfig(config);
    this._scopeCache = /* @__PURE__ */ new Map();
    this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type) {
    this._config.type = type;
  }
  get data() {
    return this._config.data;
  }
  set data(data) {
    this._config.data = initData(data);
  }
  get options() {
    return this._config.options;
  }
  set options(options) {
    this._config.options = options;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config = this._config;
    this.clearCache();
    initOptions(config);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(
      datasetType,
      () => [[
        `datasets.${datasetType}`,
        ""
      ]]
    );
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(
      `${datasetType}.transition.${transition}`,
      () => [
        [
          `datasets.${datasetType}.transitions.${transition}`,
          `transitions.${transition}`
        ],
        [
          `datasets.${datasetType}`,
          ""
        ]
      ]
    );
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(
      `${datasetType}-${elementType}`,
      () => [[
        `datasets.${datasetType}.elements.${elementType}`,
        `datasets.${datasetType}`,
        `elements.${elementType}`,
        ""
      ]]
    );
  }
  pluginScopeKeys(plugin2) {
    const id = plugin2.id;
    const type = this.type;
    return cachedKeys(
      `${type}-plugin-${id}`,
      () => [[
        `plugins.${id}`,
        ...plugin2.additionalOptionScopes || []
      ]]
    );
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = /* @__PURE__ */ new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const { options, type } = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = /* @__PURE__ */ new Set();
    keyLists.forEach((keys) => {
      if (mainScope) {
        scopes.add(mainScope);
        keys.forEach((key) => addIfFound(scopes, mainScope, key));
      }
      keys.forEach((key) => addIfFound(scopes, options, key));
      keys.forEach((key) => addIfFound(scopes, overrides[type] || {}, key));
      keys.forEach((key) => addIfFound(scopes, defaults$1, key));
      keys.forEach((key) => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(/* @__PURE__ */ Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const { options, type } = this;
    return [
      options,
      overrides[type] || {},
      defaults$1.datasets[type] || {},
      { type },
      defaults$1,
      descriptors
    ];
  }
  resolveNamedOptions(scopes, names2, context, prefixes = [""]) {
    const result = { $shared: true };
    const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
    let options = resolver;
    if (needContext(resolver, names2)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names2) {
      result[prop] = options[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes = [""], descriptorDefaults) {
    const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
    return isObject(context) ? _attachContext(resolver, context, void 0, descriptorDefaults) : resolver;
  }
}
function getResolver(resolverCache, scopes, prefixes) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = /* @__PURE__ */ new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes);
    cached = {
      resolver,
      subPrefixes: prefixes.filter((p) => !p.toLowerCase().includes("hover"))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
const hasFunction = (value) => isObject(value) && Object.getOwnPropertyNames(value).reduce((acc, key) => acc || isFunction(value[key]), false);
function needContext(proxy, names2) {
  const { isScriptable, isIndexable } = _descriptors(proxy);
  for (const prop of names2) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value = (indexable || scriptable) && proxy[prop];
    if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
      return true;
    }
  }
  return false;
}
var version = "3.9.1";
const KNOWN_POSITIONS = ["top", "bottom", "left", "right", "chartArea"];
function positionIsHorizontal(position, axis) {
  return position === "top" || position === "bottom" || KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function compare2Level(l1, l2) {
  return function(a, b) {
    return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions2 = chart.options.animation;
  chart.notifyPlugins("afterRender");
  callback(animationOptions2 && animationOptions2.onComplete, [context], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions2 = chart.options.animation;
  callback(animationOptions2 && animationOptions2.onProgress, [context], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === "string") {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
const instances = {};
const getChart = (key) => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter((c) => c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start2, move) {
  const keys = Object.keys(obj);
  for (const key of keys) {
    const intKey = +key;
    if (intKey >= start2) {
      const value = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start2) {
        obj[intKey + move] = value;
      }
    }
  }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e.type === "mouseout") {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e;
}
class Chart {
  constructor(item, userConfig) {
    const config = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error(
        "Canvas is already in use. Chart with ID '" + existingChart.id + "' must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused."
      );
    }
    const options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    const canvas = context && context.canvas;
    const height = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = void 0;
    this.boxes = [];
    this.currentDevicePixelRatio = void 0;
    this.chartArea = void 0;
    this._active = [];
    this._lastEvent = void 0;
    this._listeners = {};
    this._responsiveListeners = void 0;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = void 0;
    this.$context = void 0;
    this._doResize = debounce$1((mode) => this.update(mode), options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, "complete", onAnimationsComplete);
    animator.listen(this, "progress", onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height ? width / height : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data) {
    this.config.data = data;
  }
  get options() {
    return this._options;
  }
  set options(options) {
    this.config.options = options;
  }
  _initialize() {
    this.notifyPlugins("beforeInit");
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins("afterInit");
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height) {
    if (!animator.running(this)) {
      this._resize(width, height);
    } else {
      this._resizeBeforeDraw = { width, height };
    }
  }
  _resize(width, height) {
    const options = this.options;
    const canvas = this.canvas;
    const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
    const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? "resize" : "attach";
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins("resize", { size: newSize });
    callback(options.onResize, [this, newSize], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options = this.options;
    const scalesOptions = options.scales || {};
    each(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options = this.options;
    const scaleOpts = options.scales;
    const scales2 = this.scales;
    const updated = Object.keys(scales2).reduce((obj, id) => {
      obj[id] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(
        Object.keys(scaleOpts).map((id) => {
          const scaleOptions = scaleOpts[id];
          const axis = determineAxis(id, scaleOptions);
          const isRadial = axis === "r";
          const isHorizontal = axis === "x";
          return {
            options: scaleOptions,
            dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
            dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
          };
        })
      );
    }
    each(items, (item) => {
      const scaleOptions = item.options;
      const id = scaleOptions.id;
      const axis = determineAxis(id, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === void 0 || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id] = true;
      let scale = null;
      if (id in scales2 && scales2[id].type === scaleType) {
        scale = scales2[id];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale = new scaleClass({
          id,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales2[scale.id] = scale;
      }
      scale.init(scaleOptions, options);
    });
    each(updated, (hasUpdated, id) => {
      if (!hasUpdated) {
        delete scales2[id];
      }
    });
    each(scales2, (scale) => {
      layouts.configure(this, scale, scale.options);
      layouts.addBox(this, scale);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a, b) => a.index - b.index);
    if (numMeta > numData) {
      for (let i = numData; i < numMeta; ++i) {
        this._destroyDatasetMeta(i);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: metasets, data: { datasets } } = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index2) => {
      if (datasets.filter((x) => x === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index2);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i, ilen;
    this._removeUnreferencedMetasets();
    for (i = 0, ilen = datasets.length; i < ilen; i++) {
      const dataset = datasets[i];
      let meta = this.getDatasetMeta(i);
      const type = dataset.type || this.config.type;
      if (meta.type && meta.type !== type) {
        this._destroyDatasetMeta(i);
        meta = this.getDatasetMeta(i);
      }
      meta.type = type;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
      meta.order = dataset.order || 0;
      meta.index = i;
      meta.label = "" + dataset.label;
      meta.visible = this.isDatasetVisible(i);
      if (meta.controller) {
        meta.controller.updateIndex(i);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type);
        const { datasetElementType, dataElementType } = defaults$1.datasets[type];
        Object.assign(ControllerClass.prototype, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins("reset");
  }
  update(mode) {
    const config = this.config;
    config.update();
    const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins("beforeUpdate", { mode, cancelable: true }) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let minPadding = 0;
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
      const { controller } = this.getDatasetMeta(i);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each(newControllers, (controller) => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins("afterUpdate", { mode });
    this._layers.sort(compare2Level("z", "_idx"));
    const { _active, _lastEvent } = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each(this.scales, (scale) => {
      layouts.removeBox(this, scale);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const { _hiddenIndices } = this;
    const changes = this._getUniformDataChanges() || [];
    for (const { method, start: start2, count } of changes) {
      const move = method === "_removeElements" ? -count : count;
      moveNumericKeys(_hiddenIndices, start2, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = (idx) => new Set(
      _dataChanges.filter((c) => c[0] === idx).map((c, i) => i + "," + c.splice(1).join(","))
    );
    const changeSet = makeSet(0);
    for (let i = 1; i < datasetCount; i++) {
      if (!setsEqual(changeSet, makeSet(i))) {
        return;
      }
    }
    return Array.from(changeSet).map((c) => c.split(",")).map((a) => ({ method: a[1], start: +a[2], count: +a[3] }));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins("beforeLayout", { cancelable: true }) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each(this.boxes, (box) => {
      if (noArea && box.position === "chartArea") {
        return;
      }
      if (box.configure) {
        box.configure();
      }
      this._layers.push(...box._layers());
    }, this);
    this._layers.forEach((item, index2) => {
      item._idx = index2;
    });
    this.notifyPlugins("afterLayout");
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins("beforeDatasetsUpdate", { mode, cancelable: true }) === false) {
      return;
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this.getDatasetMeta(i).controller.configure();
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._updateDataset(i, isFunction(mode) ? mode({ datasetIndex: i }) : mode);
    }
    this.notifyPlugins("afterDatasetsUpdate", { mode });
  }
  _updateDataset(index2, mode) {
    const meta = this.getDatasetMeta(index2);
    const args = { meta, index: index2, mode, cancelable: true };
    if (this.notifyPlugins("beforeDatasetUpdate", args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins("afterDatasetUpdate", args);
  }
  render() {
    if (this.notifyPlugins("beforeRender", { cancelable: true }) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({ chart: this });
    }
  }
  draw() {
    let i;
    if (this._resizeBeforeDraw) {
      const { width, height } = this._resizeBeforeDraw;
      this._resize(width, height);
      this._resizeBeforeDraw = null;
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins("beforeDraw", { cancelable: true }) === false) {
      return;
    }
    const layers = this._layers;
    for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
      layers[i].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i < layers.length; ++i) {
      layers[i].draw(this.chartArea);
    }
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      const meta = metasets[i];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", { cancelable: true }) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      this._drawDataset(metasets[i]);
    }
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip = meta._clip;
    const useClip = !clip.disabled;
    const area = this.chartArea;
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetDraw", args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip.left === false ? 0 : area.left - clip.left,
        right: clip.right === false ? this.width : area.right + clip.right,
        top: clip.top === false ? 0 : area.top - clip.top,
        bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins("afterDatasetDraw", args);
  }
  isPointInArea(point) {
    return _isPointInArea(point, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, mode, options, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === "function") {
      return method(this, e, options, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter((x) => x && x._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext(null, { chart: this, type: "chart" }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index2) {
    this._hiddenIndices[index2] = !this._hiddenIndices[index2];
  }
  getDataVisibility(index2) {
    return !this._hiddenIndices[index2];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? "show" : "hide";
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(void 0, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, { visible });
      this.update((ctx) => ctx.datasetIndex === datasetIndex ? mode : void 0);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i, ilen;
    this.stop();
    animator.remove(this);
    for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._destroyDatasetMeta(i);
    }
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas, ctx } = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    this.notifyPlugins("destroy");
    delete instances[this.id];
    this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform = this.platform;
    const _add = (type, listener2) => {
      platform.addEventListener(this, type, listener2);
      listeners[type] = listener2;
    };
    const listener = (e, x, y) => {
      e.offsetX = x;
      e.offsetY = y;
      this._eventHandler(e);
    };
    each(this.options.events, (type) => _add(type, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform = this.platform;
    const _add = (type, listener2) => {
      platform.addEventListener(this, type, listener2);
      listeners[type] = listener2;
    };
    const _remove = (type, listener2) => {
      if (listeners[type]) {
        platform.removeEventListener(this, type, listener2);
        delete listeners[type];
      }
    };
    const listener = (width, height) => {
      if (this.canvas) {
        this.resize(width, height);
      }
    };
    let detached;
    const attached = () => {
      _remove("attach", attached);
      this.attached = true;
      this.resize();
      _add("resize", listener);
      _add("detach", detached);
    };
    detached = () => {
      this.attached = false;
      _remove("resize", listener);
      this._stop();
      this._resize(0, 0);
      _add("attach", attached);
    };
    if (platform.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each(this._listeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._listeners = {};
    each(this._responsiveListeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._responsiveListeners = void 0;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix = enabled ? "set" : "remove";
    let meta, item, i, ilen;
    if (mode === "dataset") {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller["_" + prefix + "DatasetHoverStyle"]();
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("No dataset found at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(active, lastActive);
    if (changed) {
      this._active = active;
      this._lastEvent = null;
      this._updateHoverStyles(active, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  _updateHoverStyles(active, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff = (a, b) => a.filter((x) => !b.some((y) => x.datasetIndex === y.datasetIndex && x.index === y.index));
    const deactivated = diff(lastActive, active);
    const activated = replay ? active : diff(active, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e, replay) {
    const args = {
      event: e,
      replay,
      cancelable: true,
      inChartArea: this.isPointInArea(e)
    };
    const eventFilter = (plugin2) => (plugin2.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins("afterEvent", args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e, replay, inChartArea) {
    const { _active: lastActive = [], options } = this;
    const useFinalPosition = replay;
    const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e);
    const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options.onHover, [e, active, this], this);
      if (isClick) {
        callback(options.onClick, [e, active, this], this);
      }
    }
    const changed = !_elementsEqual(active, lastActive);
    if (changed || replay) {
      this._active = active;
      this._updateHoverStyles(active, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
    if (e.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
}
const invalidatePlugins = () => each(Chart.instances, (chart) => chart._plugins.invalidate());
const enumerable = true;
Object.defineProperties(Chart, {
  defaults: {
    enumerable,
    value: defaults$1
  },
  instances: {
    enumerable,
    value: instances
  },
  overrides: {
    enumerable,
    value: overrides
  },
  registry: {
    enumerable,
    value: registry
  },
  version: {
    enumerable,
    value: version
  },
  getChart: {
    enumerable,
    value: getChart
  },
  register: {
    enumerable,
    value: (...items) => {
      registry.add(...items);
      invalidatePlugins();
    }
  },
  unregister: {
    enumerable,
    value: (...items) => {
      registry.remove(...items);
      invalidatePlugins();
    }
  }
});
function clipArc(ctx, element, endAngle) {
  const { startAngle, pixelMargin, x, y, outerRadius, innerRadius } = element;
  let angleMargin = pixelMargin / outerRadius;
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
  if (innerRadius > pixelMargin) {
    angleMargin = pixelMargin / innerRadius;
    ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
  } else {
    ctx.arc(x, y, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
  }
  ctx.closePath();
  ctx.clip();
}
function toRadiusCorners(value) {
  return _readValueToProps(value, ["outerStart", "outerEnd", "innerStart", "innerEnd"]);
}
function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
  const o = toRadiusCorners(arc.options.borderRadius);
  const halfThickness = (outerRadius - innerRadius) / 2;
  const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
  const computeOuterLimit = (val) => {
    const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
    return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
  };
  return {
    outerStart: computeOuterLimit(o.outerStart),
    outerEnd: computeOuterLimit(o.outerEnd),
    innerStart: _limitValue(o.innerStart, 0, innerLimit),
    innerEnd: _limitValue(o.innerEnd, 0, innerLimit)
  };
}
function rThetaToXY(r, theta, x, y) {
  return {
    x: x + r * Math.cos(theta),
    y: y + r * Math.sin(theta)
  };
}
function pathArc(ctx, element, offset2, spacing, end2, circular) {
  const { x, y, startAngle: start2, pixelMargin, innerRadius: innerR } = element;
  const outerRadius = Math.max(element.outerRadius + spacing + offset2 - pixelMargin, 0);
  const innerRadius = innerR > 0 ? innerR + spacing + offset2 + pixelMargin : 0;
  let spacingOffset = 0;
  const alpha2 = end2 - start2;
  if (spacing) {
    const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
    const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
    const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
    const adjustedAngle = avNogSpacingRadius !== 0 ? alpha2 * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha2;
    spacingOffset = (alpha2 - adjustedAngle) / 2;
  }
  const beta = Math.max(1e-3, alpha2 * outerRadius - offset2 / PI) / outerRadius;
  const angleOffset = (alpha2 - beta) / 2;
  const startAngle = start2 + angleOffset + spacingOffset;
  const endAngle = end2 - angleOffset - spacingOffset;
  const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
  const outerStartAdjustedRadius = outerRadius - outerStart;
  const outerEndAdjustedRadius = outerRadius - outerEnd;
  const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
  const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
  const innerStartAdjustedRadius = innerRadius + innerStart;
  const innerEndAdjustedRadius = innerRadius + innerEnd;
  const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
  const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
  ctx.beginPath();
  if (circular) {
    ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
    if (outerEnd > 0) {
      const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
    }
    const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
    ctx.lineTo(p4.x, p4.y);
    if (innerEnd > 0) {
      const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
    }
    ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
    if (innerStart > 0) {
      const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
    }
    const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
    ctx.lineTo(p8.x, p8.y);
    if (outerStart > 0) {
      const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
    }
  } else {
    ctx.moveTo(x, y);
    const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
    const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
    ctx.lineTo(outerStartX, outerStartY);
    const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
    const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
    ctx.lineTo(outerEndX, outerEndY);
  }
  ctx.closePath();
}
function drawArc(ctx, element, offset2, spacing, circular) {
  const { fullCircles, startAngle, circumference } = element;
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset2, spacing, startAngle + TAU, circular);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.fill();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + circumference % TAU;
      if (circumference % TAU === 0) {
        endAngle += TAU;
      }
    }
  }
  pathArc(ctx, element, offset2, spacing, endAngle, circular);
  ctx.fill();
  return endAngle;
}
function drawFullCircleBorders(ctx, element, inner) {
  const { x, y, startAngle, pixelMargin, fullCircles } = element;
  const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
  const innerRadius = element.innerRadius + pixelMargin;
  let i;
  if (inner) {
    clipArc(ctx, element, startAngle + TAU);
  }
  ctx.beginPath();
  ctx.arc(x, y, innerRadius, startAngle + TAU, startAngle, true);
  for (i = 0; i < fullCircles; ++i) {
    ctx.stroke();
  }
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle, startAngle + TAU);
  for (i = 0; i < fullCircles; ++i) {
    ctx.stroke();
  }
}
function drawBorder(ctx, element, offset2, spacing, endAngle, circular) {
  const { options } = element;
  const { borderWidth, borderJoinStyle } = options;
  const inner = options.borderAlign === "inner";
  if (!borderWidth) {
    return;
  }
  if (inner) {
    ctx.lineWidth = borderWidth * 2;
    ctx.lineJoin = borderJoinStyle || "round";
  } else {
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = borderJoinStyle || "bevel";
  }
  if (element.fullCircles) {
    drawFullCircleBorders(ctx, element, inner);
  }
  if (inner) {
    clipArc(ctx, element, endAngle);
  }
  pathArc(ctx, element, offset2, spacing, endAngle, circular);
  ctx.stroke();
}
class ArcElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = void 0;
    this.circumference = void 0;
    this.startAngle = void 0;
    this.endAngle = void 0;
    this.innerRadius = void 0;
    this.outerRadius = void 0;
    this.pixelMargin = 0;
    this.fullCircles = 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(chartX, chartY, useFinalPosition) {
    const point = this.getProps(["x", "y"], useFinalPosition);
    const { angle, distance } = getAngleFromPoint(point, { x: chartX, y: chartY });
    const { startAngle, endAngle, innerRadius, outerRadius, circumference } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], useFinalPosition);
    const rAdjust = this.options.spacing / 2;
    const _circumference = valueOrDefault(circumference, endAngle - startAngle);
    const betweenAngles = _circumference >= TAU || _angleBetween(angle, startAngle, endAngle);
    const withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
    return betweenAngles && withinRadius;
  }
  getCenterPoint(useFinalPosition) {
    const { x, y, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], useFinalPosition);
    const { offset: offset2, spacing } = this.options;
    const halfAngle = (startAngle + endAngle) / 2;
    const halfRadius = (innerRadius + outerRadius + spacing + offset2) / 2;
    return {
      x: x + Math.cos(halfAngle) * halfRadius,
      y: y + Math.sin(halfAngle) * halfRadius
    };
  }
  tooltipPosition(useFinalPosition) {
    return this.getCenterPoint(useFinalPosition);
  }
  draw(ctx) {
    const { options, circumference } = this;
    const offset2 = (options.offset || 0) / 2;
    const spacing = (options.spacing || 0) / 2;
    const circular = options.circular;
    this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
    this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;
    if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
      return;
    }
    ctx.save();
    let radiusOffset = 0;
    if (offset2) {
      radiusOffset = offset2 / 2;
      const halfAngle = (this.startAngle + this.endAngle) / 2;
      ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
      if (this.circumference >= PI) {
        radiusOffset = offset2;
      }
    }
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    const endAngle = drawArc(ctx, this, radiusOffset, spacing, circular);
    drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
    ctx.restore();
  }
}
ArcElement.id = "arc";
ArcElement.defaults = {
  borderAlign: "center",
  borderColor: "#fff",
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: true
};
ArcElement.defaultRoutes = {
  backgroundColor: "backgroundColor"
};
function setStyle(ctx, options, style = options) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
  const { start: segmentStart, end: segmentEnd } = segment;
  const start2 = Math.max(paramsStart, segmentStart);
  const end2 = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start: start2,
    loop: segment.loop,
    ilen: end2 < start2 && !outside ? count + end2 - start2 : end2 - start2
  };
}
function pathSegment(ctx, line, segment, params) {
  const { points, options } = line;
  const { count, start: start2, loop, ilen } = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options);
  let { move = true, reverse } = params || {};
  let i, point, prev;
  for (i = 0; i <= ilen; ++i) {
    point = points[(start2 + (reverse ? ilen - i : i)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    prev = point;
  }
  if (loop) {
    point = points[(start2 + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
  const points = line.points;
  const { count, start: start2, ilen } = pathVars(points, segment, params);
  const { move = true, reverse } = params || {};
  let avgX = 0;
  let countX = 0;
  let i, point, prevX, minY, maxY, lastY;
  const pointIndex = (index2) => (start2 + (reverse ? ilen - index2 : index2)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];
    if (point.skip) {
      continue;
    }
    const x = point.x;
    const y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      avgX = (countX * avgX + x) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x, y);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
    }
    lastY = y;
  }
  drawX();
}
function _getSegmentMethod(line) {
  const opts = line.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line, start2, count) {
  let path = line._path;
  if (!path) {
    path = line._path = new Path2D();
    if (line.path(path, start2, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line, start2, count) {
  const { segments, options } = line;
  const segmentMethod = _getSegmentMethod(line);
  for (const segment of segments) {
    setStyle(ctx, options, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line, segment, { start: start2, end: start2 + count - 1 })) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
const usePath2D = typeof Path2D === "function";
function draw(ctx, line, start2, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start2, count);
  } else {
    strokePathDirect(ctx, line, start2, count);
  }
}
class LineElement extends Element$1 {
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = void 0;
    this._chart = void 0;
    this._loop = void 0;
    this._fullLoop = void 0;
    this._path = void 0;
    this._points = void 0;
    this._segments = void 0;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options = this.options;
    if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
      const loop = options.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options = this.options;
    const value = point[property];
    const points = this.points;
    const segments = _boundSegments(this, { property, start: value, end: value });
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options);
    let i, ilen;
    for (i = 0, ilen = segments.length; i < ilen; ++i) {
      const { start: start2, end: end2 } = segments[i];
      const p1 = points[start2];
      const p2 = points[end2];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t, options.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start2, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start2 = start2 || 0;
    count = count || this.points.length - start2;
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, { start: start2, end: start2 + count - 1 });
    }
    return !!loop;
  }
  draw(ctx, chartArea, start2, count) {
    const options = this.options || {};
    const points = this.points || [];
    if (points.length && options.borderWidth) {
      ctx.save();
      draw(ctx, this, start2, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = void 0;
    }
  }
}
LineElement.id = "line";
LineElement.defaults = {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: true,
  cubicInterpolationMode: "default",
  fill: false,
  spanGaps: false,
  stepped: false,
  tension: 0
};
LineElement.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
LineElement.descriptors = {
  _scriptable: true,
  _indexable: (name) => name !== "borderDash" && name !== "fill"
};
function inRange$1(el, pos, axis, useFinalPosition) {
  const options = el.options;
  const { [axis]: value } = el.getProps([axis], useFinalPosition);
  return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = void 0;
    this.parsed = void 0;
    this.skip = void 0;
    this.stop = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options = this.options;
    const { x, y } = this.getProps(["x", "y"], useFinalPosition);
    return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, "x", useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, "y", useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x, y } = this.getProps(["x", "y"], useFinalPosition);
    return { x, y };
  }
  size(options) {
    options = options || this.options || {};
    let radius = options.radius || 0;
    radius = Math.max(radius, radius && options.hoverRadius || 0);
    const borderWidth = radius && options.borderWidth || 0;
    return (radius + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options = this.options;
    if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
      return;
    }
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.fillStyle = options.backgroundColor;
    drawPoint(ctx, options, this.x, this.y);
  }
  getRange() {
    const options = this.options || {};
    return options.radius + options.hitRadius;
  }
}
PointElement.id = "point";
PointElement.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
};
PointElement.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
function getBarBounds(bar, useFinalPosition) {
  const { x, y, base, width, height } = bar.getProps(["x", "y", "base", "width", "height"], useFinalPosition);
  let left2, right2, top2, bottom2, half;
  if (bar.horizontal) {
    half = height / 2;
    left2 = Math.min(x, base);
    right2 = Math.max(x, base);
    top2 = y - half;
    bottom2 = y + half;
  } else {
    half = width / 2;
    left2 = x - half;
    right2 = x + half;
    top2 = Math.min(y, base);
    bottom2 = Math.max(y, base);
  }
  return { left: left2, top: top2, right: right2, bottom: bottom2 };
}
function skipOrLimit(skip2, value, min2, max2) {
  return skip2 ? 0 : _limitValue(value, min2, max2);
}
function parseBorderWidth(bar, maxW, maxH) {
  const value = bar.options.borderWidth;
  const skip2 = bar.borderSkipped;
  const o = toTRBL(value);
  return {
    t: skipOrLimit(skip2.top, o.top, 0, maxH),
    r: skipOrLimit(skip2.right, o.right, 0, maxW),
    b: skipOrLimit(skip2.bottom, o.bottom, 0, maxH),
    l: skipOrLimit(skip2.left, o.left, 0, maxW)
  };
}
function parseBorderRadius(bar, maxW, maxH) {
  const { enableBorderRadius } = bar.getProps(["enableBorderRadius"]);
  const value = bar.options.borderRadius;
  const o = toTRBLCorners(value);
  const maxR = Math.min(maxW, maxH);
  const skip2 = bar.borderSkipped;
  const enableBorder = enableBorderRadius || isObject(value);
  return {
    topLeft: skipOrLimit(!enableBorder || skip2.top || skip2.left, o.topLeft, 0, maxR),
    topRight: skipOrLimit(!enableBorder || skip2.top || skip2.right, o.topRight, 0, maxR),
    bottomLeft: skipOrLimit(!enableBorder || skip2.bottom || skip2.left, o.bottomLeft, 0, maxR),
    bottomRight: skipOrLimit(!enableBorder || skip2.bottom || skip2.right, o.bottomRight, 0, maxR)
  };
}
function boundingRects$1(bar) {
  const bounds = getBarBounds(bar);
  const width = bounds.right - bounds.left;
  const height = bounds.bottom - bounds.top;
  const border = parseBorderWidth(bar, width / 2, height / 2);
  const radius = parseBorderRadius(bar, width / 2, height / 2);
  return {
    outer: {
      x: bounds.left,
      y: bounds.top,
      w: width,
      h: height,
      radius
    },
    inner: {
      x: bounds.left + border.l,
      y: bounds.top + border.t,
      w: width - border.l - border.r,
      h: height - border.t - border.b,
      radius: {
        topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
        topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
        bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
        bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
      }
    }
  };
}
function inRange(bar, x, y, useFinalPosition) {
  const skipX = x === null;
  const skipY = y === null;
  const skipBoth = skipX && skipY;
  const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
  return bounds && (skipX || _isBetween(x, bounds.left, bounds.right)) && (skipY || _isBetween(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
  return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
  ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
  const x = rect.x !== refRect.x ? -amount : 0;
  const y = rect.y !== refRect.y ? -amount : 0;
  const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
  const h3 = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
  return {
    x: rect.x + x,
    y: rect.y + y,
    w: rect.w + w,
    h: rect.h + h3,
    radius: rect.radius
  };
}
class BarElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = void 0;
    this.horizontal = void 0;
    this.base = void 0;
    this.width = void 0;
    this.height = void 0;
    this.inflateAmount = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  draw(ctx) {
    const { inflateAmount, options: { borderColor, backgroundColor } } = this;
    const { inner, outer } = boundingRects$1(this);
    const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
    ctx.save();
    if (outer.w !== inner.w || outer.h !== inner.h) {
      ctx.beginPath();
      addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
      ctx.clip();
      addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
      ctx.fillStyle = borderColor;
      ctx.fill("evenodd");
    }
    ctx.beginPath();
    addRectPath(ctx, inflateRect(inner, inflateAmount));
    ctx.fillStyle = backgroundColor;
    ctx.fill();
    ctx.restore();
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    return inRange(this, mouseX, mouseY, useFinalPosition);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange(this, mouseX, null, useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange(this, null, mouseY, useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x, y, base, horizontal } = this.getProps(["x", "y", "base", "horizontal"], useFinalPosition);
    return {
      x: horizontal ? (x + base) / 2 : x,
      y: horizontal ? y : (y + base) / 2
    };
  }
  getRange(axis) {
    return axis === "x" ? this.width / 2 : this.height / 2;
  }
}
BarElement.id = "bar";
BarElement.defaults = {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
};
BarElement.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
var elements = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement,
  LineElement,
  PointElement,
  BarElement
});
function lttbDecimation(data, start2, count, availableWidth, options) {
  const samples = options.samples || availableWidth;
  if (samples >= count) {
    return data.slice(start2, start2 + count);
  }
  const decimated = [];
  const bucketWidth = (count - 2) / (samples - 2);
  let sampledIndex = 0;
  const endIndex = start2 + count - 1;
  let a = start2;
  let i, maxAreaPoint, maxArea, area, nextA;
  decimated[sampledIndex++] = data[a];
  for (i = 0; i < samples - 2; i++) {
    let avgX = 0;
    let avgY = 0;
    let j;
    const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start2;
    const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start2;
    const avgRangeLength = avgRangeEnd - avgRangeStart;
    for (j = avgRangeStart; j < avgRangeEnd; j++) {
      avgX += data[j].x;
      avgY += data[j].y;
    }
    avgX /= avgRangeLength;
    avgY /= avgRangeLength;
    const rangeOffs = Math.floor(i * bucketWidth) + 1 + start2;
    const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start2;
    const { x: pointAx, y: pointAy } = data[a];
    maxArea = area = -1;
    for (j = rangeOffs; j < rangeTo; j++) {
      area = 0.5 * Math.abs(
        (pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy)
      );
      if (area > maxArea) {
        maxArea = area;
        maxAreaPoint = data[j];
        nextA = j;
      }
    }
    decimated[sampledIndex++] = maxAreaPoint;
    a = nextA;
  }
  decimated[sampledIndex++] = data[endIndex];
  return decimated;
}
function minMaxDecimation(data, start2, count, availableWidth) {
  let avgX = 0;
  let countX = 0;
  let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
  const decimated = [];
  const endIndex = start2 + count - 1;
  const xMin = data[start2].x;
  const xMax = data[endIndex].x;
  const dx = xMax - xMin;
  for (i = start2; i < start2 + count; ++i) {
    point = data[i];
    x = (point.x - xMin) / dx * availableWidth;
    y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
        minIndex = i;
      } else if (y > maxY) {
        maxY = y;
        maxIndex = i;
      }
      avgX = (countX * avgX + point.x) / ++countX;
    } else {
      const lastIndex = i - 1;
      if (!isNullOrUndef(minIndex) && !isNullOrUndef(maxIndex)) {
        const intermediateIndex1 = Math.min(minIndex, maxIndex);
        const intermediateIndex2 = Math.max(minIndex, maxIndex);
        if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) {
          decimated.push({
            ...data[intermediateIndex1],
            x: avgX
          });
        }
        if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) {
          decimated.push({
            ...data[intermediateIndex2],
            x: avgX
          });
        }
      }
      if (i > 0 && lastIndex !== startIndex) {
        decimated.push(data[lastIndex]);
      }
      decimated.push(point);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
      minIndex = maxIndex = startIndex = i;
    }
  }
  return decimated;
}
function cleanDecimatedDataset(dataset) {
  if (dataset._decimated) {
    const data = dataset._data;
    delete dataset._decimated;
    delete dataset._data;
    Object.defineProperty(dataset, "data", { value: data });
  }
}
function cleanDecimatedData(chart) {
  chart.data.datasets.forEach((dataset) => {
    cleanDecimatedDataset(dataset);
  });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
  const pointCount = points.length;
  let start2 = 0;
  let count;
  const { iScale } = meta;
  const { min: min2, max: max2, minDefined, maxDefined } = iScale.getUserBounds();
  if (minDefined) {
    start2 = _limitValue(_lookupByKey(points, iScale.axis, min2).lo, 0, pointCount - 1);
  }
  if (maxDefined) {
    count = _limitValue(_lookupByKey(points, iScale.axis, max2).hi + 1, start2, pointCount) - start2;
  } else {
    count = pointCount - start2;
  }
  return { start: start2, count };
}
var plugin_decimation = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: false
  },
  beforeElementsUpdate: (chart, args, options) => {
    if (!options.enabled) {
      cleanDecimatedData(chart);
      return;
    }
    const availableWidth = chart.width;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const { _data, indexAxis } = dataset;
      const meta = chart.getDatasetMeta(datasetIndex);
      const data = _data || dataset.data;
      if (resolve([indexAxis, chart.options.indexAxis]) === "y") {
        return;
      }
      if (!meta.controller.supportsDecimation) {
        return;
      }
      const xAxis = chart.scales[meta.xAxisID];
      if (xAxis.type !== "linear" && xAxis.type !== "time") {
        return;
      }
      if (chart.options.parsing) {
        return;
      }
      let { start: start2, count } = getStartAndCountOfVisiblePointsSimplified(meta, data);
      const threshold = options.threshold || 4 * availableWidth;
      if (count <= threshold) {
        cleanDecimatedDataset(dataset);
        return;
      }
      if (isNullOrUndef(_data)) {
        dataset._data = data;
        delete dataset.data;
        Object.defineProperty(dataset, "data", {
          configurable: true,
          enumerable: true,
          get: function() {
            return this._decimated;
          },
          set: function(d) {
            this._data = d;
          }
        });
      }
      let decimated;
      switch (options.algorithm) {
        case "lttb":
          decimated = lttbDecimation(data, start2, count, availableWidth, options);
          break;
        case "min-max":
          decimated = minMaxDecimation(data, start2, count, availableWidth);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
      }
      dataset._decimated = decimated;
    });
  },
  destroy(chart) {
    cleanDecimatedData(chart);
  }
};
function _segments(line, target, property) {
  const segments = line.segments;
  const points = line.points;
  const tpoints = target.points;
  const parts = [];
  for (const segment of segments) {
    let { start: start2, end: end2 } = segment;
    end2 = _findSegmentEnd(start2, end2, points);
    const bounds = _getBounds(property, points[start2], points[end2], segment.loop);
    if (!target.segments) {
      parts.push({
        source: segment,
        target: bounds,
        start: points[start2],
        end: points[end2]
      });
      continue;
    }
    const targetSegments = _boundSegments(target, bounds);
    for (const tgt of targetSegments) {
      const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
      const fillSources = _boundSegment(segment, points, subBounds);
      for (const fillSource of fillSources) {
        parts.push({
          source: fillSource,
          target: tgt,
          start: {
            [property]: _getEdge(bounds, subBounds, "start", Math.max)
          },
          end: {
            [property]: _getEdge(bounds, subBounds, "end", Math.min)
          }
        });
      }
    }
  }
  return parts;
}
function _getBounds(property, first, last, loop) {
  if (loop) {
    return;
  }
  let start2 = first[property];
  let end2 = last[property];
  if (property === "angle") {
    start2 = _normalizeAngle(start2);
    end2 = _normalizeAngle(end2);
  }
  return { property, start: start2, end: end2 };
}
function _pointsFromSegments(boundary, line) {
  const { x = null, y = null } = boundary || {};
  const linePoints = line.points;
  const points = [];
  line.segments.forEach(({ start: start2, end: end2 }) => {
    end2 = _findSegmentEnd(start2, end2, linePoints);
    const first = linePoints[start2];
    const last = linePoints[end2];
    if (y !== null) {
      points.push({ x: first.x, y });
      points.push({ x: last.x, y });
    } else if (x !== null) {
      points.push({ x, y: first.y });
      points.push({ x, y: last.y });
    }
  });
  return points;
}
function _findSegmentEnd(start2, end2, points) {
  for (; end2 > start2; end2--) {
    const point = points[end2];
    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }
  return end2;
}
function _getEdge(a, b, prop, fn2) {
  if (a && b) {
    return fn2(a[prop], b[prop]);
  }
  return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
  let points = [];
  let _loop = false;
  if (isArray(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = _pointsFromSegments(boundary, line);
  }
  return points.length ? new LineElement({
    points,
    options: { tension: 0 },
    _loop,
    _fullLoop: _loop
  }) : null;
}
function _shouldApplyFill(source) {
  return source && source.fill !== false;
}
function _resolveTarget(sources, index2, propagate) {
  const source = sources[index2];
  let fill2 = source.fill;
  const visited = [index2];
  let target;
  if (!propagate) {
    return fill2;
  }
  while (fill2 !== false && visited.indexOf(fill2) === -1) {
    if (!isNumberFinite(fill2)) {
      return fill2;
    }
    target = sources[fill2];
    if (!target) {
      return false;
    }
    if (target.visible) {
      return fill2;
    }
    visited.push(fill2);
    fill2 = target.fill;
  }
  return false;
}
function _decodeFill(line, index2, count) {
  const fill2 = parseFillOption(line);
  if (isObject(fill2)) {
    return isNaN(fill2.value) ? false : fill2;
  }
  let target = parseFloat(fill2);
  if (isNumberFinite(target) && Math.floor(target) === target) {
    return decodeTargetIndex(fill2[0], index2, target, count);
  }
  return ["origin", "start", "end", "stack", "shape"].indexOf(fill2) >= 0 && fill2;
}
function decodeTargetIndex(firstCh, index2, target, count) {
  if (firstCh === "-" || firstCh === "+") {
    target = index2 + target;
  }
  if (target === index2 || target < 0 || target >= count) {
    return false;
  }
  return target;
}
function _getTargetPixel(fill2, scale) {
  let pixel = null;
  if (fill2 === "start") {
    pixel = scale.bottom;
  } else if (fill2 === "end") {
    pixel = scale.top;
  } else if (isObject(fill2)) {
    pixel = scale.getPixelForValue(fill2.value);
  } else if (scale.getBasePixel) {
    pixel = scale.getBasePixel();
  }
  return pixel;
}
function _getTargetValue(fill2, scale, startValue) {
  let value;
  if (fill2 === "start") {
    value = startValue;
  } else if (fill2 === "end") {
    value = scale.options.reverse ? scale.min : scale.max;
  } else if (isObject(fill2)) {
    value = fill2.value;
  } else {
    value = scale.getBaseValue();
  }
  return value;
}
function parseFillOption(line) {
  const options = line.options;
  const fillOption = options.fill;
  let fill2 = valueOrDefault(fillOption && fillOption.target, fillOption);
  if (fill2 === void 0) {
    fill2 = !!options.backgroundColor;
  }
  if (fill2 === false || fill2 === null) {
    return false;
  }
  if (fill2 === true) {
    return "origin";
  }
  return fill2;
}
function _buildStackLine(source) {
  const { scale, index: index2, line } = source;
  const points = [];
  const segments = line.segments;
  const sourcePoints = line.points;
  const linesBelow = getLinesBelow(scale, index2);
  linesBelow.push(_createBoundaryLine({ x: null, y: scale.bottom }, line));
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    for (let j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }
  return new LineElement({ points, options: {} });
}
function getLinesBelow(scale, index2) {
  const below = [];
  const metas = scale.getMatchingVisibleMetas("line");
  for (let i = 0; i < metas.length; i++) {
    const meta = metas[i];
    if (meta.index === index2) {
      break;
    }
    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }
  return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
  const postponed = [];
  for (let j = 0; j < linesBelow.length; j++) {
    const line = linesBelow[j];
    const { first, last, point } = findPoint(line, sourcePoint, "x");
    if (!point || first && last) {
      continue;
    }
    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);
      if (!last) {
        break;
      }
    }
  }
  points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
  const point = line.interpolate(sourcePoint, property);
  if (!point) {
    return {};
  }
  const pointValue = point[property];
  const segments = line.segments;
  const linePoints = line.points;
  let first = false;
  let last = false;
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const firstValue = linePoints[segment.start][property];
    const lastValue = linePoints[segment.end][property];
    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last = pointValue === lastValue;
      break;
    }
  }
  return { first, last, point };
}
class simpleArc {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }
  pathSegment(ctx, bounds, opts) {
    const { x, y, radius } = this;
    bounds = bounds || { start: 0, end: TAU };
    ctx.arc(x, y, radius, bounds.end, bounds.start, true);
    return !opts.bounds;
  }
  interpolate(point) {
    const { x, y, radius } = this;
    const angle = point.angle;
    return {
      x: x + Math.cos(angle) * radius,
      y: y + Math.sin(angle) * radius,
      angle
    };
  }
}
function _getTarget(source) {
  const { chart, fill: fill2, line } = source;
  if (isNumberFinite(fill2)) {
    return getLineByIndex(chart, fill2);
  }
  if (fill2 === "stack") {
    return _buildStackLine(source);
  }
  if (fill2 === "shape") {
    return true;
  }
  const boundary = computeBoundary(source);
  if (boundary instanceof simpleArc) {
    return boundary;
  }
  return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index2) {
  const meta = chart.getDatasetMeta(index2);
  const visible = meta && chart.isDatasetVisible(index2);
  return visible ? meta.dataset : null;
}
function computeBoundary(source) {
  const scale = source.scale || {};
  if (scale.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }
  return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
  const { scale = {}, fill: fill2 } = source;
  const pixel = _getTargetPixel(fill2, scale);
  if (isNumberFinite(pixel)) {
    const horizontal = scale.isHorizontal();
    return {
      x: horizontal ? pixel : null,
      y: horizontal ? null : pixel
    };
  }
  return null;
}
function computeCircularBoundary(source) {
  const { scale, fill: fill2 } = source;
  const options = scale.options;
  const length = scale.getLabels().length;
  const start2 = options.reverse ? scale.max : scale.min;
  const value = _getTargetValue(fill2, scale, start2);
  const target = [];
  if (options.grid.circular) {
    const center = scale.getPointPositionForValue(0, start2);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale.getDistanceFromCenterForValue(value)
    });
  }
  for (let i = 0; i < length; ++i) {
    target.push(scale.getPointPositionForValue(i, value));
  }
  return target;
}
function _drawfill(ctx, source, area) {
  const target = _getTarget(source);
  const { line, scale, axis } = source;
  const lineOpts = line.options;
  const fillOption = lineOpts.fill;
  const color2 = lineOpts.backgroundColor;
  const { above = color2, below = color2 } = fillOption || {};
  if (target && line.points.length) {
    clipArea(ctx, area);
    doFill(ctx, { line, target, above, below, area, scale, axis });
    unclipArea(ctx);
  }
}
function doFill(ctx, cfg) {
  const { line, target, above, below, area, scale } = cfg;
  const property = line._loop ? "angle" : cfg.axis;
  ctx.save();
  if (property === "x" && below !== above) {
    clipVertical(ctx, target, area.top);
    fill(ctx, { line, target, color: above, scale, property });
    ctx.restore();
    ctx.save();
    clipVertical(ctx, target, area.bottom);
  }
  fill(ctx, { line, target, color: below, scale, property });
  ctx.restore();
}
function clipVertical(ctx, target, clipY) {
  const { segments, points } = target;
  let first = true;
  let lineLoop = false;
  ctx.beginPath();
  for (const segment of segments) {
    const { start: start2, end: end2 } = segment;
    const firstPoint = points[start2];
    const lastPoint = points[_findSegmentEnd(start2, end2, points)];
    if (first) {
      ctx.moveTo(firstPoint.x, firstPoint.y);
      first = false;
    } else {
      ctx.lineTo(firstPoint.x, clipY);
      ctx.lineTo(firstPoint.x, firstPoint.y);
    }
    lineLoop = !!target.pathSegment(ctx, segment, { move: lineLoop });
    if (lineLoop) {
      ctx.closePath();
    } else {
      ctx.lineTo(lastPoint.x, clipY);
    }
  }
  ctx.lineTo(target.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}
function fill(ctx, cfg) {
  const { line, target, property, color: color2, scale } = cfg;
  const segments = _segments(line, target, property);
  for (const { source: src, target: tgt, start: start2, end: end2 } of segments) {
    const { style: { backgroundColor = color2 } = {} } = src;
    const notShape = target !== true;
    ctx.save();
    ctx.fillStyle = backgroundColor;
    clipBounds(ctx, scale, notShape && _getBounds(property, start2, end2));
    ctx.beginPath();
    const lineLoop = !!line.pathSegment(ctx, src);
    let loop;
    if (notShape) {
      if (lineLoop) {
        ctx.closePath();
      } else {
        interpolatedLineTo(ctx, target, end2, property);
      }
      const targetLoop = !!target.pathSegment(ctx, tgt, { move: lineLoop, reverse: true });
      loop = lineLoop && targetLoop;
      if (!loop) {
        interpolatedLineTo(ctx, target, start2, property);
      }
    }
    ctx.closePath();
    ctx.fill(loop ? "evenodd" : "nonzero");
    ctx.restore();
  }
}
function clipBounds(ctx, scale, bounds) {
  const { top: top2, bottom: bottom2 } = scale.chart.chartArea;
  const { property, start: start2, end: end2 } = bounds || {};
  if (property === "x") {
    ctx.beginPath();
    ctx.rect(start2, top2, end2 - start2, bottom2 - top2);
    ctx.clip();
  }
}
function interpolatedLineTo(ctx, target, point, property) {
  const interpolatedPoint = target.interpolate(point, property);
  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}
var index = {
  id: "filler",
  afterDatasetsUpdate(chart, _args, options) {
    const count = (chart.data.datasets || []).length;
    const sources = [];
    let meta, i, line, source;
    for (i = 0; i < count; ++i) {
      meta = chart.getDatasetMeta(i);
      line = meta.dataset;
      source = null;
      if (line && line.options && line instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i),
          index: i,
          fill: _decodeFill(line, i, count),
          chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line
        };
      }
      meta.$filler = source;
      sources.push(source);
    }
    for (i = 0; i < count; ++i) {
      source = sources[i];
      if (!source || source.fill === false) {
        continue;
      }
      source.fill = _resolveTarget(sources, i, options.propagate);
    }
  },
  beforeDraw(chart, _args, options) {
    const draw2 = options.drawTime === "beforeDraw";
    const metasets = chart.getSortedVisibleDatasetMetas();
    const area = chart.chartArea;
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (!source) {
        continue;
      }
      source.line.updateControlPoints(area, source.axis);
      if (draw2 && source.fill) {
        _drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw(chart, _args, options) {
    if (options.drawTime !== "beforeDatasetsDraw") {
      return;
    }
    const metasets = chart.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (_shouldApplyFill(source)) {
        _drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw(chart, args, options) {
    const source = args.meta.$filler;
    if (!_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") {
      return;
    }
    _drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: "beforeDatasetDraw"
  }
};
const getBoxSize = (labelOpts, fontSize) => {
  let { boxHeight = fontSize, boxWidth = fontSize } = labelOpts;
  if (labelOpts.usePointStyle) {
    boxHeight = Math.min(boxHeight, fontSize);
    boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
  }
  return {
    boxWidth,
    boxHeight,
    itemHeight: Math.max(fontSize, boxHeight)
  };
};
const itemsEqual = (a, b) => a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element$1 {
  constructor(config) {
    super();
    this._added = false;
    this.legendHitBoxes = [];
    this._hoveredItem = null;
    this.doughnutMode = false;
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this.legendItems = void 0;
    this.columnSizes = void 0;
    this.lineWidths = void 0;
    this.maxHeight = void 0;
    this.maxWidth = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.height = void 0;
    this.width = void 0;
    this._margins = void 0;
    this.position = void 0;
    this.weight = void 0;
    this.fullSize = void 0;
  }
  update(maxWidth, maxHeight, margins) {
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins;
    this.setDimensions();
    this.buildLabels();
    this.fit();
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = this._margins.left;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = this._margins.top;
      this.bottom = this.height;
    }
  }
  buildLabels() {
    const labelOpts = this.options.labels || {};
    let legendItems = callback(labelOpts.generateLabels, [this.chart], this) || [];
    if (labelOpts.filter) {
      legendItems = legendItems.filter((item) => labelOpts.filter(item, this.chart.data));
    }
    if (labelOpts.sort) {
      legendItems = legendItems.sort((a, b) => labelOpts.sort(a, b, this.chart.data));
    }
    if (this.options.reverse) {
      legendItems.reverse();
    }
    this.legendItems = legendItems;
  }
  fit() {
    const { options, ctx } = this;
    if (!options.display) {
      this.width = this.height = 0;
      return;
    }
    const labelOpts = options.labels;
    const labelFont = toFont(labelOpts.font);
    const fontSize = labelFont.size;
    const titleHeight = this._computeTitleHeight();
    const { boxWidth, itemHeight } = getBoxSize(labelOpts, fontSize);
    let width, height;
    ctx.font = labelFont.string;
    if (this.isHorizontal()) {
      width = this.maxWidth;
      height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
    } else {
      height = this.maxHeight;
      width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
    }
    this.width = Math.min(width, options.maxWidth || this.maxWidth);
    this.height = Math.min(height, options.maxHeight || this.maxHeight);
  }
  _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
    const { ctx, maxWidth, options: { labels: { padding } } } = this;
    const hitboxes = this.legendHitBoxes = [];
    const lineWidths = this.lineWidths = [0];
    const lineHeight = itemHeight + padding;
    let totalHeight = titleHeight;
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    let row = -1;
    let top2 = -lineHeight;
    this.legendItems.forEach((legendItem, i) => {
      const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
      if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
        totalHeight += lineHeight;
        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
        top2 += lineHeight;
        row++;
      }
      hitboxes[i] = { left: 0, top: top2, row, width: itemWidth, height: itemHeight };
      lineWidths[lineWidths.length - 1] += itemWidth + padding;
    });
    return totalHeight;
  }
  _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
    const { ctx, maxHeight, options: { labels: { padding } } } = this;
    const hitboxes = this.legendHitBoxes = [];
    const columnSizes = this.columnSizes = [];
    const heightLimit = maxHeight - titleHeight;
    let totalWidth = padding;
    let currentColWidth = 0;
    let currentColHeight = 0;
    let left2 = 0;
    let col = 0;
    this.legendItems.forEach((legendItem, i) => {
      const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
      if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
        totalWidth += currentColWidth + padding;
        columnSizes.push({ width: currentColWidth, height: currentColHeight });
        left2 += currentColWidth + padding;
        col++;
        currentColWidth = currentColHeight = 0;
      }
      hitboxes[i] = { left: left2, top: currentColHeight, col, width: itemWidth, height: itemHeight };
      currentColWidth = Math.max(currentColWidth, itemWidth);
      currentColHeight += itemHeight + padding;
    });
    totalWidth += currentColWidth;
    columnSizes.push({ width: currentColWidth, height: currentColHeight });
    return totalWidth;
  }
  adjustHitBoxes() {
    if (!this.options.display) {
      return;
    }
    const titleHeight = this._computeTitleHeight();
    const { legendHitBoxes: hitboxes, options: { align, labels: { padding }, rtl } } = this;
    const rtlHelper = getRtlAdapter(rtl, this.left, this.width);
    if (this.isHorizontal()) {
      let row = 0;
      let left2 = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
      for (const hitbox of hitboxes) {
        if (row !== hitbox.row) {
          row = hitbox.row;
          left2 = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
        }
        hitbox.top += this.top + titleHeight + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left2), hitbox.width);
        left2 += hitbox.width + padding;
      }
    } else {
      let col = 0;
      let top2 = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
      for (const hitbox of hitboxes) {
        if (hitbox.col !== col) {
          col = hitbox.col;
          top2 = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
        }
        hitbox.top = top2;
        hitbox.left += this.left + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
        top2 += hitbox.height + padding;
      }
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const ctx = this.ctx;
      clipArea(ctx, this);
      this._draw();
      unclipArea(ctx);
    }
  }
  _draw() {
    const { options: opts, columnSizes, lineWidths, ctx } = this;
    const { align, labels: labelOpts } = opts;
    const defaultColor2 = defaults$1.color;
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const labelFont = toFont(labelOpts.font);
    const { color: fontColor, padding } = labelOpts;
    const fontSize = labelFont.size;
    const halfFontSize = fontSize / 2;
    let cursor;
    this.drawTitle();
    ctx.textAlign = rtlHelper.textAlign("left");
    ctx.textBaseline = "middle";
    ctx.lineWidth = 0.5;
    ctx.font = labelFont.string;
    const { boxWidth, boxHeight, itemHeight } = getBoxSize(labelOpts, fontSize);
    const drawLegendBox = function(x, y, legendItem) {
      if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
        return;
      }
      ctx.save();
      const lineWidth = valueOrDefault(legendItem.lineWidth, 1);
      ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor2);
      ctx.lineCap = valueOrDefault(legendItem.lineCap, "butt");
      ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
      ctx.lineJoin = valueOrDefault(legendItem.lineJoin, "miter");
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor2);
      ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));
      if (labelOpts.usePointStyle) {
        const drawOptions = {
          radius: boxHeight * Math.SQRT2 / 2,
          pointStyle: legendItem.pointStyle,
          rotation: legendItem.rotation,
          borderWidth: lineWidth
        };
        const centerX = rtlHelper.xPlus(x, boxWidth / 2);
        const centerY = y + halfFontSize;
        drawPointLegend(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
      } else {
        const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
        const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
        const borderRadius = toTRBLCorners(legendItem.borderRadius);
        ctx.beginPath();
        if (Object.values(borderRadius).some((v) => v !== 0)) {
          addRoundedRectPath(ctx, {
            x: xBoxLeft,
            y: yBoxTop,
            w: boxWidth,
            h: boxHeight,
            radius: borderRadius
          });
        } else {
          ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
        }
        ctx.fill();
        if (lineWidth !== 0) {
          ctx.stroke();
        }
      }
      ctx.restore();
    };
    const fillText = function(x, y, legendItem) {
      renderText(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
        strikethrough: legendItem.hidden,
        textAlign: rtlHelper.textAlign(legendItem.textAlign)
      });
    };
    const isHorizontal = this.isHorizontal();
    const titleHeight = this._computeTitleHeight();
    if (isHorizontal) {
      cursor = {
        x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
        y: this.top + padding + titleHeight,
        line: 0
      };
    } else {
      cursor = {
        x: this.left + padding,
        y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
        line: 0
      };
    }
    overrideTextDirection(this.ctx, opts.textDirection);
    const lineHeight = itemHeight + padding;
    this.legendItems.forEach((legendItem, i) => {
      ctx.strokeStyle = legendItem.fontColor || fontColor;
      ctx.fillStyle = legendItem.fontColor || fontColor;
      const textWidth = ctx.measureText(legendItem.text).width;
      const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
      const width = boxWidth + halfFontSize + textWidth;
      let x = cursor.x;
      let y = cursor.y;
      rtlHelper.setWidth(this.width);
      if (isHorizontal) {
        if (i > 0 && x + width + padding > this.right) {
          y = cursor.y += lineHeight;
          cursor.line++;
          x = cursor.x = _alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor.line]);
        }
      } else if (i > 0 && y + lineHeight > this.bottom) {
        x = cursor.x = x + columnSizes[cursor.line].width + padding;
        cursor.line++;
        y = cursor.y = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
      }
      const realX = rtlHelper.x(x);
      drawLegendBox(realX, y, legendItem);
      x = _textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
      fillText(rtlHelper.x(x), y, legendItem);
      if (isHorizontal) {
        cursor.x += width + padding;
      } else {
        cursor.y += lineHeight;
      }
    });
    restoreTextDirection(this.ctx, opts.textDirection);
  }
  drawTitle() {
    const opts = this.options;
    const titleOpts = opts.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    if (!titleOpts.display) {
      return;
    }
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const ctx = this.ctx;
    const position = titleOpts.position;
    const halfFontSize = titleFont.size / 2;
    const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
    let y;
    let left2 = this.left;
    let maxWidth = this.width;
    if (this.isHorizontal()) {
      maxWidth = Math.max(...this.lineWidths);
      y = this.top + topPaddingPlusHalfFontSize;
      left2 = _alignStartEnd(opts.align, left2, this.right - maxWidth);
    } else {
      const maxHeight = this.columnSizes.reduce((acc, size) => Math.max(acc, size.height), 0);
      y = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
    }
    const x = _alignStartEnd(position, left2, left2 + maxWidth);
    ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position));
    ctx.textBaseline = "middle";
    ctx.strokeStyle = titleOpts.color;
    ctx.fillStyle = titleOpts.color;
    ctx.font = titleFont.string;
    renderText(ctx, titleOpts.text, x, y, titleFont);
  }
  _computeTitleHeight() {
    const titleOpts = this.options.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
  }
  _getLegendItemAt(x, y) {
    let i, hitBox, lh;
    if (_isBetween(x, this.left, this.right) && _isBetween(y, this.top, this.bottom)) {
      lh = this.legendHitBoxes;
      for (i = 0; i < lh.length; ++i) {
        hitBox = lh[i];
        if (_isBetween(x, hitBox.left, hitBox.left + hitBox.width) && _isBetween(y, hitBox.top, hitBox.top + hitBox.height)) {
          return this.legendItems[i];
        }
      }
    }
    return null;
  }
  handleEvent(e) {
    const opts = this.options;
    if (!isListened(e.type, opts)) {
      return;
    }
    const hoveredItem = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const previous = this._hoveredItem;
      const sameItem = itemsEqual(previous, hoveredItem);
      if (previous && !sameItem) {
        callback(opts.onLeave, [e, previous, this], this);
      }
      this._hoveredItem = hoveredItem;
      if (hoveredItem && !sameItem) {
        callback(opts.onHover, [e, hoveredItem, this], this);
      }
    } else if (hoveredItem) {
      callback(opts.onClick, [e, hoveredItem, this], this);
    }
  }
}
function isListened(type, opts) {
  if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) {
    return true;
  }
  if (opts.onClick && (type === "click" || type === "mouseup")) {
    return true;
  }
  return false;
}
var plugin_legend = {
  id: "legend",
  _element: Legend,
  start(chart, _args, options) {
    const legend = chart.legend = new Legend({ ctx: chart.ctx, options, chart });
    layouts.configure(chart, legend, options);
    layouts.addBox(chart, legend);
  },
  stop(chart) {
    layouts.removeBox(chart, chart.legend);
    delete chart.legend;
  },
  beforeUpdate(chart, _args, options) {
    const legend = chart.legend;
    layouts.configure(chart, legend, options);
    legend.options = options;
  },
  afterUpdate(chart) {
    const legend = chart.legend;
    legend.buildLabels();
    legend.adjustHitBoxes();
  },
  afterEvent(chart, args) {
    if (!args.replay) {
      chart.legend.handleEvent(args.event);
    }
  },
  defaults: {
    display: true,
    position: "top",
    align: "center",
    fullSize: true,
    reverse: false,
    weight: 1e3,
    onClick(e, legendItem, legend) {
      const index2 = legendItem.datasetIndex;
      const ci = legend.chart;
      if (ci.isDatasetVisible(index2)) {
        ci.hide(index2);
        legendItem.hidden = true;
      } else {
        ci.show(index2);
        legendItem.hidden = false;
      }
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (ctx) => ctx.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(chart) {
        const datasets = chart.data.datasets;
        const { labels: { usePointStyle, pointStyle, textAlign, color: color2 } } = chart.legend.options;
        return chart._getSortedDatasetMetas().map((meta) => {
          const style = meta.controller.getStyle(usePointStyle ? 0 : void 0);
          const borderWidth = toPadding(style.borderWidth);
          return {
            text: datasets[meta.index].label,
            fillStyle: style.backgroundColor,
            fontColor: color2,
            hidden: !meta.visible,
            lineCap: style.borderCapStyle,
            lineDash: style.borderDash,
            lineDashOffset: style.borderDashOffset,
            lineJoin: style.borderJoinStyle,
            lineWidth: (borderWidth.width + borderWidth.height) / 4,
            strokeStyle: style.borderColor,
            pointStyle: pointStyle || style.pointStyle,
            rotation: style.rotation,
            textAlign: textAlign || style.textAlign,
            borderRadius: 0,
            datasetIndex: meta.index
          };
        }, this);
      }
    },
    title: {
      color: (ctx) => ctx.chart.options.color,
      display: false,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (name) => !name.startsWith("on"),
    labels: {
      _scriptable: (name) => !["generateLabels", "filter", "sort"].includes(name)
    }
  }
};
class Title extends Element$1 {
  constructor(config) {
    super();
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this._padding = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this.position = void 0;
    this.weight = void 0;
    this.fullSize = void 0;
  }
  update(maxWidth, maxHeight) {
    const opts = this.options;
    this.left = 0;
    this.top = 0;
    if (!opts.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = maxWidth;
    this.height = this.bottom = maxHeight;
    const lineCount = isArray(opts.text) ? opts.text.length : 1;
    this._padding = toPadding(opts.padding);
    const textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;
    if (this.isHorizontal()) {
      this.height = textSize;
    } else {
      this.width = textSize;
    }
  }
  isHorizontal() {
    const pos = this.options.position;
    return pos === "top" || pos === "bottom";
  }
  _drawArgs(offset2) {
    const { top: top2, left: left2, bottom: bottom2, right: right2, options } = this;
    const align = options.align;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (this.isHorizontal()) {
      titleX = _alignStartEnd(align, left2, right2);
      titleY = top2 + offset2;
      maxWidth = right2 - left2;
    } else {
      if (options.position === "left") {
        titleX = left2 + offset2;
        titleY = _alignStartEnd(align, bottom2, top2);
        rotation = PI * -0.5;
      } else {
        titleX = right2 - offset2;
        titleY = _alignStartEnd(align, top2, bottom2);
        rotation = PI * 0.5;
      }
      maxWidth = bottom2 - top2;
    }
    return { titleX, titleY, maxWidth, rotation };
  }
  draw() {
    const ctx = this.ctx;
    const opts = this.options;
    if (!opts.display) {
      return;
    }
    const fontOpts = toFont(opts.font);
    const lineHeight = fontOpts.lineHeight;
    const offset2 = lineHeight / 2 + this._padding.top;
    const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset2);
    renderText(ctx, opts.text, 0, 0, fontOpts, {
      color: opts.color,
      maxWidth,
      rotation,
      textAlign: _toLeftRightCenter(opts.align),
      textBaseline: "middle",
      translation: [titleX, titleY]
    });
  }
}
function createTitle(chart, titleOpts) {
  const title = new Title({
    ctx: chart.ctx,
    options: titleOpts,
    chart
  });
  layouts.configure(chart, title, titleOpts);
  layouts.addBox(chart, title);
  chart.titleBlock = title;
}
var plugin_title = {
  id: "title",
  _element: Title,
  start(chart, _args, options) {
    createTitle(chart, options);
  },
  stop(chart) {
    const titleBlock = chart.titleBlock;
    layouts.removeBox(chart, titleBlock);
    delete chart.titleBlock;
  },
  beforeUpdate(chart, _args, options) {
    const title = chart.titleBlock;
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: "center",
    display: false,
    font: {
      weight: "bold"
    },
    fullSize: true,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
const map = /* @__PURE__ */ new WeakMap();
var plugin_subtitle = {
  id: "subtitle",
  start(chart, _args, options) {
    const title = new Title({
      ctx: chart.ctx,
      options,
      chart
    });
    layouts.configure(chart, title, options);
    layouts.addBox(chart, title);
    map.set(chart, title);
  },
  stop(chart) {
    layouts.removeBox(chart, map.get(chart));
    map.delete(chart);
  },
  beforeUpdate(chart, _args, options) {
    const title = map.get(chart);
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: "center",
    display: false,
    font: {
      weight: "normal"
    },
    fullSize: true,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
const positioners$1 = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i, len;
    let x = 0;
    let y = 0;
    let count = 0;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        x += pos.x;
        y += pos.y;
        ++count;
      }
    }
    return {
      x: x / count,
      y: y / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x = eventPosition.x;
    let y = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i, len, nearestElement;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d = distanceBetweenPoints(eventPosition, center);
        if (d < minDistance) {
          minDistance = d;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x = tp.x;
      y = tp.y;
    }
    return {
      x,
      y
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) {
    return str.split("\n");
  }
  return str;
}
function createTooltipItem(chart, item) {
  const { element, datasetIndex, index: index2 } = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const { label, value } = controller.getLabelAndValue(index2);
  return {
    chart,
    label,
    parsed: controller.getParsed(index2),
    raw: chart.data.datasets[datasetIndex].data[index2],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index2,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options) {
  const ctx = tooltip.chart.ctx;
  const { body, footer, title } = tooltip;
  const { boxWidth, boxHeight } = options;
  const bodyFont = toFont(options.bodyFont);
  const titleFont = toFont(options.titleFont);
  const footerFont = toFont(options.footerFont);
  const titleLineCount = title.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options.padding);
  let height = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
  }
  if (footerLineCount) {
    height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function(line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
  each(body, (bodyItem) => {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return { width, height };
}
function determineYAlign(chart, size) {
  const { y, height } = size;
  if (y < height / 2) {
    return "top";
  } else if (y > chart.height - height / 2) {
    return "bottom";
  }
  return "center";
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
  const { x, width } = size;
  const caret = options.caretSize + options.caretPadding;
  if (xAlign === "left" && x + width + caret > chart.width) {
    return true;
  }
  if (xAlign === "right" && x - width - caret < 0) {
    return true;
  }
}
function determineXAlign(chart, options, size, yAlign) {
  const { x, width } = size;
  const { width: chartWidth, chartArea: { left: left2, right: right2 } } = chart;
  let xAlign = "center";
  if (yAlign === "center") {
    xAlign = x <= (left2 + right2) / 2 ? "left" : "right";
  } else if (x <= width / 2) {
    xAlign = "left";
  } else if (x >= chartWidth - width / 2) {
    xAlign = "right";
  }
  if (doesNotFitWithAlign(xAlign, chart, options, size)) {
    xAlign = "center";
  }
  return xAlign;
}
function determineAlignment(chart, options, size) {
  const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
  return {
    xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
    yAlign
  };
}
function alignX(size, xAlign) {
  let { x, width } = size;
  if (xAlign === "right") {
    x -= width;
  } else if (xAlign === "center") {
    x -= width / 2;
  }
  return x;
}
function alignY(size, yAlign, paddingAndSize) {
  let { y, height } = size;
  if (yAlign === "top") {
    y += paddingAndSize;
  } else if (yAlign === "bottom") {
    y -= height + paddingAndSize;
  } else {
    y -= height / 2;
  }
  return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
  const { caretSize, caretPadding, cornerRadius } = options;
  const { xAlign, yAlign } = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
  let x = alignX(size, xAlign);
  const y = alignY(size, yAlign, paddingAndSize);
  if (yAlign === "center") {
    if (xAlign === "left") {
      x += paddingAndSize;
    } else if (xAlign === "right") {
      x -= paddingAndSize;
    }
  } else if (xAlign === "left") {
    x -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === "right") {
    x += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x, 0, chart.width - size.width),
    y: _limitValue(y, 0, chart.height - size.height)
  };
}
function getAlignedX(tooltip, align, options) {
  const padding = toPadding(options.padding);
  return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback2) {
  return pushOrConcat([], splitNewlines(callback2));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext(parent, {
    tooltip,
    tooltipItems,
    type: "tooltip"
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
class Tooltip extends Element$1 {
  constructor(config) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = void 0;
    this._size = void 0;
    this._cachedAnimations = void 0;
    this._tooltipItems = [];
    this.$animations = void 0;
    this.$context = void 0;
    this.chart = config.chart || config._chart;
    this._chart = this.chart;
    this.options = config.options;
    this.dataPoints = void 0;
    this.title = void 0;
    this.beforeBody = void 0;
    this.body = void 0;
    this.afterBody = void 0;
    this.footer = void 0;
    this.xAlign = void 0;
    this.yAlign = void 0;
    this.x = void 0;
    this.y = void 0;
    this.height = void 0;
    this.width = void 0;
    this.caretX = void 0;
    this.caretY = void 0;
    this.labelColors = void 0;
    this.labelPointStyles = void 0;
    this.labelTextColors = void 0;
  }
  initialize(options) {
    this.options = options;
    this._cachedAnimations = void 0;
    this.$context = void 0;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options = this.options.setContext(this.getContext());
    const opts = options.enabled && chart.options.animation && options.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options) {
    const { callbacks } = options;
    const beforeTitle = callbacks.beforeTitle.apply(this, [context]);
    const title = callbacks.title.apply(this, [context]);
    const afterTitle = callbacks.afterTitle.apply(this, [context]);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [tooltipItems]));
  }
  getBody(tooltipItems, options) {
    const { callbacks } = options;
    const bodyItems = [];
    each(tooltipItems, (context) => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(scoped.beforeLabel.call(this, context)));
      pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
      pushOrConcat(bodyItem.after, splitNewlines(scoped.afterLabel.call(this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [tooltipItems]));
  }
  getFooter(tooltipItems, options) {
    const { callbacks } = options;
    const beforeFooter = callbacks.beforeFooter.apply(this, [tooltipItems]);
    const footer = callbacks.footer.apply(this, [tooltipItems]);
    const afterFooter = callbacks.afterFooter.apply(this, [tooltipItems]);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options) {
    const active = this._active;
    const data = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i, len;
    for (i = 0, len = active.length; i < len; ++i) {
      tooltipItems.push(createTooltipItem(this.chart, active[i]));
    }
    if (options.filter) {
      tooltipItems = tooltipItems.filter((element, index2, array) => options.filter(element, index2, array, data));
    }
    if (options.itemSort) {
      tooltipItems = tooltipItems.sort((a, b) => options.itemSort(a, b, data));
    }
    each(tooltipItems, (context) => {
      const scoped = overrideCallbacks(options.callbacks, context);
      labelColors.push(scoped.labelColor.call(this, context));
      labelPointStyles.push(scoped.labelPointStyle.call(this, context));
      labelTextColors.push(scoped.labelTextColor.call(this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options = this.options.setContext(this.getContext());
    const active = this._active;
    let properties;
    let tooltipItems = [];
    if (!active.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position = positioners$1[options.position].call(this, active, this._eventPosition);
      tooltipItems = this._createItems(options);
      this.title = this.getTitle(tooltipItems, options);
      this.beforeBody = this.getBeforeBody(tooltipItems, options);
      this.body = this.getBody(tooltipItems, options);
      this.afterBody = this.getAfterBody(tooltipItems, options);
      this.footer = this.getFooter(tooltipItems, options);
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, size);
      const alignment = determineAlignment(this.chart, options, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size.width,
        height: size.height,
        caretX: position.x,
        caretY: position.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = void 0;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options.external) {
      options.external.call(this, { chart: this.chart, tooltip: this, replay });
    }
  }
  drawCaret(tooltipPoint, ctx, size, options) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size, options) {
    const { xAlign, yAlign } = this;
    const { caretSize, cornerRadius } = options;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
    const { x: ptX, y: ptY } = tooltipPoint;
    const { width, height } = size;
    let x1, x2, x3, y1, y2, y3;
    if (yAlign === "center") {
      y2 = ptY + height / 2;
      if (xAlign === "left") {
        x1 = ptX;
        x2 = x1 - caretSize;
        y1 = y2 + caretSize;
        y3 = y2 - caretSize;
      } else {
        x1 = ptX + width;
        x2 = x1 + caretSize;
        y1 = y2 - caretSize;
        y3 = y2 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === "left") {
        x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
      } else if (xAlign === "right") {
        x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x2 = this.caretX;
      }
      if (yAlign === "top") {
        y1 = ptY;
        y2 = y1 - caretSize;
        x1 = x2 - caretSize;
        x3 = x2 + caretSize;
      } else {
        y1 = ptY + height;
        y2 = y1 + caretSize;
        x1 = x2 + caretSize;
        x3 = x2 - caretSize;
      }
      y3 = y1;
    }
    return { x1, x2, x3, y1, y2, y3 };
  }
  drawTitle(pt, ctx, options) {
    const title = this.title;
    const length = title.length;
    let titleFont, titleSpacing, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.titleAlign, options);
      ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
      ctx.textBaseline = "middle";
      titleFont = toFont(options.titleFont);
      titleSpacing = options.titleSpacing;
      ctx.fillStyle = options.titleColor;
      ctx.font = titleFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
        pt.y += titleFont.lineHeight + titleSpacing;
        if (i + 1 === length) {
          pt.y += options.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt, i, rtlHelper, options) {
    const labelColors = this.labelColors[i];
    const labelPointStyle = this.labelPointStyles[i];
    const { boxHeight, boxWidth, boxPadding } = options;
    const bodyFont = toFont(options.bodyFont);
    const colorX = getAlignedX(this, "left", options);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt.y + yOffSet;
    if (options.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options.multiKeyBackground;
      ctx.fillStyle = options.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColors.borderColor;
      ctx.fillStyle = labelColors.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = isObject(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
      ctx.strokeStyle = labelColors.borderColor;
      ctx.setLineDash(labelColors.borderDash || []);
      ctx.lineDashOffset = labelColors.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
      const borderRadius = toTRBLCorners(labelColors.borderRadius);
      if (Object.values(borderRadius).some((v) => v !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColors.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColors.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i];
  }
  drawBody(pt, ctx, options) {
    const { body } = this;
    const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
    const bodyFont = toFont(options.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
    const fillLineOfText = function(line) {
      ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
      pt.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = "middle";
    ctx.font = bodyFont.string;
    pt.x = getAlignedX(this, bodyAlignForCalculation, options);
    ctx.fillStyle = options.bodyColor;
    each(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
    for (i = 0, ilen = body.length; i < ilen; ++i) {
      bodyItem = body[i];
      textColor = this.labelTextColors[i];
      ctx.fillStyle = textColor;
      each(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt, i, rtlHelper, options);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each(this.afterBody, fillLineOfText);
    pt.y -= bodySpacing;
  }
  drawFooter(pt, ctx, options) {
    const footer = this.footer;
    const length = footer.length;
    let footerFont, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.footerAlign, options);
      pt.y += options.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
      ctx.textBaseline = "middle";
      footerFont = toFont(options.footerFont);
      ctx.fillStyle = options.footerColor;
      ctx.font = footerFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
        pt.y += footerFont.lineHeight + options.footerSpacing;
      }
    }
  }
  drawBackground(pt, ctx, tooltipSize, options) {
    const { xAlign, yAlign } = this;
    const { x, y } = pt;
    const { width, height } = tooltipSize;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(options.cornerRadius);
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x + topLeft, y);
    if (yAlign === "top") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width - topRight, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
    if (yAlign === "center" && xAlign === "right") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width, y + height - bottomRight);
    ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
    if (yAlign === "bottom") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + bottomLeft, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
    if (yAlign === "center" && xAlign === "left") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x, y + topLeft);
    ctx.quadraticCurveTo(x, y, x + topLeft, y);
    ctx.closePath();
    ctx.fill();
    if (options.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position = positioners$1[options.position].call(this, this._active, this._eventPosition);
      if (!position) {
        return;
      }
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, this._size);
      const alignment = determineAlignment(chart, options, positionAndSize);
      const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size.width;
        this.height = size.height;
        this.caretX = position.x;
        this.caretY = position.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(ctx) {
    const options = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt, ctx, tooltipSize, options);
      overrideTextDirection(ctx, options.textDirection);
      pt.y += padding.top;
      this.drawTitle(pt, ctx, options);
      this.drawBody(pt, ctx, options);
      this.drawFooter(pt, ctx, options);
      restoreTextDirection(ctx, options.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("Cannot find a dataset at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(lastActive, active);
    const positionChanged = this._positionChanged(active, eventPosition);
    if (changed || positionChanged) {
      this._active = active;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options = this.options;
    const lastActive = this._active || [];
    const active = this._getActiveElements(e, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active, e);
    const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
    if (changed) {
      this._active = active;
      if (options.enabled || options.external) {
        this._eventPosition = {
          x: e.x,
          y: e.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  }
  _positionChanged(active, e) {
    const { caretX, caretY, options } = this;
    const position = positioners$1[options.position].call(this, active, e);
    return position !== false && (caretX !== position.x || caretY !== position.y);
  }
}
Tooltip.positioners = positioners$1;
var plugin_tooltip = {
  id: "tooltip",
  _element: Tooltip,
  positioners: positioners$1,
  afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip({ chart, options });
    }
  },
  beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    if (tooltip && tooltip._willRender()) {
      const args = {
        tooltip
      };
      if (chart.notifyPlugins("beforeTooltipDraw", args) === false) {
        return;
      }
      tooltip.draw(chart.ctx);
      chart.notifyPlugins("afterTooltipDraw", args);
    }
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: true,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: ["x", "y", "width", "height", "caretX", "caretY"]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: {
      beforeTitle: noop,
      title(tooltipItems) {
        if (tooltipItems.length > 0) {
          const item = tooltipItems[0];
          const labels = item.chart.data.labels;
          const labelCount = labels ? labels.length : 0;
          if (this && this.options && this.options.mode === "dataset") {
            return item.dataset.label || "";
          } else if (item.label) {
            return item.label;
          } else if (labelCount > 0 && item.dataIndex < labelCount) {
            return labels[item.dataIndex];
          }
        }
        return "";
      },
      afterTitle: noop,
      beforeBody: noop,
      beforeLabel: noop,
      label(tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") {
          return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        }
        let label = tooltipItem.dataset.label || "";
        if (label) {
          label += ": ";
        }
        const value = tooltipItem.formattedValue;
        if (!isNullOrUndef(value)) {
          label += value;
        }
        return label;
      },
      labelColor(tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          borderColor: options.borderColor,
          backgroundColor: options.backgroundColor,
          borderWidth: options.borderWidth,
          borderDash: options.borderDash,
          borderDashOffset: options.borderDashOffset,
          borderRadius: 0
        };
      },
      labelTextColor() {
        return this.options.bodyColor;
      },
      labelPointStyle(tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
          pointStyle: options.pointStyle,
          rotation: options.rotation
        };
      },
      afterLabel: noop,
      afterBody: noop,
      beforeFooter: noop,
      footer: noop,
      afterFooter: noop
    }
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (name) => name !== "filter" && name !== "itemSort" && name !== "external",
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: ["interaction"]
};
var plugins = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Decimation: plugin_decimation,
  Filler: index,
  Legend: plugin_legend,
  SubTitle: plugin_subtitle,
  Title: plugin_title,
  Tooltip: plugin_tooltip
});
const addIfString = (labels, raw, index2, addedLabels) => {
  if (typeof raw === "string") {
    index2 = labels.push(raw) - 1;
    addedLabels.unshift({ index: index2, label: raw });
  } else if (isNaN(raw)) {
    index2 = null;
  }
  return index2;
};
function findOrAddLabel(labels, raw, index2, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index2, addedLabels);
  }
  const last = labels.lastIndexOf(raw);
  return first !== last ? index2 : first;
}
const validIndex = (index2, max2) => index2 === null ? null : _limitValue(Math.round(index2), 0, max2);
class CategoryScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this._startValue = void 0;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const { index: index2, label } of added) {
        if (labels[index2] === label) {
          labels.splice(index2, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index2 = isFinite(index2) && labels[index2] === raw ? index2 : findOrAddLabel(labels, raw, valueOrDefault(index2, raw), this._addedLabels);
    return validIndex(index2, labels.length - 1);
  }
  determineDataLimits() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min: min2, max: max2 } = this.getMinMax(true);
    if (this.options.bounds === "ticks") {
      if (!minDefined) {
        min2 = 0;
      }
      if (!maxDefined) {
        max2 = this.getLabels().length - 1;
      }
    }
    this.min = min2;
    this.max = max2;
  }
  buildTicks() {
    const min2 = this.min;
    const max2 = this.max;
    const offset2 = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = min2 === 0 && max2 === labels.length - 1 ? labels : labels.slice(min2, max2 + 1);
    this._valueRange = Math.max(labels.length - (offset2 ? 0 : 1), 1);
    this._startValue = this.min - (offset2 ? 0.5 : 0);
    for (let value = min2; value <= max2; value++) {
      ticks.push({ value });
    }
    return ticks;
  }
  getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) {
      return labels[value];
    }
    return value;
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value) {
    if (typeof value !== "number") {
      value = this.parse(value);
    }
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
CategoryScale.id = "category";
CategoryScale.defaults = {
  ticks: {
    callback: CategoryScale.prototype.getLabelForValue
  }
};
function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING = 1e-14;
  const { bounds, step, min: min2, max: max2, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const { min: rmin, max: rmax } = dataRange;
  const minDefined = !isNullOrUndef(min2);
  const maxDefined = !isNullOrUndef(max2);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
    return [{ value: rmin }, { value: rmax }];
  }
  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }
  if (bounds === "ticks") {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max2 - min2) / step, spacing / 1e3)) {
    numSpaces = Math.round(Math.min((max2 - min2) / spacing, maxTicks));
    spacing = (max2 - min2) / numSpaces;
    niceMin = min2;
    niceMax = max2;
  } else if (countDefined) {
    niceMin = minDefined ? min2 : niceMin;
    niceMax = maxDefined ? max2 : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1e3)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(
    _decimalPlaces(spacing),
    _decimalPlaces(niceMin)
  );
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min2) {
      ticks.push({ value: min2 });
      if (niceMin < min2) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min2, relativeLabelSize(min2, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min2) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    ticks.push({ value: Math.round((niceMin + j * spacing) * factor) / factor });
  }
  if (maxDefined && includeBounds && niceMax !== max2) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max2, relativeLabelSize(max2, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max2;
    } else {
      ticks.push({ value: max2 });
    }
  } else if (!maxDefined || niceMax === max2) {
    ticks.push({ value: niceMax });
  }
  return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 1e-3;
  const length = 0.75 * minSpacing * ("" + value).length;
  return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._endValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const { beginAtZero } = this.options;
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min: min2, max: max2 } = this;
    const setMin = (v) => min2 = minDefined ? min2 : v;
    const setMax = (v) => max2 = maxDefined ? max2 : v;
    if (beginAtZero) {
      const minSign = sign(min2);
      const maxSign = sign(max2);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min2 === max2) {
      let offset2 = 1;
      if (max2 >= Number.MAX_SAFE_INTEGER || min2 <= Number.MIN_SAFE_INTEGER) {
        offset2 = Math.abs(max2 * 0.05);
      }
      setMax(max2 + offset2);
      if (!beginAtZero) {
        setMin(min2 - offset2);
      }
    }
    this.min = min2;
    this.max = max2;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let { maxTicksLimit, stepSize } = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1e3) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1e3;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start2 = this.min;
    let end2 = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset2 = (end2 - start2) / Math.max(ticks.length - 1, 1) / 2;
      start2 -= offset2;
      end2 += offset2;
    }
    this._startValue = start2;
    this._endValue = end2;
    this._valueRange = end2 - start2;
  }
  getLabelForValue(value) {
    return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
}
class LinearScale extends LinearScaleBase {
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(true);
    this.min = isNumberFinite(min2) ? min2 : 0;
    this.max = isNumberFinite(max2) ? max2 : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 1e-3;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value) {
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
}
LinearScale.id = "linear";
LinearScale.defaults = {
  ticks: {
    callback: Ticks.formatters.numeric
  }
};
function isMajor(tickVal) {
  const remain = tickVal / Math.pow(10, Math.floor(log10(tickVal)));
  return remain === 1;
}
function generateTicks(generationOptions, dataRange) {
  const endExp = Math.floor(log10(dataRange.max));
  const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
  const ticks = [];
  let tickVal = finiteOrDefault(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
  let exp = Math.floor(log10(tickVal));
  let significand = Math.floor(tickVal / Math.pow(10, exp));
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  do {
    ticks.push({ value: tickVal, major: isMajor(tickVal) });
    ++significand;
    if (significand === 10) {
      significand = 1;
      ++exp;
      precision = exp >= 0 ? 1 : precision;
    }
    tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
  } while (exp < endExp || exp === endExp && significand < endSignificand);
  const lastTick = finiteOrDefault(generationOptions.max, tickVal);
  ticks.push({ value: lastTick, major: isMajor(tickVal) });
  return ticks;
}
class LogarithmicScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    const value = LinearScaleBase.prototype.parse.apply(this, [raw, index2]);
    if (value === 0) {
      this._zero = true;
      return void 0;
    }
    return isNumberFinite(value) && value > 0 ? value : null;
  }
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(true);
    this.min = isNumberFinite(min2) ? Math.max(0, min2) : null;
    this.max = isNumberFinite(max2) ? Math.max(0, max2) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let min2 = this.min;
    let max2 = this.max;
    const setMin = (v) => min2 = minDefined ? min2 : v;
    const setMax = (v) => max2 = maxDefined ? max2 : v;
    const exp = (v, m) => Math.pow(10, Math.floor(log10(v)) + m);
    if (min2 === max2) {
      if (min2 <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(exp(min2, -1));
        setMax(exp(max2, 1));
      }
    }
    if (min2 <= 0) {
      setMin(exp(max2, -1));
    }
    if (max2 <= 0) {
      setMax(exp(min2, 1));
    }
    if (this._zero && this.min !== this._suggestedMin && min2 === exp(this.min, 0)) {
      setMin(exp(min2, -1));
    }
    this.min = min2;
    this.max = max2;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value) {
    return value === void 0 ? "0" : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start2 = this.min;
    super.configure();
    this._startValue = log10(start2);
    this._valueRange = log10(this.max) - log10(start2);
  }
  getPixelForValue(value) {
    if (value === void 0 || value === 0) {
      value = this.min;
    }
    if (value === null || isNaN(value)) {
      return NaN;
    }
    return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal * this._valueRange);
  }
}
LogarithmicScale.id = "logarithmic";
LogarithmicScale.defaults = {
  ticks: {
    callback: Ticks.formatters.logarithmic,
    major: {
      enabled: true
    }
  }
};
function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults$1.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [label];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle, pos, size, min2, max2) {
  if (angle === min2 || angle === max2) {
    return {
      start: pos - size / 2,
      end: pos + size / 2
    };
  } else if (angle < min2 || angle > max2) {
    return {
      start: pos - size,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size
  };
}
function fitWithPointLabels(scale) {
  const orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale._pointLabels.length;
  const pointLabelOpts = scale.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
    padding[i] = opts.padding;
    const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
    labelSizes[i] = textSize;
    const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
    const angle = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale.setCenterPoint(
    orig.l - limits.l,
    limits.r - orig.r,
    orig.t - limits.t,
    limits.b - orig.b
  );
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle));
  const cos = Math.abs(Math.cos(angle));
  let x = 0;
  let y = 0;
  if (hLimits.start < orig.l) {
    x = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x);
  } else if (hLimits.end > orig.r) {
    x = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x);
  }
  if (vLimits.start < orig.t) {
    y = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y);
  } else if (vLimits.end > orig.b) {
    y = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y);
  }
}
function buildPointLabelItems(scale, labelSizes, padding) {
  const items = [];
  const valueCount = scale._pointLabels.length;
  const opts = scale.options;
  const extra = getTickBackdropHeight(opts) / 2;
  const outerDistance = scale.drawingArea;
  const additionalAngle = opts.pointLabels.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
    const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
    const size = labelSizes[i];
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left2 = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    items.push({
      x: pointLabelPosition.x,
      y,
      textAlign,
      left: left2,
      top: y,
      right: left2 + size.w,
      bottom: y + size.h
    });
  }
  return items;
}
function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return "center";
  } else if (angle < 180) {
    return "left";
  }
  return "right";
}
function leftForTextAlign(x, w, align) {
  if (align === "right") {
    x -= w;
  } else if (align === "center") {
    x -= w / 2;
  }
  return x;
}
function yForAngle(y, h3, angle) {
  if (angle === 90 || angle === 270) {
    y -= h3 / 2;
  } else if (angle > 270 || angle < 90) {
    y -= h3;
  }
  return y;
}
function drawPointLabels(scale, labelCount) {
  const { ctx, options: { pointLabels } } = scale;
  for (let i = labelCount - 1; i >= 0; i--) {
    const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
    const plFont = toFont(optsAtIndex.font);
    const { x, y, textAlign, left: left2, top: top2, right: right2, bottom: bottom2 } = scale._pointLabelItems[i];
    const { backdropColor } = optsAtIndex;
    if (!isNullOrUndef(backdropColor)) {
      const borderRadius = toTRBLCorners(optsAtIndex.borderRadius);
      const padding = toPadding(optsAtIndex.backdropPadding);
      ctx.fillStyle = backdropColor;
      const backdropLeft = left2 - padding.left;
      const backdropTop = top2 - padding.top;
      const backdropWidth = right2 - left2 + padding.width;
      const backdropHeight = bottom2 - top2 + padding.height;
      if (Object.values(borderRadius).some((v) => v !== 0)) {
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: backdropLeft,
          y: backdropTop,
          w: backdropWidth,
          h: backdropHeight,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
      }
    }
    renderText(
      ctx,
      scale._pointLabels[i],
      x,
      y + plFont.lineHeight / 2,
      plFont,
      {
        color: optsAtIndex.color,
        textAlign,
        textBaseline: "middle"
      }
    );
  }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
  const { ctx } = scale;
  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    let pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;
  const { color: color2, lineWidth } = gridLineOpts;
  if (!circular && !labelCount || !color2 || !lineWidth || radius < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color2;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(gridLineOpts.borderDash);
  ctx.lineDashOffset = gridLineOpts.borderDashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index2, label) {
  return createContext(parent, {
    label,
    index: index2,
    type: "pointLabel"
  });
}
class RadialLinearScale extends LinearScaleBase {
  constructor(cfg) {
    super(cfg);
    this.xCenter = void 0;
    this.yCenter = void 0;
    this.drawingArea = void 0;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w = this.width = this.maxWidth - padding.width;
    const h3 = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h3 / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w, h3) / 2);
  }
  determineDataLimits() {
    const { min: min2, max: max2 } = this.getMinMax(false);
    this.min = isNumberFinite(min2) && !isNaN(min2) ? min2 : 0;
    this.max = isNumberFinite(max2) && !isNaN(max2) ? max2 : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels().map((value, index2) => {
      const label = callback(this.options.pointLabels.callback, [value, index2], this);
      return label || label === 0 ? label : "";
    }).filter((v, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index2) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index2 * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value) {
    if (isNullOrUndef(value)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value) * scalingFactor;
    }
    return (value - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance) {
    if (isNullOrUndef(distance)) {
      return NaN;
    }
    const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index2) {
    const pointLabels = this._pointLabels || [];
    if (index2 >= 0 && index2 < pointLabels.length) {
      const pointLabel = pointLabels[index2];
      return createPointLabelContext(this.getContext(), index2, pointLabel);
    }
  }
  getPointPosition(index2, distanceFromCenter, additionalAngle = 0) {
    const angle = this.getIndexAngle(index2) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle) * distanceFromCenter + this.yCenter,
      angle
    };
  }
  getPointPositionForValue(index2, value) {
    return this.getPointPosition(index2, this.getDistanceFromCenterForValue(value));
  }
  getBasePosition(index2) {
    return this.getPointPositionForValue(index2 || 0, this.getBaseValue());
  }
  getPointLabelPosition(index2) {
    const { left: left2, top: top2, right: right2, bottom: bottom2 } = this._pointLabelItems[index2];
    return {
      left: left2,
      top: top2,
      right: right2,
      bottom: bottom2
    };
  }
  drawBackground() {
    const { backgroundColor, grid: { circular } } = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const { angleLines, grid } = opts;
    const labelCount = this._pointLabels.length;
    let i, offset2, position;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index2) => {
        if (index2 !== 0) {
          offset2 = this.getDistanceFromCenterForValue(tick.value);
          const optsAtIndex = grid.setContext(this.getContext(index2 - 1));
          drawRadiusLine(this, optsAtIndex, offset2, labelCount);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const { color: color2, lineWidth } = optsAtIndex;
        if (!lineWidth || !color2) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color2;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset2 = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
        position = this.getPointPosition(i, offset2);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset2, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    this.ticks.forEach((tick, index2) => {
      if (index2 === 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index2));
      const tickFont = toFont(optsAtIndex.font);
      offset2 = this.getDistanceFromCenterForValue(this.ticks[index2].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(
          -width / 2 - padding.left,
          -offset2 - tickFont.size / 2 - padding.top,
          width + padding.width,
          tickFont.size + padding.height
        );
      }
      renderText(ctx, tick.label, 0, -offset2, tickFont, {
        color: optsAtIndex.color
      });
    });
    ctx.restore();
  }
  drawTitle() {
  }
}
RadialLinearScale.id = "radialLinear";
RadialLinearScale.defaults = {
  display: true,
  animate: true,
  position: "chartArea",
  angleLines: {
    display: true,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: false
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: true,
    callback: Ticks.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: true,
    font: {
      size: 10
    },
    callback(label) {
      return label;
    },
    padding: 5,
    centerPointLabels: false
  }
};
RadialLinearScale.defaultRoutes = {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
};
RadialLinearScale.descriptors = {
  angleLines: {
    _fallback: "grid"
  }
};
const INTERVALS = {
  millisecond: { common: true, size: 1, steps: 1e3 },
  second: { common: true, size: 1e3, steps: 60 },
  minute: { common: true, size: 6e4, steps: 60 },
  hour: { common: true, size: 36e5, steps: 24 },
  day: { common: true, size: 864e5, steps: 30 },
  week: { common: false, size: 6048e5, steps: 4 },
  month: { common: true, size: 2628e6, steps: 12 },
  quarter: { common: false, size: 7884e6, steps: 4 },
  year: { common: true, size: 3154e7 }
};
const UNITS = Object.keys(INTERVALS);
function sorter(a, b) {
  return a - b;
}
function parse(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale._adapter;
  const { parser, round: round2, isoWeekday } = scale._parseOpts;
  let value = input;
  if (typeof parser === "function") {
    value = parser(value);
  }
  if (!isNumberFinite(value)) {
    value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
  }
  if (value === null) {
    return null;
  }
  if (round2) {
    value = round2 === "week" && (isNumber(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round2);
  }
  return +value;
}
function determineUnitForAutoTicks(minUnit, min2, max2, capacity) {
  const ilen = UNITS.length;
  for (let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    const interval = INTERVALS[UNITS[i]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max2 - min2) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min2, max2) {
  for (let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    const unit = UNITS[i];
    if (INTERVALS[unit].common && scale._adapter.diff(max2, min2, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const { lo, hi } = _lookup(timestamps, time);
    const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale, ticks, map2, majorUnit) {
  const adapter = scale._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last = ticks[ticks.length - 1].value;
  let major, index2;
  for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
    index2 = map2[major];
    if (index2 >= 0) {
      ticks[index2].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
  const ticks = [];
  const map2 = {};
  const ilen = values.length;
  let i, value;
  for (i = 0; i < ilen; ++i) {
    value = values[i];
    map2[value] = i;
    ticks.push({
      value,
      major: false
    });
  }
  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map2, majorUnit);
}
class TimeScale extends Scale {
  constructor(props) {
    super(props);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = "day";
    this._majorUnit = void 0;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = void 0;
  }
  init(scaleOpts, opts) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    adapter.init(opts);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index2) {
    if (raw === void 0) {
      return null;
    }
    return parse(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options = this.options;
    const adapter = this._adapter;
    const unit = options.time.unit || "day";
    let { min: min2, max: max2, minDefined, maxDefined } = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min2 = Math.min(min2, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max2 = Math.max(max2, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options.bounds !== "ticks" || options.ticks.source !== "labels") {
        _applyBounds(this.getMinMax(false));
      }
    }
    min2 = isNumberFinite(min2) && !isNaN(min2) ? min2 : +adapter.startOf(Date.now(), unit);
    max2 = isNumberFinite(max2) && !isNaN(max2) ? max2 : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min2, max2 - 1);
    this.max = Math.max(min2 + 1, max2);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min2 = Number.POSITIVE_INFINITY;
    let max2 = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min2 = arr[0];
      max2 = arr[arr.length - 1];
    }
    return { min: min2, max: max2 };
  }
  buildTicks() {
    const options = this.options;
    const timeOpts = options.time;
    const tickOpts = options.ticks;
    const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
    if (options.bounds === "ticks" && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min2 = this.min;
    const max2 = this.max;
    const ticks = _filterBetween(timestamps, min2, max2);
    this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min2)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? void 0 : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  afterAutoSkip() {
    if (this.options.offsetAfterAutoskip) {
      this.initOffsets(this.ticks.map((tick) => +tick.value));
    }
  }
  initOffsets(timestamps) {
    let start2 = 0;
    let end2 = 0;
    let first, last;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start2 = 1 - first;
      } else {
        start2 = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end2 = last;
      } else {
        end2 = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit = timestamps.length < 3 ? 0.5 : 0.25;
    start2 = _limitValue(start2, 0, limit);
    end2 = _limitValue(end2, 0, limit);
    this._offsets = { start: start2, end: end2, factor: 1 / (start2 + 1 + end2) };
  }
  _generate() {
    const adapter = this._adapter;
    const min2 = this.min;
    const max2 = this.max;
    const options = this.options;
    const timeOpts = options.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min2, max2, this._getLabelCapacity(min2));
    const stepSize = valueOrDefault(timeOpts.stepSize, 1);
    const weekday = minor === "week" ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber(weekday) || weekday === true;
    const ticks = {};
    let first = min2;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, "isoWeek", weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? "day" : minor);
    if (adapter.diff(max2, min2, minor) > 1e5 * stepSize) {
      throw new Error(min2 + " and " + max2 + " are too far apart with stepSize of " + stepSize + " " + minor);
    }
    const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
    for (time = first, count = 0; time < max2; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max2 || options.bounds === "ticks" || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort((a, b) => a - b).map((x) => +x);
  }
  getLabelForValue(value) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value, timeOpts.tooltipFormat);
    }
    return adapter.format(value, timeOpts.displayFormats.datetime);
  }
  _tickFormatFunction(time, index2, ticks, format) {
    const options = this.options;
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index2];
    const major = majorUnit && majorFormat && tick && tick.major;
    const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    const formatter2 = options.ticks.callback;
    return formatter2 ? callback(formatter2, [label, index2, ticks], this) : label;
  }
  generateTickLabels(ticks) {
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      tick.label = this._tickFormatFunction(tick.value, i, ticks);
    }
  }
  getDecimalForValue(value) {
    return value === null ? NaN : (value - this.min) / (this.max - this.min);
  }
  getPixelForValue(value) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle);
    const sinRotation = Math.sin(angle);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
      h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [exampleTime], this._majorUnit), format);
    const size = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return this._cache.data = metas[0].controller.getAllParsedValues(this);
    }
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
    }
    return this._cache.data = this.normalize(timestamps);
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      timestamps.push(parse(this, labels[i]));
    }
    return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
  }
  normalize(values) {
    return _arrayUnique(values.sort(sorter));
  }
}
TimeScale.id = "time";
TimeScale.defaults = {
  bounds: "data",
  adapters: {},
  time: {
    parser: false,
    unit: false,
    round: false,
    isoWeekday: false,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    major: {
      enabled: false
    }
  }
};
function interpolate(table, val, reverse) {
  let lo = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      ({ lo, hi } = _lookupByKey(table, "pos", val));
    }
    ({ pos: prevSource, time: prevTarget } = table[lo]);
    ({ pos: nextSource, time: nextTarget } = table[hi]);
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      ({ lo, hi } = _lookupByKey(table, "time", val));
    }
    ({ time: prevSource, pos: prevTarget } = table[lo]);
    ({ time: nextSource, pos: nextTarget } = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
  constructor(props) {
    super(props);
    this._table = [];
    this._minPos = void 0;
    this._tableRange = void 0;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate(table, this.min);
    this._tableRange = interpolate(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const { min: min2, max: max2 } = this;
    const items = [];
    const table = [];
    let i, ilen, prev, curr, next;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr >= min2 && curr <= max2) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [
        { time: min2, pos: 0 },
        { time: max2, pos: 1 }
      ];
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next = items[i + 1];
      prev = items[i - 1];
      curr = items[i];
      if (Math.round((next + prev) / 2) !== curr) {
        table.push({ time: curr, pos: i / (ilen - 1) });
      }
    }
    return table;
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data.length && label.length) {
      timestamps = this.normalize(data.concat(label));
    } else {
      timestamps = data.length ? data : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value) {
    return (interpolate(this._table, value) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
  }
}
TimeSeriesScale.id = "timeseries";
TimeSeriesScale.defaults = TimeScale.defaults;
var scales = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale
});
const registerables = [
  controllers,
  elements,
  plugins,
  scales
];
Chart.register(...registerables);
/*!
 * chartjs-plugin-datalabels v2.1.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
var devicePixelRatio = function() {
  if (typeof window !== "undefined") {
    if (window.devicePixelRatio) {
      return window.devicePixelRatio;
    }
    var screen = window.screen;
    if (screen) {
      return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
    }
  }
  return 1;
}();
var utils = {
  toTextLines: function(inputs) {
    var lines = [];
    var input;
    inputs = [].concat(inputs);
    while (inputs.length) {
      input = inputs.pop();
      if (typeof input === "string") {
        lines.unshift.apply(lines, input.split("\n"));
      } else if (Array.isArray(input)) {
        inputs.push.apply(inputs, input);
      } else if (!isNullOrUndef(inputs)) {
        lines.unshift("" + input);
      }
    }
    return lines;
  },
  textSize: function(ctx, lines, font) {
    var items = [].concat(lines);
    var ilen = items.length;
    var prev = ctx.font;
    var width = 0;
    var i;
    ctx.font = font.string;
    for (i = 0; i < ilen; ++i) {
      width = Math.max(ctx.measureText(items[i]).width, width);
    }
    ctx.font = prev;
    return {
      height: ilen * font.lineHeight,
      width
    };
  },
  bound: function(min2, value, max2) {
    return Math.max(min2, Math.min(value, max2));
  },
  arrayDiff: function(a0, a1) {
    var prev = a0.slice();
    var updates = [];
    var i, j, ilen, v;
    for (i = 0, ilen = a1.length; i < ilen; ++i) {
      v = a1[i];
      j = prev.indexOf(v);
      if (j === -1) {
        updates.push([v, 1]);
      } else {
        prev.splice(j, 1);
      }
    }
    for (i = 0, ilen = prev.length; i < ilen; ++i) {
      updates.push([prev[i], -1]);
    }
    return updates;
  },
  rasterize: function(v) {
    return Math.round(v * devicePixelRatio) / devicePixelRatio;
  }
};
function orient(point, origin) {
  var x0 = origin.x;
  var y0 = origin.y;
  if (x0 === null) {
    return { x: 0, y: -1 };
  }
  if (y0 === null) {
    return { x: 1, y: 0 };
  }
  var dx = point.x - x0;
  var dy = point.y - y0;
  var ln = Math.sqrt(dx * dx + dy * dy);
  return {
    x: ln ? dx / ln : 0,
    y: ln ? dy / ln : -1
  };
}
function aligned(x, y, vx, vy, align) {
  switch (align) {
    case "center":
      vx = vy = 0;
      break;
    case "bottom":
      vx = 0;
      vy = 1;
      break;
    case "right":
      vx = 1;
      vy = 0;
      break;
    case "left":
      vx = -1;
      vy = 0;
      break;
    case "top":
      vx = 0;
      vy = -1;
      break;
    case "start":
      vx = -vx;
      vy = -vy;
      break;
    case "end":
      break;
    default:
      align *= Math.PI / 180;
      vx = Math.cos(align);
      vy = Math.sin(align);
      break;
  }
  return {
    x,
    y,
    vx,
    vy
  };
}
var R_INSIDE = 0;
var R_LEFT = 1;
var R_RIGHT = 2;
var R_BOTTOM = 4;
var R_TOP = 8;
function region(x, y, rect) {
  var res = R_INSIDE;
  if (x < rect.left) {
    res |= R_LEFT;
  } else if (x > rect.right) {
    res |= R_RIGHT;
  }
  if (y < rect.top) {
    res |= R_TOP;
  } else if (y > rect.bottom) {
    res |= R_BOTTOM;
  }
  return res;
}
function clipped(segment, area) {
  var x0 = segment.x0;
  var y0 = segment.y0;
  var x1 = segment.x1;
  var y1 = segment.y1;
  var r0 = region(x0, y0, area);
  var r1 = region(x1, y1, area);
  var r, x, y;
  while (true) {
    if (!(r0 | r1) || r0 & r1) {
      break;
    }
    r = r0 || r1;
    if (r & R_TOP) {
      x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
      y = area.top;
    } else if (r & R_BOTTOM) {
      x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
      y = area.bottom;
    } else if (r & R_RIGHT) {
      y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
      x = area.right;
    } else if (r & R_LEFT) {
      y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
      x = area.left;
    }
    if (r === r0) {
      x0 = x;
      y0 = y;
      r0 = region(x0, y0, area);
    } else {
      x1 = x;
      y1 = y;
      r1 = region(x1, y1, area);
    }
  }
  return {
    x0,
    x1,
    y0,
    y1
  };
}
function compute$1(range, config) {
  var anchor = config.anchor;
  var segment = range;
  var x, y;
  if (config.clamp) {
    segment = clipped(segment, config.area);
  }
  if (anchor === "start") {
    x = segment.x0;
    y = segment.y0;
  } else if (anchor === "end") {
    x = segment.x1;
    y = segment.y1;
  } else {
    x = (segment.x0 + segment.x1) / 2;
    y = (segment.y0 + segment.y1) / 2;
  }
  return aligned(x, y, range.vx, range.vy, config.align);
}
var positioners = {
  arc: function(el, config) {
    var angle = (el.startAngle + el.endAngle) / 2;
    var vx = Math.cos(angle);
    var vy = Math.sin(angle);
    var r0 = el.innerRadius;
    var r1 = el.outerRadius;
    return compute$1({
      x0: el.x + vx * r0,
      y0: el.y + vy * r0,
      x1: el.x + vx * r1,
      y1: el.y + vy * r1,
      vx,
      vy
    }, config);
  },
  point: function(el, config) {
    var v = orient(el, config.origin);
    var rx = v.x * el.options.radius;
    var ry = v.y * el.options.radius;
    return compute$1({
      x0: el.x - rx,
      y0: el.y - ry,
      x1: el.x + rx,
      y1: el.y + ry,
      vx: v.x,
      vy: v.y
    }, config);
  },
  bar: function(el, config) {
    var v = orient(el, config.origin);
    var x = el.x;
    var y = el.y;
    var sx = 0;
    var sy = 0;
    if (el.horizontal) {
      x = Math.min(el.x, el.base);
      sx = Math.abs(el.base - el.x);
    } else {
      y = Math.min(el.y, el.base);
      sy = Math.abs(el.base - el.y);
    }
    return compute$1({
      x0: x,
      y0: y + sy,
      x1: x + sx,
      y1: y,
      vx: v.x,
      vy: v.y
    }, config);
  },
  fallback: function(el, config) {
    var v = orient(el, config.origin);
    return compute$1({
      x0: el.x,
      y0: el.y,
      x1: el.x + (el.width || 0),
      y1: el.y + (el.height || 0),
      vx: v.x,
      vy: v.y
    }, config);
  }
};
var rasterize = utils.rasterize;
function boundingRects(model) {
  var borderWidth = model.borderWidth || 0;
  var padding = model.padding;
  var th = model.size.height;
  var tw = model.size.width;
  var tx = -tw / 2;
  var ty = -th / 2;
  return {
    frame: {
      x: tx - padding.left - borderWidth,
      y: ty - padding.top - borderWidth,
      w: tw + padding.width + borderWidth * 2,
      h: th + padding.height + borderWidth * 2
    },
    text: {
      x: tx,
      y: ty,
      w: tw,
      h: th
    }
  };
}
function getScaleOrigin(el, context) {
  var scale = context.chart.getDatasetMeta(context.datasetIndex).vScale;
  if (!scale) {
    return null;
  }
  if (scale.xCenter !== void 0 && scale.yCenter !== void 0) {
    return { x: scale.xCenter, y: scale.yCenter };
  }
  var pixel = scale.getBasePixel();
  return el.horizontal ? { x: pixel, y: null } : { x: null, y: pixel };
}
function getPositioner(el) {
  if (el instanceof ArcElement) {
    return positioners.arc;
  }
  if (el instanceof PointElement) {
    return positioners.point;
  }
  if (el instanceof BarElement) {
    return positioners.bar;
  }
  return positioners.fallback;
}
function drawRoundedRect(ctx, x, y, w, h3, radius) {
  var HALF_PI2 = Math.PI / 2;
  if (radius) {
    var r = Math.min(radius, h3 / 2, w / 2);
    var left2 = x + r;
    var top2 = y + r;
    var right2 = x + w - r;
    var bottom2 = y + h3 - r;
    ctx.moveTo(x, top2);
    if (left2 < right2 && top2 < bottom2) {
      ctx.arc(left2, top2, r, -Math.PI, -HALF_PI2);
      ctx.arc(right2, top2, r, -HALF_PI2, 0);
      ctx.arc(right2, bottom2, r, 0, HALF_PI2);
      ctx.arc(left2, bottom2, r, HALF_PI2, Math.PI);
    } else if (left2 < right2) {
      ctx.moveTo(left2, y);
      ctx.arc(right2, top2, r, -HALF_PI2, HALF_PI2);
      ctx.arc(left2, top2, r, HALF_PI2, Math.PI + HALF_PI2);
    } else if (top2 < bottom2) {
      ctx.arc(left2, top2, r, -Math.PI, 0);
      ctx.arc(left2, bottom2, r, 0, Math.PI);
    } else {
      ctx.arc(left2, top2, r, -Math.PI, Math.PI);
    }
    ctx.closePath();
    ctx.moveTo(x, y);
  } else {
    ctx.rect(x, y, w, h3);
  }
}
function drawFrame(ctx, rect, model) {
  var bgColor = model.backgroundColor;
  var borderColor = model.borderColor;
  var borderWidth = model.borderWidth;
  if (!bgColor && (!borderColor || !borderWidth)) {
    return;
  }
  ctx.beginPath();
  drawRoundedRect(
    ctx,
    rasterize(rect.x) + borderWidth / 2,
    rasterize(rect.y) + borderWidth / 2,
    rasterize(rect.w) - borderWidth,
    rasterize(rect.h) - borderWidth,
    model.borderRadius
  );
  ctx.closePath();
  if (bgColor) {
    ctx.fillStyle = bgColor;
    ctx.fill();
  }
  if (borderColor && borderWidth) {
    ctx.strokeStyle = borderColor;
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = "miter";
    ctx.stroke();
  }
}
function textGeometry(rect, align, font) {
  var h3 = font.lineHeight;
  var w = rect.w;
  var x = rect.x;
  var y = rect.y + h3 / 2;
  if (align === "center") {
    x += w / 2;
  } else if (align === "end" || align === "right") {
    x += w;
  }
  return {
    h: h3,
    w,
    x,
    y
  };
}
function drawTextLine(ctx, text, cfg) {
  var shadow = ctx.shadowBlur;
  var stroked = cfg.stroked;
  var x = rasterize(cfg.x);
  var y = rasterize(cfg.y);
  var w = rasterize(cfg.w);
  if (stroked) {
    ctx.strokeText(text, x, y, w);
  }
  if (cfg.filled) {
    if (shadow && stroked) {
      ctx.shadowBlur = 0;
    }
    ctx.fillText(text, x, y, w);
    if (shadow && stroked) {
      ctx.shadowBlur = shadow;
    }
  }
}
function drawText(ctx, lines, rect, model) {
  var align = model.textAlign;
  var color2 = model.color;
  var filled = !!color2;
  var font = model.font;
  var ilen = lines.length;
  var strokeColor = model.textStrokeColor;
  var strokeWidth = model.textStrokeWidth;
  var stroked = strokeColor && strokeWidth;
  var i;
  if (!ilen || !filled && !stroked) {
    return;
  }
  rect = textGeometry(rect, align, font);
  ctx.font = font.string;
  ctx.textAlign = align;
  ctx.textBaseline = "middle";
  ctx.shadowBlur = model.textShadowBlur;
  ctx.shadowColor = model.textShadowColor;
  if (filled) {
    ctx.fillStyle = color2;
  }
  if (stroked) {
    ctx.lineJoin = "round";
    ctx.lineWidth = strokeWidth;
    ctx.strokeStyle = strokeColor;
  }
  for (i = 0, ilen = lines.length; i < ilen; ++i) {
    drawTextLine(ctx, lines[i], {
      stroked,
      filled,
      w: rect.w,
      x: rect.x,
      y: rect.y + rect.h * i
    });
  }
}
var Label = function(config, ctx, el, index2) {
  var me = this;
  me._config = config;
  me._index = index2;
  me._model = null;
  me._rects = null;
  me._ctx = ctx;
  me._el = el;
};
merge(Label.prototype, {
  _modelize: function(display, lines, config, context) {
    var me = this;
    var index2 = me._index;
    var font = toFont(resolve([config.font, {}], context, index2));
    var color2 = resolve([config.color, defaults$1.color], context, index2);
    return {
      align: resolve([config.align, "center"], context, index2),
      anchor: resolve([config.anchor, "center"], context, index2),
      area: context.chart.chartArea,
      backgroundColor: resolve([config.backgroundColor, null], context, index2),
      borderColor: resolve([config.borderColor, null], context, index2),
      borderRadius: resolve([config.borderRadius, 0], context, index2),
      borderWidth: resolve([config.borderWidth, 0], context, index2),
      clamp: resolve([config.clamp, false], context, index2),
      clip: resolve([config.clip, false], context, index2),
      color: color2,
      display,
      font,
      lines,
      offset: resolve([config.offset, 4], context, index2),
      opacity: resolve([config.opacity, 1], context, index2),
      origin: getScaleOrigin(me._el, context),
      padding: toPadding(resolve([config.padding, 4], context, index2)),
      positioner: getPositioner(me._el),
      rotation: resolve([config.rotation, 0], context, index2) * (Math.PI / 180),
      size: utils.textSize(me._ctx, lines, font),
      textAlign: resolve([config.textAlign, "start"], context, index2),
      textShadowBlur: resolve([config.textShadowBlur, 0], context, index2),
      textShadowColor: resolve([config.textShadowColor, color2], context, index2),
      textStrokeColor: resolve([config.textStrokeColor, color2], context, index2),
      textStrokeWidth: resolve([config.textStrokeWidth, 0], context, index2)
    };
  },
  update: function(context) {
    var me = this;
    var model = null;
    var rects = null;
    var index2 = me._index;
    var config = me._config;
    var value, label, lines;
    var display = resolve([config.display, true], context, index2);
    if (display) {
      value = context.dataset.data[index2];
      label = valueOrDefault(callback(config.formatter, [value, context]), value);
      lines = isNullOrUndef(label) ? [] : utils.toTextLines(label);
      if (lines.length) {
        model = me._modelize(display, lines, config, context);
        rects = boundingRects(model);
      }
    }
    me._model = model;
    me._rects = rects;
  },
  geometry: function() {
    return this._rects ? this._rects.frame : {};
  },
  rotation: function() {
    return this._model ? this._model.rotation : 0;
  },
  visible: function() {
    return this._model && this._model.opacity;
  },
  model: function() {
    return this._model;
  },
  draw: function(chart, center) {
    var me = this;
    var ctx = chart.ctx;
    var model = me._model;
    var rects = me._rects;
    var area;
    if (!this.visible()) {
      return;
    }
    ctx.save();
    if (model.clip) {
      area = model.area;
      ctx.beginPath();
      ctx.rect(
        area.left,
        area.top,
        area.right - area.left,
        area.bottom - area.top
      );
      ctx.clip();
    }
    ctx.globalAlpha = utils.bound(0, model.opacity, 1);
    ctx.translate(rasterize(center.x), rasterize(center.y));
    ctx.rotate(model.rotation);
    drawFrame(ctx, rects.frame, model);
    drawText(ctx, model.lines, rects.text, model);
    ctx.restore();
  }
});
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
function rotated(point, center, angle) {
  var cos = Math.cos(angle);
  var sin = Math.sin(angle);
  var cx = center.x;
  var cy = center.y;
  return {
    x: cx + cos * (point.x - cx) - sin * (point.y - cy),
    y: cy + sin * (point.x - cx) + cos * (point.y - cy)
  };
}
function projected(points, axis) {
  var min2 = MAX_INTEGER;
  var max2 = MIN_INTEGER;
  var origin = axis.origin;
  var i, pt, vx, vy, dp;
  for (i = 0; i < points.length; ++i) {
    pt = points[i];
    vx = pt.x - origin.x;
    vy = pt.y - origin.y;
    dp = axis.vx * vx + axis.vy * vy;
    min2 = Math.min(min2, dp);
    max2 = Math.max(max2, dp);
  }
  return {
    min: min2,
    max: max2
  };
}
function toAxis(p0, p1) {
  var vx = p1.x - p0.x;
  var vy = p1.y - p0.y;
  var ln = Math.sqrt(vx * vx + vy * vy);
  return {
    vx: (p1.x - p0.x) / ln,
    vy: (p1.y - p0.y) / ln,
    origin: p0,
    ln
  };
}
var HitBox = function() {
  this._rotation = 0;
  this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
};
merge(HitBox.prototype, {
  center: function() {
    var r = this._rect;
    return {
      x: r.x + r.w / 2,
      y: r.y + r.h / 2
    };
  },
  update: function(center, rect, rotation) {
    this._rotation = rotation;
    this._rect = {
      x: rect.x + center.x,
      y: rect.y + center.y,
      w: rect.w,
      h: rect.h
    };
  },
  contains: function(point) {
    var me = this;
    var margin = 1;
    var rect = me._rect;
    point = rotated(point, me.center(), -me._rotation);
    return !(point.x < rect.x - margin || point.y < rect.y - margin || point.x > rect.x + rect.w + margin * 2 || point.y > rect.y + rect.h + margin * 2);
  },
  intersects: function(other) {
    var r0 = this._points();
    var r1 = other._points();
    var axes = [
      toAxis(r0[0], r0[1]),
      toAxis(r0[0], r0[3])
    ];
    var i, pr0, pr1;
    if (this._rotation !== other._rotation) {
      axes.push(
        toAxis(r1[0], r1[1]),
        toAxis(r1[0], r1[3])
      );
    }
    for (i = 0; i < axes.length; ++i) {
      pr0 = projected(r0, axes[i]);
      pr1 = projected(r1, axes[i]);
      if (pr0.max < pr1.min || pr1.max < pr0.min) {
        return false;
      }
    }
    return true;
  },
  _points: function() {
    var me = this;
    var rect = me._rect;
    var angle = me._rotation;
    var center = me.center();
    return [
      rotated({ x: rect.x, y: rect.y }, center, angle),
      rotated({ x: rect.x + rect.w, y: rect.y }, center, angle),
      rotated({ x: rect.x + rect.w, y: rect.y + rect.h }, center, angle),
      rotated({ x: rect.x, y: rect.y + rect.h }, center, angle)
    ];
  }
});
function coordinates(el, model, geometry) {
  var point = model.positioner(el, model);
  var vx = point.vx;
  var vy = point.vy;
  if (!vx && !vy) {
    return { x: point.x, y: point.y };
  }
  var w = geometry.w;
  var h3 = geometry.h;
  var rotation = model.rotation;
  var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h3 / 2 * Math.sin(rotation));
  var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h3 / 2 * Math.cos(rotation));
  var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
  dx *= vx * vs;
  dy *= vy * vs;
  dx += model.offset * vx;
  dy += model.offset * vy;
  return {
    x: point.x + dx,
    y: point.y + dy
  };
}
function collide(labels, collider) {
  var i, j, s0, s1;
  for (i = labels.length - 1; i >= 0; --i) {
    s0 = labels[i].$layout;
    for (j = i - 1; j >= 0 && s0._visible; --j) {
      s1 = labels[j].$layout;
      if (s1._visible && s0._box.intersects(s1._box)) {
        collider(s0, s1);
      }
    }
  }
  return labels;
}
function compute(labels) {
  var i, ilen, label, state, geometry, center, proxy;
  for (i = 0, ilen = labels.length; i < ilen; ++i) {
    label = labels[i];
    state = label.$layout;
    if (state._visible) {
      proxy = new Proxy(label._el, { get: (el, p) => el.getProps([p], true)[p] });
      geometry = label.geometry();
      center = coordinates(proxy, label.model(), geometry);
      state._box.update(center, geometry, label.rotation());
    }
  }
  return collide(labels, function(s0, s1) {
    var h0 = s0._hidable;
    var h12 = s1._hidable;
    if (h0 && h12 || h12) {
      s1._visible = false;
    } else if (h0) {
      s0._visible = false;
    }
  });
}
var layout = {
  prepare: function(datasets) {
    var labels = [];
    var i, j, ilen, jlen, label;
    for (i = 0, ilen = datasets.length; i < ilen; ++i) {
      for (j = 0, jlen = datasets[i].length; j < jlen; ++j) {
        label = datasets[i][j];
        labels.push(label);
        label.$layout = {
          _box: new HitBox(),
          _hidable: false,
          _visible: true,
          _set: i,
          _idx: label._index
        };
      }
    }
    labels.sort(function(a, b) {
      var sa = a.$layout;
      var sb = b.$layout;
      return sa._idx === sb._idx ? sb._set - sa._set : sb._idx - sa._idx;
    });
    this.update(labels);
    return labels;
  },
  update: function(labels) {
    var dirty = false;
    var i, ilen, label, model, state;
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      label = labels[i];
      model = label.model();
      state = label.$layout;
      state._hidable = model && model.display === "auto";
      state._visible = label.visible();
      dirty |= state._hidable;
    }
    if (dirty) {
      compute(labels);
    }
  },
  lookup: function(labels, point) {
    var i, state;
    for (i = labels.length - 1; i >= 0; --i) {
      state = labels[i].$layout;
      if (state && state._visible && state._box.contains(point)) {
        return labels[i];
      }
    }
    return null;
  },
  draw: function(chart, labels) {
    var i, ilen, label, state, geometry, center;
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      label = labels[i];
      state = label.$layout;
      if (state._visible) {
        geometry = label.geometry();
        center = coordinates(label._el, label.model(), geometry);
        state._box.update(center, geometry, label.rotation());
        label.draw(chart, center);
      }
    }
  }
};
var formatter = function(value) {
  if (isNullOrUndef(value)) {
    return null;
  }
  var label = value;
  var keys, klen, k;
  if (isObject(value)) {
    if (!isNullOrUndef(value.label)) {
      label = value.label;
    } else if (!isNullOrUndef(value.r)) {
      label = value.r;
    } else {
      label = "";
      keys = Object.keys(value);
      for (k = 0, klen = keys.length; k < klen; ++k) {
        label += (k !== 0 ? ", " : "") + keys[k] + ": " + value[keys[k]];
      }
    }
  }
  return "" + label;
};
var defaults = {
  align: "center",
  anchor: "center",
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: false,
  clip: false,
  color: void 0,
  display: true,
  font: {
    family: void 0,
    lineHeight: 1.2,
    size: void 0,
    style: void 0,
    weight: null
  },
  formatter,
  labels: void 0,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: "start",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: void 0
};
var EXPANDO_KEY = "$datalabels";
var DEFAULT_KEY = "$default";
function configure(dataset, options) {
  var override = dataset.datalabels;
  var listeners = {};
  var configs = [];
  var labels, keys;
  if (override === false) {
    return null;
  }
  if (override === true) {
    override = {};
  }
  options = merge({}, [options, override]);
  labels = options.labels || {};
  keys = Object.keys(labels);
  delete options.labels;
  if (keys.length) {
    keys.forEach(function(key) {
      if (labels[key]) {
        configs.push(merge({}, [
          options,
          labels[key],
          { _key: key }
        ]));
      }
    });
  } else {
    configs.push(options);
  }
  listeners = configs.reduce(function(target, config) {
    each(config.listeners || {}, function(fn2, event) {
      target[event] = target[event] || {};
      target[event][config._key || DEFAULT_KEY] = fn2;
    });
    delete config.listeners;
    return target;
  }, {});
  return {
    labels: configs,
    listeners
  };
}
function dispatchEvent(chart, listeners, label, event) {
  if (!listeners) {
    return;
  }
  var context = label.$context;
  var groups = label.$groups;
  var callback$1;
  if (!listeners[groups._set]) {
    return;
  }
  callback$1 = listeners[groups._set][groups._key];
  if (!callback$1) {
    return;
  }
  if (callback(callback$1, [context, event]) === true) {
    chart[EXPANDO_KEY]._dirty = true;
    label.update(context);
  }
}
function dispatchMoveEvents(chart, listeners, previous, label, event) {
  var enter, leave;
  if (!previous && !label) {
    return;
  }
  if (!previous) {
    enter = true;
  } else if (!label) {
    leave = true;
  } else if (previous !== label) {
    leave = enter = true;
  }
  if (leave) {
    dispatchEvent(chart, listeners.leave, previous, event);
  }
  if (enter) {
    dispatchEvent(chart, listeners.enter, label, event);
  }
}
function handleMoveEvents(chart, event) {
  var expando = chart[EXPANDO_KEY];
  var listeners = expando._listeners;
  var previous, label;
  if (!listeners.enter && !listeners.leave) {
    return;
  }
  if (event.type === "mousemove") {
    label = layout.lookup(expando._labels, event);
  } else if (event.type !== "mouseout") {
    return;
  }
  previous = expando._hovered;
  expando._hovered = label;
  dispatchMoveEvents(chart, listeners, previous, label, event);
}
function handleClickEvents(chart, event) {
  var expando = chart[EXPANDO_KEY];
  var handlers2 = expando._listeners.click;
  var label = handlers2 && layout.lookup(expando._labels, event);
  if (label) {
    dispatchEvent(chart, handlers2, label, event);
  }
}
var plugin = {
  id: "datalabels",
  defaults,
  beforeInit: function(chart) {
    chart[EXPANDO_KEY] = {
      _actives: []
    };
  },
  beforeUpdate: function(chart) {
    var expando = chart[EXPANDO_KEY];
    expando._listened = false;
    expando._listeners = {};
    expando._datasets = [];
    expando._labels = [];
  },
  afterDatasetUpdate: function(chart, args, options) {
    var datasetIndex = args.index;
    var expando = chart[EXPANDO_KEY];
    var labels = expando._datasets[datasetIndex] = [];
    var visible = chart.isDatasetVisible(datasetIndex);
    var dataset = chart.data.datasets[datasetIndex];
    var config = configure(dataset, options);
    var elements2 = args.meta.data || [];
    var ctx = chart.ctx;
    var i, j, ilen, jlen, cfg, key, el, label;
    ctx.save();
    for (i = 0, ilen = elements2.length; i < ilen; ++i) {
      el = elements2[i];
      el[EXPANDO_KEY] = [];
      if (visible && el && chart.getDataVisibility(i) && !el.skip) {
        for (j = 0, jlen = config.labels.length; j < jlen; ++j) {
          cfg = config.labels[j];
          key = cfg._key;
          label = new Label(cfg, ctx, el, i);
          label.$groups = {
            _set: datasetIndex,
            _key: key || DEFAULT_KEY
          };
          label.$context = {
            active: false,
            chart,
            dataIndex: i,
            dataset,
            datasetIndex
          };
          label.update(label.$context);
          el[EXPANDO_KEY].push(label);
          labels.push(label);
        }
      }
    }
    ctx.restore();
    merge(expando._listeners, config.listeners, {
      merger: function(event, target, source) {
        target[event] = target[event] || {};
        target[event][args.index] = source[event];
        expando._listened = true;
      }
    });
  },
  afterUpdate: function(chart) {
    chart[EXPANDO_KEY]._labels = layout.prepare(chart[EXPANDO_KEY]._datasets);
  },
  afterDatasetsDraw: function(chart) {
    layout.draw(chart, chart[EXPANDO_KEY]._labels);
  },
  beforeEvent: function(chart, args) {
    if (chart[EXPANDO_KEY]._listened) {
      var event = args.event;
      switch (event.type) {
        case "mousemove":
        case "mouseout":
          handleMoveEvents(chart, event);
          break;
        case "click":
          handleClickEvents(chart, event);
          break;
      }
    }
  },
  afterEvent: function(chart) {
    var expando = chart[EXPANDO_KEY];
    var previous = expando._actives;
    var actives = expando._actives = chart.getActiveElements();
    var updates = utils.arrayDiff(previous, actives);
    var i, ilen, j, jlen, update2, label, labels;
    for (i = 0, ilen = updates.length; i < ilen; ++i) {
      update2 = updates[i];
      if (update2[1]) {
        labels = update2[0].element[EXPANDO_KEY] || [];
        for (j = 0, jlen = labels.length; j < jlen; ++j) {
          label = labels[j];
          label.$context.active = update2[1] === 1;
          label.update(label.$context);
        }
      }
    }
    if (expando._dirty || updates.length) {
      layout.update(expando._labels);
      chart.render();
    }
    delete expando._dirty;
  }
};
const chartsDefaultOptions = {
  line: {
    elements: {
      line: {
        backgroundColor: "rgba(66, 133, 244, 0.0)",
        borderColor: "rgb(66, 133, 244)",
        borderWidth: 2,
        tension: 0
      },
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgb(66, 133, 244)"
      }
    },
    responsive: true,
    plugins: {
      tooltip: {
        intersect: false,
        mode: "index"
      },
      legend: {
        display: true
      }
    },
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        stacked: false,
        grid: {
          borderDash: [2],
          drawBorder: false,
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  },
  bar: {
    elements: {
      line: {
        backgroundColor: "rgb(66, 133, 244)"
      },
      bar: {
        backgroundColor: "rgb(66, 133, 244)"
      }
    },
    responsive: true,
    plugins: {
      tooltip: {
        intersect: false,
        mode: "index"
      },
      legend: {
        display: true
      }
    },
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        stacked: false,
        grid: {
          borderDash: [2],
          drawBorder: false,
          color: function(context) {
            if (context.tick && context.tick.value === 0) {
              return "rgba(0,0,0, 0)";
            }
            return Chart.defaults.borderColor;
          },
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  },
  pie: {
    elements: {
      arc: { backgroundColor: "rgb(66, 133, 244)" }
    },
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    }
  },
  doughnut: {
    elements: {
      arc: { backgroundColor: "rgb(66, 133, 244)" }
    },
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    }
  },
  polarArea: {
    elements: {
      arc: { backgroundColor: "rgba(66, 133, 244, 0.5)" }
    },
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    }
  },
  radar: {
    elements: {
      line: {
        backgroundColor: "rgba(66, 133, 244, 0.5)",
        borderColor: "rgb(66, 133, 244)",
        borderWidth: 2
      },
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgb(66, 133, 244)"
      }
    },
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    }
  },
  scatter: {
    elements: {
      line: {
        backgroundColor: "rgba(66, 133, 244, 0.5)",
        borderColor: "rgb(66, 133, 244)",
        borderWidth: 2,
        tension: 0
      },
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgba(66, 133, 244, 0.5)"
      }
    },
    responsive: true,
    plugins: {
      tooltip: {
        intersect: false,
        mode: "index"
      },
      legend: {
        display: true
      }
    },
    datasets: {
      borderColor: "red"
    },
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        stacked: false,
        grid: {
          borderDash: [2],
          drawBorder: false,
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  },
  bubble: {
    elements: {
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgba(66, 133, 244, 0.5)"
      }
    },
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        grid: {
          borderDash: [2],
          drawBorder: false,
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  }
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var isMergeableObject = function isMergeableObject2(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === "object";
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }
  var customMerge = options.customMerge(key);
  return typeof customMerge === "function" ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}
function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
}
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
}
function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function(key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  getKeys(source).forEach(function(key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error("first argument should be an array");
  }
  return array.reduce(function(prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
function generateCharts(canvasRef, type, data = { datasets: [] }, options = {}) {
  const _data = ref(data);
  const _chart = ref(null);
  const _options = ref(null);
  const _plugins = ref(null);
  setupCharts();
  function setupCharts() {
    _options.value = mergeOptions(options, type, chartsDefaultOptions);
  }
  function mergeOptions(options2, type2, defaultOptions2) {
    if (!options2) {
      options2 = {};
    }
    const mergeObjects = (target, source, options3) => {
      const destination = target.slice();
      source.forEach((item, index2) => {
        if (typeof destination[index2] === "undefined") {
          destination[index2] = options3.cloneUnlessOtherwiseSpecified(
            item,
            options3
          );
        } else if (options3.isMergeableObject(item)) {
          destination[index2] = cjs(target[index2], item, options3);
        } else if (target.indexOf(item) === -1) {
          destination.push(item);
        }
      });
      return destination;
    };
    return cjs(defaultOptions2[type2], options2, {
      arrayMerge: mergeObjects
    });
  }
  function addDataLabels() {
    _plugins.value = [plugin];
  }
  function renderChart() {
    destroyChart();
    if (canvasRef instanceof HTMLCanvasElement) {
      _chart.value = new Chart(canvasRef.getContext("2d"), {
        type,
        data: _data.value,
        options: _options.value,
        plugins: _plugins.value
      });
    }
  }
  function updateChart(data2, options2) {
    _options.value = mergeOptions(options2, type, chartsDefaultOptions);
    _data.value = data2;
    renderChart();
  }
  function destroyChart() {
    if (_chart.value) {
      _chart.value.destroy();
      _chart.value = null;
    }
  }
  return {
    setupCharts,
    renderChart,
    addDataLabels,
    destroyChart,
    updateChart
  };
}
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "MDBChart",
  props: {
    tag: {
      type: String,
      default: "canvas"
    },
    type: String,
    data: Object,
    options: Object,
    datalabels: {
      type: Boolean,
      default: false
    },
    id: String,
    canvasClass: String
  },
  setup(__props) {
    const props = __props;
    const canvasRef = ref(null);
    const uid2 = props.id || getUID("MDBChart-");
    const setupChartsFunc = ref(null);
    const renderChartFunc = ref(null);
    const addDataLabelsFunc = ref(null);
    const updateChartFunc = ref(null);
    const getChartsFunctions = ({
      setupCharts,
      renderChart,
      addDataLabels,
      updateChart
    }) => {
      setupChartsFunc.value = setupCharts;
      renderChartFunc.value = renderChart;
      addDataLabelsFunc.value = addDataLabels;
      updateChartFunc.value = updateChart;
    };
    watch(
      () => props.data,
      (newData) => {
        updateChartFunc.value(
          newData,
          props.options
        );
      }
    );
    watch(
      () => props.options,
      (newOptions) => {
        updateChartFunc.value(props.data, newOptions);
      }
    );
    onMounted(() => {
      const chartsFunctions = generateCharts(
        canvasRef.value,
        props.type,
        props.data,
        props.options
      );
      getChartsFunctions(chartsFunctions);
      if (props.datalabels) {
        addDataLabelsFunc.value();
      }
      renderChartFunc.value();
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        id: unref(uid2),
        ref_key: "canvasRef",
        ref: canvasRef,
        class: normalizeClass(__props.canvasClass)
      }, null, 8, ["id", "class"]);
    };
  }
});
const _hoisted_1$g = { class: "valid-feedback" };
const _hoisted_2$c = { class: "invalid-feedback" };
const _hoisted_3$9 = ["onClick", "onKeydown"];
const _hoisted_4$9 = {
  key: 1,
  class: "select-arrow"
};
const _hoisted_5$8 = ["id"];
const _hoisted_6$7 = ["tabindex"];
const _hoisted_7$6 = ["placeholder", "onKeydown"];
const _hoisted_8$5 = { class: "select-options-list" };
const _hoisted_9$5 = ["onClick"];
const _hoisted_10$4 = { class: "select-option-text" };
const _hoisted_11$1 = { class: "form-check" };
const _hoisted_12$1 = ["checked"];
const _hoisted_13$1 = ["onClick", "aria-selected", "aria-disabled", "hidden"];
const _hoisted_14$1 = {
  key: 0,
  class: "select-option-text"
};
const _hoisted_15$1 = { class: "form-check" };
const _hoisted_16$1 = ["checked"];
const _hoisted_17$1 = {
  key: 0,
  class: "select-option-secondary-text"
};
const _hoisted_18$1 = {
  key: 1,
  class: "select-option-text"
};
const _hoisted_19$1 = {
  key: 0,
  class: "select-option-secondary-text"
};
const _hoisted_20$1 = {
  key: 2,
  class: "select-option-icon-container"
};
const _hoisted_21$1 = ["src"];
const __default__$6 = {
  inheritAttrs: false
};
const _sfc_main$m = defineComponent({
  ...__default__$6,
  __name: "MDBSelect",
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: [String, Array, Number],
    preselect: {
      type: Boolean,
      default: true
    },
    label: String,
    placeholder: String,
    disabled: Boolean,
    optionHeight: {
      type: Number,
      default: 38
    },
    visibleOptions: {
      type: Number,
      default: 5
    },
    optionsSelectedLabel: {
      type: String,
      default: "options selected"
    },
    displayedLabels: {
      type: Number,
      default: 5
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    selectAllLabel: {
      type: String,
      default: "Select all"
    },
    required: Boolean,
    size: String,
    clearButton: Boolean,
    multiple: Boolean,
    isValidated: Boolean,
    isValid: Boolean,
    validFeedback: String,
    invalidFeedback: String,
    filter: Boolean,
    searchPlaceholder: {
      type: String,
      default: "Search..."
    },
    noResultsText: {
      type: String,
      default: "No results"
    },
    filterDebounce: {
      type: Number,
      default: 300
    },
    tag: {
      type: String,
      default: "div"
    },
    arrow: {
      type: Boolean,
      default: true
    },
    autoSelect: Boolean,
    tabindex: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "update:options",
    "update:selected",
    "update:modelValue",
    "change",
    "open",
    "close",
    "clear"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const className = computed(() => {
      return [
        "select-wrapper",
        isSelectValidated.value && isSelectValid.value ? "is-valid" : "",
        isSelectValidated.value && !isSelectValid.value ? "is-invalid" : ""
      ];
    });
    const inputClassName = computed(() => {
      return [
        isPopperActive.value && "focused",
        modelSelected.value && !inputValue.value || isPopperActive.value ? "active" : null
      ];
    });
    const selectDropdownContainerStyle = computed(() => {
      return {
        width: dropdownWidth.value
      };
    });
    const selectOptionsWrapperStyle = computed(() => {
      return {
        maxHeight: `${props.visibleOptions * props.optionHeight}px`
      };
    });
    const selectWrapperRef = ref(null);
    const dropdownRef = ref(null);
    const selectOptionsWrapperRef = ref(null);
    const dropdownId = getUID("MDBSelectDropdown-");
    const dropdownWidth = ref("200px");
    const isDropdownActive = ref(false);
    const activeOptionKey = ref(null);
    let wasInitiated = false;
    const popperConfig = {
      placement: "bottom-start",
      eventsEnabled: true,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 1]
          }
        }
      ]
    };
    const modelOptions = ref(props.options);
    const filteredOptions = ref(modelOptions.value);
    const modelSelected = ref(props.selected);
    const isOptgroup = ref(modelOptions.value.some((option) => option.optgroup));
    modelOptions.value.map((option, key) => option.mdbKey = key);
    let lookupLastTime = 0;
    let lookupPrefix = "";
    const dropdownTabindex = ref(0);
    const { setPopper, isPopperActive, closePopper, openPopper } = MDBPopper();
    const toggle = () => {
      if (isPopperActive.value) {
        close();
      } else {
        open();
      }
    };
    const close = () => {
      if (!isPopperActive.value) {
        return;
      }
      dropdownTabindex.value = -1;
      closePopper();
      emit("close");
      setActiveOptionKey();
      setTimeout(() => {
        isDropdownActive.value = false;
        search.value = "";
        filteredOptions.value = modelOptions.value;
      }, 300);
    };
    const open = () => {
      if (props.disabled || isPopperActive.value) {
        return;
      }
      dropdownTabindex.value = 0;
      isDropdownActive.value = true;
      setActiveOptionKey();
      nextTick(() => openDropdown());
      if (props.filter) {
        setTimeout(() => {
          initSearch();
          scrollToInput();
        }, 100);
      }
    };
    const setOption = (key) => {
      if (props.multiple) {
        if (key === -1) {
          return toggleSelectAll();
        }
        if (!modelOptions.value[key].disabled) {
          modelOptions.value[key].selected = !modelOptions.value[key].selected;
        }
      } else {
        modelOptions.value.forEach((option) => {
          option.selected = false;
        });
        modelOptions.value[key].selected = true;
      }
    };
    const clear = () => {
      modelOptions.value.forEach((option) => {
        option.selected = false;
      });
      activeOptionKey.value = null;
      emit("clear");
    };
    const setValue = (request) => {
      clear();
      if (props.multiple && Array.isArray(request)) {
        request.forEach((val) => {
          const selectedKey = modelOptions.value.findIndex(
            (option) => option.value === val
          );
          if (selectedKey >= 0) {
            setOption(selectedKey);
          }
        });
      } else {
        const selectedKey = modelOptions.value.findIndex(
          (option) => option.value === request
        );
        if (selectedKey >= 0) {
          setOption(selectedKey);
          close();
        }
      }
    };
    const toggleSelectAll = () => {
      const areAllOptionsSelected = areAllOptionsChecked.value;
      modelOptions.value.forEach((option) => {
        option.selected = !areAllOptionsSelected;
      });
    };
    const emitChangeEvents = () => {
      emit("update:selected", modelSelected.value);
      if (wasInitiated) {
        emit("change");
      } else {
        wasInitiated = true;
      }
    };
    const setActiveOptionKey = () => {
      if (selectedOptions.value[0]) {
        activeOptionKey.value = filteredOptions.value.findIndex(
          (option) => option === selectedOptions.value[0]
        );
        if (props.multiple && props.selectAll && areAllOptionsChecked.value) {
          activeOptionKey.value = -1;
        }
      }
    };
    const openDropdown = () => {
      if (!dropdownRef.value) {
        return;
      }
      setPopper(selectWrapperRef.value, dropdownRef.value, popperConfig);
      openPopper();
      dropdownWidth.value = `${selectWrapperRef.value.offsetWidth}px`;
      nextTick(() => scrollBottomToOption());
      emit("open");
    };
    const initSearch = () => {
      if (searchRef.value) {
        searchRef.value.focus();
        searchHeight = searchWrapperRef.value.offsetHeight;
      }
    };
    const getScrollParent2 = (node) => {
      if (node == null) {
        return null;
      }
      if (node.scrollHeight > node.clientHeight) {
        return node;
      } else {
        return getScrollParent2(node.parentNode);
      }
    };
    const scrollToInput = () => {
      if (!window) {
        return;
      }
      if (window.innerWidth < 992) {
        const scrollableParent = getScrollParent2(selectWrapperRef.value);
        const selectOffsetTop = selectWrapperRef.value.offsetTop;
        scrollableParent.scrollTo({
          top: selectOffsetTop - 20,
          behavior: "smooth"
        });
      }
    };
    const setFirstNotDisabledOption = () => {
      if (!props.multiple && props.preselect && modelOptions.value.filter((option) => option.selected === true).length === 0) {
        const firstNotDisabledOption = modelOptions.value.findIndex(
          (option) => option.disabled !== true
        );
        setOption(firstNotDisabledOption);
      }
      if (!props.preselect) {
        wasInitiated = true;
      }
    };
    const handleOptionClick = (option) => {
      if (option.disabled) {
        return;
      }
      setOption(option.mdbKey);
      if (!props.multiple) {
        close();
      }
    };
    const setDefaults = () => {
      setFirstNotDisabledOption();
      setActiveOptionKey();
    };
    const selectedOptions = computed(() => {
      if (props.multiple) {
        modelSelected.value = modelOptions.value.filter((option) => option.selected === true).map((option) => option.value).join(",");
      } else if (modelOptions.value.filter((value) => value.selected === true).length > 0) {
        modelSelected.value = modelOptions.value.filter(
          (value) => value.selected === true
        )[0].value;
      } else {
        modelSelected.value = "";
        return "";
      }
      return modelOptions.value.filter((value) => value.selected === true);
    });
    const inputValue = computed(() => {
      if (!selectedOptions.value || selectedOptions.value.length === 0) {
        return "";
      } else if (selectedOptions.value.length === 1) {
        return selectedOptions.value[0].text;
      } else if (props.multiple) {
        if (props.displayedLabels !== -1 && selectedOptions.value.length > props.displayedLabels) {
          return `${selectedOptions.value.length} ${props.optionsSelectedLabel}`;
        } else {
          return selectedOptions.value.map((selectedOption) => selectedOption.text).join(", ");
        }
      }
      return "";
    });
    const areAllOptionsChecked = computed(() => {
      if (props.multiple && props.selectAll && selectedOptions.value.length === modelOptions.value.length) {
        return true;
      }
      return false;
    });
    const activeEl = computed(() => {
      return dropdownRef.value.querySelectorAll(".select-option")[activeOptionKey.value];
    });
    const isSelectAllVisible = computed(() => {
      if (props.multiple && props.selectAll && search.value === "") {
        return true;
      }
      return false;
    });
    const selectAllOptionHeight = computed(() => {
      if (isSelectAllVisible.value) {
        return props.optionHeight;
      }
      return 0;
    });
    const activeOptionOffsetTop = computed(() => {
      let offsetTop = 0;
      if (activeEl.value) {
        offsetTop = activeEl.value.offsetTop + selectAllOptionHeight.value - searchHeight;
      }
      return offsetTop;
    });
    const optionListHeight = computed(() => {
      return props.visibleOptions * props.optionHeight;
    });
    const isActiveOptionVisible = computed(() => {
      if (selectOptionsWrapperRef.value && selectOptionsWrapperRef.value.scrollTop < activeOptionOffsetTop.value && selectOptionsWrapperRef.value.scrollTop + optionListHeight.value > activeOptionOffsetTop.value) {
        return true;
      }
      return false;
    });
    const handleEnterAndSpace = () => {
      if (props.multiple) {
        if (isPopperActive.value && activeOptionKey.value === null) {
          close();
          focusInput();
        } else if (isPopperActive.value && activeOptionKey.value === -1) {
          setOption(-1);
        } else if (isPopperActive.value && activeOptionKey.value !== null) {
          setOption(filteredOptions.value[activeOptionKey.value].mdbKey);
        } else {
          open();
        }
      } else {
        if (isPopperActive.value) {
          if (activeOptionKey.value !== null) {
            setOption(filteredOptions.value[activeOptionKey.value].mdbKey);
          }
          close();
          focusInput();
        } else {
          open();
        }
      }
    };
    const handleTab = () => {
      if (props.autoSelect && !props.multiple && isPopperActive.value && activeOptionKey.value !== null) {
        setOption(filteredOptions.value[activeOptionKey.value].mdbKey);
      }
      close();
    };
    const onKeyDown = (event) => {
      if (props.disabled && !props.filter) {
        return;
      }
      const lookupThreshold = 1e3;
      const now = performance.now();
      if (now - lookupLastTime > lookupThreshold) {
        lookupPrefix = "";
      }
      lookupPrefix += event.key.toLowerCase();
      lookupLastTime = now;
      const index2 = modelOptions.value.findIndex((item) => {
        const text = item.text.toString();
        return text.toLowerCase().startsWith(lookupPrefix) && !item.disabled && !item.hidden;
      });
      if (index2 !== -1) {
        activeOptionKey.value = index2;
        scrollBottomToOption();
      }
    };
    const focusInput = () => {
      if (props.filter) {
        selectWrapperRef.value.querySelector(".select-input").focus();
      }
    };
    const handleArrowDown = () => {
      setNextActiveOptionKey();
      if (isDropdownActive.value) {
        scrollBottomToOption();
      }
      if (!props.multiple && !isDropdownActive.value) {
        setOption(activeOptionKey.value);
      } else if (props.multiple && !isDropdownActive.value) {
        open();
      }
    };
    const handleArrowUp = () => {
      if (activeOptionKey.value === null) {
        return;
      }
      setPrevActiveOptionKey();
      if (isDropdownActive.value) {
        scrollTopToOption();
      }
      if (!props.multiple && !isDropdownActive.value) {
        setOption(activeOptionKey.value);
      } else if (props.multiple && !isDropdownActive.value) {
        open();
      }
    };
    const setNextActiveOptionKey = () => {
      let nextOptionKey = activeOptionKey.value;
      if (activeOptionKey.value === null && isSelectAllVisible.value) {
        nextOptionKey = -1;
      } else {
        nextOptionKey = filteredOptions.value.findIndex(
          (option, key) => (key > nextOptionKey || nextOptionKey === null) && !option.disabled && !option.hidden
        );
        if (nextOptionKey === -1) {
          return;
        }
      }
      activeOptionKey.value = nextOptionKey;
    };
    const setPrevActiveOptionKey = () => {
      let prevOptionKey = activeOptionKey.value;
      if (activeOptionKey.value === 0 && isSelectAllVisible.value) {
        prevOptionKey = -1;
      } else {
        prevOptionKey = filteredOptions.value.indexOf(
          filteredOptions.value.filter(
            (option, key) => key < prevOptionKey && !option.disabled && !option.hidden
          ).pop()
        );
        if (prevOptionKey === -1) {
          return;
        }
      }
      activeOptionKey.value = prevOptionKey;
    };
    const scrollBottomToOption = () => {
      if (!isActiveOptionVisible.value && selectOptionsWrapperRef.value) {
        const offsetBottom = activeOptionOffsetTop.value - optionListHeight.value + props.optionHeight;
        selectOptionsWrapperRef.value.scrollTo(0, offsetBottom);
      }
    };
    const scrollTopToOption = () => {
      if (!isActiveOptionVisible.value && selectOptionsWrapperRef.value) {
        selectOptionsWrapperRef.value.scrollTo(0, activeOptionOffsetTop.value);
      }
    };
    const isSelectValidated = ref(props.isValidated);
    const isSelectValid = ref(props.isValid);
    const searchWrapperRef = ref(null);
    const searchRef = ref(null);
    const search = ref("");
    let filterTimeout;
    let searchHeight = 0;
    const handleFilter = (event) => {
      clearTimeout(filterTimeout);
      filterTimeout = setTimeout(() => {
        activeOptionKey.value = null;
        const target = event.target;
        search.value = target.value.toLowerCase();
        filteredOptions.value = modelOptions.value.filter(
          (option) => option.text.toLowerCase().includes(search.value)
        );
        closePopper();
        openPopper();
      }, props.filterDebounce);
    };
    onBeforeMount(() => {
      if (modelOptions.value.length > 0) {
        setDefaults();
      }
    });
    watch(
      () => props.options,
      (options) => {
        modelOptions.value = options;
        modelOptions.value.map((option, key) => option.mdbKey = key);
        filteredOptions.value = modelOptions.value;
        if (modelOptions.value.length > 0) {
          setDefaults();
        }
      }
    );
    watch(
      () => modelSelected.value,
      () => emitChangeEvents()
    );
    watch(
      () => props.isValidated,
      (value) => isSelectValidated.value = value
    );
    watch(
      () => props.isValid,
      (value) => isSelectValid.value = value
    );
    expose({
      clear,
      close,
      open,
      setValue,
      setOption,
      toggle,
      toggleSelectAll
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
          ref_key: "selectWrapperRef",
          ref: selectWrapperRef,
          class: unref(className)
        }, _ctx.$attrs, {
          onClick: toggle,
          onKeydown: [
            withKeys(withModifiers(handleEnterAndSpace, ["prevent"]), ["enter"]),
            withKeys(close, ["esc"]),
            withKeys(withModifiers(handleArrowDown, ["prevent", "exact"]), ["down"]),
            withKeys(withModifiers(handleArrowUp, ["prevent", "exact"]), ["up"]),
            withKeys(handleTab, ["tab"]),
            withKeys(withModifiers(open, ["alt"]), ["down"]),
            withKeys(withModifiers(close, ["alt"]), ["up"]),
            withKeys(withModifiers(handleEnterAndSpace, ["prevent"]), ["space"]),
            onKeyDown
          ]
        }), {
          default: withCtx(() => [
            createVNode(_sfc_main$O, {
              modelValue: unref(inputValue),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(inputValue) ? inputValue.value = $event : null),
              labelClass: "select-label",
              class: normalizeClass(["select-input", unref(inputClassName)]),
              label: __props.label,
              placeholder: __props.placeholder,
              disabled: __props.disabled,
              size: __props.size,
              "aria-disabled": __props.disabled,
              "aria-expanded": isDropdownActive.value,
              "aria-required": __props.isValidated && __props.required,
              role: __props.filter ? "combobox" : "listbox",
              tabindex: __props.tabindex,
              "aria-haspopup": "true",
              readonly: ""
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_1$g, toDisplayString(__props.validFeedback), 1),
                createElementVNode("div", _hoisted_2$c, toDisplayString(__props.invalidFeedback), 1),
                unref(inputValue) && __props.clearButton ? (openBlock(), createElementBlock("span", {
                  key: 0,
                  class: "select-clear-btn",
                  tabindex: "0",
                  onClick: withModifiers(clear, ["stop"]),
                  onKeydown: withKeys(withModifiers(clear, ["stop"]), ["enter"])
                }, "\u2715", 40, _hoisted_3$9)) : createCommentVNode("", true),
                __props.arrow ? (openBlock(), createElementBlock("span", _hoisted_4$9)) : createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "class", "label", "placeholder", "disabled", "size", "aria-disabled", "aria-expanded", "aria-required", "role", "tabindex"])
          ]),
          _: 1
        }, 16, ["class", "onKeydown"])), [
          [unref(vMdbClickOutside), close]
        ]),
        isDropdownActive.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          id: unref(dropdownId),
          ref_key: "dropdownRef",
          ref: dropdownRef,
          class: "select-dropdown-container",
          style: normalizeStyle(unref(selectDropdownContainerStyle))
        }, [
          createElementVNode("div", {
            class: normalizeClass(["select-dropdown", unref(isPopperActive) && "open"]),
            tabindex: dropdownTabindex.value
          }, [
            __props.filter ? (openBlock(), createElementBlock("div", {
              key: 0,
              ref_key: "searchWrapperRef",
              ref: searchWrapperRef,
              class: "input-group",
              onClick: _cache[2] || (_cache[2] = withModifiers(() => {
              }, ["stop"]))
            }, [
              createElementVNode("input", {
                ref_key: "searchRef",
                ref: searchRef,
                class: "form-control select-filter-input",
                placeholder: __props.searchPlaceholder,
                role: "searchbox",
                type: "text",
                onInput: handleFilter,
                onKeydown: [
                  withKeys(withModifiers(handleEnterAndSpace, ["prevent"]), ["enter"]),
                  withKeys(close, ["esc"]),
                  withKeys(withModifiers(handleArrowDown, ["prevent"]), ["down"]),
                  withKeys(withModifiers(handleArrowUp, ["prevent"]), ["up"]),
                  withKeys(handleTab, ["tab"])
                ],
                onTouchstart: _cache[1] || (_cache[1] = withModifiers(() => {
                }, ["stop"]))
              }, null, 40, _hoisted_7$6)
            ], 512)) : createCommentVNode("", true),
            createElementVNode("div", {
              ref_key: "selectOptionsWrapperRef",
              ref: selectOptionsWrapperRef,
              class: "select-options-wrapper",
              style: normalizeStyle(unref(selectOptionsWrapperStyle)),
              onTouchstart: _cache[3] || (_cache[3] = withModifiers(() => {
              }, ["stop"]))
            }, [
              __props.filter && filteredOptions.value.length === 0 ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "select-no-results",
                style: normalizeStyle({ height: `${__props.optionHeight}px` })
              }, toDisplayString(__props.noResultsText), 5)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_8$5, [
                __props.multiple && __props.selectAll && search.value === "" ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(["select-option", [
                    activeOptionKey.value === -1 && "active",
                    unref(areAllOptionsChecked) && "selected",
                    isOptgroup.value ? "select-option-group" : null
                  ]]),
                  style: normalizeStyle({ height: `${__props.optionHeight}px` }),
                  onClick: withModifiers(toggleSelectAll, ["stop"])
                }, [
                  createElementVNode("span", _hoisted_10$4, [
                    createElementVNode("div", _hoisted_11$1, [
                      createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        checked: unref(areAllOptionsChecked),
                        tabindex: "-1"
                      }, null, 8, _hoisted_12$1),
                      createTextVNode(" " + toDisplayString(__props.selectAllLabel), 1)
                    ])
                  ])
                ], 14, _hoisted_9$5)) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList(filteredOptions.value, (option, key) => {
                  return openBlock(), createElementBlock("div", {
                    class: normalizeClass(["select-option", [
                      option.disabled && "disabled",
                      activeOptionKey.value === key && "active",
                      option.selected && "selected",
                      isOptgroup.value && !option.optgroup ? "select-option-group" : null
                    ]]),
                    style: normalizeStyle({ height: `${__props.optionHeight}px` }),
                    onClick: withModifiers(($event) => handleOptionClick(option), ["stop"]),
                    key,
                    role: "option",
                    "aria-selected": option.selected,
                    "aria-disabled": option.disabled || false,
                    hidden: option.hidden
                  }, [
                    __props.multiple ? (openBlock(), createElementBlock("span", _hoisted_14$1, [
                      createElementVNode("div", _hoisted_15$1, [
                        createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          checked: option.selected,
                          tabindex: "-1"
                        }, null, 8, _hoisted_16$1),
                        createTextVNode(" " + toDisplayString(option.text) + " ", 1),
                        option.secondaryText ? (openBlock(), createElementBlock("span", _hoisted_17$1, toDisplayString(option.secondaryText), 1)) : createCommentVNode("", true)
                      ])
                    ])) : (openBlock(), createElementBlock("span", _hoisted_18$1, [
                      createTextVNode(toDisplayString(option.text) + " ", 1),
                      option.secondaryText ? (openBlock(), createElementBlock("span", _hoisted_19$1, toDisplayString(option.secondaryText), 1)) : createCommentVNode("", true)
                    ])),
                    option.icon ? (openBlock(), createElementBlock("span", _hoisted_20$1, [
                      createElementVNode("img", {
                        class: "select-option-icon rounded-circle",
                        src: option.icon,
                        alt: "select-icon"
                      }, null, 8, _hoisted_21$1)
                    ])) : createCommentVNode("", true)
                  ], 14, _hoisted_13$1);
                }), 128))
              ])
            ], 36),
            _ctx.$slots.default ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: "select-custom-content",
              onClick: _cache[4] || (_cache[4] = withModifiers(() => {
              }, ["stop"])),
              onTouchstart: _cache[5] || (_cache[5] = withModifiers(() => {
              }, ["stop"]))
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 32)) : createCommentVNode("", true)
          ], 10, _hoisted_6$7)
        ], 12, _hoisted_5$8)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$f = {
  class: "datatable-inner table-responsive",
  style: { "overflow": "auto", "position": "relative" }
};
const _hoisted_2$b = { class: "table datatable-table" };
const _hoisted_3$8 = {
  key: 0,
  class: "datatable-header"
};
const _hoisted_4$8 = ["onClick"];
const _hoisted_5$7 = {
  key: 1,
  class: "datatable-body"
};
const _hoisted_6$6 = ["data-mdb-index", "onClick"];
const _hoisted_7$5 = { key: 0 };
const _hoisted_8$4 = ["contenteditable", "onBlur", "innerHTML"];
const _hoisted_9$4 = {
  key: 2,
  class: "datatable-body"
};
const _hoisted_10$3 = {
  key: 0,
  class: "datatable-loader bg-light"
};
const _hoisted_11 = { class: "datatable-loader-inner" };
const _hoisted_12 = {
  key: 1,
  class: "text-center text-muted my-4"
};
const _hoisted_13 = {
  key: 2,
  class: "datatable-pagination"
};
const _hoisted_14 = { class: "datatable-select-wrapper" };
const _hoisted_15 = { class: "datatable-select-text" };
const _hoisted_16 = { class: "datatable-pagination-nav" };
const _hoisted_17 = { class: "datatable-pagination-buttons" };
const _hoisted_18 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-angle-double-left" }, null, -1);
const _hoisted_19 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1);
const _hoisted_20 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1);
const _hoisted_21 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-angle-double-right" }, null, -1);
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "MDBDatatable",
  props: {
    bordered: Boolean,
    borderless: Boolean,
    borderColor: String,
    clickableRows: Boolean,
    color: String,
    dark: Boolean,
    defaultValue: {
      type: String,
      default: "-"
    },
    dataset: {
      type: Object,
      default() {
        return {
          columns: [],
          rows: []
        };
      }
    },
    edit: Boolean,
    entries: {
      type: Number,
      default: 10
    },
    entriesOptions: {
      type: Array,
      default: () => [10, 25, 50, 200, "All"]
    },
    fixedHeader: Boolean,
    fullPagination: Boolean,
    hover: Boolean,
    loaderClass: {
      type: String,
      default: "bg-primary"
    },
    loading: Boolean,
    loadingMessage: {
      type: String,
      default: "Loading results..."
    },
    maxHeight: [Number, String],
    maxWidth: {
      type: [Number, String],
      default: "100%"
    },
    multi: Boolean,
    noFoundMessage: {
      type: String,
      default: "No matching results found"
    },
    ofPaginationText: {
      type: String,
      default: "of"
    },
    pagination: {
      type: Boolean,
      default: true
    },
    rowsText: {
      type: String,
      default: "Rows per page:"
    },
    search: String,
    searchColumns: {
      type: Array,
      default: () => []
    },
    selectable: Boolean,
    sm: Boolean,
    sortField: String,
    sortOrder: String,
    striped: Boolean,
    tag: {
      type: String,
      default: "div"
    },
    searchCaseSensitive: Boolean,
    disableSortToDefault: Boolean
  },
  emits: [
    "render",
    "selected-rows",
    "selected-indexes",
    "all-selected",
    "row-click",
    "update"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const slots = useSlots();
    const className = computed(() => [
      "datatable",
      props.color,
      props.bordered && "datatable-bordered",
      props.borderColor && `border-${props.borderColor}`,
      props.borderless && "datatable-borderless",
      props.clickableRows && "datatable-clickable-rows",
      props.dark && "datatable-dark",
      props.hover && "datatable-hover",
      props.loading && "datatable-loading",
      props.sm && "datatable-sm",
      props.striped && "datatable-striped"
    ]);
    const height = computed(
      () => typeof props.maxHeight === "number" ? props.maxHeight + "px" : props.maxHeight
    );
    const width = computed(
      () => typeof props.maxWidth === "number" ? props.maxWidth + "px" : props.maxWidth
    );
    const data = ref({});
    const rowsPerPage = ref(props.entries);
    const pageKey = ref(0);
    const pages = computed(
      () => data.value.rows ? Math.ceil(data.value.rows.length / rowsPerPage.value) : 1
    );
    const firstRowIndex = computed(
      () => data.value.rows ? pageKey.value * rowsPerPage.value + 1 : 1
    );
    const lastRowIndex = computed(
      () => data.value.rows ? pageKey.value === pages.value - 1 ? data.value.rows.length : pageKey.value * rowsPerPage.value + rowsPerPage.value : rowsPerPage.value
    );
    const hasRows = computed(
      () => data.value.rows ? data.value.rows.length > 0 : false
    );
    const allRows = computed(() => data.value.rows && data.value.rows.length);
    const selectOptions = ref(
      props.entriesOptions.map((entry) => {
        return {
          text: entry,
          value: typeof entry === "string" ? allRows : entry,
          selected: entry === rowsPerPage.value
        };
      })
    );
    const datatableKey = ref(0);
    const defaultData = {};
    onMounted(() => {
      if (slots.default && slots.default()[0].type === "table") {
        getDataFromSlot(slots.default()[0]);
      } else {
        getDataFromProps();
      }
    });
    if (slots.default) {
      watch(
        () => slots.default(),
        () => {
          if (slots.default().length > 0 && slots.default()[0].type === "table") {
            getDataFromSlot(slots.default()[0]);
          }
        }
      );
    } else {
      watch(
        () => props.dataset,
        () => {
          getDataFromProps();
          sort();
        },
        { deep: true }
      );
    }
    watch(
      () => rowsPerPage.value,
      () => {
        pageKey.value = 0;
        datatableKey.value++;
        nextTick(() => emit("render", data.value));
      }
    );
    const setData = (columns, rows) => {
      data.value.columns = columns;
      data.value.rows = rows;
      setDefaultData(columns, rows);
      nextTick(() => emit("render", data.value));
    };
    const setDefaultData = (columns, rows) => {
      defaultData.columns = [...columns];
      defaultData.rows = [...rows];
    };
    const getGeneratedColumns = () => {
      if (props.dataset.columns[0].field) {
        return [...props.dataset.columns];
      } else {
        return props.dataset.columns.map((th) => {
          return {
            label: th,
            field: th.toLowerCase()
          };
        });
      }
    };
    const getGeneratedRows = (columns) => {
      let rows = [];
      if (props.dataset.rows[0][columns[0].field]) {
        rows = props.dataset.rows.map((row, key) => ({
          ...row,
          mdbIndex: key,
          selected: false
        }));
      } else {
        const rowsArr = props.dataset.rows.map((tr) => tr);
        rowsArr.forEach((row, key) => {
          rows.push({});
          row.forEach((td, tdKey) => {
            rows[key][columns[tdKey].field] = td;
            rows[key].mdbIndex = key;
            rows[key].selected = false;
          });
        });
      }
      return rows;
    };
    const setColMarginsAndFormats = (columns, formattedColumns) => {
      let colMarginLeft = -columns[0].width || 0;
      const colLeftMargins = columns.map((col) => {
        colMarginLeft += col.fixed ? col.width || 0 : 0;
        return colMarginLeft;
      });
      columns.forEach((col, key) => {
        if (col.fixed && col.fixed === "right") {
          col.right = true;
        }
        if ("format" in col) {
          formattedColumns.push({ field: col.field, rules: col.format.value });
        }
        col.left = colLeftMargins[key];
      });
    };
    const formatCells = (rows, formattedColumns) => {
      rows.forEach((row, key) => {
        row.formats = {};
        formattedColumns.forEach((col) => {
          row.formats[col.field] = col.rules[key];
        });
      });
    };
    const createStringWithProperties = (el) => {
      let props2 = "";
      if (el.props) {
        Object.keys(el.props).forEach((key) => {
          props2 += `${key}="${el.props[key]}"`;
        });
      }
      return props2;
    };
    const createHTMLElementStringFromSlots = (data2) => {
      const content = [];
      data2.forEach((el) => {
        if (el.children !== " ") {
          const props2 = createStringWithProperties(el);
          if (typeof el.type !== "symbol") {
            content.push(`<${el.type} ${props2}>`);
          }
        }
        if (el.children) {
          if (typeof el.children === "string") {
            content.push(`${el.children}`);
          } else {
            const childrenElements = createHTMLElementStringFromSlots(
              el.children
            );
            content.push(childrenElements);
          }
        }
        if (el.children !== " ") {
          if (typeof el.type !== "symbol") {
            content.push(`</${el.type}>`);
          }
        }
      });
      return content.join("");
    };
    const getDataFromSlot = (slot) => {
      const columns = slot.children[0].children[0].children.map(
        (th) => {
          return {
            label: th.children,
            field: th.children.toLowerCase(),
            sort: th.props && th.props["data-mdb-sort"] === "false" ? false : true
          };
        }
      );
      const rows = [];
      const rowsObj = slot.children[1].children.map(
        (tr) => tr.children
      );
      rowsObj.forEach((row, key) => {
        rows.push({});
        row.forEach((td, tdKey) => {
          if (typeof td.children === "object") {
            rows[key][columns[tdKey].field] = createHTMLElementStringFromSlots(
              td.children
            );
          } else {
            rows[key][columns[tdKey].field] = td.children;
          }
          rows[key].mdbIndex = key;
          rows[key].selected = false;
        });
      });
      setData(columns, rows);
    };
    const getDataFromProps = () => {
      let columns = [];
      let rows = [];
      if (props.dataset.columns && props.dataset.columns.length > 0) {
        columns = getGeneratedColumns();
      }
      if (props.dataset.rows && props.dataset.rows.length > 0) {
        rows = getGeneratedRows(columns);
      }
      const formattedColumns = [];
      setColMarginsAndFormats(columns, formattedColumns);
      if (formattedColumns.length > 0) {
        formatCells(rows, formattedColumns);
      }
      setData(columns, rows);
    };
    const setActivePage = (value) => {
      if (value < pages.value) {
        pageKey.value = value;
        emit("render", data.value);
      }
    };
    const orderBy = ref(props.sortOrder || null);
    const orderKey = ref(props.sortField || null);
    const setOrderData = (order2, key) => {
      orderBy.value = order2;
      orderKey.value = key;
    };
    const sortAsc = () => {
      data.value.rows.sort(
        (a, b) => a[orderKey.value] > b[orderKey.value] ? 1 : b[orderKey.value] > a[orderKey.value] ? -1 : 0
      );
    };
    const sortDesc = () => {
      data.value.rows.sort(
        (a, b) => a[orderKey.value] < b[orderKey.value] ? 1 : b[orderKey.value] < a[orderKey.value] ? -1 : 0
      );
    };
    const sortAndFilter = (key) => {
      if (orderBy.value === null || orderKey.value !== key || props.disableSortToDefault && orderBy.value === "desc") {
        setOrderData("asc", key);
        sortAsc();
      } else if (orderBy.value === "asc" && orderKey.value === key) {
        setOrderData("desc", key);
        sortDesc();
      } else {
        setOrderData(null, null);
        data.value.rows = [...defaultData.rows];
        if (search.value) {
          filter();
        }
      }
      nextTick(() => emit("render", data.value));
    };
    const sort = () => {
      if (orderBy.value === "asc") {
        sortAsc();
      } else if (orderBy.value === "desc") {
        sortDesc();
      }
      nextTick(() => emit("render", data.value));
    };
    onMounted(() => {
      if (orderKey.value) {
        sort();
      }
    });
    const search = ref("");
    const searchColumns = ref(props.searchColumns);
    const filter = () => {
      if (searchColumns.value.length > 0) {
        data.value.rows = defaultData.rows.filter(
          (row) => searchColumns.value.map((column) => {
            let td = row[column];
            if (td.indexOf("/>") !== -1 || td.indexOf("</") !== -1) {
              td = td.split(">")[1];
              td = td.split("<")[0];
            }
            return props.searchCaseSensitive ? td.toString().includes(search.value) : td.toString().toLowerCase().includes(search.value);
          }).some((value) => value === true)
        );
      } else {
        data.value.rows = defaultData.rows.filter(
          (row) => data.value.columns.map((column) => {
            let td = row[column.field];
            if (td.indexOf("/>") !== -1 || td.indexOf("</") !== -1) {
              td = td.split(">")[1];
              td = td.split("<")[0];
            }
            return props.searchCaseSensitive ? td.toString().includes(search.value) : td.toString().toLowerCase().includes(search.value);
          }).some((value) => value === true)
        );
      }
    };
    watch(
      () => props.search,
      (searchString) => {
        search.value = !props.searchCaseSensitive ? searchString.toLowerCase() : searchString;
        if (searchString === "") {
          data.value.rows = defaultData.rows;
        } else {
          filter();
        }
        sort();
        pageKey.value = 0;
      }
    );
    watch(
      () => props.searchColumns,
      (searchCols) => {
        searchColumns.value = searchCols;
        filter();
        sort();
        pageKey.value = 0;
      }
    );
    const selectedRows = computed(
      () => data.value.rows.filter((row) => row.selected === true)
    );
    const selectedIndexes = computed(
      () => selectedRows.value.map((row) => row.mdbIndex)
    );
    const allSelected = computed(
      () => selectedIndexes.value.length === data.value.rows.length
    );
    const allSelectedCheckbox = ref(false);
    const handleCheckboxChange = (rowId, rowChecked) => {
      if (!props.multi && rowChecked === false) {
        data.value.rows.forEach((row) => {
          if (row.mdbIndex !== rowId) {
            row.selected = false;
          }
        });
      }
      emitSelectedValues();
      updateAllSelectedCheckbox();
    };
    const toggleSelectAll = () => {
      if (allSelected.value) {
        data.value.rows.forEach((row) => row.selected = false);
      } else {
        data.value.rows.forEach((row) => row.selected = true);
      }
      emitSelectedValues();
    };
    const updateAllSelectedCheckbox = () => {
      nextTick(() => allSelectedCheckbox.value = allSelected.value);
    };
    const emitSelectedValues = () => {
      nextTick(() => {
        emit("selected-rows", selectedRows.value);
        emit("selected-indexes", selectedIndexes.value);
        emit("all-selected", allSelected.value);
      });
    };
    const handleRowClick = (index2) => {
      emit("row-click", index2);
    };
    const handleCellBlur = (event, rowIndex, field) => {
      if (props.edit) {
        const target = event.target;
        data.value.rows[rowIndex][field] = target.innerHTML;
        nextTick(() => {
          sort();
          emit("update", data.value);
        });
      }
    };
    expose({ setActivePage });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        key: datatableKey.value,
        class: normalizeClass(unref(className)),
        style: normalizeStyle({ maxWidth: unref(width) })
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$f, [
            createVNode(_sfc_main$p, {
              width: unref(width),
              height: unref(height),
              wheelPropagation: true,
              style: { "background-color": "inherit" }
            }, {
              default: withCtx(() => [
                createElementVNode("table", _hoisted_2$b, [
                  data.value.columns ? (openBlock(), createElementBlock("thead", _hoisted_3$8, [
                    createElementVNode("tr", null, [
                      __props.selectable ? (openBlock(), createElementBlock("th", {
                        key: 0,
                        scope: "col",
                        class: normalizeClass(__props.fixedHeader && "fixed-cell")
                      }, [
                        __props.multi ? (openBlock(), createBlock(_sfc_main$M, {
                          key: 0,
                          modelValue: allSelectedCheckbox.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => allSelectedCheckbox.value = $event),
                          onClick: withModifiers(toggleSelectAll, ["stop"]),
                          wrapperClass: "d-flex align-items-center mb-0"
                        }, null, 8, ["modelValue", "onClick"])) : createCommentVNode("", true)
                      ], 2)) : createCommentVNode("", true),
                      (openBlock(true), createElementBlock(Fragment, null, renderList(data.value.columns, (col, colKey) => {
                        return openBlock(), createElementBlock("th", {
                          key: "col-" + colKey,
                          scope: "col",
                          style: normalizeStyle({
                            cursor: col.sort !== false ? "pointer" : "default",
                            minWidth: col.width + "px",
                            maxWidth: col.width + "px",
                            left: col.fixed && !col.right ? col.left + "px" : "",
                            right: col.fixed && col.right ? 0 : ""
                          }),
                          class: normalizeClass((__props.fixedHeader || col.fixed) && "fixed-cell"),
                          onClick: ($event) => col.sort !== false && sortAndFilter(col.field)
                        }, [
                          col.sort !== false ? (openBlock(), createElementBlock("i", {
                            key: 0,
                            class: normalizeClass(["datatable-sort-icon fas fa-arrow-up", orderBy.value && orderKey.value === col.field && "active"]),
                            style: normalizeStyle({
                              transform: orderBy.value === "desc" && orderKey.value === col.field ? "rotate(180deg)" : "rotate(0deg)"
                            })
                          }, null, 6)) : createCommentVNode("", true),
                          createTextVNode(" " + toDisplayString(col.label), 1)
                        ], 14, _hoisted_4$8);
                      }), 128))
                    ])
                  ])) : createCommentVNode("", true),
                  data.value.rows && data.value.rows.length > 0 || __props.loading ? (openBlock(), createElementBlock("tbody", _hoisted_5$7, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(data.value.rows.slice(
                      pageKey.value * rowsPerPage.value,
                      pageKey.value * rowsPerPage.value + rowsPerPage.value
                    ), (row, rowKey) => {
                      return openBlock(), createElementBlock("tr", {
                        key: "row-" + row.mdbIndex,
                        "data-mdb-index": row.mdbIndex,
                        class: normalizeClass(row.selected && "active"),
                        scope: "row",
                        onClick: ($event) => handleRowClick(row.mdbIndex)
                      }, [
                        __props.selectable ? (openBlock(), createElementBlock("td", _hoisted_7$5, [
                          createVNode(_sfc_main$M, {
                            modelValue: row.selected,
                            "onUpdate:modelValue": ($event) => row.selected = $event,
                            "data-mdb-row-index": row.mdbIndex,
                            onClick: _cache[1] || (_cache[1] = withModifiers(() => {
                            }, ["stop"])),
                            onChange: ($event) => handleCheckboxChange(row.mdbIndex, row.selected)
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "data-mdb-row-index", "onChange"])
                        ])) : createCommentVNode("", true),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(data.value.columns, (col, colKey) => {
                          return openBlock(), createElementBlock("td", {
                            key: "cell-" + colKey,
                            style: normalizeStyle([
                              row.formats && row.formats[col.field],
                              {
                                minWidth: col.width + "px",
                                maxWidth: col.width + "px",
                                left: col.fixed && !col.right ? col.left + "px" : false,
                                right: col.fixed && col.right ? 0 : false
                              }
                            ]),
                            class: normalizeClass(col.fixed && "fixed-cell"),
                            contenteditable: __props.edit ? true : null,
                            onBlur: ($event) => handleCellBlur($event, rowKey, col.field),
                            innerHTML: row[col.field] ? row[col.field] : row[col.field] === 0 ? 0 : __props.defaultValue
                          }, null, 46, _hoisted_8$4);
                        }), 128))
                      ], 10, _hoisted_6$6);
                    }), 128))
                  ])) : (openBlock(), createElementBlock("tbody", _hoisted_9$4, [
                    createElementVNode("tr", null, [
                      createElementVNode("td", null, toDisplayString(__props.noFoundMessage), 1)
                    ])
                  ]))
                ])
              ]),
              _: 1
            }, 8, ["width", "height"])
          ]),
          __props.loading ? (openBlock(), createElementBlock("div", _hoisted_10$3, [
            createElementVNode("span", _hoisted_11, [
              createElementVNode("span", {
                class: normalizeClass(["datatable-progress", __props.loaderClass])
              }, null, 2)
            ])
          ])) : createCommentVNode("", true),
          __props.loading ? (openBlock(), createElementBlock("p", _hoisted_12, "Loading results...")) : createCommentVNode("", true),
          __props.pagination ? (openBlock(), createElementBlock("div", _hoisted_13, [
            createElementVNode("div", _hoisted_14, [
              createElementVNode("p", _hoisted_15, toDisplayString(__props.rowsText), 1),
              createVNode(_sfc_main$m, {
                options: selectOptions.value,
                "onUpdate:options": _cache[2] || (_cache[2] = ($event) => selectOptions.value = $event),
                selected: rowsPerPage.value,
                "onUpdate:selected": _cache[3] || (_cache[3] = ($event) => rowsPerPage.value = $event)
              }, null, 8, ["options", "selected"])
            ]),
            createElementVNode("div", _hoisted_16, toDisplayString(unref(hasRows) ? `${unref(firstRowIndex)} - ${unref(lastRowIndex)}` : 0) + " " + toDisplayString(__props.ofPaginationText) + " " + toDisplayString(data.value.rows ? data.value.rows.length : ""), 1),
            createElementVNode("div", _hoisted_17, [
              __props.fullPagination ? (openBlock(), createBlock(_sfc_main$1C, {
                key: 0,
                ripple: false,
                color: "link",
                class: "datatable-pagination-button datatable-pagination-start",
                disabled: pageKey.value === 0 ? true : null,
                onClick: _cache[4] || (_cache[4] = () => {
                  pageKey.value = 0;
                  _ctx.$nextTick(() => _ctx.$emit("render", data.value));
                })
              }, {
                default: withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["disabled"])) : createCommentVNode("", true),
              createVNode(_sfc_main$1C, {
                ripple: false,
                color: "link",
                class: "datatable-pagination-button datatable-pagination-left",
                disabled: pageKey.value === 0 ? true : null,
                onClick: _cache[5] || (_cache[5] = () => {
                  pageKey.value--;
                  _ctx.$nextTick(() => _ctx.$emit("render", data.value));
                })
              }, {
                default: withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["disabled"]),
              createVNode(_sfc_main$1C, {
                ripple: false,
                color: "link",
                class: "datatable-pagination-button datatable-pagination-right",
                disabled: pageKey.value === unref(pages) - 1 || unref(pages) === 0 ? true : null,
                onClick: _cache[6] || (_cache[6] = () => {
                  pageKey.value++;
                  _ctx.$nextTick(() => _ctx.$emit("render", data.value));
                })
              }, {
                default: withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["disabled"]),
              __props.fullPagination ? (openBlock(), createBlock(_sfc_main$1C, {
                key: 1,
                ripple: false,
                color: "link",
                class: "datatable-pagination-button datatable-pagination-start",
                disabled: pageKey.value === unref(pages) - 1 || unref(pages) === 0 ? true : null,
                onClick: _cache[7] || (_cache[7] = () => {
                  pageKey.value = unref(pages) - 1;
                  _ctx.$nextTick(() => _ctx.$emit("render", data.value));
                })
              }, {
                default: withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["disabled"])) : createCommentVNode("", true)
            ])
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "style"]);
    };
  }
});
const handlers = {
  tap: (e, data) => {
    if (e.touches.length === data.pointers) {
      data.origin = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      };
      data.tapCount += 1;
      if (data.tapCount === 1) {
        data.timer = setTimeout(() => {
          data.tapCount = 0;
        }, data.interval);
      }
      if (data.timer && data.tapCount === data.taps) {
        clearTimeout(data.timer);
        data.tapCount = 0;
        data.callback({
          origin: data.origin
        });
      }
    }
  },
  swipe: (e, data) => {
    if (e.type === "touchstart") {
      data.startTouch = e;
    } else if (e.type === "touchmove" && data.startTouch instanceof TouchEvent) {
      e.preventDefault();
      if (!data.startTouch) {
        return;
      }
      data.touch = e;
      const { clientX, clientY } = data.startTouch.touches[0];
      const { clientX: x, clientY: y } = data.touch.touches[0];
      const moveValue = {
        x: x - clientX,
        y: y - clientY
      };
      const displacement = {
        x: {
          direction: moveValue.x < 0 ? "left" : "right",
          value: Math.abs(moveValue.x)
        },
        y: {
          direction: moveValue.y < 0 ? "up" : "down",
          value: Math.abs(moveValue.y)
        }
      };
      if (data.direction === "all" && (displacement.x.value > data.threshold || displacement.y.value > data.threshold)) {
        const direction = displacement.y.value > displacement.x.value ? displacement.y.direction : displacement.x.direction;
        data.callback(direction);
        data.startTouch = null;
        data.touch = null;
      } else {
        const axis = data.direction === "left" || data.direction === "right" || data.direction === "x" ? "x" : "y";
        if (displacement[axis].value > data.threshold && (data.direction === axis || displacement[axis].direction === data.direction)) {
          data.callback(displacement[axis].direction);
          data.startTouch = null;
          data.touch = null;
        }
      }
    }
  },
  pinch(e, data) {
    if (e.touches.length < 2 && e.type !== "touchend") {
      return;
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    if (e.type === "touchstart") {
      const [touch1, touch2] = e.touches;
      data.startTouch = Math.sqrt(
        (touch2.clientX - touch1.clientX) ** 2 + (touch2.clientY - touch1.clientY) ** 2
      );
      data.origin = {
        x: touch1.clientX + (touch2.clientX - touch1.clientX) / 2,
        y: touch1.clientY + (touch2.clientY - touch1.clientY) / 2
      };
      const ratio2 = typeof data.touch === "number" ? data.touch / data.startTouch : void 0;
      data.callback({
        ratio: ratio2,
        origin: data.origin
      });
    } else if (e.type === "touchmove") {
      const [touch1, touch2] = e.touches;
      data.touch = Math.sqrt(
        (touch2.clientX - touch1.clientX) ** 2 + (touch2.clientY - touch1.clientY) ** 2
      );
    }
    const ratio = typeof data.touch === "number" && typeof data.startTouch === "number" ? data.touch / data.startTouch : void 0;
    data.callback({
      ratio,
      origin: data.origin
    });
  },
  press(e, data) {
    if (e.touches.length !== data.pointers) {
      return;
    }
    if (e.type === "touchstart") {
      data.startTouch = e;
      data.timeout = setTimeout(() => {
        data.callback();
        data.timeout = "complete";
      }, data.time);
    } else if (e.type === "touchend") {
      if (typeof data.timeout === "number") {
        clearTimeout(data.timeout);
      }
      if (data.startTouch instanceof TouchEvent) {
        e.timeStamp - data.startTouch.timeStamp > data.time && data.timeout !== "complete" && data.callback();
      }
    }
  },
  rotate(e, data) {
    if (e.type === "touchstart") {
      e.preventDefault();
      data.origin = {};
      if (e.touches.length === 1 && data.pointers === 1) {
        const { left: left2, top: top2, width, height } = data.element.getBoundingClientRect();
        data.origin.pivot = {
          x: left2 + width / 2,
          y: top2 + height / 2
        };
      } else if (e.touches.length === 2 && data.pointers === 2) {
        const [t2, t1] = e.touches;
        const position = {
          x1: t1.clientX,
          x2: t2.clientX,
          y1: t1.clientY,
          y2: t2.clientY
        };
        data.origin.pivot = {
          x: (position.x1 + position.x2) / 2,
          y: (position.y1 + position.y2) / 2
        };
      } else {
        return;
      }
    } else if (e.type === "touchmove") {
      e.preventDefault();
      let input;
      if (e.touches.length === 1 && data.pointers === 1) {
        input = e.touches[0];
      } else if (e.touches.length === 2 && data.pointers === 2) {
        const getRightMostTouch = (touches) => {
          let rightMost = null;
          const distance = Number.MIN_VALUE;
          const touchesArray = Array.from(touches);
          touchesArray.forEach((touch2) => {
            if (touch2.clientX > distance) {
              rightMost = touch2;
            }
          });
          return rightMost;
        };
        input = getRightMostTouch(e.touches);
      } else {
        return;
      }
      const getAngle = (x1, y1, x2, y2) => {
        const value = Math.atan2(y2 - y1, x2 - x1);
        const result2 = value * (180 / Math.PI);
        return Math.round(result2 + 360) % 360;
      };
      if (data.origin.pivot && input) {
        data.origin.currentAngle = getAngle(
          data.origin.pivot.x,
          data.origin.pivot.y,
          input.clientX,
          input.clientY
        );
      }
      if (!data.origin.initialAngle) {
        data.origin.initialAngle = data.origin.previousAngle = data.origin.currentAngle;
        data.origin.distance = data.origin.change = 0;
      } else if (data.origin.currentAngle && data.origin.previousAngle && data.origin.distance) {
        data.origin.change = data.origin.currentAngle - data.origin.previousAngle;
        data.origin.distance += data.origin.change;
      }
      data.origin.previousAngle = data.origin.currentAngle;
      const result = {
        currentAngle: data.origin.currentAngle,
        distance: data.origin.distance,
        change: data.origin.change
      };
      data.callback(result);
    } else if (e.type === "touchend") {
      data.origin = {};
    }
  },
  pan(e, data) {
    if (e.type === "touchstart") {
      data.startTouch = e;
    } else if (e.type === "touchmove" && data.startTouch) {
      e.preventDefault();
      data.touch = e;
      const startTouch = data.startTouch;
      const { clientX, clientY } = startTouch.touches[0];
      const { clientX: x, clientY: y } = data.touch.touches[0];
      let movement = {
        x: 0,
        y: 0
      };
      const moveValue = {
        x: x - clientX,
        y: y - clientY
      };
      const displacement = {
        x: {
          direction: moveValue.x < 0 ? "left" : "right",
          value: Math.abs(moveValue.x)
        },
        y: {
          direction: moveValue.y < 0 ? "up" : "down",
          value: Math.abs(moveValue.y)
        }
      };
      if (data.direction === "all" && (displacement.x.value > data.threshold || displacement.y.value > data.threshold)) {
        movement = {
          x: moveValue.x,
          y: moveValue.y
        };
        data.callback(movement);
        data.startTouch = data.touch;
      } else {
        const axis = data.direction === "left" || data.direction === "right" || data.direction === "x" ? "x" : "y";
        if (displacement[axis].value > data.threshold && (data.direction === axis || displacement[axis].direction === data.direction)) {
          movement[axis] = moveValue[axis];
          data.callback(movement);
          data.startTouch = data.touch;
        }
      }
    }
  }
};
var vMdbTouch = {
  mounted(el, binding) {
    if (binding.value === false)
      return;
    const { arg, modifiers } = binding;
    const argToPass = arg;
    el.data = {
      ...el.data,
      [argToPass]: null
    };
    el.data[argToPass] = {
      element: el,
      startTouch: null,
      touch: null,
      timeout: null,
      origin: {
        x: 0,
        y: 0
      },
      tapCount: 0,
      modifiers,
      angle: binding.value.angle || 0,
      threshold: binding.value.threshold || 20,
      direction: binding.value.direction || "all",
      interval: binding.value.interval || 500,
      timer: null,
      time: binding.value.time || 250,
      taps: binding.value.taps || 1,
      pointers: binding.value.pointers || 1,
      callback: binding.value.callback || binding.value
    };
    const argInHandlers = arg;
    const argInData = arg;
    const data = el.data;
    el.addEventListener(
      "touchstart",
      (e) => handlers[argInHandlers](e, data[argInData])
    );
    if (arg !== "tap") {
      el.addEventListener(
        "touchmove",
        (e) => handlers[argInHandlers](e, data[argInData])
      );
      el.addEventListener(
        "touchend",
        (e) => handlers[argInHandlers](e, data[argInData])
      );
    }
  },
  updated(el, binding) {
    if (binding.value === false)
      return;
    const { arg } = binding;
    const argInData = arg;
    const data = el.data;
    Object.keys(binding.value).forEach((key) => {
      if (binding.value[key] !== binding.oldValue[key]) {
        data[argInData] = {
          ...data[argInData],
          [key]: binding.value[key]
        };
      }
    });
  },
  unmounted(el, binding) {
    if (binding.value === false)
      return;
    const { arg } = binding;
    const argInHandlers = arg;
    el.removeEventListener("touchstart", () => handlers[argInHandlers]);
    el.removeEventListener("touchend", () => handlers[argInHandlers]);
    el.removeEventListener("touchmove", () => handlers[argInHandlers]);
  }
};
var vMdbScrollLock = {
  mounted(el, binding) {
    let { x: blockX, y: blockY } = binding.modifiers;
    const blocked = binding.value === void 0 ? true : binding.value;
    if (blockX === void 0 && blockY === void 0) {
      blockX = true;
      blockY = true;
    }
    el.blockScroll = () => {
      const body = document.querySelector("body");
      if (blockY && body) {
        el.prevOverflowY = body.style.overflowY;
        body.style.overflowY = "hidden";
      }
      if (blockX && body) {
        el.prevOverflowX = body.style.overflowX;
        body.style.overflowX = "hidden";
      }
    };
    el.enableScroll = () => {
      const body = document.querySelector("body");
      if (blockY && body)
        body.style.overflowY = el.prevOverflowY;
      if (blockX && body)
        body.style.overflowX = el.prevOverflowX;
    };
    if (blocked)
      el.blockScroll();
  },
  updated(el, binding) {
    if (binding.value === void 0)
      return;
    if (binding.value)
      el.blockScroll();
    else
      el.enableScroll();
  },
  unmounted(el) {
    el.enableScroll();
  }
};
const _hoisted_1$e = ["onClick"];
const __default__$5 = {
  inheritAttrs: false
};
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  ...__default__$5,
  __name: "MDBSideNav",
  props: {
    tag: {
      type: String,
      default: "nav"
    },
    color: {
      type: String,
      default: "primary"
    },
    classes: String,
    modelValue: Boolean,
    relative: {
      type: Boolean,
      default: false
    },
    absolute: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "over",
      validator: (value) => ["over", "side", "push"].indexOf(value.toLowerCase()) > -1
    },
    light: {
      type: Boolean,
      defualt: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    slim: {
      type: Boolean,
      default: false
    },
    slimCollapsed: {
      type: Boolean,
      default: true
    },
    slimWidth: {
      type: Number,
      default: 60
    },
    sidenavWidth: {
      type: Number,
      default: 240
    },
    backdrop: {
      type: Boolean,
      default: true
    },
    backdropClass: String,
    backdropStyle: String,
    contentSelector: String,
    id: String,
    modeBreakpoint: Number,
    closeOnEsc: {
      type: Boolean,
      default: false
    },
    expandOnHover: {
      type: Boolean,
      default: false
    },
    scrollLock: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const sidenav = ref("sidenav");
    const isMounted = ref(false);
    const className = computed(() => {
      return [
        "sidenav",
        props.color && `sidenav-${props.color}`,
        props.absolute && "sidenav-absolute",
        props.relative && "sidenav-relative",
        props.light && "sidenav-light",
        props.right && "sidenav-right",
        props.slim && "sidenav-slim",
        props.slim && props.slimCollapsed && isSlimCollapsed.value && "sidenav-slim-collapsed",
        props.classes
      ];
    });
    const transitionName = computed(() => {
      return props.right ? "right-sidenav" : "sidenav";
    });
    const isBackdropActive = computed(() => {
      if (isMounted.value && props.backdrop && isActive.value && sidenavMode.value === "over") {
        return true;
      }
      return false;
    });
    const getSidenavScrollheight = () => {
      var _a;
      if (props.relative || props.absolute) {
        const parent = sidenav.value.parentNode;
        return (_a = parent.offsetHeight) != null ? _a : null;
      }
      return window.innerHeight;
    };
    const handleHeightChange = () => {
      windowHeight.value = getSidenavScrollheight();
    };
    const windowHeight = ref(null);
    const sidenavMode = ref(props.mode);
    const toggleButton = ref(null);
    const windowWidth = ref(window.innerWidth);
    const modeTransitionOver = ref(false);
    const handleModeTransitionResize = () => {
      windowWidth.value = window.innerWidth;
      if (window.innerWidth < props.modeBreakpoint) {
        sidenavMode.value = "over";
        emit("update:modelValue", false);
        modeTransitionOver.value = true;
        if (toggleButton.value) {
          toggleButton.value.style.display = "unset";
        }
      } else {
        sidenavMode.value = "side";
        if (!isActive.value) {
          emit("update:modelValue", true);
        }
        modeTransitionOver.value = false;
        if (toggleButton.value) {
          toggleButton.value.style.display = "none";
        }
      }
      setContentOffset(sidenavMode.value);
    };
    const pageContent = ref(null);
    const contentOffsetWidth = computed(() => {
      if (isActive.value) {
        return props.slim ? props.slimCollapsed ? props.slimWidth : props.slimWidth + props.sidenavWidth : props.sidenavWidth;
      }
      return 0;
    });
    const setContentOffset = (value) => {
      if (!pageContent.value) {
        pageContent.value = document.querySelector(props.contentSelector);
      }
      const marginProperty = props.right ? "margin-left" : "margin-right";
      const paddingProperty = props.right ? "padding-right" : "padding-left";
      if (!pageContent.value)
        return;
      pageContent.value.style.transition = "all 0.3s linear 0s";
      if (value === "push") {
        pageContent.value.style[marginProperty] = -1 * contentOffsetWidth.value + "px";
        pageContent.value.style[paddingProperty] = contentOffsetWidth.value + 20 + "px";
      } else if (value === "side") {
        pageContent.value.style[marginProperty] = "0px";
        pageContent.value.style[paddingProperty] = contentOffsetWidth.value + 20 + "px";
      } else if (value === "over") {
        pageContent.value.style[paddingProperty] = "20px";
        pageContent.value.style[marginProperty] = "0px";
      }
      setTimeout(() => {
        pageContent.value.style.transition = "all 0.3s ease 0s";
      }, 300);
    };
    const isActive = ref(props.modelValue);
    const setFocusTrapHandler = () => {
      nextTick(() => {
        calculateFocusTrap();
        on(window, "keydown", focusFirstElement);
      });
    };
    watch(
      () => props.modelValue,
      (cur) => {
        isActive.value = cur;
        if (isActive.value && sidenavMode.value === "over") {
          setFocusTrapHandler();
        }
        if (isActive.value && props.closeOnEsc) {
          bindHandleEscapeClick();
        }
        setContentOffset(sidenavMode.value);
      }
    );
    watchEffect(() => sidenavMode.value = props.mode);
    watch(
      () => props.mode,
      (cur) => {
        if (isActive.value) {
          setContentOffset(cur);
          if (cur === "over") {
            setFocusTrapHandler();
          } else if (cur !== "over" && lastFocusableElement && lastFocusableElement.value) {
            removeFocusTrap();
          }
        }
      }
    );
    const parentsEl = (element, selector) => {
      const parents = [];
      let ancestor = element.parentNode;
      while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== 3) {
        if (ancestor.matches(selector)) {
          parents.push(ancestor);
        }
        ancestor = ancestor.parentNode;
      }
      return parents;
    };
    const prevEl = (element, selector) => {
      let previous = element.previousElementSibling;
      while (previous) {
        if (previous.matches(selector)) {
          return [previous];
        }
        previous = previous.previousElementSibling;
      }
      return [];
    };
    const activeNode = ref(null);
    const setActiveNode = (id, node) => {
      activeNode.value = id;
      const [collapse] = parentsEl(node, ".sidenav-collapse");
      if (!collapse) {
        setActiveCategory();
        return;
      }
      const [category] = prevEl(collapse, ".sidenav-link");
      setActiveCategory(category);
    };
    const setActiveCategory = (el = void 0) => {
      [...sidenav.value.querySelectorAll(".sidenav-menu")].forEach(
        (menu) => {
          const collapses = menu.querySelectorAll(
            ".sidenav-collapse"
          );
          collapses.forEach((collapse) => {
            const [collapseToggler] = prevEl(collapse, ".sidenav-link");
            if (!el || collapseToggler.id !== el.id) {
              collapseToggler.classList.remove("active");
            } else {
              collapseToggler.classList.add("active");
            }
          });
        }
      );
    };
    provide("activeNode", activeNode);
    provide("setActiveNode", setActiveNode);
    const bindHandleEscapeClick = () => {
      on(document, "keydown", handleEscKey);
    };
    const handleEscKey = (event) => {
      if (props.closeOnEsc && event.key === "Escape" && toggleButton.value && toggleButton.value.style.display !== "none") {
        emit("update:modelValue", false);
        off(document, "keydown", handleEscKey);
      }
    };
    const hideSideNav = () => {
      emit("update:modelValue", false);
    };
    const firstFocusableElement = ref(null);
    const lastFocusableElement = ref(null);
    const calculateFocusTrap = () => {
      const focusable = Array.from(
        sidenav.value.querySelectorAll(
          'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => {
        return !el.classList.contains("ps__thumb-x") && !el.classList.contains("ps__thumb-y");
      });
      if (focusable.length === 0)
        return;
      firstFocusableElement.value = focusable[0];
      const lastElement = focusable[focusable.length - 1];
      if (lastFocusableElement.value && lastFocusableElement.value !== lastElement) {
        off(lastFocusableElement.value, "blur", focusTrap);
      }
      lastFocusableElement.value = lastElement;
      on(lastFocusableElement.value, "blur", focusTrap);
    };
    const focusTrap = () => {
      if (!firstFocusableElement.value)
        return;
      firstFocusableElement.value.focus();
    };
    const focusFirstElement = (event) => {
      if (isActive.value && event.key === "Tab") {
        event.preventDefault();
        focusTrap();
      }
      off(window, "keydown", focusFirstElement);
    };
    const removeFocusTrap = () => {
      off(lastFocusableElement.value, "blur", focusTrap);
    };
    const isSlimCollapsed = ref(props.slimCollapsed);
    watch(
      () => [props.slim, props.slimCollapsed],
      () => {
        setContentOffset(sidenavMode.value);
      }
    );
    const mockSpacebarJump = (event) => {
      if (event.key !== " ") {
        return;
      }
      const jumpBy = 0.87 * window.innerHeight;
      const windowFromTop = window.scrollY;
      window.scrollTo(0, windowFromTop + jumpBy);
    };
    const onMouseEnter = () => {
      on(window, "keydown", mockSpacebarJump);
    };
    const onMouseLeave = () => {
      if (props.slim && props.expandOnHover) {
        isSlimCollapsed.value = true;
      }
      off(window, "keydown", mockSpacebarJump);
    };
    const onMouseOver = () => {
      if (props.slim && props.expandOnHover) {
        isSlimCollapsed.value = false;
      }
    };
    const swipe = (direction) => {
      let isOpenSwipeDirection = direction === "right" ? true : false;
      if (props.right) {
        isOpenSwipeDirection = !isOpenSwipeDirection;
      }
      if (props.slim && isSlimCollapsed.value && isOpenSwipeDirection) {
        isSlimCollapsed.value = false;
        return;
      }
      if (props.slim && !isSlimCollapsed.value && !isOpenSwipeDirection) {
        isSlimCollapsed.value = true;
      }
    };
    provide("sidenavColor", props.color);
    onBeforeMount(() => {
      if (props.modeBreakpoint && window.innerWidth < props.modeBreakpoint) {
        emit("update:modelValue", false);
        isActive.value = false;
      }
    });
    onMounted(() => {
      isMounted.value = true;
      if (props.contentSelector) {
        pageContent.value = document.querySelector(props.contentSelector);
      }
      if (props.modelValue) {
        setContentOffset(props.mode);
      }
      if (props.mode === "over") {
        setFocusTrapHandler();
      }
      if (props.closeOnEsc) {
        bindHandleEscapeClick();
      }
      toggleButton.value = document.querySelector(`[aria-controls="#${props.id}"]`);
      if (props.dark) {
        sidenav.value.style.backgroundColor = "#2d2c2c";
      }
      windowHeight.value = getSidenavScrollheight();
      on(window, "resize", handleHeightChange);
      if (props.modeBreakpoint) {
        handleModeTransitionResize();
        on(window, "resize", handleModeTransitionResize);
      }
      on(window, "keydown", focusFirstElement);
    });
    onUnmounted(() => {
      off(window, "resize", handleModeTransitionResize);
      off(window, "resize", handleHeightChange);
      off(document, "keydown", handleEscKey);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(Transition, { name: unref(transitionName) }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
              class: unref(className),
              id: __props.id
            }, _ctx.$attrs, {
              ref_key: "sidenav",
              ref: sidenav,
              onMouseenter: onMouseEnter,
              onMouseover: onMouseOver,
              onMouseleave: onMouseLeave
            }), {
              default: withCtx(() => [
                createVNode(_sfc_main$p, {
                  disableKeyboard: "",
                  suppressScrollX: "",
                  height: `${windowHeight.value}px`
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["height"])
              ]),
              _: 3
            }, 16, ["class", "id"])), [
              [vShow, isActive.value],
              [unref(vMdbTouch), {
                callback: swipe,
                direction: "x"
              }, "swipe"],
              [unref(vMdbScrollLock), __props.scrollLock]
            ])
          ]),
          _: 3
        }, 8, ["name"]),
        createVNode(Transition, { name: "backdrop" }, {
          default: withCtx(() => [
            unref(isBackdropActive) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["sidenav-backdrop", __props.backdropClass]),
              style: normalizeStyle(__props.backdropStyle),
              onClick: withModifiers(hideSideNav, ["self"])
            }, null, 14, _hoisted_1$e)) : createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
const __default__$4 = {
  inheritAttrs: false
};
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  ...__default__$4,
  __name: "MDBSideNavMenu",
  props: {
    tag: {
      type: String,
      default: "ul"
    },
    classes: String,
    accordion: {
      type: Boolean,
      default: false
    },
    scrollContainer: Boolean
  },
  setup(__props) {
    const props = __props;
    const className = computed(() => {
      return ["sidenav-menu", props.classes];
    });
    const accordionState = reactive({
      itemsCount: 0,
      active: null
    });
    const incrementAccordionItemsCount = () => {
      accordionState.itemsCount++;
      return accordionState.itemsCount;
    };
    const setAccordionActiveItem = (item) => {
      accordionState.active = item;
    };
    provide("accordionState", props.accordion ? accordionState : null);
    provide("incrementAccordionItemsCount", incrementAccordionItemsCount);
    provide("setAccordionActiveItem", setAccordionActiveItem);
    onMounted(() => {
      if (props.scrollContainer) {
        setupScrollContent();
      }
    });
    const sidenavMenu = ref("sidenavMenu");
    const scrollElementHeight = ref("100%");
    const setupScrollContent = () => {
      const scrollElement = sidenavMenu.value;
      const siblings = Array.from(
        scrollElement.parentNode.parentNode.children
      ).filter((el) => el !== scrollElement.parentNode);
      const siblingsHeight = siblings.reduce((a, b) => {
        return a + b.clientHeight;
      }, 0);
      scrollElementHeight.value = `calc(100% - ${siblingsHeight}px)`;
    };
    return (_ctx, _cache) => {
      return __props.scrollContainer ? (openBlock(), createBlock(_sfc_main$p, {
        key: 0,
        height: scrollElementHeight.value,
        suppressScrollX: ""
      }, {
        default: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({ class: unref(className) }, _ctx.$attrs, {
            ref_key: "sidenavMenu",
            ref: sidenavMenu
          }), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16, ["class"]))
        ]),
        _: 3
      }, 8, ["height"])) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 1,
        class: unref(className)
      }, _ctx.$attrs, {
        ref_key: "sidenavMenu",
        ref: sidenavMenu
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"]));
    };
  }
});
const __default__$3 = {
  inheritAttrs: false
};
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  ...__default__$3,
  __name: "MDBSideNavLink",
  props: {
    tag: {
      type: String,
      default: "a"
    },
    id: String,
    href: String,
    to: [String, Object],
    exact: {
      type: Boolean,
      default: false
    },
    newTab: {
      type: Boolean,
      default: false
    },
    classes: String,
    icon: String,
    iconStyle: String,
    iconSize: String,
    iconFlag: String,
    iconClass: String,
    modelValue: Boolean,
    ripple: {
      type: [Object, Boolean],
      default: true
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const uid2 = ref(props.id || getUID("MDBSideNavLink-"));
    const sidenavLink = ref("sidenavLink");
    const hasCollapsibleContent = inject(
      "hasCollapsibleContent",
      false
    );
    const activeNode = inject("activeNode", false);
    const setActiveNode = inject("setActiveNode", false);
    const activeClass = computed(
      () => activeNode && activeNode.value === uid2.value
    );
    const className = computed(() => {
      return ["sidenav-link", activeClass.value ? "active" : null, props.classes];
    });
    const isOpened = ref(props.modelValue);
    const rotateIcon = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (cur) => {
        isOpened.value = cur;
        rotateIcon.value = cur;
      }
    );
    let isToggling = false;
    const toggleActive = () => {
      if (isToggling) {
        return;
      }
      isToggling = true;
      if (hasCollapsibleContent && hasCollapsibleContent.value) {
        emit("update:modelValue", !props.modelValue);
      } else {
        isOpened.value = true;
      }
      setActiveNode && setActiveNode(uid2.value, sidenavLink.value);
      setTimeout(() => {
        isToggling = false;
      }, 300);
    };
    const tab = computed(() => {
      if (props.newTab) {
        return "_blank";
      }
      return false;
    });
    const iconClasses = computed(() => {
      return ["rotate-icon", props.iconClass];
    });
    const iconTransform = computed(() => {
      return { transform: `rotate(${isOpened.value ? 180 : 0}deg)` };
    });
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        if (hasCollapsibleContent && hasCollapsibleContent.value) {
          emit("update:modelValue", !props.modelValue);
        } else {
          toggleActive();
        }
      }
    };
    const openCollapse = inject("openCollapse", false);
    const openParentCollapse = () => {
      if (openCollapse) {
        openCollapse();
        emit("update:modelValue", true);
      }
    };
    const rippleConfig = ref(
      typeof props.ripple === "boolean" ? { color: inject("sidenavColor", "primary") } : {
        color: inject("sidenavColor", "primary"),
        ...props.ripple
      }
    );
    onMounted(() => {
      if (window.location.href === props.href || window.location.hash && window.location.hash.substring(1) === props.to || window.location.pathname !== "/" && window.location.pathname === props.to) {
        toggleActive();
        openParentCollapse();
      }
    });
    return (_ctx, _cache) => {
      const _component_router_link = resolveComponent("router-link");
      return __props.to ? withDirectives((openBlock(), createBlock(_component_router_link, mergeProps({
        key: 0,
        id: uid2.value,
        ref_key: "sidenavLink",
        ref: sidenavLink,
        class: unref(className),
        exact: __props.exact,
        to: __props.to,
        target: unref(tab),
        "active-class": "active",
        "exact-active-class": "exact-active",
        tabindex: "0"
      }, _ctx.$attrs, {
        onKeydown: handleKeyDown,
        onClick: toggleActive
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          __props.icon ? (openBlock(), createBlock(_sfc_main$17, {
            key: 0,
            icon: __props.icon,
            iconStyle: __props.iconStyle,
            size: __props.iconSize,
            flag: __props.iconFlag,
            class: normalizeClass(unref(iconClasses)),
            style: normalizeStyle(unref(iconTransform))
          }, null, 8, ["icon", "iconStyle", "size", "flag", "class", "style"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["id", "class", "exact", "to", "target"])), [
        [unref(RippleDirective), rippleConfig.value]
      ]) : withDirectives((openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 1,
        id: uid2.value,
        ref_key: "sidenavLink",
        ref: sidenavLink,
        href: __props.href,
        class: unref(className),
        target: unref(tab),
        tabindex: "0"
      }, _ctx.$attrs, {
        onKeydown: handleKeyDown,
        onClick: toggleActive
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          __props.icon ? (openBlock(), createBlock(_sfc_main$17, {
            key: 0,
            icon: __props.icon,
            iconStyle: __props.iconStyle,
            size: __props.iconSize,
            flag: __props.iconFlag,
            class: normalizeClass(unref(iconClasses)),
            style: normalizeStyle(unref(iconTransform))
          }, null, 8, ["icon", "iconStyle", "size", "flag", "class", "style"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["id", "href", "class", "target"])), [
        [unref(RippleDirective), rippleConfig.value]
      ]);
    };
  }
});
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "MDBSideNavItem",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    collapse: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    classes: String,
    icon: String,
    iconStyle: {
      type: String,
      default: "fas"
    },
    iconClass: {
      type: String,
      default: "fa-fw me-3"
    },
    title: String,
    hasArrow: {
      type: Boolean,
      default: true
    },
    nonSlim: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const className = computed(() => {
      return ["sidenav-item", props.classes];
    });
    const nonSlimClass = computed(() => {
      return [props.nonSlim && "sidenav-non-slim"];
    });
    watch(
      () => [props.nonSlim, props.show],
      ([currentSlim, currentShow]) => {
        if (currentSlim && !currentShow) {
          setTimeout(() => {
            spanArray.forEach((element) => {
              element.style.display = "none";
            });
          }, 300);
        } else if (!currentSlim || currentSlim && currentShow) {
          spanArray.forEach((element) => {
            element.style.display = "unset";
          });
        }
      }
    );
    const isArrowIcon = computed(() => {
      return props.hasArrow ? "angle-down" : "";
    });
    const hasCollapsibleContent = ref(false);
    provide("hasCollapsibleContent", hasCollapsibleContent);
    let spanArray;
    onMounted(() => {
      spanArray = [
        ...document.querySelectorAll(
          ".sidenav-non-slim"
        )
      ];
      if (props.nonSlim) {
        spanArray.forEach((element) => {
          element.style.display = "none";
        });
      }
      if (props.collapse) {
        hasCollapsibleContent.value = true;
      }
    });
    const isActive = ref(props.show);
    watch(
      () => props.show,
      (cur) => isActive.value = cur
    );
    return (_ctx, _cache) => {
      return __props.collapse ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 0,
        class: unref(className)
      }, _ctx.$attrs), {
        default: withCtx(() => [
          createVNode(_sfc_main$i, {
            modelValue: isActive.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isActive.value = $event),
            icon: unref(isArrowIcon)
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$17, {
                icon: __props.icon,
                iconStyle: __props.iconStyle,
                class: normalizeClass(__props.iconClass)
              }, null, 8, ["icon", "iconStyle", "class"]),
              createElementVNode("span", {
                class: normalizeClass(unref(nonSlimClass))
              }, toDisplayString(__props.title), 3)
            ]),
            _: 1
          }, 8, ["modelValue", "icon"]),
          createVNode(_sfc_main$1k, {
            modelValue: isActive.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isActive.value = $event),
            sidenav: "",
            tag: "ul"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["modelValue"])
        ]),
        _: 3
      }, 16, ["class"])) : (openBlock(), createBlock(resolveDynamicComponent(__props.tag), mergeProps({
        key: 1,
        class: unref(className)
      }, _ctx.$attrs), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"]));
    };
  }
});
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "MDBNavbar",
  props: {
    tag: {
      type: String,
      default: "nav"
    },
    bg: {
      type: String
    },
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    double: {
      type: Boolean,
      default: false
    },
    expand: {
      type: String
    },
    position: {
      type: String
    },
    transparent: {
      type: Boolean,
      default: false
    },
    scrolling: {
      type: Boolean,
      default: false
    },
    scrollingOffset: {
      type: Number,
      default: 100
    },
    center: {
      type: Boolean,
      default: false
    },
    container: {
      type: [Boolean, String],
      default: false
    },
    classContainer: {
      type: String
    },
    classNavbar: String,
    scroll: Boolean
  },
  setup(__props) {
    const props = __props;
    const isScrolled = ref(false);
    const className = computed(() => {
      return [
        props.scroll && "navbar-scroll",
        isScrolled.value ? "navbar-scrolled" : null,
        props.classNavbar
      ].join(" ");
    });
    const handleScroll = () => {
      if (window.scrollY > 0) {
        isScrolled.value = true;
      } else {
        isScrolled.value = false;
      }
    };
    onMounted(() => {
      on(window, "scroll", handleScroll);
    });
    onUnmounted(() => {
      off(window, "scroll", handleScroll);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$15, mergeProps(_ctx.$props, { classNavbar: unref(className) }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["classNavbar"]);
    };
  }
});
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h3 = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, m = function(t2, e2, n2) {
      var r2 = String(t2);
      return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
    }, g = { s: m, z: function(t2) {
      var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
      return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
    }, m: function t2(e2, n2) {
      if (e2.date() < n2.date())
        return -t2(n2, e2);
      var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, f), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), f);
      return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
    }, a: function(t2) {
      return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
    }, p: function(t2) {
      return { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h3 }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t2) {
      return void 0 === t2;
    } }, v = "en", D = {};
    D[v] = M;
    var p = function(t2) {
      return t2 instanceof _;
    }, S = function t2(e2, n2, r2) {
      var i2;
      if (!e2)
        return v;
      if ("string" == typeof e2) {
        var s2 = e2.toLowerCase();
        D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
        var u2 = e2.split("-");
        if (!i2 && u2.length > 1)
          return t2(u2[0]);
      } else {
        var a2 = e2.name;
        D[a2] = e2, i2 = a2;
      }
      return !r2 && i2 && (v = i2), i2 || !r2 && v;
    }, w = function(t2, e2) {
      if (p(t2))
        return t2.clone();
      var n2 = "object" == typeof e2 ? e2 : {};
      return n2.date = t2, n2.args = arguments, new _(n2);
    }, O = g;
    O.l = S, O.i = p, O.w = function(t2, e2) {
      return w(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
    };
    var _ = function() {
      function M2(t2) {
        this.$L = S(t2.locale, null, true), this.parse(t2);
      }
      var m2 = M2.prototype;
      return m2.parse = function(t2) {
        this.$d = function(t3) {
          var e2 = t3.date, n2 = t3.utc;
          if (null === e2)
            return new Date(NaN);
          if (O.u(e2))
            return new Date();
          if (e2 instanceof Date)
            return new Date(e2);
          if ("string" == typeof e2 && !/Z$/i.test(e2)) {
            var r2 = e2.match(l);
            if (r2) {
              var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t2), this.$x = t2.x || {}, this.init();
      }, m2.init = function() {
        var t2 = this.$d;
        this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
      }, m2.$utils = function() {
        return O;
      }, m2.isValid = function() {
        return !(this.$d.toString() === $);
      }, m2.isSame = function(t2, e2) {
        var n2 = w(t2);
        return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
      }, m2.isAfter = function(t2, e2) {
        return w(t2) < this.startOf(e2);
      }, m2.isBefore = function(t2, e2) {
        return this.endOf(e2) < w(t2);
      }, m2.$g = function(t2, e2, n2) {
        return O.u(t2) ? this[e2] : this.set(n2, t2);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t2, e2) {
        var n2 = this, r2 = !!O.u(e2) || e2, h4 = O.p(t2), $2 = function(t3, e3) {
          var i2 = O.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
          return r2 ? i2 : i2.endOf(a);
        }, l2 = function(t3, e3) {
          return O.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, g2 = "set" + (this.$u ? "UTC" : "");
        switch (h4) {
          case c:
            return r2 ? $2(1, 0) : $2(31, 11);
          case f:
            return r2 ? $2(1, M3) : $2(0, M3 + 1);
          case o:
            var v2 = this.$locale().weekStart || 0, D2 = (y2 < v2 ? y2 + 7 : y2) - v2;
            return $2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
          case a:
          case d:
            return l2(g2 + "Hours", 0);
          case u:
            return l2(g2 + "Minutes", 1);
          case s:
            return l2(g2 + "Seconds", 2);
          case i:
            return l2(g2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t2) {
        return this.startOf(t2, false);
      }, m2.$set = function(t2, e2) {
        var n2, o2 = O.p(t2), h4 = "set" + (this.$u ? "UTC" : ""), $2 = (n2 = {}, n2[a] = h4 + "Date", n2[d] = h4 + "Date", n2[f] = h4 + "Month", n2[c] = h4 + "FullYear", n2[u] = h4 + "Hours", n2[s] = h4 + "Minutes", n2[i] = h4 + "Seconds", n2[r] = h4 + "Milliseconds", n2)[o2], l2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === f || o2 === c) {
          var y2 = this.clone().set(d, 1);
          y2.$d[$2](l2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
        } else
          $2 && this.$d[$2](l2);
        return this.init(), this;
      }, m2.set = function(t2, e2) {
        return this.clone().$set(t2, e2);
      }, m2.get = function(t2) {
        return this[O.p(t2)]();
      }, m2.add = function(r2, h4) {
        var d2, $2 = this;
        r2 = Number(r2);
        var l2 = O.p(h4), y2 = function(t2) {
          var e2 = w($2);
          return O.w(e2.date(e2.date() + Math.round(t2 * r2)), $2);
        };
        if (l2 === f)
          return this.set(f, this.$M + r2);
        if (l2 === c)
          return this.set(c, this.$y + r2);
        if (l2 === a)
          return y2(1);
        if (l2 === o)
          return y2(7);
        var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[l2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return O.w(m3, this);
      }, m2.subtract = function(t2, e2) {
        return this.add(-1 * t2, e2);
      }, m2.format = function(t2) {
        var e2 = this, n2 = this.$locale();
        if (!this.isValid())
          return n2.invalidDate || $;
        var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, f2 = n2.months, h4 = function(t3, n3, i3, s3) {
          return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
        }, c2 = function(t3) {
          return O.s(s2 % 12 || 12, t3, "0");
        }, d2 = n2.meridiem || function(t3, e3, n3) {
          var r3 = t3 < 12 ? "AM" : "PM";
          return n3 ? r3.toLowerCase() : r3;
        }, l2 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a2 + 1, MM: O.s(a2 + 1, 2, "0"), MMM: h4(n2.monthsShort, a2, f2, 3), MMMM: h4(f2, a2), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: h4(n2.weekdaysMin, this.$W, o2, 2), ddd: h4(n2.weekdaysShort, this.$W, o2, 3), dddd: o2[this.$W], H: String(s2), HH: O.s(s2, 2, "0"), h: c2(1), hh: c2(2), a: d2(s2, u2, true), A: d2(s2, u2, false), m: String(u2), mm: O.s(u2, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: i2 };
        return r2.replace(y, function(t3, e3) {
          return e3 || l2[t3] || i2.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d2, $2) {
        var l2, y2 = O.p(d2), M3 = w(r2), m3 = (M3.utcOffset() - this.utcOffset()) * e, g2 = this - M3, v2 = O.m(this, M3);
        return v2 = (l2 = {}, l2[c] = v2 / 12, l2[f] = v2, l2[h3] = v2 / 3, l2[o] = (g2 - m3) / 6048e5, l2[a] = (g2 - m3) / 864e5, l2[u] = g2 / n, l2[s] = g2 / e, l2[i] = g2 / t, l2)[y2] || g2, $2 ? v2 : O.a(v2);
      }, m2.daysInMonth = function() {
        return this.endOf(f).$D;
      }, m2.$locale = function() {
        return D[this.$L];
      }, m2.locale = function(t2, e2) {
        if (!t2)
          return this.$L;
        var n2 = this.clone(), r2 = S(t2, e2, true);
        return r2 && (n2.$L = r2), n2;
      }, m2.clone = function() {
        return O.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), T = _.prototype;
    return w.prototype = T, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function(t2) {
      T[t2[1]] = function(e2) {
        return this.$g(e2, t2[0], t2[1]);
      };
    }), w.extend = function(t2, e2) {
      return t2.$i || (t2(e2, _, w), t2.$i = true), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t2) {
      return w(1e3 * t2);
    }, w.en = D[v], w.Ls = D, w.p = {}, w;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
var isToday$1 = { exports: {} };
(function(module, exports) {
  !function(e, o) {
    module.exports = o();
  }(commonjsGlobal, function() {
    return function(e, o, t) {
      o.prototype.isToday = function() {
        var e2 = "YYYY-MM-DD", o2 = t();
        return this.format(e2) === o2.format(e2);
      };
    };
  });
})(isToday$1);
var isToday = isToday$1.exports;
var customParseFormat$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e2) {
      return (e2 = +e2) + (e2 > 68 ? 1900 : 2e3);
    };
    var a = function(e2) {
      return function(t2) {
        this[e2] = +t2;
      };
    }, f = [/[+-]\d\d:?(\d\d)?|Z/, function(e2) {
      (this.zone || (this.zone = {})).offset = function(e3) {
        if (!e3)
          return 0;
        if ("Z" === e3)
          return 0;
        var t2 = e3.match(/([+-]|\d\d)/g), n2 = 60 * t2[1] + (+t2[2] || 0);
        return 0 === n2 ? 0 : "+" === t2[0] ? -n2 : n2;
      }(e2);
    }], h3 = function(e2) {
      var t2 = o[e2];
      return t2 && (t2.indexOf ? t2 : t2.s.concat(t2.f));
    }, u = function(e2, t2) {
      var n2, r2 = o.meridiem;
      if (r2) {
        for (var i2 = 1; i2 <= 24; i2 += 1)
          if (e2.indexOf(r2(i2, 0, t2)) > -1) {
            n2 = i2 > 12;
            break;
          }
      } else
        n2 = e2 === (t2 ? "pm" : "PM");
      return n2;
    }, d = { A: [i, function(e2) {
      this.afternoon = u(e2, false);
    }], a: [i, function(e2) {
      this.afternoon = u(e2, true);
    }], S: [/\d/, function(e2) {
      this.milliseconds = 100 * +e2;
    }], SS: [n, function(e2) {
      this.milliseconds = 10 * +e2;
    }], SSS: [/\d{3}/, function(e2) {
      this.milliseconds = +e2;
    }], s: [r, a("seconds")], ss: [r, a("seconds")], m: [r, a("minutes")], mm: [r, a("minutes")], H: [r, a("hours")], h: [r, a("hours")], HH: [r, a("hours")], hh: [r, a("hours")], D: [r, a("day")], DD: [n, a("day")], Do: [i, function(e2) {
      var t2 = o.ordinal, n2 = e2.match(/\d+/);
      if (this.day = n2[0], t2)
        for (var r2 = 1; r2 <= 31; r2 += 1)
          t2(r2).replace(/\[|\]/g, "") === e2 && (this.day = r2);
    }], M: [r, a("month")], MM: [n, a("month")], MMM: [i, function(e2) {
      var t2 = h3("months"), n2 = (h3("monthsShort") || t2.map(function(e3) {
        return e3.slice(0, 3);
      })).indexOf(e2) + 1;
      if (n2 < 1)
        throw new Error();
      this.month = n2 % 12 || n2;
    }], MMMM: [i, function(e2) {
      var t2 = h3("months").indexOf(e2) + 1;
      if (t2 < 1)
        throw new Error();
      this.month = t2 % 12 || t2;
    }], Y: [/[+-]?\d+/, a("year")], YY: [n, function(e2) {
      this.year = s(e2);
    }], YYYY: [/\d{4}/, a("year")], Z: f, ZZ: f };
    function c(n2) {
      var r2, i2;
      r2 = n2, i2 = o && o.formats;
      for (var s2 = (n2 = r2.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t2, n3, r3) {
        var o2 = r3 && r3.toUpperCase();
        return n3 || i2[r3] || e[r3] || i2[o2].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e2, t3, n4) {
          return t3 || n4.slice(1);
        });
      })).match(t), a2 = s2.length, f2 = 0; f2 < a2; f2 += 1) {
        var h4 = s2[f2], u2 = d[h4], c2 = u2 && u2[0], l = u2 && u2[1];
        s2[f2] = l ? { regex: c2, parser: l } : h4.replace(/^\[|\]$/g, "");
      }
      return function(e2) {
        for (var t2 = {}, n3 = 0, r3 = 0; n3 < a2; n3 += 1) {
          var i3 = s2[n3];
          if ("string" == typeof i3)
            r3 += i3.length;
          else {
            var o2 = i3.regex, f3 = i3.parser, h5 = e2.slice(r3), u3 = o2.exec(h5)[0];
            f3.call(t2, u3), e2 = e2.replace(u3, "");
          }
        }
        return function(e3) {
          var t3 = e3.afternoon;
          if (void 0 !== t3) {
            var n4 = e3.hours;
            t3 ? n4 < 12 && (e3.hours += 12) : 12 === n4 && (e3.hours = 0), delete e3.afternoon;
          }
        }(t2), t2;
      };
    }
    return function(e2, t2, n2) {
      n2.p.customParseFormat = true, e2 && e2.parseTwoDigitYear && (s = e2.parseTwoDigitYear);
      var r2 = t2.prototype, i2 = r2.parse;
      r2.parse = function(e3) {
        var t3 = e3.date, r3 = e3.utc, s2 = e3.args;
        this.$u = r3;
        var a2 = s2[1];
        if ("string" == typeof a2) {
          var f2 = true === s2[2], h4 = true === s2[3], u2 = f2 || h4, d2 = s2[2];
          h4 && (d2 = s2[2]), o = this.$locale(), !f2 && d2 && (o = n2.Ls[d2]), this.$d = function(e4, t4, n3) {
            try {
              if (["x", "X"].indexOf(t4) > -1)
                return new Date(("X" === t4 ? 1e3 : 1) * e4);
              var r4 = c(t4)(e4), i3 = r4.year, o2 = r4.month, s3 = r4.day, a3 = r4.hours, f3 = r4.minutes, h5 = r4.seconds, u3 = r4.milliseconds, d3 = r4.zone, l2 = new Date(), m2 = s3 || (i3 || o2 ? 1 : l2.getDate()), M2 = i3 || l2.getFullYear(), Y = 0;
              i3 && !o2 || (Y = o2 > 0 ? o2 - 1 : l2.getMonth());
              var p = a3 || 0, v = f3 || 0, D = h5 || 0, g = u3 || 0;
              return d3 ? new Date(Date.UTC(M2, Y, m2, p, v, D, g + 60 * d3.offset * 1e3)) : n3 ? new Date(Date.UTC(M2, Y, m2, p, v, D, g)) : new Date(M2, Y, m2, p, v, D, g);
            } catch (e5) {
              return new Date("");
            }
          }(t3, a2, r3), this.init(), d2 && true !== d2 && (this.$L = this.locale(d2).$L), u2 && t3 != this.format(a2) && (this.$d = new Date("")), o = {};
        } else if (a2 instanceof Array)
          for (var l = a2.length, m = 1; m <= l; m += 1) {
            s2[1] = a2[m - 1];
            var M = n2.apply(this, s2);
            if (M.isValid()) {
              this.$d = M.$d, this.$L = M.$L, this.init();
              break;
            }
            m === l && (this.$d = new Date(""));
          }
        else
          i2.call(this, e3);
      };
    };
  });
})(customParseFormat$1);
var customParseFormat = customParseFormat$1.exports;
var isSameOrAfter$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    return function(e, t) {
      t.prototype.isSameOrAfter = function(e2, t2) {
        return this.isSame(e2, t2) || this.isAfter(e2, t2);
      };
    };
  });
})(isSameOrAfter$1);
var isSameOrAfter = isSameOrAfter$1.exports;
var isSameOrBefore$1 = { exports: {} };
(function(module, exports) {
  !function(e, i) {
    module.exports = i();
  }(commonjsGlobal, function() {
    return function(e, i) {
      i.prototype.isSameOrBefore = function(e2, i2) {
        return this.isSame(e2, i2) || this.isBefore(e2, i2);
      };
    };
  });
})(isSameOrBefore$1);
var isSameOrBefore = isSameOrBefore$1.exports;
var isoWeek$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var e = "day";
    return function(t, i, s) {
      var a = function(t2) {
        return t2.add(4 - t2.isoWeekday(), e);
      }, d = i.prototype;
      d.isoWeekYear = function() {
        return a(this).year();
      }, d.isoWeek = function(t2) {
        if (!this.$utils().u(t2))
          return this.add(7 * (t2 - this.isoWeek()), e);
        var i2, d2, n2, o, r = a(this), u = (i2 = this.isoWeekYear(), d2 = this.$u, n2 = (d2 ? s.utc : s)().year(i2).startOf("year"), o = 4 - n2.isoWeekday(), n2.isoWeekday() > 4 && (o += 7), n2.add(o, e));
        return r.diff(u, "week") + 1;
      }, d.isoWeekday = function(e2) {
        return this.$utils().u(e2) ? this.day() || 7 : this.day(this.day() % 7 ? e2 : e2 - 7);
      };
      var n = d.startOf;
      d.startOf = function(e2, t2) {
        var i2 = this.$utils(), s2 = !!i2.u(t2) || t2;
        return "isoweek" === i2.p(e2) ? s2 ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e2, t2);
      };
    };
  });
})(isoWeek$1);
var isoWeek = isoWeek$1.exports;
var advancedFormat$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    return function(e, t, r) {
      var n = t.prototype, s = n.format;
      r.en.ordinal = function(e2) {
        var t2 = ["th", "st", "nd", "rd"], r2 = e2 % 100;
        return "[" + e2 + (t2[(r2 - 20) % 10] || t2[r2] || t2[0]) + "]";
      }, n.format = function(e2) {
        var t2 = this, r2 = this.$locale();
        if (!this.isValid())
          return s.bind(this)(e2);
        var n2 = this.$utils(), a = (e2 || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e3) {
          switch (e3) {
            case "Q":
              return Math.ceil((t2.$M + 1) / 3);
            case "Do":
              return r2.ordinal(t2.$D);
            case "gggg":
              return t2.weekYear();
            case "GGGG":
              return t2.isoWeekYear();
            case "wo":
              return r2.ordinal(t2.week(), "W");
            case "w":
            case "ww":
              return n2.s(t2.week(), "w" === e3 ? 1 : 2, "0");
            case "W":
            case "WW":
              return n2.s(t2.isoWeek(), "W" === e3 ? 1 : 2, "0");
            case "k":
            case "kk":
              return n2.s(String(0 === t2.$H ? 24 : t2.$H), "k" === e3 ? 1 : 2, "0");
            case "X":
              return Math.floor(t2.$d.getTime() / 1e3);
            case "x":
              return t2.$d.getTime();
            case "z":
              return "[" + t2.offsetName() + "]";
            case "zzz":
              return "[" + t2.offsetName("long") + "]";
            default:
              return e3;
          }
        });
        return s.bind(this)(a);
      };
    };
  });
})(advancedFormat$1);
var advancedFormat = advancedFormat$1.exports;
const debounce = ref(false);
const useScrollbarWidth = () => {
  const defaultPaddingRight = document.body.style.paddingRight;
  const getScrollbarWidth = () => {
    const scrollDiv = document.createElement("div");
    scrollDiv.className = "modal-scrollbar-measure";
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  };
  const beforeEnter = () => {
    if (document.body.scrollHeight > window.innerHeight) {
      debounce.value = true;
      document.body.classList.add("modal-open");
      const paddingRightWhenActive = Number(getScrollbarWidth().toFixed(2));
      if (paddingRightWhenActive > 0) {
        document.body.style.paddingRight = `${paddingRightWhenActive}px`;
      }
      setTimeout(() => debounce.value = false, 500);
    }
  };
  const afterLeave = () => {
    if (debounce.value)
      return;
    document.body.classList.remove("modal-open");
    document.body.style.paddingRight = defaultPaddingRight;
  };
  return {
    beforeEnter,
    afterLeave
  };
};
const _hoisted_1$d = { class: "datepicker-header" };
const _hoisted_2$a = { class: "datepicker-title" };
const _hoisted_3$7 = { class: "datepicker-title-text" };
const _hoisted_4$7 = { class: "datepicker-date" };
const _hoisted_5$6 = { class: "datepicker-date-text" };
const _hoisted_6$5 = {
  key: 0,
  class: "buttons-container"
};
const _hoisted_7$4 = /* @__PURE__ */ createElementVNode("button", {
  type: "button",
  class: "datepicker-button-toggle",
  "data-mdb-toggle": "datepicker"
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "far fa-calendar datepicker-toggle-icon" })
], -1);
const _hoisted_8$3 = /* @__PURE__ */ createElementVNode("i", { class: "far fa-clock fa-sm timepicker-icon" }, null, -1);
const _hoisted_9$3 = [
  _hoisted_8$3
];
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "MDBDatepickerHeader",
  setup(__props) {
    const headerDate = inject("headerDate");
    const weekdaysShort = inject("weekdaysShort");
    const monthsShort = inject("monthsShort");
    const title = inject("title");
    const headerWeekday = computed(() => weekdaysShort[headerDate.value.day()]);
    const headerMonth = computed(() => monthsShort[headerDate.value.month()]);
    const headerMonthday = computed(() => headerDate.value.date());
    const dateTimepicker = inject("dateTimepicker", null);
    const changePicker = inject("changePicker", null);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$d, [
        createElementVNode("div", _hoisted_2$a, [
          createElementVNode("span", _hoisted_3$7, toDisplayString(unref(title)), 1)
        ]),
        createElementVNode("div", _hoisted_4$7, [
          createElementVNode("span", _hoisted_5$6, toDisplayString(unref(headerWeekday)) + ", " + toDisplayString(unref(headerMonth)) + " " + toDisplayString(unref(headerMonthday)), 1)
        ]),
        unref(dateTimepicker) ? (openBlock(), createElementBlock("div", _hoisted_6$5, [
          _hoisted_7$4,
          createElementVNode("button", {
            type: "button",
            class: "timepicker-button-toggle",
            "data-mdb-toggle": "timepicker",
            onClick: _cache[0] || (_cache[0] = ($event) => unref(changePicker)("timepicker"))
          }, _hoisted_9$3)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const _hoisted_1$c = ["aria-label"];
const _hoisted_2$9 = { class: "datepicker-arrow-controls" };
const _hoisted_3$6 = ["aria-label"];
const _hoisted_4$6 = ["aria-label"];
const _hoisted_5$5 = ["onKeydown"];
const _hoisted_6$4 = { class: "datepicker-table" };
const _hoisted_7$3 = ["aria-label"];
const _hoisted_8$2 = { class: "datepicker-table-body" };
const _hoisted_9$2 = ["aria-label", "aria-selected", "onClick"];
const _hoisted_10$2 = {
  key: 0,
  class: "datepicker-cell-content datepicker-small-cell-content"
};
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "MDBDatepickerDayView",
  props: {
    inline: Boolean
  },
  setup(__props) {
    const props = __props;
    const activeDate = inject("activeDate");
    const selectedDate = inject("selectedDate");
    const focusedDate = inject("focusedDate");
    const monthsFull = inject("monthsFull");
    const weekdaysNarrow = inject("weekdaysNarrow");
    const weekdaysFull = inject("weekdaysFull");
    const prevMonthLabel = inject("prevMonthLabel");
    const nextMonthLabel = inject("nextMonthLabel");
    const startDay = inject("startDay");
    const switchToMultiYearViewLabel = inject("switchToMultiYearViewLabel");
    const activeMonth = computed(() => monthsFull[activeDate.value.month()]);
    const activeYear = computed(() => activeDate.value.year());
    const selectDay = inject("selectDay");
    const goToPrevMonth = inject("goToPrevMonth");
    const goToNextMonth = inject("goToNextMonth");
    const changeView = inject("changeView");
    const minDate = inject("minDate");
    const maxDate = inject("maxDate");
    const startDate = inject("startDate");
    const filter = inject("filter");
    const today = inject("today");
    const disablePast = inject("disablePast");
    const disableFuture = inject("disableFuture");
    const days = computed(() => {
      const list = [];
      for (let i = 0; i < 6; i++) {
        list.push([]);
        let startingWeekDate;
        if (startDay === 0) {
          startingWeekDate = activeDate.value.startOf("month").add(i, "week").startOf("week");
        } else if (startDay === 1) {
          startingWeekDate = activeDate.value.startOf("month").add(i, "week").startOf("isoWeek");
        }
        for (let j = 0; j < 7; j++) {
          const dayJS = startingWeekDate.add(j, "day");
          list[i].push({
            current: dayJS.isToday(),
            dayJS,
            disabled: dayJS.month() !== activeDate.value.month(),
            focused: dayJS.date() === focusedDate.value.date(),
            label: dayJS.date(),
            selectable: isDateSelectable(dayJS) && !filter(dayJS),
            selected: dayJS.isSame(selectedDate.value, "day"),
            ariaLabel: dayJS.toString()
          });
        }
      }
      return list;
    });
    const handleSelectDay = (day) => {
      if (day.disabled) {
        return;
      }
      selectDay(day);
    };
    const isDateSelectable = (date) => {
      if (disablePast) {
        if (startDate.value) {
          return date.isSameOrAfter(startDate.value);
        } else {
          return date.add(1, "day").isSameOrAfter(today.value);
        }
      } else if (disableFuture) {
        return date.isSameOrBefore(startDate.value || today.value);
      } else if (minDate.value && maxDate.value) {
        return date.isSameOrAfter(minDate.value) && date.isSameOrBefore(maxDate.value);
      } else if (minDate.value) {
        return date.isSameOrAfter(minDate.value);
      } else if (maxDate.value) {
        return date.isSameOrBefore(maxDate.value);
      }
      return true;
    };
    const handleDayUp = inject("handleDayUp");
    const handleDayDown = inject("handleDayDown");
    const handleDayLeft = inject("handleDayLeft");
    const handleDayRight = inject("handleDayRight");
    const handleDayHome = inject("handleDayHome");
    const handleDayEnd = inject("handleDayEnd");
    const handleDayPageUp = inject("handleDayPageUp");
    const handleDayPageDown = inject("handleDayPageDown");
    const isDatepickerViewFocused = ref(false);
    const handleEnter = () => {
      if (isDateSelectable(focusedDate.value) && !filter(focusedDate.value)) {
        const dateObj = {};
        dateObj.dayJS = focusedDate.value;
        selectDay(dateObj);
      }
    };
    const handleKeydown = (event) => {
      switch (event.key) {
        case "Home":
          handleDayHome();
          break;
        case "End":
          handleDayEnd();
          break;
        case "PageUp":
          handleDayPageUp();
          break;
        case "PageDown":
          handleDayPageDown();
          break;
      }
    };
    const datepickerDateControlsRef = ref(null);
    const handleTab = (event) => {
      if (props.inline) {
        event.preventDefault();
        const changeButtonEl = datepickerDateControlsRef.value.querySelector(
          ".datepicker-view-change-button"
        );
        changeButtonEl.focus();
      }
    };
    const datepickerViewRef = ref(null);
    onMounted(() => {
      setTimeout(() => {
        datepickerViewRef.value.focus();
      }, 100);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          ref_key: "datepickerDateControlsRef",
          ref: datepickerDateControlsRef,
          class: "datepicker-date-controls"
        }, [
          createElementVNode("button", {
            class: "datepicker-view-change-button",
            "aria-label": unref(switchToMultiYearViewLabel),
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => unref(changeView)("year"), ["stop"]))
          }, toDisplayString(unref(activeMonth)) + " " + toDisplayString(unref(activeYear)), 9, _hoisted_1$c),
          createElementVNode("div", _hoisted_2$9, [
            createElementVNode("button", {
              class: "datepicker-previous-button",
              "aria-label": unref(prevMonthLabel),
              onClick: _cache[1] || (_cache[1] = (...args) => unref(goToPrevMonth) && unref(goToPrevMonth)(...args))
            }, null, 8, _hoisted_3$6),
            createElementVNode("button", {
              class: "datepicker-next-button",
              "aria-label": unref(nextMonthLabel),
              onClick: _cache[2] || (_cache[2] = (...args) => unref(goToNextMonth) && unref(goToNextMonth)(...args))
            }, null, 8, _hoisted_4$6)
          ])
        ], 512),
        createElementVNode("div", {
          ref_key: "datepickerViewRef",
          ref: datepickerViewRef,
          class: "datepicker-view",
          tabindex: "0",
          onKeydown: [
            _cache[3] || (_cache[3] = withKeys(withModifiers(
              (...args) => unref(handleDayUp) && unref(handleDayUp)(...args),
              ["prevent"]
            ), ["up"])),
            _cache[4] || (_cache[4] = withKeys(withModifiers(
              (...args) => unref(handleDayDown) && unref(handleDayDown)(...args),
              ["prevent"]
            ), ["down"])),
            _cache[5] || (_cache[5] = withKeys(withModifiers(
              (...args) => unref(handleDayLeft) && unref(handleDayLeft)(...args),
              ["prevent"]
            ), ["left"])),
            _cache[6] || (_cache[6] = withKeys(withModifiers(
              (...args) => unref(handleDayRight) && unref(handleDayRight)(...args),
              ["prevent"]
            ), ["right"])),
            withKeys(withModifiers(handleEnter, ["prevent"]), ["enter"]),
            handleKeydown,
            withKeys(handleTab, ["tab"])
          ],
          onFocus: _cache[7] || (_cache[7] = ($event) => isDatepickerViewFocused.value = true),
          onBlur: _cache[8] || (_cache[8] = ($event) => isDatepickerViewFocused.value = false)
        }, [
          createElementVNode("table", _hoisted_6$4, [
            createElementVNode("thead", null, [
              createElementVNode("tr", null, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(weekdaysNarrow), (weekday, key) => {
                  return openBlock(), createElementBlock("th", {
                    key,
                    class: "datepicker-day-heading",
                    scope: "col",
                    "aria-label": unref(weekdaysFull)[key]
                  }, toDisplayString(weekday), 9, _hoisted_7$3);
                }), 128))
              ])
            ]),
            createElementVNode("tbody", _hoisted_8$2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(days), (week, key) => {
                return openBlock(), createElementBlock("tr", { key }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(week, (day, keyInWeek) => {
                    return openBlock(), createElementBlock("td", {
                      key: keyInWeek,
                      class: normalizeClass(["datepicker-cell datepicker-small-cell datepicker-day-cell", [
                        day.current && "current",
                        day.focused && isDatepickerViewFocused.value && "focused",
                        day.selected && "selected",
                        !day.selectable && "disabled"
                      ]]),
                      "aria-label": day.ariaLabel,
                      "aria-selected": day.selected,
                      onClick: ($event) => handleSelectDay(day)
                    }, [
                      !day.disabled ? (openBlock(), createElementBlock("div", _hoisted_10$2, toDisplayString(day.label), 1)) : createCommentVNode("", true)
                    ], 10, _hoisted_9$2);
                  }), 128))
                ]);
              }), 128))
            ])
          ])
        ], 40, _hoisted_5$5)
      ], 64);
    };
  }
});
const _hoisted_1$b = { class: "datepicker-date-controls" };
const _hoisted_2$8 = ["aria-label"];
const _hoisted_3$5 = { class: "datepicker-arrow-controls" };
const _hoisted_4$5 = ["aria-label"];
const _hoisted_5$4 = ["aria-label"];
const _hoisted_6$3 = ["onKeydown"];
const _hoisted_7$2 = { class: "datepicker-table" };
const _hoisted_8$1 = { class: "datepicker-table-body" };
const _hoisted_9$1 = ["aria-label", "onClick"];
const _hoisted_10$1 = { class: "datepicker-cell-content datepicker-large-cell-content" };
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "MDBDatepickerYearView",
  setup(__props) {
    const activeDate = inject("activeDate");
    const selectedDate = inject("selectedDate");
    const focusedDate = inject("focusedDate");
    const setFocusedDate = inject("setFocusedDate");
    const changeActiveYear = inject("changeActiveYear");
    const changeView = inject("changeView");
    const today = inject("today");
    const nextMultiYearLabel = inject("nextMultiYearLabel");
    const prevMultiYearLabel = inject("prevMultiYearLabel");
    const switchToDayViewLabel = inject("switchToDayViewLabel");
    const startingYearKey = ref(-5);
    const minDate = inject("minDate");
    const maxDate = inject("maxDate");
    const disablePast = inject("disablePast");
    const disableFuture = inject("disableFuture");
    const startingYear = computed(() => {
      if (startingYearKey.value < 0) {
        return activeDate.value.subtract(-startingYearKey.value, "year");
      }
      return activeDate.value.add(startingYearKey.value, "year");
    });
    const years = computed(() => {
      const list = [];
      for (let i = 0; i < 6; i++) {
        list.push([]);
        const rowStartingDate = startingYear.value.add(i + i * 3, "year");
        for (let j = 0; j < 4; j++) {
          const colStartingDate = rowStartingDate.add(j, "year");
          list[i].push({
            current: colStartingDate.year() === today.year(),
            focused: colStartingDate.isSame(focusedDate.value, "year"),
            label: colStartingDate.year(),
            selectable: isYearSelectable(colStartingDate.year()),
            selected: colStartingDate.isSame(selectedDate.value, "year")
          });
        }
      }
      return list;
    });
    const isYearSelectable = (year) => {
      if (disablePast) {
        return year >= today.year();
      } else if (disableFuture) {
        return year <= today.year();
      } else if (minDate.value && maxDate.value) {
        return year >= minDate.value.year() && year <= maxDate.value.year();
      } else if (minDate.value) {
        console.log(minDate.value);
        return year >= minDate.value.year();
      } else if (maxDate.value) {
        return year <= maxDate.value.year();
      }
      return true;
    };
    const handleYearClick = (year) => {
      changeActiveYear(year);
      changeView("month");
    };
    const handleDecrementYear = inject(
      "handleDecrementYear"
    );
    const handleIncrementYear = inject(
      "handleIncrementYear"
    );
    const handleYearHome = inject("handleYearHome");
    const handleYearEnd = inject("handleYearEnd");
    const handleYearPageUp = inject("handleYearPageUp");
    const handleYearPageDown = inject("handleYearPageDown");
    const datepickerViewRef = ref(null);
    const isDatepickerViewFocused = ref(false);
    const handleEnter = () => {
      if (!isYearSelectable(focusedDate.value.year()))
        return;
      changeActiveYear(focusedDate.value.year());
      changeView("month");
    };
    const handleKeydown = (event) => {
      switch (event.key) {
        case "Home":
          handleYearHome();
          break;
        case "End":
          handleYearEnd();
          break;
        case "PageUp":
          handleYearPageUp();
          break;
        case "PageDown":
          handleYearPageDown();
          break;
      }
    };
    onMounted(() => {
      setTimeout(() => {
        datepickerViewRef.value.focus();
      }, 100);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$b, [
          createElementVNode("button", {
            class: "datepicker-view-change-button",
            "aria-label": unref(switchToDayViewLabel),
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => unref(changeView)("day"), ["stop"]))
          }, toDisplayString(unref(years)[0][0].label) + " - " + toDisplayString(unref(years)[5][unref(years)[5].length - 1].label), 9, _hoisted_2$8),
          createElementVNode("div", _hoisted_3$5, [
            createElementVNode("button", {
              class: "datepicker-previous-button",
              "aria-label": unref(prevMultiYearLabel),
              onClick: _cache[1] || (_cache[1] = () => {
                unref(setFocusedDate)(unref(focusedDate).subtract(24, "year"));
                startingYearKey.value -= 24;
              })
            }, null, 8, _hoisted_4$5),
            createElementVNode("button", {
              class: "datepicker-next-button",
              "aria-label": unref(nextMultiYearLabel),
              onClick: _cache[2] || (_cache[2] = () => {
                unref(setFocusedDate)(unref(focusedDate).add(24, "year"));
                startingYearKey.value += 24;
              })
            }, null, 8, _hoisted_5$4)
          ])
        ]),
        createElementVNode("div", {
          ref_key: "datepickerViewRef",
          ref: datepickerViewRef,
          class: "datepicker-view",
          tabindex: "0",
          onKeydown: [
            _cache[3] || (_cache[3] = withKeys(withModifiers(($event) => unref(handleDecrementYear)(4), ["prevent"]), ["up"])),
            _cache[4] || (_cache[4] = withKeys(withModifiers(($event) => unref(handleIncrementYear)(4), ["prevent"]), ["down"])),
            _cache[5] || (_cache[5] = withKeys(withModifiers(($event) => unref(handleDecrementYear)(1), ["prevent"]), ["left"])),
            _cache[6] || (_cache[6] = withKeys(withModifiers(($event) => unref(handleIncrementYear)(1), ["prevent"]), ["right"])),
            withKeys(handleEnter, ["enter"]),
            handleKeydown
          ],
          onFocus: _cache[7] || (_cache[7] = ($event) => isDatepickerViewFocused.value = true),
          onBlur: _cache[8] || (_cache[8] = ($event) => isDatepickerViewFocused.value = false)
        }, [
          createElementVNode("table", _hoisted_7$2, [
            createElementVNode("tbody", _hoisted_8$1, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(years), (yearRow, key) => {
                return openBlock(), createElementBlock("tr", { key }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(yearRow, (year, keyInYear) => {
                    return openBlock(), createElementBlock("td", {
                      key: keyInYear,
                      class: normalizeClass(["datepicker-cell datepicker-large-cell datepicker-year-cell", [
                        year.current && "current",
                        year.focused && isDatepickerViewFocused.value && "focused",
                        !year.selectable && "disabled",
                        year.selected && "selected"
                      ]]),
                      "aria-label": year.label,
                      onClick: withModifiers(($event) => !year.disabled && handleYearClick(year.label), ["stop"])
                    }, [
                      createElementVNode("div", _hoisted_10$1, toDisplayString(year.label), 1)
                    ], 10, _hoisted_9$1);
                  }), 128))
                ]);
              }), 128))
            ])
          ])
        ], 40, _hoisted_6$3)
      ], 64);
    };
  }
});
const _hoisted_1$a = { class: "datepicker-date-controls" };
const _hoisted_2$7 = ["aria-label"];
const _hoisted_3$4 = { class: "datepicker-arrow-controls" };
const _hoisted_4$4 = ["aria-label"];
const _hoisted_5$3 = ["aria-label"];
const _hoisted_6$2 = ["onKeydown"];
const _hoisted_7$1 = { class: "datepicker-table" };
const _hoisted_8 = { class: "datepicker-table-body" };
const _hoisted_9 = ["aria-label", "onClick"];
const _hoisted_10 = { class: "datepicker-cell-content datepicker-large-cell-content" };
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "MDBDatepickerMonthView",
  setup(__props) {
    const activeDate = inject("activeDate");
    const selectedDate = inject("selectedDate");
    const focusedDate = inject("focusedDate");
    const setFocusedDate = inject("setFocusedDate");
    const monthsShort = inject("monthsShort");
    const changeActiveYear = inject("changeActiveYear");
    const changeActiveMonth = inject("changeActiveMonth");
    const changeView = inject("changeView");
    const today = inject("today");
    const nextYearLabel = inject("nextYearLabel");
    const prevYearLabel = inject("prevYearLabel");
    const switchToDayViewLabel = inject("switchToDayViewLabel");
    const minDate = inject("minDate");
    const maxDate = inject("maxDate");
    const disablePast = inject("disablePast");
    const disableFuture = inject("disableFuture");
    const months = computed(() => {
      const list = [];
      for (let i = 0; i < 3; i++) {
        list.push([]);
        const rowStartingDate = activeDate.value.startOf("year").add(i * 4, "month");
        for (let j = 0; j < 4; j++) {
          const colStartingDate = rowStartingDate.add(j, "month");
          list[i].push({
            ariaLabel: `${monthsShort[colStartingDate.month()]}, ${colStartingDate.year()}`,
            current: colStartingDate.month() === today.month() && colStartingDate.year() === today.year(),
            focused: colStartingDate.month() === focusedDate.value.month(),
            key: colStartingDate.month(),
            label: monthsShort[colStartingDate.month()],
            selectable: isMonthSelectable(colStartingDate),
            selected: colStartingDate.isSame(selectedDate.value, "month") && colStartingDate.isSame(selectedDate.value, "year")
          });
          if (colStartingDate.month() === focusedDate.value.month()) {
            const newFocusedDateMonth = colStartingDate;
            const newFocusedDate = newFocusedDateMonth.set("date", focusedDate.value.date()).set("year", activeDate.value.year());
            setFocusedDate(newFocusedDate);
          }
        }
      }
      return list;
    });
    const isMonthSelectable = (date) => {
      if (disablePast) {
        return date.add(1, "month").isSameOrAfter(today.value);
      } else if (disableFuture) {
        return date.isSameOrBefore(today.value);
      } else if (minDate.value && maxDate.value) {
        return date.isSameOrAfter(minDate.value, "month") && date.isSameOrBefore(maxDate.value, "month") && isRangeYearSelectable(date.year());
      } else if (minDate.value) {
        return date.isSameOrAfter(minDate.value, "month") && isMinYearSelectable(date.year());
      } else if (maxDate.value) {
        return date.isSameOrBefore(maxDate.value, "month") && isMaxYearSelectable(date.year());
      }
      return true;
    };
    const isRangeYearSelectable = (year) => {
      if (typeof minDate.value !== "string" && typeof maxDate.value !== "string") {
        if (year >= minDate.value.year() && year <= maxDate.value.year()) {
          return true;
        }
      }
      return false;
    };
    const isMinYearSelectable = (year) => {
      if (typeof minDate.value !== "string") {
        if (year >= minDate.value.year()) {
          return true;
        }
      }
      return false;
    };
    const isMaxYearSelectable = (year) => {
      if (typeof maxDate.value !== "string") {
        if (year <= maxDate.value.year()) {
          return true;
        }
      }
      return false;
    };
    const handleDecrementMonth = inject(
      "handleDecrementMonth"
    );
    const handleIncrementMonth = inject(
      "handleIncrementMonth"
    );
    const handleMonthHome = inject("handleMonthHome");
    const handleMonthEnd = inject("handleMonthEnd");
    const handleMonthPageUp = inject("handleMonthPageUp");
    const handleMonthPageDown = inject("handleMonthPageDown");
    const datepickerViewRef = ref(null);
    const isDatepickerViewFocused = ref(false);
    const handleEnter = () => {
      if (!isMonthSelectable(focusedDate.value))
        return;
      changeActiveMonth(focusedDate.value.month());
      changeView("day");
    };
    const handleKeydown = (event) => {
      switch (event.key) {
        case "Home":
          handleMonthHome();
          break;
        case "End":
          handleMonthEnd();
          break;
        case "PageUp":
          handleMonthPageUp();
          break;
        case "PageDown":
          handleMonthPageDown();
          break;
      }
    };
    onMounted(() => {
      setTimeout(() => {
        datepickerViewRef.value.focus();
      }, 100);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$a, [
          createElementVNode("button", {
            class: "datepicker-view-change-button",
            "aria-label": unref(switchToDayViewLabel),
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => unref(changeView)("day"), ["stop"]))
          }, toDisplayString(unref(activeDate).year()), 9, _hoisted_2$7),
          createElementVNode("div", _hoisted_3$4, [
            createElementVNode("button", {
              class: "datepicker-previous-button",
              "aria-label": unref(prevYearLabel),
              onClick: _cache[1] || (_cache[1] = ($event) => unref(changeActiveYear)(unref(activeDate).year() - 1))
            }, null, 8, _hoisted_4$4),
            createElementVNode("button", {
              class: "datepicker-next-button",
              "aria-label": unref(nextYearLabel),
              onClick: _cache[2] || (_cache[2] = ($event) => unref(changeActiveYear)(unref(activeDate).year() + 1))
            }, null, 8, _hoisted_5$3)
          ])
        ]),
        createElementVNode("div", {
          ref_key: "datepickerViewRef",
          ref: datepickerViewRef,
          class: "datepicker-view",
          tabindex: "0",
          onKeydown: [
            _cache[3] || (_cache[3] = withKeys(withModifiers(($event) => unref(handleDecrementMonth)(4), ["prevent"]), ["up"])),
            _cache[4] || (_cache[4] = withKeys(withModifiers(($event) => unref(handleIncrementMonth)(4), ["prevent"]), ["down"])),
            _cache[5] || (_cache[5] = withKeys(withModifiers(($event) => unref(handleDecrementMonth)(1), ["prevent"]), ["left"])),
            _cache[6] || (_cache[6] = withKeys(withModifiers(($event) => unref(handleIncrementMonth)(1), ["prevent"]), ["right"])),
            withKeys(handleEnter, ["enter"]),
            handleKeydown
          ],
          onFocus: _cache[7] || (_cache[7] = ($event) => isDatepickerViewFocused.value = true),
          onBlur: _cache[8] || (_cache[8] = ($event) => isDatepickerViewFocused.value = false)
        }, [
          createElementVNode("table", _hoisted_7$1, [
            createElementVNode("tbody", _hoisted_8, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(months), (monthRow, key) => {
                return openBlock(), createElementBlock("tr", { key }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(monthRow, (month, keyInMonth) => {
                    return openBlock(), createElementBlock("td", {
                      key: keyInMonth,
                      class: normalizeClass(["datepicker-cell datepicker-large-cell datepicker-month-cell", [
                        month.current && "current",
                        month.focused && isDatepickerViewFocused.value && "focused",
                        !month.selectable && "disabled",
                        month.selected && "selected"
                      ]]),
                      "aria-label": month.ariaLabel,
                      onClick: withModifiers(
                        () => {
                          if (!month.disabled) {
                            unref(changeActiveMonth)(month.key);
                            unref(changeView)("day");
                          }
                        },
                        ["stop"]
                      )
                    }, [
                      createElementVNode("div", _hoisted_10, toDisplayString(month.label), 1)
                    ], 10, _hoisted_9);
                  }), 128))
                ]);
              }), 128))
            ])
          ])
        ], 40, _hoisted_6$2)
      ], 64);
    };
  }
});
const _hoisted_1$9 = {
  key: 3,
  class: "datepicker-footer"
};
const _hoisted_2$6 = ["aria-label"];
const _hoisted_3$3 = ["aria-label"];
const _hoisted_4$3 = ["aria-label", "onKeydown"];
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "MDBDatepickerMain",
  props: {
    inline: Boolean
  },
  setup(__props) {
    const ok = inject("ok");
    const cancel = inject("cancel");
    const clear = inject("clear");
    const view = inject("view");
    const cancelBtnText = inject("cancelBtnText");
    const clearBtnText = inject("clearBtnText");
    const okBtnText = inject("okBtnText");
    const cancelBtnLabel = inject("cancelBtnLabel");
    const clearBtnLabel = inject("clearBtnLabel");
    const okBtnLabel = inject("okBtnLabel");
    const datepickerMainRef = ref(null);
    const handleTab = () => {
      const changeButtonEl = datepickerMainRef.value.querySelector(
        ".datepicker-view-change-button"
      );
      changeButtonEl.focus();
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "datepickerMainRef",
        ref: datepickerMainRef,
        class: "datepicker-main"
      }, [
        unref(view) === "day" ? (openBlock(), createBlock(_sfc_main$e, {
          key: 0,
          inline: __props.inline
        }, null, 8, ["inline"])) : createCommentVNode("", true),
        unref(view) === "year" ? (openBlock(), createBlock(_sfc_main$d, { key: 1 })) : createCommentVNode("", true),
        unref(view) === "month" ? (openBlock(), createBlock(_sfc_main$c, { key: 2 })) : createCommentVNode("", true),
        !__props.inline ? (openBlock(), createElementBlock("div", _hoisted_1$9, [
          createElementVNode("button", {
            class: "datepicker-footer-btn datepicker-clear-btn",
            "aria-label": unref(clearBtnLabel),
            onClick: _cache[0] || (_cache[0] = (...args) => unref(clear) && unref(clear)(...args))
          }, toDisplayString(unref(clearBtnText)), 9, _hoisted_2$6),
          createElementVNode("button", {
            class: "datepicker-footer-btn datepicker-cancel-btn",
            "aria-label": unref(cancelBtnLabel),
            onClick: _cache[1] || (_cache[1] = (...args) => unref(cancel) && unref(cancel)(...args))
          }, toDisplayString(unref(cancelBtnText)), 9, _hoisted_3$3),
          createElementVNode("button", {
            class: "datepicker-footer-btn datepicker-ok-btn",
            "aria-label": unref(okBtnLabel),
            onClick: _cache[2] || (_cache[2] = (...args) => unref(ok) && unref(ok)(...args)),
            onKeydown: withKeys(withModifiers(handleTab, ["prevent"]), ["tab"])
          }, toDisplayString(unref(okBtnText)), 41, _hoisted_4$3)
        ])) : createCommentVNode("", true)
      ], 512);
    };
  }
});
const _hoisted_1$8 = {
  key: 0,
  class: "datepicker-backdrop"
};
const _hoisted_2$5 = {
  key: 1,
  class: "datepicker-modal-container"
};
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "MDBDatepickerModal",
  props: {
    modelValue: Boolean
  },
  emits: ["update:modelValue", "cancel"],
  setup(__props, { emit }) {
    const props = __props;
    const { beforeEnter, afterLeave } = useScrollbarWidth();
    const isActive = ref(props.modelValue);
    const handleClickOutside = () => {
      if (!isActive.value || debounce2.value)
        return;
      isActive.value = false;
      emit("cancel");
      emit("update:modelValue", false);
    };
    const debounce2 = ref(true);
    watch(
      () => props.modelValue,
      (value) => {
        isActive.value = value;
        setTimeout(() => {
          debounce2.value = value;
          setTimeout(() => debounce2.value = !value, 100);
        }, 500);
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(TransitionGroup, {
          name: "datepicker-fade",
          onBeforeEnter: unref(beforeEnter),
          onAfterLeave: unref(afterLeave)
        }, {
          default: withCtx(() => [
            isActive.value ? (openBlock(), createElementBlock("div", _hoisted_1$8)) : createCommentVNode("", true),
            isActive.value ? withDirectives((openBlock(), createElementBlock("div", _hoisted_2$5, [
              createVNode(_sfc_main$f),
              createVNode(_sfc_main$b)
            ])), [
              [unref(vMdbClickOutside), handleClickOutside]
            ]) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onBeforeEnter", "onAfterLeave"])
      ]);
    };
  }
});
const _hoisted_1$7 = ["innerHTML"];
const __default__$2 = {
  inheritAttrs: false
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  __name: "MDBDatepicker",
  props: {
    cancelBtnLabel: {
      type: String,
      default: "Cancel selection"
    },
    cancelBtnText: {
      type: String,
      default: "Cancel"
    },
    clearBtnLabel: {
      type: String,
      default: "Clear selection"
    },
    clearBtnText: {
      type: String,
      default: "Clear"
    },
    filter: {
      type: Function,
      default: () => false
    },
    format: {
      type: String,
      default: "DD/MM/YYYY"
    },
    inline: Boolean,
    invalidFeedback: String,
    invalidLabel: {
      type: String,
      default: "Invalid date or date format"
    },
    inputToggle: Boolean,
    isValid: Boolean,
    isValidated: Boolean,
    max: String,
    min: String,
    modelValue: String,
    monthsFull: {
      type: Array,
      default: () => [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    },
    monthsShort: {
      type: Array,
      default: () => [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    },
    nextMonthLabel: {
      type: String,
      default: "Next month"
    },
    nextMultiYearLabel: {
      type: String,
      default: "Next 24 years"
    },
    nextYearLabel: {
      type: String,
      default: "Next year"
    },
    okBtnLabel: {
      type: String,
      default: "Confirm selection"
    },
    okBtnText: {
      type: String,
      default: "Ok"
    },
    prevMonthLabel: {
      type: String,
      default: "Previous month"
    },
    prevMultiYearLabel: {
      type: String,
      default: "Previous 24 years"
    },
    prevYearLabel: {
      type: String,
      default: "Previous year"
    },
    startDate: String,
    startDay: {
      type: Number,
      default: 0
    },
    switchToMultiYearViewLabel: {
      type: String,
      default: "Choose year and month"
    },
    switchToDayViewLabel: {
      type: String,
      default: "Choose date"
    },
    title: {
      type: String,
      default: "Select date"
    },
    toggleButton: {
      type: Boolean,
      default: true
    },
    toggleDatepicker: Function,
    toggleIcon: {
      type: String,
      default: "<i class='far fa-calendar datepicker-toggle-icon'></i>"
    },
    validate: Boolean,
    validLabel: {
      type: String
    },
    validFeedback: String,
    view: {
      type: String,
      default: "day"
    },
    weekdaysFull: {
      type: Array,
      default: () => [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ]
    },
    weekdaysNarrow: {
      type: Array,
      default: () => ["S", "M", "T", "W", "T", "F", "S"]
    },
    weekdaysShort: {
      type: Array,
      default: () => ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    },
    disabled: Boolean,
    disablePast: {
      type: Boolean,
      default: false
    },
    disableFuture: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue",
    "update:isValid",
    "update:isValidated",
    "close",
    "open",
    "cancel"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    dayjs.extend(isToday);
    dayjs.extend(customParseFormat);
    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);
    dayjs.extend(isoWeek);
    dayjs.extend(advancedFormat);
    const inputValue = ref(props.modelValue || "");
    const isActive = ref(false);
    const view = ref(props.view);
    const valid = ref(props.isValid);
    const validated = ref(props.isValidated);
    const validate = ref(props.validate);
    watchEffect(() => {
      validate.value = props.validate;
      if (!validate.value) {
        validated.value = false;
        valid.value = false;
      }
    });
    watchEffect(() => {
      if (validate.value) {
        valid.value = props.isValid;
      }
    });
    watchEffect(() => {
      if (validate.value) {
        validated.value = props.isValidated;
      }
    });
    const minDate = ref(props.min ? dayjs(props.min, props.format) : "");
    const maxDate = ref(props.max ? dayjs(props.max, props.format) : "");
    const startDate = ref(
      props.startDate ? dayjs(props.startDate, props.format) : ""
    );
    const today = dayjs();
    const allowedDate = (date) => {
      if (props.disablePast) {
        if (startDate.value) {
          typeof date !== "string" && date.isSameOrAfter(startDate.value);
        } else {
          typeof date !== "string" && date.add(1, "day").isSameOrAfter(today);
        }
      } else if (props.disableFuture) {
        typeof date !== "string" && date.isSameOrBefore(startDate.value || today);
      } else if (minDate.value && maxDate.value && startDate.value) {
        return startDate.value && typeof date !== "string" && date.isSameOrBefore(maxDate.value) && date.isSameOrAfter(minDate.value) ? date : startDate.value;
      } else if (minDate.value && maxDate.value) {
        return typeof date !== "string" && date.isAfter(minDate.value) && date.isBefore(maxDate.value) ? date : minDate.value;
      } else if (maxDate.value && startDate.value) {
        return typeof date !== "string" && date.isSameOrBefore(startDate.value) && date.isSameOrBefore(maxDate.value) ? date : startDate.value;
      } else if (minDate.value && startDate.value) {
        return typeof date !== "string" && date.isSameOrAfter(startDate.value) && date.isSameOrAfter(minDate.value) ? startDate.value : date;
      } else if (minDate.value) {
        return typeof date !== "string" && date.isSameOrAfter(minDate.value) ? date : minDate.value;
      } else if (maxDate.value) {
        return typeof date !== "string" && date.isSameOrBefore(maxDate.value) ? date : maxDate.value;
      }
      return date;
    };
    const isInRange = (date) => {
      if (props.disablePast) {
        if (startDate.value) {
          return date.isSameOrAfter(startDate.value);
        } else {
          return date.add(1, "day").isSameOrAfter(today);
        }
      } else if (props.disableFuture) {
        return date.isSameOrBefore(startDate.value || today);
      } else if (minDate.value && maxDate.value && startDate.value) {
        return startDate.value && date.isSameOrBefore(maxDate.value) && date.isSameOrAfter(minDate.value);
      } else if (minDate.value && maxDate.value) {
        return date.isSameOrAfter(minDate.value) && date.isSameOrBefore(maxDate.value);
      } else if (maxDate.value && startDate.value) {
        return startDate.value && date.isSameOrBefore(maxDate.value);
      } else if (minDate.value && startDate.value) {
        return startDate.value && date.isSameOrAfter(minDate.value);
      } else if (minDate.value) {
        return date.isSameOrAfter(minDate.value);
      } else if (maxDate.value) {
        return date.isSameOrBefore(maxDate.value);
      }
      return true;
    };
    const isDateValid = (date, clear2 = void 0) => {
      var _a;
      const hasCustomFormats = (_a = props.format.match(/[,-]/)) == null ? void 0 : _a.length;
      const isValid = hasCustomFormats ? dayjs(date).isValid() : dayjs(date, props.format).isValid();
      if (date !== "" && (!isValid || !isInRange(dayjs(date, props.format)))) {
        if (validate.value) {
          validated.value = true;
          valid.value = false;
        }
        emit("update:isValid", false);
        emit("update:isValidated", true);
        return false;
      } else {
        if (validate.value) {
          validated.value = date === "" ? false : props.validLabel ? true : clear2 ? false : true;
          valid.value = true;
        }
        emit("update:isValid", true);
        emit("update:isValidated", validated.value);
        return true;
      }
    };
    const setInitialValue = () => {
      const fallbackDate = allowedDate(
        startDate.value || today || minDate.value || maxDate.value
      );
      return inputValue.value === "" ? dayjs(fallbackDate, props.format) : isDateValid(inputValue.value) ? dayjs(inputValue.value, props.format) : dayjs(fallbackDate, props.format);
    };
    const activeDate = ref(setInitialValue());
    const headerDate = ref(activeDate.value);
    const selectedDate = ref(
      dayjs(inputValue.value, props.format).isValid() ? headerDate.value : null
    );
    const focusedDate = ref(selectedDate.value || activeDate.value);
    const isToggleButtonActive = computed(
      () => props.disabled ? false : props.toggleButton
    );
    watch(
      () => props.min,
      (cur) => {
        minDate.value = cur ? dayjs(cur, props.format) : "";
      }
    );
    watch(
      () => props.max,
      (cur) => {
        maxDate.value = cur ? dayjs(cur, props.format) : "";
      }
    );
    const goToPrevMonth = () => {
      activeDate.value = activeDate.value.subtract(1, "month");
      focusedDate.value = activeDate.value;
    };
    const goToNextMonth = () => {
      activeDate.value = activeDate.value.add(1, "month");
      focusedDate.value = activeDate.value;
    };
    const selectDay = (day) => {
      headerDate.value = dayjs(day.dayJS);
      selectedDate.value = headerDate.value;
      focusedDate.value = headerDate.value;
      if (props.inline) {
        ok();
      }
    };
    const changeActiveYear = (year) => {
      headerDate.value = headerDate.value.year(year);
      activeDate.value = headerDate.value;
      focusedDate.value = headerDate.value;
    };
    const changeActiveMonth = (month) => {
      headerDate.value = headerDate.value.month(month);
      activeDate.value = headerDate.value;
      focusedDate.value = headerDate.value;
    };
    const changeView = (newView) => {
      view.value = newView;
    };
    const ok = () => {
      updateInputValue();
      isActive.value = false;
    };
    const cancel = () => {
      isActive.value = false;
      handleCancelValues();
    };
    const clear = () => {
      const validStartDate = allowedDate(
        startDate.value || today || minDate.value || maxDate.value
      );
      selectedDate.value = null;
      updateInputValue();
      activeDate.value = dayjs(inputValue.value, props.format).isValid() ? dayjs(inputValue.value, props.format) : dayjs(validStartDate);
      headerDate.value = activeDate.value;
      focusedDate.value = activeDate.value;
    };
    const updateInputValue = () => {
      if (selectedDate.value) {
        inputValue.value = selectedDate.value.format(props.format);
      } else {
        inputValue.value = "";
      }
      emit("update:modelValue", inputValue.value);
    };
    const handleCancelValues = () => {
      activeDate.value = setInitialValue();
      headerDate.value = dayjs(activeDate.value);
      selectedDate.value = dayjs(activeDate.value);
      focusedDate.value = selectedDate.value || activeDate.value;
      emit("cancel");
    };
    const handleClickOutside = () => {
      if (props.inline && !debounce2.value) {
        emit("cancel");
        isActive.value = false;
      } else {
        handleCancelValues();
      }
    };
    const handleInputToggle = () => {
      if (props.inputToggle) {
        isActive.value = !isActive.value;
      }
    };
    const dateTimepicker = inject("dateTimepicker", null);
    const datepickerRef = ref(null);
    const datepickerInlineRef = ref(null);
    const toggleButtonRef = ref(null);
    const debounce2 = ref(true);
    const triggerRef = computed(() => {
      if (props.inline && dateTimepicker) {
        return dateTimepicker.value.inputRef;
      }
      return datepickerRef.value;
    });
    if (props.inline) {
      const { setPopper, openPopper, closePopper } = MDBPopper();
      watch(
        () => isActive.value,
        (isActive2) => {
          debounce2.value = isActive2;
          setTimeout(() => {
            debounce2.value = !isActive2;
          }, 1e3);
          if (isActive2) {
            nextTick(() => {
              setPopper(triggerRef.value, datepickerInlineRef.value, {
                placement: "bottom-start",
                eventsEnabled: true
              });
              openPopper();
              emit("open");
            });
          } else {
            closePopper();
            focusToggler();
            setTimeout(() => {
              setDefaults();
              emit("close");
            }, 400);
          }
        }
      );
    } else {
      watch(
        () => isActive.value,
        (isActive2) => {
          if (isActive2) {
            emit("open");
          } else {
            focusToggler();
            setTimeout(() => {
              setDefaults();
              emit("close");
            }, 400);
          }
        }
      );
    }
    const focusToggler = () => {
      if (toggleButtonRef.value) {
        toggleButtonRef.value.focus();
      } else {
        datepickerRef.value.querySelector("input").focus();
      }
    };
    const setDefaults = () => {
      const allowed = allowedDate(today);
      activeDate.value = selectedDate.value ? selectedDate.value : allowed;
      focusedDate.value = activeDate.value;
      view.value = "day";
    };
    const setFocusedDate = (date) => {
      focusedDate.value = date;
    };
    const activeDateObject = computed(() => activeDate.value);
    const headerDateObject = computed(() => headerDate.value);
    const selectedDateObject = computed(() => selectedDate.value);
    const focusedDateObject = computed(() => focusedDate.value);
    const weekdaysNarrow = [...props.weekdaysNarrow];
    const weekdaysFull = [...props.weekdaysFull];
    if (props.startDay === 1) {
      weekdaysNarrow.push(weekdaysNarrow.shift());
      weekdaysFull.push(weekdaysFull.shift());
    }
    provide("activeDate", activeDateObject);
    provide("headerDate", headerDateObject);
    provide("selectedDate", selectedDateObject);
    provide("focusedDate", focusedDateObject);
    provide("setFocusedDate", setFocusedDate);
    provide("inputValue", inputValue);
    provide("monthsFull", props.monthsFull);
    provide("monthsShort", props.monthsShort);
    provide("title", props.title);
    provide("weekdaysFull", weekdaysFull);
    provide("weekdaysNarrow", weekdaysNarrow);
    provide("weekdaysShort", props.weekdaysShort);
    provide("goToPrevMonth", goToPrevMonth);
    provide("goToNextMonth", goToNextMonth);
    provide("selectDay", selectDay);
    provide("changeActiveYear", changeActiveYear);
    provide("changeActiveMonth", changeActiveMonth);
    provide("ok", ok);
    provide("cancel", cancel);
    provide("clear", clear);
    provide("view", view);
    provide("today", today);
    provide("changeView", changeView);
    provide("cancelBtnText", props.cancelBtnText);
    provide("clearBtnText", props.clearBtnText);
    provide("okBtnText", props.okBtnText);
    provide("minDate", minDate);
    provide("maxDate", maxDate);
    provide("startDate", startDate);
    provide("filter", props.filter);
    provide("startDay", props.startDay);
    provide("disablePast", props.disablePast);
    provide("disableFuture", props.disableFuture);
    provide("cancelBtnLabel", props.cancelBtnLabel);
    provide("clearBtnLabel", props.clearBtnLabel);
    provide("okBtnLabel", props.okBtnLabel);
    provide("nextMonthLabel", props.nextMonthLabel);
    provide("prevMonthLabel", props.prevMonthLabel);
    provide("nextYearLabel", props.nextYearLabel);
    provide("prevYearLabel", props.prevYearLabel);
    provide("nextMultiYearLabel", props.nextMultiYearLabel);
    provide("prevMultiYearLabel", props.prevMultiYearLabel);
    provide("switchToMultiYearViewLabel", props.switchToMultiYearViewLabel);
    provide("switchToDayViewLabel", props.switchToDayViewLabel);
    const handleDayUp = () => {
      const prevWeek = focusedDate.value.subtract(1, "week");
      if (focusedDate.value.month() !== prevWeek.month()) {
        activeDate.value = prevWeek;
      }
      focusedDate.value = prevWeek;
    };
    const handleDayDown = () => {
      const nextWeek = focusedDate.value.add(1, "week");
      if (focusedDate.value.month() !== nextWeek.month()) {
        activeDate.value = nextWeek;
      }
      focusedDate.value = nextWeek;
    };
    const handleDayLeft = () => {
      const prevDay = focusedDate.value.subtract(1, "day");
      if (focusedDate.value.date() === 1) {
        activeDate.value = prevDay;
      }
      focusedDate.value = prevDay;
    };
    const handleDayRight = () => {
      const nextDay = focusedDate.value.add(1, "day");
      if (focusedDate.value.date() === dayjs(focusedDate.value).daysInMonth()) {
        activeDate.value = nextDay;
      }
      focusedDate.value = focusedDate.value.add(1, "day");
    };
    const handleDayHome = () => {
      focusedDate.value = focusedDate.value.startOf("month");
    };
    const handleDayEnd = () => {
      focusedDate.value = focusedDate.value.endOf("month");
    };
    const handleDayPageUp = () => {
      focusedDate.value = focusedDate.value.subtract(1, "month");
      activeDate.value = focusedDate.value;
    };
    const handleDayPageDown = () => {
      focusedDate.value = focusedDate.value.add(1, "month");
      activeDate.value = focusedDate.value;
    };
    const handleDecrementYear = (key) => {
      const decrementYear = focusedDate.value.subtract(key, "year");
      const startingYearRange = activeDate.value.year() - 5;
      if (decrementYear.year() < startingYearRange) {
        activeDate.value = activeDate.value.subtract(24, "year");
      }
      focusedDate.value = decrementYear;
    };
    const handleIncrementYear = (key) => {
      const incrementYear = focusedDate.value.add(key, "year");
      const endingYearRange = activeDate.value.year() + 18;
      if (incrementYear.year() > endingYearRange) {
        activeDate.value = activeDate.value.add(24, "year");
      }
      focusedDate.value = incrementYear;
    };
    const handleYearHome = () => {
      focusedDate.value = activeDate.value.subtract(5, "year");
    };
    const handleYearEnd = () => {
      focusedDate.value = activeDate.value.add(18, "year");
    };
    const handleYearPageUp = () => {
      activeDate.value = activeDate.value.subtract(24, "year");
      focusedDate.value = focusedDate.value.subtract(24, "year");
    };
    const handleYearPageDown = () => {
      activeDate.value = activeDate.value.add(24, "year");
      focusedDate.value = focusedDate.value.add(24, "year");
    };
    const handleDecrementMonth = (key) => {
      focusedDate.value = focusedDate.value.subtract(key, "month");
      activeDate.value = focusedDate.value;
    };
    const handleIncrementMonth = (key) => {
      focusedDate.value = focusedDate.value.add(key, "month");
      activeDate.value = focusedDate.value;
    };
    const handleMonthHome = () => {
      focusedDate.value = activeDate.value.startOf("year");
      activeDate.value = focusedDate.value;
    };
    const handleMonthEnd = () => {
      focusedDate.value = activeDate.value.endOf("year");
      activeDate.value = focusedDate.value;
    };
    const handleMonthPageUp = () => {
      activeDate.value = activeDate.value.subtract(1, "year");
      focusedDate.value = activeDate.value;
    };
    const handleMonthPageDown = () => {
      activeDate.value = activeDate.value.add(1, "year");
      focusedDate.value = activeDate.value;
    };
    provide("handleDayUp", handleDayUp);
    provide("handleDayDown", handleDayDown);
    provide("handleDayLeft", handleDayLeft);
    provide("handleDayRight", handleDayRight);
    provide("handleDayHome", handleDayHome);
    provide("handleDayEnd", handleDayEnd);
    provide("handleDayPageUp", handleDayPageUp);
    provide("handleDayPageDown", handleDayPageDown);
    provide("handleDecrementYear", handleDecrementYear);
    provide("handleIncrementYear", handleIncrementYear);
    provide("handleYearHome", handleYearHome);
    provide("handleYearEnd", handleYearEnd);
    provide("handleYearPageUp", handleYearPageUp);
    provide("handleYearPageDown", handleYearPageDown);
    provide("handleDecrementMonth", handleDecrementMonth);
    provide("handleIncrementMonth", handleIncrementMonth);
    provide("handleMonthHome", handleMonthHome);
    provide("handleMonthEnd", handleMonthEnd);
    provide("handleMonthPageUp", handleMonthPageUp);
    provide("handleMonthPageDown", handleMonthPageDown);
    const handleEsc = (event) => {
      if (event.key === "Escape" && isActive.value) {
        cancel();
      }
    };
    onMounted(() => {
      on(document, "keydown", handleEsc);
    });
    onUnmounted(() => {
      off(document, "keydown", handleEsc);
    });
    const open = () => {
      isActive.value = true;
    };
    const close = () => {
      isActive.value = false;
    };
    const resetDates = (date = false) => {
      const fallbackDate = allowedDate(startDate.value || today);
      selectedDate.value = null;
      if (typeof fallbackDate !== "string") {
        headerDate.value = fallbackDate;
        activeDate.value = fallbackDate;
        focusedDate.value = fallbackDate;
      }
      if (date && typeof date === "string") {
        inputValue.value = date;
      }
    };
    watch(
      () => inputValue.value,
      (date) => {
        if (isDateValid(date, true)) {
          selectedDate.value = dayjs(date, props.format);
          headerDate.value = dayjs(date, props.format);
          activeDate.value = dayjs(date, props.format);
          focusedDate.value = dayjs(date, props.format);
        } else {
          resetDates();
          emit("update:isValid", false);
          emit("update:isValidated", true);
        }
        emit("update:modelValue", inputValue.value);
      }
    );
    const modelValueProp = toRefs(props).modelValue;
    watch(
      () => modelValueProp.value,
      (date) => {
        if (isDateValid(date, true)) {
          if (date !== "") {
            selectedDate.value = dayjs(date, props.format);
            headerDate.value = dayjs(date, props.format);
            activeDate.value = dayjs(date, props.format);
            focusedDate.value = dayjs(date, props.format);
            inputValue.value = date;
          } else {
            resetDates();
          }
        } else {
          resetDates(!validate.value && date);
          emit("update:isValid", false);
          emit("update:isValidated", true);
        }
      }
    );
    expose({
      open,
      close
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "form-outline datepicker",
        ref_key: "datepickerRef",
        ref: datepickerRef
      }, [
        createVNode(_sfc_main$O, mergeProps(_ctx.$attrs, {
          modelValue: inputValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
          wrap: false,
          "aria-haspopup": "dialog",
          isValid: __props.isValid,
          isValidated: validated.value,
          invalidFeedback: __props.invalidFeedback ? __props.invalidFeedback : __props.invalidLabel,
          validFeedback: __props.validLabel || __props.validFeedback,
          disabled: __props.disabled,
          onClick: handleInputToggle,
          onKeydown: withKeys(handleInputToggle, ["enter"])
        }), null, 16, ["modelValue", "isValid", "isValidated", "invalidFeedback", "validFeedback", "disabled", "onKeydown"]),
        unref(isToggleButtonActive) ? (openBlock(), createElementBlock("button", {
          key: 0,
          ref_key: "toggleButtonRef",
          ref: toggleButtonRef,
          type: "button",
          class: "datepicker-toggle-button",
          "aria-haspopup": "dialog",
          onClick: _cache[1] || (_cache[1] = ($event) => isActive.value = !isActive.value),
          innerHTML: __props.toggleIcon
        }, null, 8, _hoisted_1$7)) : createCommentVNode("", true),
        __props.inline ? (openBlock(), createBlock(Teleport, {
          key: 1,
          to: "body"
        }, [
          createVNode(Transition, { name: "datepicker-fade" }, {
            default: withCtx(() => [
              isActive.value ? withDirectives((openBlock(), createElementBlock("div", {
                key: 0,
                ref_key: "datepickerInlineRef",
                ref: datepickerInlineRef,
                class: "datepicker-dropdown-container"
              }, [
                createVNode(_sfc_main$b, { inline: "" })
              ])), [
                [unref(vMdbClickOutside), handleClickOutside]
              ]) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])) : (openBlock(), createBlock(_sfc_main$a, {
          key: 2,
          modelValue: isActive.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isActive.value = $event),
          onCancel: handleClickOutside
        }, null, 8, ["modelValue"]))
      ], 512);
    };
  }
});
const _hoisted_1$6 = { class: "w-100 d-flex justify-content-between" };
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "MDBTimepickerFooter",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const okLabel = inject("okLabel", null);
    const clearLabel = inject("clearLabel", null);
    const cancelLabel = inject("cancelLabel", null);
    const handleOkClick = inject("handleOkClick", null);
    const handleClearClick = inject("handleClearClick", null);
    const handleCancelClick = inject("handleCancelClick", null);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), { class: "timepicker-footer" }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$6, [
            createElementVNode("button", {
              type: "button",
              class: "timepicker-button timepicker-clear",
              tabindex: "0",
              onClick: _cache[0] || (_cache[0] = (...args) => unref(handleClearClick) && unref(handleClearClick)(...args)),
              onKeydown: [
                _cache[1] || (_cache[1] = withKeys(
                  (...args) => unref(handleClearClick) && unref(handleClearClick)(...args),
                  ["enter"]
                )),
                _cache[2] || (_cache[2] = withKeys(
                  (...args) => unref(handleClearClick) && unref(handleClearClick)(...args),
                  ["space"]
                ))
              ]
            }, toDisplayString(unref(clearLabel)), 33),
            createElementVNode("button", {
              type: "button",
              class: "timepicker-button timepicker-cancel",
              tabindex: "0",
              onClick: _cache[3] || (_cache[3] = (...args) => unref(handleCancelClick) && unref(handleCancelClick)(...args)),
              onKeydown: [
                _cache[4] || (_cache[4] = withKeys(
                  (...args) => unref(handleCancelClick) && unref(handleCancelClick)(...args),
                  ["enter"]
                )),
                _cache[5] || (_cache[5] = withKeys(
                  (...args) => unref(handleCancelClick) && unref(handleCancelClick)(...args),
                  ["space"]
                ))
              ]
            }, toDisplayString(unref(cancelLabel)), 33),
            createElementVNode("button", {
              type: "button",
              class: "timepicker-button timepicker-submit",
              tabindex: "0",
              onClick: _cache[6] || (_cache[6] = (...args) => unref(handleOkClick) && unref(handleOkClick)(...args)),
              onKeydown: [
                _cache[7] || (_cache[7] = withKeys(
                  (...args) => unref(handleOkClick) && unref(handleOkClick)(...args),
                  ["enter"]
                )),
                _cache[8] || (_cache[8] = withKeys(
                  (...args) => unref(handleOkClick) && unref(handleOkClick)(...args),
                  ["space"]
                ))
              ]
            }, toDisplayString(unref(okLabel)), 33)
          ])
        ]),
        _: 1
      });
    };
  }
});
const _hoisted_1$5 = { class: "timepicker-current-wrapper" };
const _hoisted_2$4 = ["aria-label"];
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "MDBTimepickerHeader",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const hoursFormat = inject("hoursFormat", null);
    const amLabel = inject("amLabel", null);
    const pmLabel = inject("pmLabel", null);
    const okLabel = inject("okLabel", null);
    const inline = inject("inline", null);
    const increment = inject("increment", null);
    const hours = inject("hours", null);
    const minutes = inject("minutes", null);
    const dayTime = inject("dayTime", null);
    const unitsMode = inject("unitsMode", null);
    const changeDayTime = inject("changeDayTime", null);
    const handleOkClick = inject("handleOkClick", null);
    const chageUnitsMode = inject("chageUnitsMode", null);
    const incrementHoursValue = inject("incrementHoursValue", null);
    const incrementMinutesValue = inject("incrementMinutesValue", null);
    const renderedHours = computed(() => {
      const checkHours = typeof hours.value === "string" ? parseFloat(hours.value) : hours.value;
      if (isNaN(checkHours)) {
        return 12;
      }
      if (hoursFormat == 24 && hours.value === 24) {
        return "00";
      }
      return hours.value;
    });
    const renderedMinutes = computed(
      () => isNaN(minutes == null ? void 0 : minutes.value) ? "00" : minutes.value
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        class: normalizeClass([
          "timepicker-head d-flex flex-row align-items-center justify-content-center",
          unref(inline) && "timepicker-head-inline"
        ]),
        style: normalizeStyle({ paddingRight: `${unref(inline) ? 0 : unref(hoursFormat) ? 50 : 0}px` })
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass([
              "timepicker-head-content d-flex w-100 justify-content-evenly",
              unref(inline) && "align-items-center"
            ])
          }, [
            createElementVNode("div", _hoisted_1$5, [
              createElementVNode("span", {
                class: normalizeClass([
                  "position-relative h-100",
                  unref(inline) && "timepicker-inline-hour-icons"
                ])
              }, [
                unref(inline) ? (openBlock(), createElementBlock("i", {
                  key: 0,
                  class: "fas fa-chevron-up position-absolute text-white timepicker-icon-up timepicker-icon-inline-hour",
                  onClick: _cache[0] || (_cache[0] = ($event) => unref(incrementHoursValue)(1))
                })) : createCommentVNode("", true),
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass([
                    "timepicker-current timepicker-hour",
                    unref(inline) && "timepicker-current-inline",
                    unref(unitsMode) === "hours" && "active"
                  ]),
                  style: normalizeStyle({ pointerEvents: unref(unitsMode) === "hours" ? "none" : "auto" }),
                  tabindex: "0",
                  onClick: _cache[1] || (_cache[1] = ($event) => unref(chageUnitsMode)("hours")),
                  onKeydown: [
                    _cache[2] || (_cache[2] = withKeys(($event) => unref(chageUnitsMode)("hours"), ["enter"])),
                    _cache[3] || (_cache[3] = withKeys(($event) => unref(chageUnitsMode)("hours"), ["space"]))
                  ]
                }, toDisplayString(unref(renderedHours)), 39),
                unref(inline) ? (openBlock(), createElementBlock("i", {
                  key: 1,
                  class: normalizeClass([
                    "fas fa-chevron-down position-absolute text-white timepicker-icon-down timepicker-icon-inline-hour"
                  ]),
                  onClick: _cache[4] || (_cache[4] = ($event) => unref(incrementHoursValue)(-1))
                })) : createCommentVNode("", true)
              ], 2),
              createElementVNode("button", {
                type: "button",
                class: normalizeClass(["timepicker-dot", unref(inline) && "timepicker-current-inline"]),
                disabled: ""
              }, " : ", 2),
              createElementVNode("span", {
                class: normalizeClass([
                  "position-relative h-100",
                  unref(inline) && "timepicker-inline-minutes-icons"
                ])
              }, [
                unref(inline) ? (openBlock(), createElementBlock("i", {
                  key: 0,
                  class: "fas fa-chevron-up position-absolute text-white timepicker-icon-up timepicker-icon-inline-minute",
                  onClick: _cache[5] || (_cache[5] = ($event) => unref(incrementMinutesValue)(unref(increment)))
                })) : createCommentVNode("", true),
                createElementVNode("button", {
                  type: "button",
                  class: normalizeClass([
                    "timepicker-current timepicker-minute",
                    unref(inline) && "timepicker-current-inline",
                    unref(unitsMode) === "minutes" && "active"
                  ]),
                  style: normalizeStyle({
                    pointerEvents: unref(unitsMode) === "minutes" ? "none" : "auto"
                  }),
                  tabindex: "0",
                  onClick: _cache[6] || (_cache[6] = ($event) => unref(chageUnitsMode)("minutes")),
                  onKeydown: [
                    _cache[7] || (_cache[7] = withKeys(($event) => unref(chageUnitsMode)("minutes"), ["enter"])),
                    _cache[8] || (_cache[8] = withKeys(($event) => unref(chageUnitsMode)("minutes"), ["space"]))
                  ]
                }, toDisplayString(unref(renderedMinutes)), 39),
                unref(inline) ? (openBlock(), createElementBlock("i", {
                  key: 1,
                  class: "fas fa-chevron-down position-absolute text-white timepicker-icon-down timepicker-icon-inline-minute",
                  onClick: _cache[9] || (_cache[9] = ($event) => unref(incrementMinutesValue)(-unref(increment)))
                })) : createCommentVNode("", true)
              ], 2)
            ]),
            unref(hoursFormat) === 12 ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass([
                "d-flex justify-content-center timepicker-mode-wrapper",
                !unref(inline) && "flex-column"
              ])
            }, [
              createElementVNode("button", {
                type: "button",
                class: normalizeClass([
                  "timepicker-hour-mode timepicker-am",
                  unref(inline) && "me-2 ms-4",
                  unref(dayTime) === "am" && "active"
                ]),
                tabindex: "0",
                onKeydown: [
                  _cache[10] || (_cache[10] = withKeys(($event) => unref(changeDayTime)("am"), ["enter"])),
                  _cache[11] || (_cache[11] = withKeys(($event) => unref(changeDayTime)("am"), ["space"]))
                ],
                onClick: _cache[12] || (_cache[12] = ($event) => unref(changeDayTime)("am"))
              }, toDisplayString(unref(amLabel)), 35),
              createElementVNode("button", {
                class: normalizeClass([
                  "timepicker-hour-mode timepicker-pm",
                  unref(dayTime) === "pm" && "active"
                ]),
                tabindex: "0",
                "aria-label": unref(pmLabel),
                onKeydown: [
                  _cache[13] || (_cache[13] = withKeys(($event) => unref(changeDayTime)("pm"), ["enter"])),
                  _cache[14] || (_cache[14] = withKeys(($event) => unref(changeDayTime)("pm"), ["space"]))
                ],
                onClick: _cache[15] || (_cache[15] = ($event) => unref(changeDayTime)("pm"))
              }, toDisplayString(unref(pmLabel)), 43, _hoisted_2$4),
              unref(inline) ? (openBlock(), createElementBlock("button", {
                key: 0,
                type: "button",
                class: "timepicker-button timepicker-submit timepicker-submit-inline py-1 px-2 mb-0",
                tabindex: "0",
                onClick: _cache[16] || (_cache[16] = (...args) => unref(handleOkClick) && unref(handleOkClick)(...args)),
                onKeydown: [
                  _cache[17] || (_cache[17] = withKeys(
                    (...args) => unref(handleOkClick) && unref(handleOkClick)(...args),
                    ["enter"]
                  )),
                  _cache[18] || (_cache[18] = withKeys(
                    (...args) => unref(handleOkClick) && unref(handleOkClick)(...args),
                    ["space"]
                  ))
                ]
              }, toDisplayString(unref(okLabel)), 33)) : createCommentVNode("", true)
            ], 2)) : unref(hoursFormat) === 24 && unref(inline) ? (openBlock(), createElementBlock("button", {
              key: 1,
              class: "timepicker-button timepicker-submit timepicker-submit-inline py-1 px-2 mb-0",
              tabindex: "0",
              onClick: _cache[19] || (_cache[19] = (...args) => unref(handleOkClick) && unref(handleOkClick)(...args)),
              onKeydown: [
                _cache[20] || (_cache[20] = withKeys(
                  (...args) => unref(handleOkClick) && unref(handleOkClick)(...args),
                  ["enter"]
                )),
                _cache[21] || (_cache[21] = withKeys(
                  (...args) => unref(handleOkClick) && unref(handleOkClick)(...args),
                  ["space"]
                ))
              ]
            }, toDisplayString(unref(okLabel)), 33)) : createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["class", "style"]);
    };
  }
});
const _hoisted_1$4 = /* @__PURE__ */ createElementVNode("span", { class: "timepicker-middle-dot position-absolute" }, null, -1);
const _hoisted_2$3 = /* @__PURE__ */ createElementVNode("div", { class: "timepicker-circle position-absolute" }, null, -1);
const _hoisted_3$2 = [
  _hoisted_2$3
];
const _hoisted_4$2 = { class: "timepicker-tips-element" };
const _hoisted_5$2 = { class: "timepicker-tips-inner-element" };
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "MDBTimepickerClock",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    unitsMode: String,
    max: Number,
    min: Number,
    rotate: {
      type: Number,
      default: 0
    },
    increment: Boolean,
    modelValue: [Number, String],
    angle: [Number, String],
    double: Boolean,
    size: {
      type: [Number, String],
      default: 260
    },
    allowedValues: Function
  },
  emits: ["input", "change", "update:angle"],
  setup(__props, { emit }) {
    const props = __props;
    const clockRef = ref("clockRef");
    const innerClockRef = ref("innerClockRef");
    const handRef = ref("handRef");
    const tipRef = ref([]);
    const setTipRef = (el) => {
      if (el) {
        tipRef.value.push(el);
      }
    };
    const tipClassName = computed(() => {
      return [`timepicker-time-tips-${props.unitsMode}`];
    });
    const activeClass = ref("");
    const handAngle = ref(props.angle);
    const firstOpen = ref(true);
    const handStyle = computed(() => {
      if (!firstOpen.value) {
        const modelValueNumber = typeof props.modelValue === "string" ? parseInt(props.modelValue, 10) : props.modelValue;
        handAngle.value = props.rotate + degreesPerUnit.value * (modelValueNumber - props.min);
        emit("update:angle", handAngle.value);
        setTimeout(() => {
          activeClass.value = "active";
        }, 400);
      } else {
        nextTick(() => {
          firstOpen.value = false;
        });
      }
      return {
        transform: `rotateZ(${handAngle.value}deg)`,
        height: handScale.value
      };
    });
    const handTransformClass = ref("timepicker-transform");
    const shouldClockAnimateOnShow = inject("shouldClockAnimateOnShow", null);
    const setClockAnimateOnShow = inject("setClockAnimateOnShow", null);
    const displayedValue = computed(() => {
      const value = typeof props.modelValue === "string" ? parseInt(props.modelValue, 10) : props.modelValue;
      return props.modelValue === null ? outerCircleValues.value[outerCircleValues.value.length - 1] : value;
    });
    const outerClockSize = ref(null);
    const innerClockSize = ref(null);
    const getCircleGeometry = (circleSize) => {
      const width = (circleSize - 32) / 2;
      const radius = width - 4;
      return {
        width,
        height: width,
        radius
      };
    };
    const elementCount = computed(() => {
      return props.max - props.min + 1;
    });
    const roundElementCount = computed(() => {
      return props.double ? elementCount.value / 2 : elementCount.value;
    });
    const degreesPerUnit = computed(() => {
      return 360 / roundElementCount.value;
    });
    const handScale = computed(() => {
      return props.double && (props.modelValue > 12 || props.modelValue === "00") ? `21.5%` : `calc(40% - 1px)`;
    });
    const radian = (el) => {
      return el * (Math.PI / 180);
    };
    const getStyle2 = (tipIndex, circleSize) => {
      const { x, y } = getPosition(tipIndex, circleSize);
      return `left: ${x}; bottom: ${y}`;
    };
    const getPosition = (tipIndex, circleSize) => {
      const angle2 = radian(tipIndex * degreesPerUnit.value);
      const { width, height, radius } = getCircleGeometry(circleSize);
      const result = {
        x: `${width + Math.sin(angle2) * radius}px`,
        y: `${height + Math.cos(angle2) * radius}px`
      };
      return result;
    };
    const outerCircleValues = computed(() => {
      if (props.double) {
        return tipsValues(1, 12);
      }
      return tipsValues(props.min, props.max);
    });
    const innerCircleValues = computed(() => {
      if (props.double) {
        return tipsValues(13, 24);
      }
      return null;
    });
    const setClockSizes = () => {
      if (innerClockRef.value instanceof HTMLElement && props.double) {
        innerClockSize.value = innerClockRef.value.offsetWidth;
      }
      if (clockRef.value instanceof HTMLElement) {
        outerClockSize.value = clockRef.value.offsetWidth;
      }
    };
    const tipsValues = (min2, max2) => {
      setClockSizes();
      const circleSize = props.double && max2 === 24 ? innerClockSize.value : outerClockSize.value;
      const list = [];
      const increment = props.unitsMode === "hours" ? 1 : 5;
      for (let tipIndex = min2; tipIndex <= max2; tipIndex += increment) {
        list.push({
          value: tipIndex === 24 ? `00` : formatTimeValue(tipIndex),
          active: tipIndex === displayedValue.value,
          disabled: !isAllowed(tipIndex),
          style: getStyle2(tipIndex, circleSize)
        });
      }
      return list;
    };
    const isDragging = ref(false);
    const onMouseDown = (e) => {
      isDragging.value = true;
      e.preventDefault();
      onDragMove(e);
      on(document, "mouseup", onMouseUp);
      onMulti(
        document,
        "mouseup mousemove mouseleave mouseover touchstart touchmove touchend",
        onDragMove
      );
    };
    const onMouseUp = (e) => {
      e.preventDefault();
      isDragging.value = false;
      emit("change");
      offMulti(
        document,
        "mouseup mousemove mouseleave mouseover touchstart touchmove touchend",
        onDragMove
      );
    };
    const onDragMove = (e) => {
      if (!(clockRef.value instanceof HTMLElement) || !isDragging.value || !clockRef.value)
        return;
      const { width, top: top2, left: left2 } = clockRef.value.getBoundingClientRect();
      const { clientX, clientY } = "touches" in e ? e.touches[0] : e;
      const center = { x: width / 2, y: -width / 2 };
      const coords = { x: clientX - left2, y: top2 - clientY };
      const handAngle2 = Math.round(angle(center, coords) - props.rotate + 360) % 360;
      const { radius: outerRadius } = getCircleGeometry(outerClockSize.value);
      let innerRadius = null;
      if (props.double) {
        const { radius } = getCircleGeometry(innerClockSize.value);
        innerRadius = radius;
      }
      const insideClick = props.double && euclidean(center, coords) < (outerRadius + innerRadius) / 2 - 16;
      const value = Math.round(handAngle2 / degreesPerUnit.value) + props.min + (insideClick ? roundElementCount.value : 0);
      if (handAngle2 >= 360 - degreesPerUnit.value / 2) {
        update2(insideClick ? props.max : props.min);
      } else {
        update2(value);
      }
    };
    const update2 = (value) => {
      if (props.modelValue !== value && isAllowed(value)) {
        emit("input", value);
      }
    };
    const euclidean = (p0, p1) => {
      const dx = p1.x - p0.x;
      const dy = p1.y - p0.y;
      return Math.sqrt(dx * dx + dy * dy);
    };
    const angle = (center, p1) => {
      const value = 2 * Math.atan2(p1.y - center.y - euclidean(center, p1), p1.x - center.x);
      return Math.abs(value * 180 / Math.PI);
    };
    const isAllowed = (value) => {
      return !props.allowedValues || props.allowedValues(value);
    };
    const formatTimeValue = (value) => {
      return props.unitsMode === "minutes" && value < 10 ? `0${value}` : value;
    };
    onMounted(() => {
      setTimeout(() => {
        setClockAnimateOnShow(false);
        handTransformClass.value = "";
      }, 400);
    });
    onUnmounted(() => {
      off(document, "mouseup", onMouseUp);
      offMulti(
        document,
        "mouseup mousemove mouseleave mouseover touchstart touchmove touchend",
        onDragMove
      );
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "clockRef",
        ref: clockRef,
        class: normalizeClass([
          "timepicker-clock",
          unref(shouldClockAnimateOnShow) && "timepicker-clock-animation"
        ]),
        onMousedown: onMouseDown,
        onTouchstart: onMouseDown,
        onMouseup: onMouseUp,
        onTouchend: onMouseUp
      }, {
        default: withCtx(() => [
          _hoisted_1$4,
          createElementVNode("div", {
            ref_key: "handRef",
            ref: handRef,
            class: normalizeClass([
              "timepicker-hand-pointer",
              "position-absolute",
              handTransformClass.value
            ]),
            style: normalizeStyle(unref(handStyle))
          }, _hoisted_3$2, 6),
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(outerCircleValues), (tip, key) => {
            return openBlock(), createElementBlock("span", {
              ref_for: true,
              ref: setTipRef,
              key,
              style: normalizeStyle(tip.style),
              class: normalizeClass([
                unref(tipClassName),
                tip.active && activeClass.value,
                tip.disabled && "disabled"
              ])
            }, [
              createElementVNode("span", _hoisted_4$2, toDisplayString(tip.value), 1)
            ], 6);
          }), 128)),
          __props.double ? (openBlock(), createElementBlock("div", {
            key: 0,
            ref_key: "innerClockRef",
            ref: innerClockRef,
            class: "timepicker-clock-inner"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(innerCircleValues), (tip, key) => {
              return openBlock(), createElementBlock("span", {
                ref_for: true,
                ref: setTipRef,
                key,
                style: normalizeStyle(tip.style),
                class: normalizeClass([
                  "timepicker-time-tips-inner",
                  tip.active && activeClass.value,
                  tip.disabled && "disabled"
                ])
              }, [
                createElementVNode("span", _hoisted_5$2, toDisplayString(tip.value), 1)
              ], 6);
            }), 128))
          ], 512)) : createCommentVNode("", true)
        ]),
        _: 1
      }, 40, ["class"]);
    };
  }
});
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "MDBTimepickerPlate",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(__props) {
    const hoursFormat = inject("hoursFormat", null);
    inject("increment", null);
    const hours = inject("hours", null);
    const minutes = inject("minutes", null);
    const unitsMode = inject("unitsMode", null);
    const updateMinutesValue = inject(
      "updateMinutesValue",
      null
    );
    const updateHoursValue = inject("updateHoursValue", null);
    const chageUnitsMode = inject("chageUnitsMode", null);
    const double = computed(() => {
      return hoursFormat === 24;
    });
    const angle = ref(360);
    const allowedHours = inject(
      "allowedHours",
      null
    );
    const allowedMinutes = inject(
      "allowedMinutes",
      null
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), { class: "timepicker-clock-wrapper d-flex justify-content-center flex-column align-items-center" }, {
        default: withCtx(() => [
          unref(unitsMode) === "hours" ? (openBlock(), createBlock(_sfc_main$6, {
            key: 0,
            modelValue: unref(hours),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(hours) ? hours.value = $event : null),
            angle: angle.value,
            "onUpdate:angle": _cache[1] || (_cache[1] = ($event) => angle.value = $event),
            unitsMode: unref(unitsMode),
            min: 1,
            max: unref(hoursFormat),
            allowedValues: unref(allowedHours),
            rotate: 30,
            double: unref(double),
            onInput: _cache[2] || (_cache[2] = (e) => unref(updateHoursValue)(e)),
            onChange: _cache[3] || (_cache[3] = ($event) => unref(chageUnitsMode)("minutes"))
          }, null, 8, ["modelValue", "angle", "unitsMode", "max", "allowedValues", "double"])) : createCommentVNode("", true),
          unref(unitsMode) === "minutes" ? (openBlock(), createBlock(_sfc_main$6, {
            key: 1,
            modelValue: unref(minutes),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => isRef(minutes) ? minutes.value = $event : null),
            angle: angle.value,
            "onUpdate:angle": _cache[5] || (_cache[5] = ($event) => angle.value = $event),
            unitsMode: unref(unitsMode),
            min: 0,
            max: 59,
            allowedValues: unref(allowedMinutes),
            onInput: _cache[6] || (_cache[6] = (e) => unref(updateMinutesValue)(e))
          }, null, 8, ["modelValue", "angle", "unitsMode", "allowedValues"])) : createCommentVNode("", true)
        ]),
        _: 1
      });
    };
  }
});
var vMdbFocusTrap = {
  mounted(el) {
    if (!el)
      return;
    let firstFocusableElement;
    let lastFocusableElement;
    el.initFocusTrap = () => {
      el.calculateFocusTrap();
      on(window, "keydown", el.focusFirstElement);
    };
    el.calculateFocusTrap = () => {
      const focusable = Array.from(
        el.querySelectorAll(
          'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((item) => {
        return !item.classList.contains("ps__thumb-x") && !item.classList.contains("ps__thumb-y") && !item.disabled;
      });
      if (focusable.length === 0)
        return;
      firstFocusableElement = focusable[0];
      lastFocusableElement = focusable[focusable.length - 1];
      on(
        lastFocusableElement,
        "keydown",
        (e) => el.focusFirstElement(e, true)
      );
    };
    el.focusTrap = () => {
      if (!firstFocusableElement)
        return;
      firstFocusableElement.focus();
    };
    el.focusFirstElement = (e, trap = false) => {
      if (e.key === "Tab") {
        e.preventDefault();
        el.focusTrap();
      }
      if (trap)
        return;
      off(window, "keydown", el.focusFirstElement);
    };
    el.removeFocusTrap = () => {
      off(lastFocusableElement, "keydown", el.handleLastElementKeydown);
    };
    el.initFocusTrap();
  },
  unmounted(el) {
    if (!el)
      return;
    el.removeFocusTrap();
  }
};
const _hoisted_1$3 = ["onClick"];
const _hoisted_2$2 = {
  ref: "timepickerContainerRef",
  class: "d-flex align-items-center justify-content-center flex-column shadow timepicker-container"
};
const _hoisted_3$1 = { class: "d-flex flex-column timepicker-elements justify-content-around" };
const _hoisted_4$1 = {
  key: 0,
  class: "buttons-container"
};
const _hoisted_5$1 = /* @__PURE__ */ createElementVNode("i", { class: "far fa-calendar datepicker-toggle-icon" }, null, -1);
const _hoisted_6$1 = [
  _hoisted_5$1
];
const _hoisted_7 = /* @__PURE__ */ createElementVNode("button", {
  type: "button",
  class: "timepicker-button-toggle",
  "data-mdb-toggle": "timepicker"
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "far fa-clock fa-sm timepicker-icon" })
], -1);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "MDBTimepickerModal",
  props: {
    modelValue: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  emits: ["cancel", "update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const modalRef = ref(null);
    const wrapperRef = ref(null);
    const wrapperClass = computed(() => {
      return [
        "timepicker-wrapper h-100 d-flex align-items-center justify-content-center flex-column position-fixed"
      ];
    });
    const { beforeEnter, afterLeave } = useScrollbarWidth();
    const isActive = ref(props.modelValue);
    const handleClickOutside = () => {
      if (!isActive.value || debounce2.value)
        return;
      isActive.value = false;
      emit("cancel");
      emit("update:modelValue", false);
    };
    const debounce2 = ref(true);
    watch(
      () => props.modelValue,
      (value) => {
        isActive.value = value;
        setTimeout(() => {
          debounce2.value = value;
          setTimeout(() => debounce2.value = !value, 100);
        }, 500);
      }
    );
    const dateTimepicker = inject("dateTimepicker", null);
    const changePicker = inject("changePicker", null);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(Transition, {
          name: "timepicker-fade",
          onBeforeEnter: unref(beforeEnter),
          onAfterLeave: unref(afterLeave)
        }, {
          default: withCtx(() => [
            isActive.value ? (openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
              key: 0,
              ref_key: "modalRef",
              ref: modalRef,
              class: "timepicker-modal",
              tabindex: "-1",
              role: "dialog"
            }, {
              default: withCtx(() => [
                withDirectives((openBlock(), createElementBlock("div", {
                  ref_key: "wrapperRef",
                  ref: wrapperRef,
                  class: normalizeClass(unref(wrapperClass)),
                  style: { "opacity": "1" },
                  onClick: withModifiers(handleClickOutside, ["self"])
                }, [
                  createElementVNode("div", _hoisted_2$2, [
                    createElementVNode("div", _hoisted_3$1, [
                      createVNode(_sfc_main$7),
                      unref(dateTimepicker) ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
                        createElementVNode("button", {
                          type: "button",
                          class: "datepicker-button-toggle",
                          "data-mdb-toggle": "datepicker",
                          onClick: _cache[0] || (_cache[0] = ($event) => unref(changePicker)("datepicker"))
                        }, _hoisted_6$1),
                        _hoisted_7
                      ])) : createCommentVNode("", true),
                      createVNode(_sfc_main$5)
                    ]),
                    createVNode(_sfc_main$8)
                  ], 512)
                ], 10, _hoisted_1$3)), [
                  [unref(vMdbFocusTrap)]
                ])
              ]),
              _: 1
            }, 512)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onBeforeEnter", "onAfterLeave"])
      ]);
    };
  }
});
const _hoisted_1$2 = { class: "d-flex align-items-center justify-content-center flex-column shadow timepicker-container" };
const _hoisted_2$1 = { class: "d-flex flex-column timepicker-elements justify-content-around timepicker-elements-inline" };
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "MDBTimepickerInline",
  props: {
    modelvalue: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  emits: ["cancel"],
  setup(__props, { emit }) {
    const modalRef = ref(null);
    const wrapperRef = ref(null);
    const wrapperClass = computed(() => {
      return [
        "timepicker-wrapper h-100 d-flex align-items-center justify-content-center flex-column timepicker-wrapper-inline"
      ];
    });
    const { setPopper, openPopper, closePopper } = MDBPopper();
    const parentId = inject("inputId", null);
    const dateTimepicker = inject("dateTimepicker", null);
    const fallbackPlacements = ["top", "right", "bottom", "left"];
    const popperSetup = () => {
      let triggerEl;
      if (parentId) {
        triggerEl = document.getElementById(parentId);
      }
      if (dateTimepicker) {
        triggerEl = dateTimepicker.value.inputRef;
      }
      const popperEl = modalRef.value;
      const config = {
        placement: `bottom-start`,
        eventsEnabled: true,
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements
            }
          },
          {
            name: "preventOverflow",
            options: {
              boundary: "clippingParent"
            }
          }
        ]
      };
      setPopper(triggerEl, popperEl, config);
      openPopper();
    };
    inject("handleCancelClick", null);
    const debounce2 = ref(false);
    const handleCancelModal = (e) => {
      const target = e.target;
      if (!target.closest(".timepicker-modal")) {
        if (debounce2.value) {
          emit("cancel");
        }
      }
    };
    onMounted(() => {
      popperSetup();
      setTimeout(() => {
        debounce2.value = true;
      }, 500);
    });
    onBeforeUnmount(() => {
      closePopper();
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(__props.tag), {
        ref_key: "modalRef",
        ref: modalRef,
        class: "timepicker-modal",
        tabindex: "-1",
        role: "dialog"
      }, {
        default: withCtx(() => [
          withDirectives((openBlock(), createElementBlock("div", {
            ref_key: "wrapperRef",
            ref: wrapperRef,
            class: normalizeClass(unref(wrapperClass)),
            style: { "opacity": "1" }
          }, [
            createElementVNode("div", _hoisted_1$2, [
              createElementVNode("div", _hoisted_2$1, [
                createVNode(_sfc_main$7)
              ])
            ])
          ], 2)), [
            [unref(vMdbClickOutside), handleCancelModal],
            [unref(vMdbFocusTrap)]
          ])
        ]),
        _: 1
      }, 512);
    };
  }
});
const __default__$1 = {
  inheritAttrs: false
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  __name: "MDBTimepicker",
  props: {
    modelValue: [String, Date],
    label: String,
    id: String,
    icon: {
      type: Boolean,
      default: true
    },
    iconClass: {
      type: String,
      default: "far fa-clock fa-sm"
    },
    selfOpen: Boolean,
    inline: {
      type: Boolean,
      default: false
    },
    hoursFormat: {
      type: Number,
      default: 12,
      validator: (value) => value === 24 || value === 12
    },
    min: [Number, String],
    max: [Number, String],
    increment: {
      type: Number,
      default: 1,
      validator: (value) => {
        return [1, 5, 10, 15, 30].indexOf(value) > -1;
      }
    },
    amLabel: {
      type: String,
      default: "AM"
    },
    pmLabel: {
      type: String,
      default: "PM"
    },
    okLabel: {
      type: String,
      default: "ok"
    },
    clearLabel: {
      type: String,
      default: "clear"
    },
    cancelLabel: {
      type: String,
      default: "cancel"
    },
    invalidLabel: {
      type: String,
      default: "Invalid date format"
    },
    invalidFeedback: String,
    validLabel: String,
    validFeedback: String,
    isValid: Boolean,
    isValidated: Boolean,
    disablePast: {
      type: Boolean,
      default: false
    },
    disableFuture: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue",
    "update:isValid",
    "update:isValidated",
    "open",
    "close"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    const inputRef = ref(null);
    const modalRef = ref(null);
    const btnRef = ref(null);
    const uid2 = props.id || getUID("MDBInput-");
    provide("inputId", uid2);
    const inputWrapperClass = computed(() => {
      return "timepicker";
    });
    const customIconClass = computed(() => {
      return ["timepicker-icon", props.iconClass];
    });
    provide("hoursFormat", props.hoursFormat);
    provide("amLabel", props.amLabel);
    provide("pmLabel", props.pmLabel);
    provide("okLabel", props.okLabel);
    provide("clearLabel", props.clearLabel);
    provide("cancelLabel", props.cancelLabel);
    provide("inline", props.inline);
    provide("increment", props.increment);
    provide("min", props.min);
    provide("max", props.max);
    const inputValue = ref(props.modelValue);
    const modelValueProp = toRefs(props).modelValue;
    watch(
      () => modelValueProp.value,
      (cur) => {
        if (cur && cur !== inputValue.value) {
          inputValue.value = cur;
          formatToAmPm(cur);
        }
      }
    );
    const hours = ref(12);
    const minutes = ref(0);
    const unitsMode = ref("hours");
    const dayTime = ref("am");
    const currentDate = new Date().toLocaleTimeString("en-US");
    const computedMinutes = computed(() => {
      const minutesValue = typeof minutes.value === "string" ? parseInt(minutes.value) : minutes.value;
      return minutesValue < 10 ? `0${minutesValue}` : minutesValue;
    });
    const computedHours = computed(() => {
      if (hours.value < 10) {
        return hours.value.toString().startsWith("0") ? hours.value.toString() : hours.value === 0 ? `00` : `0${hours.value}`;
      } else {
        return hours.value === 24 ? "00" : hours.value;
      }
    });
    const computedMinValue = computed(() => {
      if (props.min === void 0) {
        return 0;
      }
      const min2 = props.min;
      if (props.hoursFormat === 24) {
        return getMinutesValue(getTimeUnits(min2));
      }
      return getMinutesValue(getTimeUnits(min2, dayTime.value));
    });
    const computedMaxValue = computed(() => {
      if (props.max === void 0) {
        return 24 * 60;
      }
      const max2 = props.max;
      if (props.hoursFormat === 24) {
        return getMinutesValue(getTimeUnits(max2));
      }
      return getMinutesValue(getTimeUnits(max2, dayTime.value));
    });
    const computedDisablePropsValue = computed(() => {
      if (props.disablePast && props.disableFuture === void 0) {
        return 0;
      }
      if (props.hoursFormat === 24) {
        return getMinutesValue(getTimeUnits(currentDate));
      }
      return getMinutesValue(getTimeUnits(currentDate, dayTime.value));
    });
    const changeDayTime = (value) => {
      if (!value)
        return;
      dayTime.value = value.toLowerCase();
    };
    const chageUnitsMode = (value) => {
      if (!value)
        return;
      unitsMode.value = value.toLowerCase();
    };
    const updateHoursValue = (value) => {
      hours.value = value;
    };
    const incrementHoursValue = (delta, currentValue = hours.value, recursion = void 0) => {
      if (unitsMode.value !== "hours") {
        chageUnitsMode("hours");
      }
      const valueToPass = typeof currentValue === "string" ? parseInt(currentValue) : currentValue;
      const isCurrentInRange = allowedHours(valueToPass);
      const incrementedValue = valueToPass + delta;
      let result = incrementedValue <= 0 || incrementedValue === 24 ? props.hoursFormat : incrementedValue > props.hoursFormat ? 1 : incrementedValue;
      const isIncrementedInRange = allowedHours(result);
      if (isCurrentInRange && !isIncrementedInRange) {
        result = incrementHoursValue(delta, result, true);
      } else if (!isCurrentInRange && !isIncrementedInRange) {
        if (props.hoursFormat === 24) {
          result = incrementHoursValue(delta, result, true);
        } else {
          const activeValues = document.querySelectorAll(
            ".timepicker-time-tips-hours:not(.disabled)"
          );
          const minV = props.min;
          const maxV = props.max;
          const min2 = props.min && getTimeUnits(minV);
          const max2 = props.max && getTimeUnits(maxV);
          if (!activeValues.length) {
            if (delta > 0) {
              result = min2 ? min2.hours : 1;
              minutes.value = allowedMinutes(minutes.value) ? minutes.value : min2 ? min2.minutes : max2 ? max2.minutes : 0;
              changeDayTime(
                min2 && min2.ampm || max2 && max2.ampm || dayTime.value
              );
            } else if (delta < 0) {
              result = max2 ? max2.hours : props.hoursFormat;
              minutes.value = allowedMinutes(minutes.value) ? minutes.value : max2 ? max2.minutes : min2 ? min2.minutes : 0;
              changeDayTime(
                max2 && max2.ampm || min2 && min2.ampm || dayTime.value
              );
            }
          } else {
            result = incrementHoursValue(delta, result, true);
          }
        }
      }
      if (recursion) {
        return result;
      }
      hours.value = result;
    };
    const updateMinutesValue = (value) => {
      minutes.value = value;
    };
    const incrementMinutesValue = (delta, currentValue = minutes.value, recursion = void 0) => {
      if (unitsMode.value !== "minutes") {
        chageUnitsMode("minutes");
      }
      const isCurrentInRange = allowedMinutes(currentValue);
      const incrementedValue = currentValue + delta;
      let result = incrementedValue < 0 ? 60 - props.increment : incrementedValue > 59 ? 0 : incrementedValue;
      const isIncrementedInRange = allowedMinutes(result);
      if (isCurrentInRange && !isIncrementedInRange) {
        result = incrementMinutesValue(delta, result, true);
      } else if (!isCurrentInRange && !isIncrementedInRange) {
        const activeValues = document.querySelectorAll(
          ".timepicker-time-tips-minutes:not(.disabled)"
        );
        const minV = props.min;
        const maxV = props.max;
        const min2 = props.min && getTimeUnits(minV);
        const max2 = props.max && getTimeUnits(maxV);
        if (!activeValues.length) {
          if (delta > 0) {
            result = min2 && min2.minutes ? min2.minutes : 0;
            hours.value = allowedHours(hours.value) ? hours.value : min2 ? min2.hours : 1;
            changeDayTime(min2 && min2.ampm || max2 && max2.ampm || dayTime.value);
          } else if (delta < 0) {
            result = max2 && max2.minutes ? max2.minutes : min2 && min2.minutes ? min2.minutes : 0;
            hours.value = allowedHours(hours.value) ? hours.value : max2 ? max2.hours : props.hoursFormat;
            changeDayTime(max2 && max2.ampm || min2 && min2.ampm || dayTime.value);
          }
        } else {
          result = incrementMinutesValue(delta, result, true);
        }
      }
      if (recursion) {
        return result;
      }
      minutes.value = result;
    };
    const handleOkClick = () => {
      if (!allowedHours(hours.value) || !allowedMinutes(minutes.value)) {
        return;
      }
      inputValue.value = props.hoursFormat === 12 ? `${computedHours.value}:${computedMinutes.value} ${dayTime.value.toUpperCase()}` : `${computedHours.value}:${computedMinutes.value}`;
      close();
      unitsMode.value = "hours";
    };
    const handleClearClick = () => {
      inputValue.value = "";
      hours.value = 12;
      minutes.value = 0;
      unitsMode.value = "hours";
      dayTime.value = "am";
    };
    const handleCancelClick = () => {
      if (!inputValue.value) {
        handleClearClick();
      }
      close();
      formatToAmPm(inputValue.value);
    };
    const handleInput = (e) => {
      const target = e.target;
      const { value } = target;
      if (checkFormatValidity(value.trimEnd())) {
        formatToAmPm(value);
      }
    };
    watch(
      () => inputValue.value,
      (cur) => {
        const current = cur;
        checkFormatValidity(current.trimEnd(), true);
        emit("update:modelValue", cur);
      }
    );
    const formatToAmPm = (date) => {
      if (date === "")
        return;
      let _hours;
      let _minutes;
      let _amOrPm;
      if (typeof date !== "string" && isValidDate(date)) {
        _hours = date.getHours();
        _minutes = date.getMinutes();
        _hours %= 12;
        _hours = _hours || 12;
        _amOrPm = _hours >= 12 ? "PM" : "AM";
      } else if (typeof date === "string" && !isValidDate(date)) {
        const {
          hours: inputHours,
          minutes: inputMinutes,
          ampm = null
        } = getTimeUnits(date);
        if (ampm) {
          _amOrPm = ampm;
        }
        _hours = inputHours;
        _minutes = inputMinutes;
      }
      hours.value = parseInt(_hours) < 10 ? `0${_hours}` : _hours;
      minutes.value = parseInt(_minutes) < 10 ? `0${_minutes}` : _minutes;
      changeDayTime(_amOrPm);
      chageUnitsMode("hours");
      return `${hours.value}:${minutes.value} ${props.hoursFormat === 12 ? dayTime.value : ""}`;
    };
    const getTimeUnits = (date, computedDayTime = null) => {
      let [time, ampm] = date.split(" ");
      let [hours2, minutes2] = time.split(":");
      if (props.hoursFormat === 12 && !ampm && computedDayTime) {
        ampm = computedDayTime;
      }
      hours2 = parseInt(hours2);
      minutes2 = parseInt(minutes2);
      return { hours: hours2, minutes: minutes2, ampm };
    };
    provide("hours", computedHours);
    provide("minutes", computedMinutes);
    provide("unitsMode", unitsMode);
    provide("dayTime", dayTime);
    provide("changeDayTime", changeDayTime);
    provide("chageUnitsMode", chageUnitsMode);
    provide("updateHoursValue", updateHoursValue);
    provide("incrementHoursValue", incrementHoursValue);
    provide("updateMinutesValue", updateMinutesValue);
    provide("incrementMinutesValue", incrementMinutesValue);
    provide("handleOkClick", handleOkClick);
    provide("handleClearClick", handleClearClick);
    provide("handleCancelClick", handleCancelClick);
    const handleKeydown = (e) => {
      if (!isActive.value)
        return;
      const { key } = e;
      if (key === "Escape") {
        close();
      }
      if (key !== "Tab") {
        e.preventDefault();
      } else if (key === "Tab" && e.target === document.body) {
        modalRef.value.$refs.modalRef.focus();
      }
      switch (key) {
        case "ArrowUp":
          handleChangeTime(1);
          break;
        case "ArrowDown":
          handleChangeTime(-1);
          break;
        case "ArrowLeft":
          handleChangeClockCircle("left");
          break;
        case "ArrowRight":
          handleChangeClockCircle("right");
          break;
      }
    };
    const handleChangeTime = (multiplier) => {
      if (unitsMode.value === "hours") {
        incrementHoursValue(1 * multiplier);
      } else {
        incrementMinutesValue(props.increment * multiplier);
      }
    };
    const handleChangeClockCircle = (side) => {
      if (props.hoursFormat === 12 || unitsMode.value === "minutes") {
        return;
      }
      if (side === "left" && hours.value < 12) {
        hours.value += 12;
      }
      if (side === "right" && hours.value > 12) {
        hours.value -= 12;
      }
    };
    const blurInput = () => {
      inputRef.value.$refs.inputRef.focus();
      inputRef.value.$refs.inputRef.blur();
    };
    const focusToggler = () => {
      if (btnRef.value) {
        btnRef.value.focus();
      } else {
        inputRef.value.$refs.inputRef.focus();
      }
    };
    const valid = ref(props.isValid);
    const validated = ref(props.isValidated);
    watchEffect(() => {
      valid.value = props.isValid;
    });
    watchEffect(() => {
      validated.value = props.isValidated;
    });
    const validationTitle = computed(() => {
      return props.hoursFormat === 12 ? "Date should match HH:MM 12-hour format, optional leading 0, mandatory meridiems (AM/PM)" : "Date should match HH:MM 24-hour format, optional leading 0";
    });
    const validationPattern = computed(() => {
      return props.hoursFormat === 12 ? /\b((1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm]))/ : /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
    });
    const checkFormatValidity = (date, clear = void 0) => {
      if (!validationPattern.value.test(date)) {
        validated.value = true;
        valid.value = false;
        emit("update:isValid", false);
        emit("update:isValidated", true);
        return false;
      } else {
        validated.value = props.validLabel ? true : clear ? false : true;
        valid.value = true;
        emit("update:isValid", true);
        emit("update:isValidated", validated.value);
        return true;
      }
    };
    const isValidDate = (date) => {
      return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
    };
    const getMinutesValue = ({ hours: hours2, minutes: minutes2, ampm }) => {
      ampm = ampm ? ampm.toLowerCase() : ampm;
      const addition = props.hoursFormat === 12 && ampm === "pm" ? 12 * 60 : 0;
      minutes2 = minutes2 || 0;
      return hours2 * 60 + minutes2 + addition;
    };
    const allowedHours = (value) => {
      if (!props.max && !props.min && !props.disablePast && !props.disableFuture) {
        return value;
      }
      let _max = computedMaxValue.value;
      let _min = computedMinValue.value;
      let _disableProps = computedDisablePropsValue.value;
      if (_max && _min && _max < _min) {
        [_max, _min] = [_min, _max];
      }
      _min = _min - _min % 60;
      _disableProps = _disableProps - _disableProps % 60;
      const addition = props.hoursFormat === 12 && dayTime.value.toLowerCase() === "pm" ? 12 * 60 : 0;
      const selectedHourValue = value * 60 + addition;
      let boundryCondition = true;
      if (props.min)
        boundryCondition = boundryCondition && selectedHourValue >= _min;
      if (props.max)
        boundryCondition = boundryCondition && selectedHourValue <= _max;
      if (props.disablePast)
        boundryCondition = boundryCondition && selectedHourValue >= _disableProps;
      if (props.disableFuture)
        boundryCondition = boundryCondition && selectedHourValue <= _disableProps;
      return boundryCondition;
    };
    const allowedMinutes = (value) => {
      if (!props.max && !props.min && !props.disablePast && !props.disableFuture) {
        return value / props.increment === Math.floor(value / props.increment);
      }
      let _max = computedMaxValue.value;
      let _min = computedMinValue.value;
      if (_max && _min && _max < _min) {
        [_max, _min] = [_min, _max];
      }
      const addition = props.hoursFormat === 12 && dayTime.value.toLowerCase() === "pm" ? 12 * 60 : 0;
      const hourValue = hours.value * 60 + addition;
      let boundryCondition = true;
      if (props.min)
        boundryCondition = boundryCondition && hourValue + value >= _min;
      if (props.max)
        boundryCondition = boundryCondition && hourValue + value <= _max;
      if (props.disablePast)
        boundryCondition = boundryCondition && hourValue + value >= computedDisablePropsValue.value;
      if (props.disableFuture)
        boundryCondition = boundryCondition && hourValue + value <= computedDisablePropsValue.value;
      return boundryCondition && value / props.increment === Math.floor(value / props.increment);
    };
    provide("allowedHours", allowedHours);
    provide("allowedMinutes", allowedMinutes);
    const isActive = ref(false);
    const shouldClockAnimateOnShow = ref(true);
    const setClockAnimateOnShow = (value) => {
      shouldClockAnimateOnShow.value = value;
    };
    const debounce2 = ref(false);
    const handleSelfOpen = () => !props.icon && props.selfOpen && togglePicker();
    const togglePicker = () => {
      if (debounce2.value)
        return;
      if (!isActive.value) {
        open();
      } else {
        close();
      }
    };
    const open = () => {
      if (debounce2.value)
        return;
      debounce2.value = true;
      isActive.value = true;
      emit("open");
      blurInput();
      setTimeout(() => debounce2.value = false, 250);
    };
    const close = () => {
      if (debounce2.value)
        return;
      debounce2.value = true;
      isActive.value = false;
      emit("close");
      focusToggler();
      setClockAnimateOnShow(true);
      setTimeout(() => debounce2.value = false, 250);
    };
    provide("isActive", isActive.value);
    provide("close", close);
    provide("shouldClockAnimateOnShow", shouldClockAnimateOnShow);
    provide("setClockAnimateOnShow", setClockAnimateOnShow);
    onMounted(() => {
      if (props.modelValue) {
        inputValue.value = formatToAmPm(props.modelValue);
      } else {
        if (props.max) {
          const maxV = props.max;
          const max2 = getTimeUnits(maxV);
          hours.value = max2.hours < 12 ? max2.hours : 12;
          minutes.value = max2.hours < 12 ? max2.minutes : 0;
        }
        if (props.min) {
          const minV = props.min;
          const min2 = getTimeUnits(minV);
          hours.value = min2.hours > hours.value ? min2.hours : hours.value;
          minutes.value = min2.hours > hours.value ? min2.minutes : 0;
        }
      }
      on(window, "keydown", handleKeydown);
    });
    onUnmounted(() => {
      off(window, "keydown", handleKeydown);
    });
    expose({
      togglePicker,
      open,
      close
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_sfc_main$O, mergeProps({
          id: unref(uid2),
          ref_key: "inputRef",
          ref: inputRef,
          modelValue: inputValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
          label: __props.label,
          wrapperClass: unref(inputWrapperClass)
        }, _ctx.$attrs, {
          "aria-haspopup": "dialog",
          invalidFeedback: __props.invalidFeedback ? __props.invalidFeedback : __props.invalidLabel,
          validFeedback: __props.validLabel || __props.validFeedback,
          isValid: valid.value,
          isValidated: validated.value,
          title: unref(validationTitle),
          onClick: handleSelfOpen,
          onInput: handleInput
        }), {
          default: withCtx(() => [
            __props.icon ? (openBlock(), createElementBlock("button", {
              key: 0,
              ref_key: "btnRef",
              ref: btnRef,
              type: "button",
              class: "timepicker-toggle-button",
              "aria-haspopup": "dialog",
              onClick: togglePicker
            }, [
              createElementVNode("i", {
                class: normalizeClass(unref(customIconClass))
              }, null, 2)
            ], 512)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 16, ["id", "modelValue", "label", "wrapperClass", "invalidFeedback", "validFeedback", "isValid", "isValidated", "title"]),
        __props.inline ? (openBlock(), createBlock(Teleport, {
          key: 0,
          to: "body"
        }, [
          createVNode(Transition, { name: "timepicker-fade" }, {
            default: withCtx(() => [
              isActive.value ? (openBlock(), createBlock(_sfc_main$3, {
                key: 0,
                ref_key: "modalRef",
                ref: modalRef,
                onCancel: handleCancelClick
              }, null, 512)) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])) : (openBlock(), createBlock(_sfc_main$4, {
          key: 1,
          ref_key: "modalRef",
          ref: modalRef,
          modelValue: isActive.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => isActive.value = $event),
          onCancel: handleCancelClick
        }, null, 8, ["modelValue"]))
      ], 64);
    };
  }
});
const _hoisted_1$1 = ["disabled"];
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "MDBDateTimepicker",
  props: {
    datepicker: Object,
    defaultTime: String,
    defaultDate: String,
    disabled: Boolean,
    modelValue: {
      type: [String, Date]
    },
    label: String,
    icon: {
      type: Boolean,
      default: true
    },
    iconClass: {
      type: String,
      default: "far fa-calendar fa-sm"
    },
    id: String,
    inline: Boolean,
    inputToggle: Boolean,
    invalidLabel: {
      type: String,
      default: "Invalid date format"
    },
    isValid: Boolean,
    isValidated: Boolean,
    validLabel: {
      type: String
    },
    timepicker: Object,
    toggleButton: {
      type: Boolean,
      default: true
    },
    dateTimeSeparator: {
      type: String,
      default: ","
    },
    dateFormat: {
      type: String,
      default: "DD/MM/YYYY"
    }
  },
  emits: [
    "update:isValid",
    "update:isValidated",
    "update:modelValue",
    "open",
    "close"
  ],
  setup(__props, { expose, emit }) {
    var _a, _b;
    const props = __props;
    const datepickerRef = ref(null);
    const timepickerRef = ref(null);
    const inputRef = ref(null);
    const btnRef = ref(null);
    const uid2 = props.id || getUID("MDBInput-");
    provide("dateTimepicker", inputRef);
    const inputWrapperClass = computed(() => {
      return "datetimepicker";
    });
    const customIconClass = computed(() => {
      return ["timepicker-icon", props.iconClass];
    });
    const timeDateValue = typeof props.modelValue === "string" && props.modelValue !== "" ? props.modelValue.split(",") : props.modelValue;
    const datepickerModel = ref(
      props.defaultDate || ((_a = timeDateValue[0]) == null ? void 0 : _a.trim()) || ""
    );
    const timepickerModel = ref(
      props.defaultTime || ((_b = timeDateValue[1]) == null ? void 0 : _b.trim()) || ""
    );
    const separator = ref(props.dateTimeSeparator);
    const inputValue = computed(() => {
      if (props.dateFormat.includes(separator.value)) {
        separator.value = "@@";
      }
      if (datepickerModel.value && timepickerModel.value) {
        return `${datepickerModel.value}${separator.value} ${timepickerModel.value}`;
      }
      return "";
    });
    watch(
      () => inputValue.value,
      (cur) => {
        emit("update:modelValue", cur);
      }
    );
    watch(
      () => props.modelValue,
      (curr, prev) => {
        if (curr === prev || typeof curr !== "string") {
          return;
        }
        const value = curr.split(separator.value);
        if (value[0] === "" || !value[1]) {
          datepickerModel.value = "";
          timepickerModel.value = "";
          return;
        }
        datepickerModel.value = value[0];
        timepickerModel.value = value[1].trim();
      }
    );
    const shouldTimepickerOpen = ref(true);
    const timepickerProps = computed(() => {
      return {
        ...toRaw(props.timepicker),
        inline: props.inline
      };
    });
    const datepickerProps = computed(() => {
      return {
        ...toRaw(props.datepicker),
        inline: props.inline
      };
    });
    const toggleDatepicker = () => {
      datepickerRef.value.open();
    };
    const toggleTimepicker = () => {
      if (!shouldTimepickerOpen.value)
        return;
      timepickerRef.value.open();
    };
    const handleCancel = () => {
      shouldTimepickerOpen.value = false;
      setTimeout(() => shouldTimepickerOpen.value = true, 500);
    };
    const handleInputToggle = () => {
      if (props.inputToggle) {
        toggleDatepicker();
      }
    };
    const changePicker = (picker) => {
      if (picker === "timepicker") {
        datepickerRef.value.close();
      } else if (picker === "datepicker") {
        timepickerRef.value.close();
        setTimeout(() => toggleDatepicker(), 300);
      }
    };
    const open = () => {
      datepickerRef.value.open();
      emit("open");
    };
    const close = () => {
      datepickerRef.value.close();
      timepickerRef.value.close();
      emit("close");
    };
    provide("changePicker", changePicker);
    const isTimepickerValidated = ref(false);
    const isTimepickerValid = ref(true);
    const isDatepickerValidated = ref(false);
    const isDatepickerValid = ref(true);
    const valid = ref(props.isValid);
    const validated = ref(props.isValidated);
    watchEffect(() => {
      valid.value = props.isValid;
    });
    watchEffect(() => {
      validated.value = props.isValidated;
    });
    watch(
      () => [isTimepickerValid.value, isDatepickerValid.value],
      (cur) => {
        if (cur.some((value) => typeof value === "boolean" && value === false)) {
          emit("update:isValid", false);
          setInputsInvalid();
        }
        if (cur.every((value) => !!value)) {
          emit("update:isValid", true);
        }
      },
      { immediate: true }
    );
    watch(
      () => [isTimepickerValidated.value, isDatepickerValidated.value],
      (cur) => {
        if (cur.some((value) => value))
          emit("update:isValidated", true);
        if (cur.every((value) => typeof value === "boolean" && value === false)) {
          emit("update:isValidated", false);
        }
      },
      { immediate: true }
    );
    const setInputsInvalid = () => {
      if (!validated.value)
        return;
      datepickerModel.value = isDatepickerValid.value ? datepickerModel.value : "";
      timepickerModel.value = isTimepickerValid.value ? timepickerModel.value : "";
    };
    expose({
      open,
      close
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_sfc_main$O, mergeProps({
          id: unref(uid2),
          ref_key: "inputRef",
          ref: inputRef,
          modelValue: unref(inputValue),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(inputValue) ? inputValue.value = $event : null),
          label: __props.label,
          wrapperClass: unref(inputWrapperClass)
        }, _ctx.$attrs, {
          invalidFeedback: __props.invalidLabel,
          validFeedback: __props.validLabel,
          "aria-haspopup": "dialog",
          isValid: valid.value,
          isValidated: validated.value,
          disabled: __props.disabled,
          onClick: withModifiers(handleInputToggle, ["stop"]),
          onKeydown: withKeys(handleInputToggle, ["enter"])
        }), {
          default: withCtx(() => [
            __props.icon && __props.toggleButton ? (openBlock(), createElementBlock("button", {
              key: 0,
              ref_key: "btnRef",
              ref: btnRef,
              type: "button",
              class: "datetimepicker-toggle-button",
              "aria-haspopup": "dialog",
              disabled: __props.disabled,
              onClick: toggleDatepicker
            }, [
              createElementVNode("i", {
                class: normalizeClass(unref(customIconClass))
              }, null, 2)
            ], 8, _hoisted_1$1)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 16, ["id", "modelValue", "label", "wrapperClass", "invalidFeedback", "validFeedback", "isValid", "isValidated", "disabled", "onClick", "onKeydown"]),
        withDirectives(createElementVNode("div", null, [
          createVNode(_sfc_main$9, mergeProps({
            ref_key: "datepickerRef",
            ref: datepickerRef,
            modelValue: datepickerModel.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => datepickerModel.value = $event),
            isValidated: isDatepickerValidated.value,
            "onUpdate:isValidated": _cache[2] || (_cache[2] = ($event) => isDatepickerValidated.value = $event),
            isValid: isDatepickerValid.value,
            "onUpdate:isValid": _cache[3] || (_cache[3] = ($event) => isDatepickerValid.value = $event),
            label: "Select a date",
            format: __props.dateFormat
          }, unref(datepickerProps), {
            onCancel: handleCancel,
            onClose: toggleTimepicker
          }), null, 16, ["modelValue", "isValidated", "isValid", "format"]),
          createVNode(_sfc_main$2, mergeProps({
            ref_key: "timepickerRef",
            ref: timepickerRef,
            isValidated: isTimepickerValidated.value,
            "onUpdate:isValidated": _cache[4] || (_cache[4] = ($event) => isTimepickerValidated.value = $event),
            isValid: isTimepickerValid.value,
            "onUpdate:isValid": _cache[5] || (_cache[5] = ($event) => isTimepickerValid.value = $event),
            modelValue: timepickerModel.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => timepickerModel.value = $event),
            label: "Select a time"
          }, unref(timepickerProps)), null, 16, ["isValidated", "isValid", "modelValue"])
        ], 512), [
          [vShow, false]
        ])
      ], 64);
    };
  }
});
const UP_ARROW = 38;
const DOWN_ARROW = 40;
const HOME = 36;
const END = 35;
const ENTER = 13;
const ESCAPE = 27;
const TAB = 9;
const _hoisted_1 = {
  key: 0,
  class: "autocomplete-loader spinner-border"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("span", { className: "sr-only" }, "Loading...", -1);
const _hoisted_3 = [
  _hoisted_2
];
const _hoisted_4 = ["id"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["innerHTML"];
const __default__ = {
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "MDBAutocomplete",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    filter: Function,
    displayValue: Function,
    itemContent: Function,
    noResultsText: {
      type: String,
      default: "No results"
    },
    threshold: {
      type: Number,
      default: 0
    },
    optionHeight: {
      type: Number,
      default: 38
    },
    visibleOptions: {
      type: Number,
      default: 5
    },
    label: String,
    placeholder: String,
    disabled: Boolean,
    required: Boolean,
    size: String,
    isValidated: Boolean,
    isValid: Boolean,
    validFeedback: String,
    invalidFeedback: String,
    autoSelect: Boolean
  },
  emits: [
    "update:modelValue",
    "open",
    "close",
    "update",
    "item-select"
  ],
  setup(__props, { expose, emit }) {
    const props = __props;
    computed(() => {
      return [
        "autocomplete-wrapper",
        isSelectValidated.value && isSelectValid.value ? "is-valid" : "",
        isSelectValidated.value && !isSelectValid.value ? "is-invalid" : ""
      ];
    });
    const autocompleteDropdownContainerStyle = computed(() => {
      return {
        width: dropdownWidth.value
      };
    });
    const autocompleteItemsListStyle = computed(() => {
      return {
        maxHeight: `${props.visibleOptions * props.optionHeight}px`
      };
    });
    const autocompleteWrapperRef = ref(null);
    const dropdownRef = ref(null);
    const dropdownId = getUID("MDBAutocompleteDropdown-");
    const dropdownWidth = ref("200px");
    const isDropdownActive = ref(false);
    const popperConfig = {
      placement: "bottom-start",
      eventsEnabled: true,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 1]
          }
        }
      ]
    };
    const filteredData = ref([]);
    const activeItem = ref(-1);
    const { setPopper, isPopperActive, closePopper, openPopper } = MDBPopper();
    const toggle = () => {
      if (isPopperActive.value) {
        close();
      } else {
        open();
      }
    };
    const close = () => {
      closePopper();
      emit("close");
      setTimeout(() => {
        isDropdownActive.value = false;
      }, 300);
    };
    const open = () => {
      if (props.threshold !== void 0 && inputValue.value.length >= props.threshold) {
        isDropdownActive.value = true;
        nextTick(() => openDropdown());
      }
    };
    const inputValue = ref(props.modelValue);
    const updateModelValue = () => {
      emit("update:modelValue", inputValue.value);
    };
    const handleItemClick = (itemIndex) => {
      activeItem.value = itemIndex;
      const item = filteredData.value[itemIndex];
      inputValue.value = props.displayValue ? props.displayValue(item) : item;
      emit("item-select", item);
      close();
    };
    const openDropdown = () => {
      if (!dropdownRef.value) {
        return;
      }
      setPopper(
        autocompleteWrapperRef.value.inputRef,
        dropdownRef.value,
        popperConfig
      );
      openPopper();
      handleFilter();
      dropdownWidth.value = `${autocompleteWrapperRef.value.inputRef.offsetWidth}px`;
      emit("open");
    };
    const scrollToItem = () => {
      var _a, _b;
      if (activeItem.value > -1) {
        const list = (_a = dropdownRef.value) == null ? void 0 : _a.querySelector("ul");
        if (list) {
          const listHeight = list.offsetHeight;
          const listElements = (_b = dropdownRef.value) == null ? void 0 : _b.querySelectorAll("li");
          if (listElements) {
            const item = listElements[activeItem.value];
            const itemHeight = item.offsetHeight;
            const scrollTop = list.scrollTop;
            const itemOffset = activeItem.value * itemHeight;
            const isBelow = itemOffset + itemHeight > scrollTop + listHeight;
            const isAbove = itemOffset < scrollTop;
            if (isAbove) {
              list.scrollTop = itemOffset;
            } else if (isBelow) {
              list.scrollTop = itemOffset - listHeight + itemHeight;
            } else {
              list.scrollTop = scrollTop;
            }
          }
        }
      }
    };
    const handleOpenKeydown = (event) => {
      const key = event.keyCode;
      const isCloseKey = key === ESCAPE || key === UP_ARROW && event.altKey || key === TAB;
      if (isCloseKey) {
        if (key === TAB && props.autoSelect) {
          if (activeItem.value > -1) {
            handleItemClick(activeItem.value);
          }
        }
        close();
        autocompleteWrapperRef.value.inputRef.focus();
        return;
      }
      switch (key) {
        case DOWN_ARROW:
          activeItem.value = activeItem.value < filteredData.value.length - 1 ? activeItem.value + 1 : activeItem.value;
          break;
        case UP_ARROW:
          activeItem.value = activeItem.value > 0 ? activeItem.value - 1 : activeItem.value;
          break;
        case HOME:
          activeItem.value = 0;
          break;
        case END:
          activeItem.value = filteredData.value.length - 1;
          break;
        case ENTER:
          if (activeItem.value > -1) {
            handleItemClick(activeItem.value);
          }
          return;
        default:
          return;
      }
    };
    const isSelectValidated = ref(props.isValidated);
    const isSelectValid = ref(props.isValid);
    const isLoadingData = ref(false);
    const handleFilter = () => {
      const isPromise = (value) => {
        return !!value && !Array.isArray(value) && typeof value.then === "function";
      };
      if (isPopperActive) {
        const data = props.filter(inputValue.value);
        if (isPromise(data)) {
          isLoadingData.value = true;
          data.then((items) => {
            filteredData.value = items;
            emit("update", items);
            isLoadingData.value = false;
          });
        } else {
          emit("update", data);
          filteredData.value = data;
        }
      }
    };
    watchEffect(() => inputValue.value = props.modelValue);
    watch(
      () => inputValue.value,
      () => {
        if (!isDropdownActive.value && props.threshold !== void 0 && inputValue.value.length >= props.threshold) {
          open();
        }
        if (isDropdownActive.value && props.threshold !== void 0 && inputValue.value.length < props.threshold) {
          close();
        }
        activeItem.value = -1;
        updateModelValue();
        handleFilter();
      }
    );
    watch(
      () => [activeItem.value, isPopperActive],
      () => scrollToItem()
    );
    watch(
      () => props.isValidated,
      (value) => isSelectValidated.value = value
    );
    watch(
      () => props.isValid,
      (value) => isSelectValid.value = value
    );
    expose({
      open,
      close,
      toggle
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_sfc_main$O, mergeProps({
          ref_key: "autocompleteWrapperRef",
          ref: autocompleteWrapperRef,
          modelValue: inputValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
          type: "text",
          labelClass: "autocomplete-label",
          class: ["autocomplete-input", unref(isPopperActive) && "focused"],
          label: __props.label,
          placeholder: __props.placeholder,
          disabled: __props.disabled,
          size: __props.size,
          "aria-disabled": __props.disabled,
          "aria-expanded": isDropdownActive.value,
          "aria-required": __props.isValidated && __props.required,
          validFeedback: __props.validFeedback,
          invalidFeedback: __props.invalidFeedback,
          required: __props.required,
          role: "combobox",
          "aria-haspopup": "true"
        }, _ctx.$attrs, {
          onFocus: toggle,
          onKeydown: handleOpenKeydown,
          onTouchstart: _cache[1] || (_cache[1] = withModifiers(() => {
          }, ["stop"])),
          onClickOutside: close
        }), {
          default: withCtx(() => [
            isLoadingData.value ? (openBlock(), createElementBlock("div", _hoisted_1, _hoisted_3)) : createCommentVNode("", true)
          ]),
          _: 1
        }, 16, ["modelValue", "class", "label", "placeholder", "disabled", "size", "aria-disabled", "aria-expanded", "aria-required", "validFeedback", "invalidFeedback", "required"]),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          isDropdownActive.value && __props.threshold !== void 0 && inputValue.value.length >= __props.threshold ? (openBlock(), createElementBlock("div", {
            key: 0,
            id: unref(dropdownId),
            ref_key: "dropdownRef",
            ref: dropdownRef,
            class: "autocomplete-dropdown-container",
            style: normalizeStyle(unref(autocompleteDropdownContainerStyle))
          }, [
            createElementVNode("div", {
              class: normalizeClass(["autocomplete-dropdown", unref(isPopperActive) && "open"]),
              tabindex: "0"
            }, [
              createElementVNode("ul", {
                class: "autocomplete-items-list",
                style: normalizeStyle(unref(autocompleteItemsListStyle))
              }, [
                filteredData.value.length === 0 ? (openBlock(), createElementBlock("li", {
                  key: 0,
                  class: "autocomplete-item autocomplete-no-results",
                  style: { height: `px` },
                  onClick: _cache[2] || (_cache[2] = withModifiers(() => {
                  }, ["stop"]))
                }, toDisplayString(__props.noResultsText), 1)) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList(filteredData.value, (item, i) => {
                  return openBlock(), createElementBlock("li", {
                    key: i,
                    class: normalizeClass(["autocomplete-item", [activeItem.value === i && "active"]]),
                    style: { height: `px` },
                    role: "option",
                    onClick: withModifiers(($event) => handleItemClick(i), ["stop"])
                  }, [
                    createTextVNode(toDisplayString(__props.itemContent ? null : __props.displayValue ? __props.displayValue(item) : item) + " ", 1),
                    __props.itemContent ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      innerHTML: __props.itemContent(item)
                    }, null, 8, _hoisted_6)) : createCommentVNode("", true)
                  ], 10, _hoisted_5);
                }), 128)),
                _ctx.$slots.default ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: "autocomplete-custom-content",
                  onClick: _cache[3] || (_cache[3] = withModifiers(() => {
                  }, ["stop"])),
                  onTouchstart: _cache[4] || (_cache[4] = withModifiers(() => {
                  }, ["stop"]))
                }, [
                  renderSlot(_ctx.$slots, "default")
                ], 32)) : createCommentVNode("", true)
              ], 4)
            ], 2)
          ], 12, _hoisted_4)) : createCommentVNode("", true)
        ]))
      ], 64);
    };
  }
});
const defaultOptions$2 = {
  animationSticky: "",
  animationUnsticky: "",
  boundary: false,
  direction: "down",
  media: 0,
  offset: 0,
  delay: 0,
  position: "top"
};
var mdbSticky = {
  mounted(el, binding) {
    if (!el) {
      return;
    }
    const options = {
      ...defaultOptions$2,
      ...binding.value
    };
    let windowScrollTop = 0;
    let scrollDirection = null;
    let hiddenElement = null;
    el.isSticked = false;
    const elStyle = el.style;
    el.classList.add("sticky");
    if (!("IntersectionObserver" in window)) {
      setTimeout(() => {
        const originalScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        el.originalScrollTop = el.getBoundingClientRect().top + originalScrollTop;
      }, 100);
    } else {
      const intersectionOptions = {
        rootMargin: "0px",
        threshold: 1
      };
      const callback2 = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const originalScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            el.originalScrollTop = el.getBoundingClientRect().top + originalScrollTop;
            observer.disconnect();
          }
        });
      };
      const observer = new IntersectionObserver(callback2, intersectionOptions);
      observer.observe(el);
    }
    const setStickyStyle = () => {
      const { height, left: left2, width } = el.getBoundingClientRect();
      const offset2 = typeof options.offset === "string" ? parseInt(options.offset) : options.offset;
      elStyle.position = "fixed";
      elStyle.top = options.position === "top" && `${0 + offset2}px`;
      elStyle.bottom = options.position === "bottom" && `${0 + offset2}px`;
      elStyle.height = `${height}px`;
      elStyle.width = `${width}px`;
      elStyle.left = `${left2}px`;
      elStyle.marginLeft = 0;
      elStyle.zIndex = "100";
      return;
    };
    const resetStickyStyle = () => {
      elStyle.position = null;
      elStyle.top = null;
      elStyle.bottom = null;
      elStyle.height = null;
      elStyle.width = null;
      elStyle.left = null;
      elStyle.zIndex = null;
      elStyle.marginLeft = null;
      return;
    };
    const toggleClass = (addClass, removeClass, target) => {
      if (addClass) {
        target.classList.add(addClass);
      }
      if (removeClass) {
        target.classList.remove(removeClass);
      }
    };
    const activateSticky = () => {
      if (el.isSticked) {
        return;
      }
      if (options.animationSticky !== "") {
        el.classList.add("animation");
        toggleClass(options.animationSticky, options.animationUnsticky, el);
      }
      setStickyStyle();
      if (hiddenElement) {
        hiddenElement.hidden = false;
      }
      el.isSticked = true;
    };
    const deactivateSticky = () => {
      if (!el.isSticked) {
        return;
      }
      const { animationDuration } = getComputedStyle(el);
      const duration = options.animationUnsticky !== "" ? parseFloat(animationDuration) * 1e3 : 0;
      if (options.animationUnsticky !== "") {
        el.classList.add("animation");
        toggleClass(options.animationUnsticky, options.animationSticky, el);
      }
      setTimeout(() => {
        if (el.classList.contains(options.animationSticky)) {
          return;
        }
        toggleClass("", options.animationUnsticky, el);
        resetStickyStyle();
        removeHiddenElement();
        el.isSticked = false;
      }, duration);
    };
    const updateScrollDirection = (scrollTop) => {
      if (scrollTop > windowScrollTop) {
        scrollDirection = "down";
      } else {
        scrollDirection = "up";
      }
    };
    const checkPushPoint = (scrollTop) => {
      const elHeight = el.getBoundingClientRect().height;
      const delay = typeof options.delay === "string" ? parseInt(options.delay) : options.delay;
      if (options.position === "top") {
        return options.offset >= el.originalScrollTop - scrollTop + delay;
      }
      return el.originalScrollTop + elHeight < window.innerHeight + scrollTop - delay;
    };
    const getOffset = (element) => {
      const rect = element.getBoundingClientRect();
      const offsetElement = {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft
      };
      const bottom2 = offsetElement.left === 0 && offsetElement.top === 0 ? 0 : window.innerHeight - rect.bottom;
      return {
        ...offsetElement,
        bottom: bottom2
      };
    };
    const copyElement = (elementToCopy) => {
      var _a;
      const { height, width } = elementToCopy.getBoundingClientRect();
      const copiedItem = elementToCopy.cloneNode(false);
      copiedItem.hidden = true;
      const copiedItem_STYLE = copiedItem.style;
      copiedItem_STYLE.height = `${height}px`;
      copiedItem_STYLE.width = `${width}px`;
      copiedItem_STYLE.opacity = "0";
      (_a = elementToCopy.parentElement) == null ? void 0 : _a.insertBefore(copiedItem, elementToCopy);
      return copiedItem;
    };
    const createHiddenElement = () => {
      if (!hiddenElement) {
        hiddenElement = copyElement(el);
      }
    };
    const removeHiddenElement = () => {
      if (!hiddenElement) {
        return;
      }
      hiddenElement.remove();
      hiddenElement = null;
    };
    const checkBoundaryPosition = () => {
      var _a;
      const { position, boundary } = options;
      let { offset: offset2 } = options;
      const { height } = el.getBoundingClientRect();
      const parentOffset = {
        height: (_a = el.parentElement) == null ? void 0 : _a.getBoundingClientRect().height,
        ...getOffset(el.parentElement)
      };
      offset2 = typeof offset2 === "string" ? parseInt(offset2) : offset2;
      let stopPoint;
      let stopper;
      if (boundary && boundary !== true) {
        stopper = document.querySelector(boundary);
      }
      if (stopper) {
        stopPoint = getOffset(stopper).top - height - offset2;
      } else {
        stopPoint = parentOffset.height + parentOffset[position] - height - offset2;
      }
      const isStickyTop = position === "top";
      const isStickyBottom = position === "bottom";
      const isStickyBoundary = boundary;
      const isBelowStopPoint = stopPoint < 0;
      const isBelowParentElementEnd = stopPoint > parentOffset.height - height;
      if (isStickyTop) {
        if (isBelowStopPoint && isStickyBoundary) {
          elStyle.top = `${offset2 + stopPoint}px`;
        } else {
          elStyle.top = `${offset2 + 0}px`;
        }
      }
      if (isStickyBottom) {
        if (isBelowStopPoint && isStickyBoundary) {
          elStyle.bottom = `${offset2 + stopPoint}px`;
        } else if (isBelowParentElementEnd && isStickyBoundary) {
          elStyle.bottom = `${offset2 + parentOffset.bottom}px`;
        } else {
          elStyle.bottom = `${offset2 + 0}px`;
        }
      }
    };
    const scrollHandler = () => {
      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop;
      updateScrollDirection(scrollTop);
      const isCorrectScrollDirection = [scrollDirection, "both"].includes(
        options.direction
      );
      const isPushPointReached = checkPushPoint(scrollTop);
      const shouldBeSticky = isPushPointReached && !el.isSticked && isCorrectScrollDirection;
      const shouldNotBeSticky = (!isPushPointReached || !isCorrectScrollDirection) && el.isSticked;
      if (shouldBeSticky) {
        createHiddenElement();
        activateSticky();
        checkBoundaryPosition();
      }
      if (shouldNotBeSticky) {
        deactivateSticky();
      }
      if (el.isSticked) {
        checkBoundaryPosition();
      }
      windowScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };
    el.scrollInit = () => {
      if (window.innerWidth <= options.media) {
        return;
      }
      if (!window.requestAnimationFrame) {
        return setTimeout(scrollHandler, 16);
      }
      window.requestAnimationFrame(scrollHandler);
    };
    window.addEventListener("scroll", (e) => el.scrollInit(e));
  },
  unmounted(el, binding) {
    if (binding.value === false) {
      return;
    }
    window.removeEventListener("scroll", (e) => el.scrollInit(e));
  }
};
const defaultOptions$1 = {
  src: "",
  placeholder: "https://place-hold.it/600x400?text=Loading",
  error: "https://place-hold.it/600x400?text=Error",
  delay: 500,
  offset: 0,
  animation: false,
  parent: null,
  parentEl: null,
  childElements: null
};
var mdbLazy = {
  mounted(el, binding) {
    if (!el) {
      return;
    }
    const { arg } = binding;
    const options = {
      ...defaultOptions$1,
      ...binding.value
    };
    if (options.parent) {
      options.parentEl = document.querySelector(options.parent);
    }
    if (arg && arg === "container") {
      options.childElements = el.querySelectorAll("img, video");
      options.childElements.forEach((child) => {
        on(child, "error", () => errorHandler(child));
      });
    }
    setPlaceholder();
    function setPlaceholder() {
      var _a;
      if (arg && arg === "container") {
        (_a = options.childElements) == null ? void 0 : _a.forEach((child) => {
          const { lazyPlaceholder } = child.dataset;
          if (child.nodeName === "IMG") {
            child.setAttribute("src", lazyPlaceholder || options.placeholder);
          } else if (child.nodeName === "VIDEO") {
            child.setAttribute(
              "poster",
              lazyPlaceholder || options.placeholder
            );
          }
        });
        return;
      }
      if (el.nodeName === "IMG") {
        el.setAttribute("src", options.placeholder);
      } else if (el.nodeName === "VIDEO") {
        el.setAttribute("poster", options.placeholder);
      }
    }
    function inViewport() {
      const offsetValues = el.getBoundingClientRect();
      if (options.parentEl) {
        const parentRect = options.parentEl.getBoundingClientRect();
        return parentRect.y > 0 && parentRect.y < window.innerHeight && offsetValues.y >= parentRect.y && offsetValues.y <= parentRect.y + parentRect.height && offsetValues.y <= window.innerHeight;
      }
      return offsetValues.top + options.offset <= window.innerHeight && offsetValues.bottom >= 0;
    }
    function setSrc(el2, src) {
      el2.setAttribute("src", src);
    }
    el.scrollHandler = () => {
      if (inViewport()) {
        el.timeout = setTimeout(() => {
          var _a;
          if (arg && arg === "container") {
            (_a = options.childElements) == null ? void 0 : _a.forEach((child) => {
              const { lazySrc, lazyAnimation } = child.dataset;
              if (options.animation || lazyAnimation) {
                child.classList.add("animation");
                options.animation ? child.classList.add(options.animation) : lazyAnimation ? child.classList.add(lazyAnimation) : null;
              }
              setSrc(child, lazySrc || options.src);
            });
          } else {
            if (options.animation) {
              el.classList.add("animation");
              el.classList.add(options.animation);
            }
            setSrc(el, options.src);
          }
        }, options.delay);
        if (options.parentEl) {
          off(options.parentEl, "scroll", el.scrollHandler);
        }
        off(window, "scroll", el.scrollHandler);
      }
    };
    function errorHandler(el2) {
      const { lazyError } = el2.dataset;
      el2.setAttribute("src", lazyError || options.error);
    }
    el.scrollHandler();
    if (options.parent) {
      on(options.parentEl, "scroll", el.scrollHandler);
    } else {
      on(window, "scroll", el.scrollHandler);
    }
    on(el, "error", () => errorHandler(el));
  },
  unmounted(el) {
    off(window, "scroll", el.scrollHandler);
  }
};
var mdbInfiniteScroll = {
  mounted(el, binding) {
    const { arg } = binding;
    if (arg === "window") {
      el.scrollableContainer = window;
      el.prevScrollPosition = window.scrollY;
    } else if (el.style.overflowY === "scroll" || el.style.overflowX === "scroll") {
      el.scrollableContainer = el;
      el.prevScrollPosition = arg === "x" ? el.scrollLeft : el.scrollTop;
    }
    el.handleScroll = () => {
      const rect = el.getBoundingClientRect();
      let condition;
      let scrollPosition;
      if (el.scrollableContainer === el) {
        if (arg === "x") {
          condition = rect.width + el.scrollLeft + 10 >= el.scrollWidth;
          scrollPosition = el.scrollLeft;
        } else {
          condition = rect.height + el.scrollTop >= el.scrollHeight;
          scrollPosition = el.scrollTop;
        }
      } else if (arg === "window") {
        condition = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight;
        scrollPosition = window.scrollY;
      }
      if (scrollPosition && scrollPosition < el.prevScrollPosition)
        return;
      if (scrollPosition && condition) {
        el.prevScrollPosition = scrollPosition;
        binding.value();
      }
    };
    el.scrollableContainer.addEventListener("scroll", el.handleScroll);
  },
  unmounted(el) {
    el.scrollableContainer.removeEventListener("scroll", el.handleScroll);
  }
};
const defaultOptions = {
  container: "body",
  offset: 0,
  easing: "linear",
  duration: 500
};
const motions = {
  motionLinear: (t) => {
    return t;
  },
  motionEaseInQuad: (t) => {
    return t * t;
  },
  motionEaseInCubic: (t) => {
    return t * t * t;
  },
  motionEaseInQuart: (t) => {
    return t * t * t * t;
  },
  motionEaseInQuint: (t) => {
    return t * t * t * t * t;
  },
  motionEaseInOutQuad: (t) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  motionEaseInOutCubic: (t) => {
    t /= 0.5;
    if (t < 1)
      return t * t * t / 2;
    t -= 2;
    return (t * t * t + 2) / 2;
  },
  motionEaseInOutQuart: (t) => {
    t /= 0.5;
    if (t < 1)
      return 0.5 * t * t * t * t;
    t -= 2;
    return -(t * t * t * t - 2) / 2;
  },
  motionEaseInOutQuint: (t) => {
    t /= 0.5;
    if (t < 1)
      return t * t * t * t * t / 2;
    t -= 2;
    return (t * t * t * t * t + 2) / 2;
  },
  motionEaseOutQuad: (t) => {
    return -t * (t - 2);
  },
  motionEaseOutCubic: (t) => {
    t--;
    return t * t * t + 1;
  },
  motionEaseOutQuart: (t) => {
    t--;
    return -(t * t * t * t - 1);
  },
  motionEaseOutQuint: (t) => {
    t--;
    return t * t * t * t * t + 1;
  }
};
var mdbSmoothScroll = {
  mounted(el, binding) {
    const href = el.getAttribute("href") || binding.value;
    const options = {
      ...defaultOptions,
      ...binding.value
    };
    const isWindow = () => {
      return options.container === "body";
    };
    const containerToScroll = isWindow() ? document.documentElement : document.querySelector(options.container);
    const easingFunction = () => {
      const easing = options.easing;
      const motionName = `motion${easing[0].toUpperCase()}${easing.slice(1)}`;
      return motions[motionName] ? motions[motionName] : motions.motionLinear;
    };
    const offsetFromEl = () => {
      const heightFromTop = containerToScroll.scrollTop;
      const el2 = document.querySelector(href);
      const elY = el2.getBoundingClientRect().y;
      if (isWindow()) {
        return elY - options.offset + heightFromTop;
      }
      const containerY = containerToScroll.getBoundingClientRect().y;
      const offsetFromContainer = elY - containerY;
      return offsetFromContainer - options.offset + heightFromTop;
    };
    const inViewport = () => {
      if (isWindow()) {
        return true;
      }
      const rect = containerToScroll.getBoundingClientRect();
      return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    };
    const scrollOnNextTick = (scrollingContainer, positionFrom, positionTo, scrollProgress, speed, step, easing) => {
      const progressWrongValue = scrollProgress < 0;
      const scrollEnd = scrollProgress > 1;
      const speedWrongValue = speed <= 0;
      if (progressWrongValue || scrollEnd || speedWrongValue) {
        if (binding.value.callback) {
          binding.value.callback("mdbScrollEnd");
        } else {
          el.dispatchEvent(new CustomEvent("mdbScrollEnd"));
        }
        scrollingContainer.scrollTop = positionTo;
        return;
      }
      scrollingContainer.scrollTo({
        top: positionFrom - (positionFrom - positionTo) * easing(scrollProgress)
      });
      scrollProgress += speed * step;
      setTimeout(() => {
        scrollOnNextTick(
          scrollingContainer,
          positionFrom,
          positionTo,
          scrollProgress,
          speed,
          step,
          easing
        );
      });
    };
    el.handleClick = (e) => {
      e.preventDefault();
      const scrollingContainer = containerToScroll;
      const positionFrom = containerToScroll.scrollTop;
      const positionTo = offsetFromEl();
      const scrollProgress = 0;
      const speed = 1 / options.duration;
      const step = 4.25;
      el.easing = easingFunction();
      if (!inViewport()) {
        if (binding.value.callback) {
          binding.value.callback("mdbScrollStart");
        } else {
          el.dispatchEvent(new CustomEvent("mdbScrollStart"));
        }
        scrollOnNextTick(
          document.documentElement,
          document.documentElement.scrollTop,
          containerToScroll.offsetTop,
          scrollProgress,
          speed,
          step,
          el.easing
        );
        setTimeout(() => {
          scrollOnNextTick(
            scrollingContainer,
            positionFrom,
            positionTo,
            scrollProgress,
            speed,
            step,
            el.easing
          );
        }, options.duration);
      } else {
        if (binding.value.callback) {
          binding.value.callback("mdbScrollStart");
        } else {
          el.dispatchEvent(new CustomEvent("mdbScrollStart"));
        }
        scrollOnNextTick(
          scrollingContainer,
          positionFrom,
          positionTo,
          scrollProgress,
          speed,
          step,
          el.easing
        );
      }
    };
    el.addEventListener("click", (e) => {
      el.handleClick(e);
    });
  },
  unmounted(el) {
    el.removeEventListener("click", () => {
      el.handleClick();
    });
  }
};
var mdbIntersectionObserver = {
  mounted(el, binding) {
    el.intersect = {
      visible: false,
      container: window,
      lostVisibility: null
    };
    if (binding.value) {
      el.intersect = {
        ...el.intersect,
        ...binding.value
      };
    }
    if (el.parentNode.style.overflowY === "scroll" || el.parentNode.style.overflowY === "auto" && binding.arg === "container") {
      el.intersect.container = el.parentNode;
    }
    el.intersect.isVisible = () => {
      let visible = false;
      const { y, height } = el.getBoundingClientRect();
      if (el.intersect.container === window) {
        visible = y < window.innerHeight && y + height > 0;
      } else {
        const parent = el.parentNode;
        const { y: parentY, height: parentHeight } = parent.getBoundingClientRect();
        visible = parentHeight + parentY >= y && y + height >= parentY;
      }
      return visible;
    };
    const callback2 = (e) => {
      var _a, _b;
      (_b = (_a = el.intersect).callback) == null ? void 0 : _b.call(_a, e);
    };
    el.intersect.callback = () => {
      var _a, _b;
      const condition = (_b = (_a = el.intersect).isVisible) == null ? void 0 : _b.call(_a);
      if (condition) {
        !el.intersect.visible && binding.value.callback();
        el.intersect.visible = true;
        if (el.intersect.once)
          el.intersect.container.removeEventListener("scroll", callback2);
      } else {
        if (el.intersect.lostVisibility !== null) {
          el.intersect.visible && el.intersect.lostVisibility();
        }
        el.intersect.visible = false;
      }
    };
    if (el.intersect.start)
      binding.value.callback();
    el.intersect.container.addEventListener("scroll", el.intersect.callback);
  },
  unmounted(el) {
    el.intersect.container.removeEventListener("scroll", el.intersect.callback);
  }
};
var mdbResize = {
  mounted(el, binding) {
    if (binding.value.start) {
      binding.value.callback();
    }
    window.addEventListener("resize", binding.value.callback);
  },
  unmounted(el, binding) {
    window.removeEventListener("resize", binding.value.callback);
  }
};
var mdbMutate = {
  mounted(el, binding) {
    let handler;
    let options;
    if (typeof binding.value === "function") {
      handler = binding.value;
      options = binding.modifiers;
    } else if (binding.value.handler) {
      handler = binding.value.handler;
      options = binding.value.options;
    }
    el.observer = new MutationObserver(handler);
    el.observer.observe(el, options);
  },
  unmounted(el) {
    el.observer.disconnect();
  }
};
var mdbClipboard = {
  mounted(el, binding) {
    el.copyToClipboard = () => {
      let copyValue = null;
      const bindingInstance = binding.instance;
      if (binding.value) {
        copyValue = binding.value;
      } else if (binding.value === void 0) {
        copyValue = el.textContent;
      } else if (bindingInstance.value) {
        if (binding.modifiers.input) {
          copyValue = bindingInstance.value;
        } else {
          copyValue = bindingInstance.value.textContent;
        }
      }
      if (copyValue) {
        navigator.clipboard.writeText(copyValue);
      }
    };
    el.addEventListener("click", el.copyToClipboard);
  },
  unmounted(el) {
    el.removeEventListener("click", el.copyToClipboard);
  }
};
var mdbHotkey = {
  mounted(el, binding) {
    const { modifiers, arg } = binding;
    el.eventElement = arg === "window" ? window : arg === "document" ? document : el;
    const keymap = Object.keys(binding.value).map((set2) => {
      const keys = set2.split("+");
      const combination = {
        hotkey: set2,
        key: "",
        altKey: false,
        ctrlKey: false,
        metaKey: false
      };
      keys.forEach((key) => {
        switch (key) {
          case "ctrl":
            combination.ctrlKey = true;
            break;
          case "alt":
            combination.altKey = true;
            break;
          case "meta":
            combination.metaKey = true;
            break;
          default:
            combination.key = key;
            break;
        }
      });
      return combination;
    });
    el.hotkeyHandler = (event) => {
      modifiers.prevent && event.preventDefault();
      modifiers.stop && event.stopPropagation();
      const { key, altKey, ctrlKey, metaKey } = event;
      keymap.forEach((k, index2) => {
        const keyCombination = keymap[index2];
        if (keyCombination.key.toLowerCase() === key.toLowerCase() && keyCombination.altKey === altKey && keyCombination.ctrlKey === ctrlKey && keyCombination.metaKey === metaKey) {
          binding.value[keyCombination.hotkey]();
        }
      });
    };
    el.eventElement.addEventListener("keydown", el.hotkeyHandler);
  },
  unmounted(el) {
    el.eventElement.removeEventListener("keydown", el.hotkeyHandler);
  }
};
export { _sfc_main$19 as MDBAccordion, _sfc_main$18 as MDBAccordionItem, _sfc_main$F as MDBAlert, _sfc_main$y as MDBAnimation, _sfc_main as MDBAutocomplete, _sfc_main$1D as MDBBadge, _sfc_main$_ as MDBBreadcrumb, _sfc_main$Z as MDBBreadcrumbItem, _sfc_main$1C as MDBBtn, _sfc_main$1A as MDBBtnClose, _sfc_main$1B as MDBBtnGroup, _sfc_main$1z as MDBCard, _sfc_main$1y as MDBCardBody, _sfc_main$1t as MDBCardFooter, _sfc_main$1r as MDBCardGroup, _sfc_main$1u as MDBCardHeader, _sfc_main$1v as MDBCardImg, _sfc_main$1s as MDBCardLink, _sfc_main$1w as MDBCardText, _sfc_main$1x as MDBCardTitle, _sfc_main$1q as MDBCarousel, _sfc_main$n as MDBChart, _sfc_main$M as MDBCheckbox, _sfc_main$s as MDBChip, _sfc_main$r as MDBChipsInput, _sfc_main$S as MDBCol, _sfc_main$1k as MDBCollapse, _sfc_main$Q as MDBContainer, _sfc_main$l as MDBDatatable, _sfc_main$1 as MDBDateTimepicker, _sfc_main$9 as MDBDatepicker, _sfc_main$1j as MDBDropdown, _sfc_main$1g as MDBDropdownItem, _sfc_main$1h as MDBDropdownMenu, _sfc_main$1i as MDBDropdownToggle, _sfc_main$K as MDBFile, _sfc_main$Y as MDBFooter, _sfc_main$17 as MDBIcon, _sfc_main$O as MDBInput, _sfc_main$u as MDBLightbox, _sfc_main$t as MDBLightboxItem, _sfc_main$1p as MDBListGroup, _sfc_main$1o as MDBListGroupItem, _sfc_main$o as MDBLoading, _sfc_main$E as MDBModal, _sfc_main$1b as MDBModalBody, _sfc_main$1a as MDBModalFooter, _sfc_main$1d as MDBModalHeader, _sfc_main$1c as MDBModalTitle, _sfc_main$q as MDBMultiRange, _sfc_main$g as MDBNavbar, _sfc_main$14 as MDBNavbarBrand, _sfc_main$12 as MDBNavbarItem, _sfc_main$13 as MDBNavbarNav, _sfc_main$H as MDBNavbarToggler, _sfc_main$$ as MDBPageItem, _sfc_main$10 as MDBPageNav, _sfc_main$11 as MDBPagination, _sfc_main$v as MDBPopconfirm, _sfc_main$1e as MDBPopover, _sfc_main$1n as MDBProgress, _sfc_main$1m as MDBProgressBar, _sfc_main$L as MDBRadio, _sfc_main$J as MDBRange, _sfc_main$D as MDBRating, _sfc_main$C as MDBRatingItem, _sfc_main$R as MDBRow, _sfc_main$p as MDBScrollbar, _sfc_main$m as MDBSelect, _sfc_main$k as MDBSideNav, _sfc_main$h as MDBSideNavItem, _sfc_main$i as MDBSideNavLink, _sfc_main$j as MDBSideNavMenu, _sfc_main$1l as MDBSpinner, _sfc_main$B as MDBStepper, _sfc_main$x as MDBStepperContent, _sfc_main$w as MDBStepperForm, _sfc_main$z as MDBStepperHead, _sfc_main$A as MDBStepperStep, _sfc_main$I as MDBSwitch, _sfc_main$T as MDBTabContent, _sfc_main$V as MDBTabItem, _sfc_main$W as MDBTabNav, _sfc_main$U as MDBTabPane, _sfc_main$P as MDBTable, _sfc_main$X as MDBTabs, _sfc_main$N as MDBTextarea, _sfc_main$2 as MDBTimepicker, _sfc_main$G as MDBToast, _sfc_main$1f as MDBTooltip, vMdbClickOutside as mdbClickOutside, mdbClipboard, mdbHotkey, mdbInfiniteScroll, mdbIntersectionObserver, mdbLazy, mdbMutate, mdbResize, RippleDirective as mdbRipple, vMdbScrollLock as mdbScrollLock, ScrollSpyDirective as mdbScrollspy, mdbSmoothScroll, mdbSticky, vMdbTouch as mdbTouch };
